webpackJsonp([2],{

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Progress = __webpack_require__(544);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Progress = function (_Component) {
    _inherits(Progress, _Component);

    function Progress() {
        _classCallCheck(this, Progress);

        return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
    }

    _createClass(Progress, [{
        key: '_getLabel',
        value: function _getLabel() {
            if (this.props.failed) {
                return _strings2.default.orderFailed;
            }
            if (this.props.isSuccessful) {
                return _strings2.default.orderSubmitted;
            }
            return _strings2.default.submittingOrder;
        }
    }, {
        key: '_getHelpPrompt',
        value: function _getHelpPrompt() {
            var _this2 = this;

            if (this.props.failed) {
                return _react2.default.createElement(
                    'a',
                    {
                        className: 'cursor-pointer',
                        onClick: function onClick() {
                            return _this2.props.openHelp();
                        }
                    },
                    _strings2.default.orderHelp
                );
            }
            return '';
        }
    }, {
        key: '_getStatus',
        value: function _getStatus() {
            if (this.props.failed) {
                return 'danger';
            }
            if (this.props.isSuccessful) {
                return 'success';
            }
            return 'info';
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'strong',
                        null,
                        this._getLabel()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-b-sm' },
                    _react2.default.createElement(
                        'small',
                        null,
                        this._getHelpPrompt()
                    )
                ),
                _react2.default.createElement(_Progress.ProgressBar, {
                    progress: 100,
                    striped: true,
                    animated: !this.props.complete,
                    status: this._getStatus()
                })
            );
        }
    }]);

    return Progress;
}(_react.Component);

Progress.propTypes = {
    complete: _propTypes2.default.bool.isRequired,
    failed: _propTypes2.default.bool.isRequired,
    isSuccessful: _propTypes2.default.bool.isRequired,
    openHelp: _propTypes2.default.func.isRequired
};
exports.default = Progress;

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(546);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__(1007);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactForm = function (_Component) {
    _inherits(ContactForm, _Component);

    function ContactForm() {
        _classCallCheck(this, ContactForm);

        return _possibleConstructorReturn(this, (ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).apply(this, arguments));
    }

    _createClass(ContactForm, [{
        key: '_handleMessageChange',
        value: function _handleMessageChange(evt) {
            this.props.updateMessage(evt.target.value);
        }
    }, {
        key: '_handleSubjectChange',
        value: function _handleSubjectChange(evt) {
            this.props.updateSubjectIndex(parseInt(evt.target.value, 10));
        }
    }, {
        key: '_handleSendClick',
        value: function _handleSendClick() {
            this.props.sendMessage();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                message = _props.message,
                messageInTransit = _props.messageInTransit,
                contacts = _props.contacts,
                subjectIndex = _props.subjectIndex,
                messageSent = _props.messageSent;

            var label = messageSent ? _react2.default.createElement(
                'div',
                { className: 'disappearing-label' },
                _react2.default.createElement(
                    _reactTransitionGroup.CSSTransition,
                    {
                        classNames: 'animate',
                        timeout: 5000,
                        appear: true,
                        'in': true
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _strings2.default.messageSent
                    )
                )
            ) : null;

            return _react2.default.createElement(
                'form',
                { className: 'contact-form p-a-md' },
                _react2.default.createElement(
                    'fieldset',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'subject' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            _strings2.default.subject
                        )
                    ),
                    _react2.default.createElement(
                        'select',
                        {
                            className: 'form-control',
                            id: 'subject',
                            value: subjectIndex,
                            onChange: function onChange(evt) {
                                return _this2._handleSubjectChange(evt);
                            },
                            disabled: messageInTransit
                        },
                        contacts.map(function (contact, i) {
                            return _react2.default.createElement(
                                'option',
                                { key: i, value: i },
                                contact.kind
                            );
                        })
                    )
                ),
                _react2.default.createElement(
                    'fieldset',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'emailText' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            _strings2.default.message
                        )
                    ),
                    _react2.default.createElement('textarea', {
                        className: 'form-control',
                        id: 'emailText',
                        value: message,
                        onChange: function onChange(evt) {
                            return _this2._handleMessageChange(evt);
                        },
                        disabled: messageInTransit
                    })
                ),
                _react2.default.createElement(
                    'fieldset',
                    { className: 'form-group m-b-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-8 p-l-0 text-muted' },
                        label
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4 text-right p-r-0' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-success',
                                type: 'button',
                                onClick: function onClick() {
                                    return _this2._handleSendClick();
                                },
                                disabled: message === '' || messageInTransit
                            },
                            _strings2.default.sendMessage
                        )
                    )
                )
            );
        }
    }]);

    return ContactForm;
}(_react.Component);

ContactForm.propTypes = {
    contacts: _propTypes2.default.arrayOf(_MapPropTypes2.default.ContactProps).isRequired,
    updateSubjectIndex: _propTypes2.default.func.isRequired,
    updateMessage: _propTypes2.default.func.isRequired,
    sendMessage: _propTypes2.default.func.isRequired,
    subjectIndex: _propTypes2.default.number.isRequired,
    message: _propTypes2.default.string.isRequired,
    messageInTransit: _propTypes2.default.bool.isRequired,
    messageSent: _propTypes2.default.bool.isRequired
};
exports.default = ContactForm;

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

module.exports = {"name":"@disw/map-client","version":"0.1.3","description":"Siemens Advantage client interface.","scripts":{"clean":"rm -rf dist/*","build":"npx webpack -p","watch":"npx webpack --progress --colors --watch","pretest":"npx eslint app"},"keywords":["Siemens EDA","Siemens","EDA","Advantage","MAP"],"authors":["Karthik Vajja <karthik.vajja@siemens.com>","Siva Kishore Bonu <sivakishore.bonu@siemens.com"],"license":"UNLICENSED","repository":"ssh://git@bitbucket.org:disw-ps-siemens/advantage-v2-client.git","dependencies":{"@mgc/map-client-shared":"0.1.28","@mgc/map-react-joyride":"^1.0.0","@mgc/react-components":"^3.2.1","babel-polyfill":"^6.23.0","chart.js":"^2.9.4","cookie":"^0.3.1","moment":"^2.18.1","numeral":"^2.0.6","prop-types":"^15.7.2","raven-js":"^3.17.0","react":"^15.6.1","react-bootstrap":"^0.31.1","react-chartjs-2":"^2.5.5","react-custom-scrollbars":"^4.2.1","react-dom":"^15.6.1","react-dropzone":"^4.2.8","react-flatpickr":"^3.5.0","react-loadable":"^5.3.1","react-localization":"^0.1.1","react-redux":"^5.0.5","react-router":"^4.1.1","react-router-dom":"^4.1.1","react-select-plus":"^1.2.0","react-transition-group":"^2.2.1","redux":"^3.7.2","reselect":"^3.0.1","react-icons":"^4.11.0","moment-precise-range-plugin":"^1.3.0"},"devDependencies":{"babel-core":"^6.25.0","babel-eslint":"^10.0.1","babel-loader":"^7.1.1","babel-preset-es2015":"^6.24.1","babel-preset-react":"^6.24.1","babel-preset-stage-2":"^6.24.1","css-loader":"^0.28.4","dotenv-webpack":"^1.5.3","eslint":"^5.16.0","eslint-plugin-react":"^7.12.4","extract-text-webpack-plugin":"^3.0.0","html-webpack-plugin":"^2.29.0","node-sass":"^4.14.1","redux-devtools":"^3.4.0","sass-loader":"^6.0.6","style-loader":"^0.18.2","webpack":"^3.2.0","webpack-dev-server":"^2.11.5"}}

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _HelpModal = __webpack_require__(545);

var _HelpModal2 = _interopRequireDefault(_HelpModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_Component) {
    _inherits(Footer, _Component);

    function Footer() {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
    }

    _createClass(Footer, [{
        key: '_renderButton',
        value: function _renderButton() {
            var _this2 = this;

            if (!this.props.isLoggedIn) {
                return _react2.default.createElement('span', null);
            }

            return _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-info-outline btn-sm help-button',
                    onClick: function onClick() {
                        return _this2.props.openHelpModal();
                    }
                },
                _strings2.default.needHelpQuestion
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'container-full border-top p-y' },
                _react2.default.createElement(
                    'div',
                    { className: 'item-flex' },
                    _react2.default.createElement('div', { className: 'item-flex-main' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-flex-addon text-xs text-muted' },
                        this._renderButton()
                    )
                ),
                _react2.default.createElement(_HelpModal2.default, null),
                ' '
            );
        }
    }]);

    return Footer;
}(_react.Component);

Footer.propTypes = { openHelpModal: _propTypes2.default.func.isRequired };

Footer.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        isLoggedIn: _selectors2.default.login.getIsLoggedIn
    });
};

Footer.mapDispatch = function (dispatch) {
    return {
        openHelpModal: function openHelpModal() {
            return dispatch(_ui2.default.openHelpModal());
        }
    };
};

exports.default = (0, _ReduxStore.attach)(Footer);

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactComponents = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MigrationNotice = function (_Component) {
    _inherits(MigrationNotice, _Component);

    function MigrationNotice(props) {
        _classCallCheck(this, MigrationNotice);

        var _this = _possibleConstructorReturn(this, (MigrationNotice.__proto__ || Object.getPrototypeOf(MigrationNotice)).call(this));

        _this.state = {
            visible: Object.prototype.hasOwnProperty.call(props, 'visible') ? props.visible : true
        };
        return _this;
    }

    _createClass(MigrationNotice, [{
        key: '_renderNotice',
        value: function _renderNotice() {
            if (!this.state.visible) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    'As part of the ongoing transition from Mentor Graphics to Siemens EDA, Mentor Advantge has transitioned to this new URL with Siemens branding.'
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'm-b-xs' },
                    'In order to simplify the login process across Siemens web sites, Siemens Advantage has been configured to use the Siemens DISW login system. This brings it in-line with Support Center and other Siemens web properties. Most users won\'t notice any changes and will be able to log-in with their existing password. Users with log-in trouble should reach out to their local contact for assistance.'
                )
            );
        }
    }, {
        key: '_renderToggle',
        value: function _renderToggle() {
            var _this2 = this;

            if (this.state.visible) {
                return null;
            }

            return _react2.default.createElement(
                'a',
                {
                    className: 'cursor-pointer text-mute text-small',
                    onClick: function onClick() {
                        return _this2.setState({ visible: true });
                    }
                },
                _react2.default.createElement(
                    'em',
                    null,
                    'Show details...'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'card m-b-0' },
                _react2.default.createElement(
                    'div',
                    { className: 'card-header bg-success text-small p-a-xs text-inverse' },
                    _react2.default.createElement(_reactComponents.Icon, { className: 'm-x-xs', name: 'icon-info' }),
                    ' Welcome to Siemens Advantage'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card-body p-a-sm' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12 migration-panel' },
                            this._renderNotice(),
                            this._renderToggle()
                        )
                    )
                )
            );
        }
    }]);

    return MigrationNotice;
}(_react.Component);

MigrationNotice.propTypes = {
    visible: _propTypes2.default.bool
};

exports.default = MigrationNotice;

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(132);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _BaseLayout = __webpack_require__(160);

var _BaseLayout2 = _interopRequireDefault(_BaseLayout);

var _Loading = __webpack_require__(551);

var _Loading2 = _interopRequireDefault(_Loading);

var _OrderForm = __webpack_require__(1015);

var _OrderForm2 = _interopRequireDefault(_OrderForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Order = function (_Component) {
    _inherits(Order, _Component);

    function Order() {
        _classCallCheck(this, Order);

        return _possibleConstructorReturn(this, (Order.__proto__ || Object.getPrototypeOf(Order)).apply(this, arguments));
    }

    _createClass(Order, [{
        key: 'render',
        value: function render() {
            if (false) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/maintenance' });
            }
            if (this.props.wantLogin) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
            }
            if (!this.props.isLoggedIn) {
                return _react2.default.createElement(_Loading2.default, null);
            }
            return _react2.default.createElement(
                _BaseLayout2.default,
                null,
                _react2.default.createElement(_OrderForm2.default, null)
            );
        }
    }]);

    return Order;
}(_react.Component);

Order.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        isLoggedIn: _selectors2.default.login.getIsLoggedIn,
        wantLogin: _selectors2.default.login.getWantLogin
    });
};

exports.default = (0, _ReduxStore.attach)(Order);

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactComponents = __webpack_require__(35);

var _reactSelectPlus = __webpack_require__(92);

var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _offer = __webpack_require__(113);

var _offer2 = _interopRequireDefault(_offer);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _help = __webpack_require__(115);

var _help2 = _interopRequireDefault(_help);

var _Cart = __webpack_require__(1016);

var _Cart2 = _interopRequireDefault(_Cart);

var _Balance = __webpack_require__(1032);

var _Balance2 = _interopRequireDefault(_Balance);

var _Selector = __webpack_require__(1125);

var _Selector2 = _interopRequireDefault(_Selector);

var _AddHostServer = __webpack_require__(1126);

var _AddHostServer2 = _interopRequireDefault(_AddHostServer);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _PricingModal = __webpack_require__(1128);

var _PricingModal2 = _interopRequireDefault(_PricingModal);

var _CheckoutModal = __webpack_require__(1131);

var _CheckoutModal2 = _interopRequireDefault(_CheckoutModal);

var _sites = __webpack_require__(114);

var _sites2 = _interopRequireDefault(_sites);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

__webpack_require__(1135);

var _reactBootstrap = __webpack_require__(64);

var _UploadConfiguration = __webpack_require__(1136);

var _UploadConfiguration2 = _interopRequireDefault(_UploadConfiguration);

var _order = __webpack_require__(78);

var _order2 = _interopRequireDefault(_order);

var _ShoppingCartModal = __webpack_require__(542);

var _ShoppingCartModal2 = _interopRequireDefault(_ShoppingCartModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SERVER = 'server';
var PRODUCT = 'product';

var OrderForm = function (_Component) {
    _inherits(OrderForm, _Component);

    function OrderForm(props) {
        _classCallCheck(this, OrderForm);

        var _this = _possibleConstructorReturn(this, (OrderForm.__proto__ || Object.getPrototypeOf(OrderForm)).call(this, props));

        _this.handleEditCartChange = function (value) {
            _this.setState({ editCart: value });
        };

        _this.state = {
            cartErrorMessage: '', editCart: false
        };
        _this._validateCartItemsAndProceedToShoppingCart = _this._validateCartItemsAndProceedToShoppingCart.bind(_this);
        return _this;
    }

    _createClass(OrderForm, [{
        key: '_handleSiteSelected',
        value: function _handleSiteSelected(id) {
            this.props.selectSite(id);
        }
    }, {
        key: '_handleOfferChange',
        value: function _handleOfferChange(option) {
            this.props.selectOffer(option.value);
            this.props.setItems();
            this.props.selectProduct(-1);
            this._renderOrderForm;
            this.setState({ editCart: false, cartErrorMessage: '' });
        }
    }, {
        key: '_checkProductConfig',
        value: function _checkProductConfig() {
            return this.props.offer.enterprise_deal || this._checkAllowedCompany(this.props.offer.account.soldTo, PRODUCT);
        }
    }, {
        key: '_checkAllowedCompany',
        value: function _checkAllowedCompany(soldto, type) {
            var allowed = false;
            switch (type) {
                case SERVER:
                    allowed = "201876".includes(soldto) ? true : false;
                    break;
                case PRODUCT:
                    allowed = "201876".includes(soldto) ? true : false;
                    break;
            }
            return allowed;
        }
    }, {
        key: '_checkServerConfig',
        value: function _checkServerConfig() {
            return this._checkAllowedCompany(this.props.offer.account.soldTo, SERVER);
        }
    }, {
        key: '_closeEditCart',
        value: function _closeEditCart() {
            // set edit cart items back to false and then reset state.
            this.props.saveShoppingCart(this.props.user.id);
            this.setState({ editCart: false });
        }
    }, {
        key: '_handleProductListDownload',
        value: function _handleProductListDownload(id) {
            this.props.downloadConfigurationProductList(id);
        }
    }, {
        key: '_validateCartItemsAndCheckout',
        value: function _validateCartItemsAndCheckout() {
            var isValidCart = true;
            var cartErrorMessage = '';
            this.setState({
                cartErrorMessage: cartErrorMessage
            });
            // commenting the check for number of seats for tier pricing and allowing to place the order 
            // this.props.cart.forEach((item) => {
            //     if (!item.isTieredDiscountApplied && item.pricing.tieredDiscount) {
            //         // check for number of seats
            //         if (item.seats < 11) {
            //             isValidCart = false;
            //             cartErrorMessage =
            //                 item.pricing.product.name +
            //                 ` is using the lower price tier. Therefore you need to keep a minimum of 11 active licenses. Currently there ${item.seats === 1 ? 'is' : 'are'
            //                 } ${item.seats}  active license(s) in this time window`;
            //         }
            //     }
            // });
            if (isValidCart) {
                this.props.openModal('checkout');
            }
            this.setState({
                cartErrorMessage: cartErrorMessage
            });
        }
    }, {
        key: '_validateCartItemsAndProceedToShoppingCart',
        value: function _validateCartItemsAndProceedToShoppingCart() {
            var itemIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var saveForLater = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var isValidCart = true;
            var cartErrorMessage = '';
            itemIndex;
            this.setState({
                cartErrorMessage: cartErrorMessage
            });

            this.props.cart.forEach(function (item, index) {
                if (itemIndex !== undefined && index != itemIndex) {
                    return;
                }
                item.addedToCart = true;
                item.saveForLater = saveForLater;
                // commenting the  check for number of seats for tier pricing and allowing to place the order 
                // if (!item.isTieredDiscountApplied && item.pricing.tieredDiscount) {
                //     // check for number of seats
                //     if (item.seats < 11) {
                //         isValidCart = false;
                //         cartErrorMessage =
                //             item.pricing.product.name +
                //             ` is using the lower price tier. Therefore you need to keep a minimum of 11 active licenses. Currently there ${
                //                 item.seats === 1 ? 'is' : 'are'
                //             } ${item.seats}  active license(s) in this time window`;
                //     }
                // }
            });
            if (isValidCart) {
                this.props.saveShoppingCart(this.props.user.id);
                // Disabling opening of shopping cart pop up on save and keeping it for future use in case business changes their mind.
                // if(itemIndex === undefined){
                //     this.props.openModal('shoppingcart');
                // }
            }
            this.setState({
                cartErrorMessage: cartErrorMessage
            });
        }
    }, {
        key: '_renderOfferSelect',
        value: function _renderOfferSelect() {
            var _this2 = this;

            if (!this.props.showOfferSelect) {
                return _react2.default.createElement('span', null);
            }

            function itemRenderer(_ref) {
                var offer = _ref.offer;

                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'strong',
                        null,
                        offer.mentorId,
                        ' - ',
                        offer.account.name
                    ),
                    ' ',
                    _react2.default.createElement(
                        'small',
                        { className: 'p-l text-mute' },
                        _react2.default.createElement(_reactComponents.Icon, { name: 'icon-calendar' }),
                        ' ',
                        _utils2.default.formatShortDate(offer.validFrom),
                        ' -',
                        ' ',
                        _utils2.default.formatShortDate(offer.validTo)
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'p-a bg-info-light border-all m-b br-a-sm' },
                _react2.default.createElement(
                    'div',
                    { className: 'offer-select' },
                    _react2.default.createElement(_reactSelectPlus2.default, {
                        value: this.props.selectedOfferIndex,
                        multi: false,
                        clearable: false,
                        searchable: this.props.offers.length > 3,
                        options: this.props.offers.map(function (offer, index) {
                            return {
                                value: index,
                                label: _strings2.default.dealId + ' ' + offer.mentorId,
                                offer: offer
                            };
                        }),
                        onChange: function onChange(option) {
                            return _this2._handleOfferChange(option);
                        },
                        valueRenderer: itemRenderer,
                        optionRenderer: itemRenderer
                    })
                )
            );
        }
    }, {
        key: '_renderCart',
        value: function _renderCart() {
            if (!this.props.showCart && !this.state.editCart) {
                return _react2.default.createElement('span', null);
            }

            return _react2.default.createElement(
                'div',
                { className: 'card m-b-0 cart' },
                _react2.default.createElement(_Cart2.default, { editCart: this.state.editCart,
                    SaveCartItem: this._validateCartItemsAndProceedToShoppingCart }),
                ' '
            );
        }
    }, {
        key: '_renderOrderForm',
        value: function _renderOrderForm() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'order-form' },
                this.state.cartErrorMessage ? _react2.default.createElement(
                    'div',
                    { className: 'row text-center text-danger ' },
                    this.state.cartErrorMessage
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-6' },
                        this._renderOfferSelect()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card m-a-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row row-flex middle-xs row-flush row-bordered' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12 flex-align-top' },
                            _react2.default.createElement(
                                'div',
                                { className: 'p-a-md' },
                                !this.state.editCart ? _react2.default.createElement(_Selector2.default, {
                                    offer: this.props.offer,
                                    addProductToCart: this.props.addProductToCart,
                                    selectedProductIndex: this.props.selectedProductIndex,
                                    selectProduct: this.props.selectProduct
                                }) : _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'h1',
                                        { className: 'card-header' },
                                        'Your Cart'
                                    )
                                ),
                                this._renderCart()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12 text-center' },
                            _react2.default.createElement(_Balance2.default, { editCart: this.state.editCart }),
                            ' '
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-t-md text-right footer' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-6' },
                            _react2.default.createElement(
                                'button',
                                {
                                    id: 'pricingBtn',
                                    onClick: function onClick() {
                                        return _this3.props.openModal('pricing');
                                    },
                                    className: 'btn btn-info pull-left pricing-btn'
                                },
                                _react2.default.createElement(_reactComponents.Icon, { name: 'icon-table' }),
                                ' ',
                                _strings2.default.pricing
                            )
                        ),
                        !this.state.editCart ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-3' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        id: 'saveForlater',
                                        className: 'btn btn-xl btn-primary btn-block order-button',
                                        disabled: !this.props.readyForaddToCart,
                                        onClick: function onClick() {
                                            return _this3._validateCartItemsAndProceedToShoppingCart(undefined, true);
                                        }
                                    },
                                    _strings2.default.saveForLater,
                                    ' ',
                                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-arrow-right4' })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-3' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        id: 'addToCart',
                                        className: 'btn btn-xl btn-primary btn-block order-button',
                                        disabled: !this.props.readyForaddToCart,
                                        onClick: function onClick() {
                                            return _this3._validateCartItemsAndProceedToShoppingCart();
                                        }
                                    },
                                    _strings2.default.addToCart,
                                    ' ',
                                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-arrow-right4' })
                                )
                            )
                        ) : _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-3' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        className: 'btn btn-xl btn-primary btn-block order-button',
                                        disabled: !this.props.readyForCheckout,
                                        onClick: function onClick() {
                                            return _this3._closeEditCart();
                                        }
                                    },
                                    _strings2.default.saveAndContinueShopping,
                                    ' ',
                                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-arrow-right4' })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-3' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        className: 'btn btn-xl btn-primary btn-block order-button',
                                        disabled: !this.props.readyForCheckout
                                        // onClick={() => this.props.openModal('checkout')}
                                        , onClick: function onClick() {
                                            return _this3._validateCartItemsAndCheckout();
                                        }
                                    },
                                    _strings2.default.checkout,
                                    ' ',
                                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-arrow-right4' })
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    '\xA0'
                ),
                this._checkProductConfig() ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'card m-a-0' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row row-flex middle-xs row-flush row-bordered' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-12 flex-align-bottom' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'p-a-md' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card raised-sm border-none product-selector' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'card-header card-header-success text-inverse' },
                                            _react2.default.createElement(
                                                'b',
                                                null,
                                                'Configure products with a template'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'card-block' },
                                            _react2.default.createElement(
                                                _reactBootstrap.Grid,
                                                null,
                                                _react2.default.createElement(
                                                    _reactBootstrap.Row,
                                                    { className: 'show-grid align-items-center' },
                                                    _react2.default.createElement(_UploadConfiguration2.default, {
                                                        downloadConfigurationProductList: function downloadConfigurationProductList(id) {
                                                            return _this3._handleProductListDownload(id);
                                                        }
                                                    })
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '\xA0'
                    )
                ) : _react2.default.createElement('div', null),
                this._checkServerConfig() ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'card m-a-0' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row row-flex middle-xs row-flush row-bordered' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-12 flex-align-bottom' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'p-a-md' },
                                    _react2.default.createElement(_AddHostServer2.default, {
                                        selectedSiteId: this.props.selectedSiteId,
                                        selectedSite: this.props.selectedSite,
                                        selectSite: function selectSite(id) {
                                            return _this3._handleSiteSelected(id);
                                        },
                                        sites: this.props.offer.sites,
                                        showAlert: this.props.showAlert
                                    })
                                )
                            )
                        )
                    )
                ) : _react2.default.createElement('div', null),
                _react2.default.createElement(_PricingModal2.default, null),
                ' ',
                _react2.default.createElement(_ShoppingCartModal2.default, { onEditCartChange: this.handleEditCartChange }),
                ' ',
                _react2.default.createElement(_CheckoutModal2.default, { onEditCartChange: this.handleEditCartChange }),
                ' '
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            if (!this.props.offerIsUsable) {
                if (this.props.offersRetrieved) {
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'h1',
                            null,
                            _strings2.default.noOffersAvailable
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    className: 'cursor-pointer',
                                    onClick: function onClick() {
                                        return _this4.props.openHelpModal(_this4.props.helpSubjectIndex);
                                    }
                                },
                                _strings2.default.contactForHelp
                            )
                        )
                    );
                }
                return _react2.default.createElement('div', null);
            }
            return this._renderOrderForm();
        }
    }]);

    return OrderForm;
}(_react.Component);

OrderForm.propTypes = {
    // functions
    addProductToCart: _propTypes2.default.func.isRequired,
    openModal: _propTypes2.default.func.isRequired,
    selectOffer: _propTypes2.default.func.isRequired,
    setItems: _propTypes2.default.func.isRequired,
    selectProduct: _propTypes2.default.func.isRequired,
    openHelpModal: _propTypes2.default.func.isRequired,
    saveShoppingCart: _propTypes2.default.func.isRequired,
    downloadConfigurationProductList: _propTypes2.default.func.isRequired,
    // data
    offer: _MapPropTypes2.default.OfferProps,
    selectedOfferIndex: _propTypes2.default.number.isRequired,
    offers: _propTypes2.default.arrayOf(_MapPropTypes2.default.OfferProps),
    offerIsUsable: _propTypes2.default.bool.isRequired,
    offersRetrieved: _propTypes2.default.bool.isRequired,
    readyForCheckout: _propTypes2.default.bool.isRequired,
    readyForaddToCart: _propTypes2.default.bool.isRequired,
    // site
    selectSite: _propTypes2.default.func.isRequired,
    selectedSite: _propTypes2.default.object,
    selectedSiteId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    // User
    user: _MapPropTypes2.default.UserProps,
    editCart: _propTypes2.default.bool,
    showCart: _propTypes2.default.bool,
    showOfferSelect: _propTypes2.default.bool,
    cart: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        item: _MapPropTypes2.default.CartItemProps,
        product: _MapPropTypes2.default.PricingProps
    })).isRequired,
    selectedProductIndex: _propTypes2.default.number,
    showAlert: _propTypes2.default.bool,
    helpSubjectIndex: _propTypes2.default.number

};

OrderForm.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        offer: _selectors2.default.offer.getSelectedOffer,
        selectedOfferIndex: _selectors2.default.offer.getSelectedOfferIndex,
        offers: _selectors2.default.offer.getOffers,
        showOfferSelect: _selectors2.default.offer.showOfferSelect,
        showCart: _selectors2.default.cart.showCart,
        editCartItems: _selectors2.default.cart.editCart,
        cart: _selectors2.default.cart.getCartContents,
        offersRetrieved: _selectors2.default.offer.getOffersRetrieved,
        offerIsUsable: _selectors2.default.offer.getOfferIsUsable,
        readyForCheckout: _selectors2.default.cart.readyForCheckout,
        readyForaddToCart: _selectors2.default.cart.readyForaddToCart,
        selectedProductIndex: _selectors2.default.offer.getSelectedProductIndex,
        // site
        sites: _selectors2.default.sites.getSites,
        selectedSite: _selectors2.default.sites.getSelectedSite,
        selectedSiteId: _selectors2.default.sites.getSelectedSiteId,
        showAlert: _selectors2.default.sites.showAlert,
        user: _selectors2.default.user.getMyself
    });
};

OrderForm.mapDispatch = function (dispatch) {
    return {
        addProductToCart: function addProductToCart(productIndex) {
            return dispatch(_cart2.default.addProductToCart(productIndex));
        },
        openModal: function openModal(modalName) {
            return dispatch(_ui2.default.openModal(modalName));
        },
        openHelpModal: function openHelpModal() {
            dispatch(_help2.default.showContactTab());
            dispatch(_help2.default.updateContactSubjectIndex(_help2.default.contactSubjects.indexOf('General Inquiry')));
            dispatch(_ui2.default.openHelpModal());
        },
        selectOffer: function selectOffer(offerIndex) {
            return dispatch(_offer2.default.selectOffer(offerIndex));
        },
        setItems: function setItems() {
            return dispatch(_cart2.default.setItems());
        },
        selectProduct: function selectProduct(productIndex) {
            return dispatch(_offer2.default.selectProduct(productIndex));
        },
        selectSite: function selectSite(id) {
            return dispatch(_sites2.default.selectSite(id));
        },
        // fetchAllSites: () => dispatch(SiteActions.fetchSites()),
        downloadConfigurationProductList: function downloadConfigurationProductList(id) {
            return dispatch(_order2.default.downloadConfigurationProductList(id));
        },
        saveShoppingCart: function saveShoppingCart(userId) {
            return dispatch(_cart2.default.saveShoppingCart(userId));
        }
    };
};

exports.default = (0, _ReduxStore.attach)(OrderForm);

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _CartItem = __webpack_require__(1017);

var _CartItem2 = _interopRequireDefault(_CartItem);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__(1031);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cart = function (_Component) {
    _inherits(Cart, _Component);

    function Cart() {
        _classCallCheck(this, Cart);

        return _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).apply(this, arguments));
    }

    _createClass(Cart, [{
        key: '_renderItems',
        value: function _renderItems() {
            var _this2 = this;

            if (this.props.cart.length === 0) {
                return _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                        'td',
                        { colSpan: '8', className: 'text-center' },
                        _react2.default.createElement(
                            'em',
                            { className: 'text-gray-light' },
                            _strings2.default.selectAProduct,
                            '.'
                        )
                    )
                );
            }

            return this.props.cart.map(function (item, originalIndex) {
                return _extends({}, item, { originalIndex: originalIndex });
            }).filter(function (item) {
                return item.addedToCart == _this2.props.editCart && !item.saveForLater;
            }).map(function (item) {
                return _react2.default.createElement(_CartItem2.default, {
                    updateDateRange: function updateDateRange(startDate, endDate) {
                        return _this2.props.updateDateRange(item.originalIndex, startDate, endDate);
                    },
                    updateStartDate: function updateStartDate(startDate) {
                        _this2.props.updateStartDate(item.originalIndex, startDate);
                    },
                    updateEndDate: function updateEndDate(endDate) {
                        _this2.props.updateEndDate(item.originalIndex, endDate);
                    },
                    updateMonthCount: function updateMonthCount(monthCount) {
                        _this2.props.updateMonthCount(item.originalIndex, monthCount);
                    },
                    updateWeekCount: function updateWeekCount(weekCount) {
                        _this2.props.updateWeekCount(item.originalIndex, weekCount);
                    },
                    updateSeats: function updateSeats(seats) {
                        _this2.props.updateSeats(item.originalIndex, seats);
                    },
                    updateServer: function updateServer(siteIndex, serverIndex) {
                        _this2.props.updateServer(item.originalIndex, siteIndex, serverIndex);
                    },
                    removeItemFromCart: function removeItemFromCart() {
                        return _this2.props.removeItemFromCart(item.originalIndex, item.cartId);
                    },
                    addItemToCart: function addItemToCart() {
                        return _this2.props.SaveCartItem(item.originalIndex);
                    },
                    offer: _this2.props.offer,
                    serversBySite: _this2.props.serversBySite,
                    item: item,
                    readyForaddToCart: _this2.props.readyForaddToCart,
                    editCart: _this2.props.editCart,
                    key: item.originalIndex // Use original index as the key
                    , serverAliases: _this2.props.serverAliases,
                    isPricingContinuous: _this2.props.isPricingContinuous,
                    hasOnlyWeeklyPricing: _this2.props.hasOnlyWeeklyPricing,
                    myself: _this2.props.myself
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.showCart && !this.props.editCart) {
                return _react2.default.createElement('div', null);
            }

            var firstThClasses = 'text-xs text-uppercase';
            var thClasses = 'text-center ' + firstThClasses;

            return _react2.default.createElement(
                'table',
                { className: 'table m-b-0 cart' },
                _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            { className: firstThClasses },
                            _strings2.default.product
                        ),
                        _react2.default.createElement(
                            'th',
                            { className: firstThClasses, width: '350' },
                            _strings2.default.server
                        ),
                        _react2.default.createElement(
                            'th',
                            { className: thClasses, width: '90' },
                            _strings2.default.seats
                        ),
                        _react2.default.createElement(
                            'th',
                            { className: thClasses, width: '220' },
                            _strings2.default.duration
                        ),
                        _react2.default.createElement(
                            'th',
                            { className: thClasses },
                            _strings2.default.creditsSeat
                        ),
                        _react2.default.createElement(
                            'th',
                            { className: thClasses },
                            _strings2.default.subtotal
                        ),
                        _react2.default.createElement('th', { className: 'actionLeftBorder' })
                    )
                ),
                _react2.default.createElement(
                    'tbody',
                    null,
                    this._renderItems()
                )
            );
        }
    }]);

    return Cart;
}(_react.Component);

Cart.propTypes = {
    offer: _MapPropTypes2.default.OfferProps,
    isPricingContinuous: _propTypes2.default.bool.isRequired,
    hasOnlyWeeklyPricing: _propTypes2.default.bool.isRequired,
    serversBySite: _propTypes2.default.arrayOf(_MapPropTypes2.default.SiteProps),
    cart: _MapPropTypes2.default.CartProps,
    showCart: _propTypes2.default.bool.isRequired,
    readyForaddToCart: _propTypes2.default.bool.isRequired,
    serverAliases: _propTypes2.default.object,
    myself: _MapPropTypes2.default.UserProps,
    removeItemFromCart: _propTypes2.default.func.isRequired,
    SaveCartItem: _propTypes2.default.func.isRequired,
    updateStartDate: _propTypes2.default.func.isRequired,
    updateMonthCount: _propTypes2.default.func.isRequired,
    updateSeats: _propTypes2.default.func.isRequired,
    updateServer: _propTypes2.default.func.isRequired,
    updateWeekCount: _propTypes2.default.func.isRequired,
    updateEndDate: _propTypes2.default.func.isRequired,
    editCart: _propTypes2.default.bool.isRequired
};

Cart.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        offer: _selectors2.default.offer.getSelectedOffer,
        isPricingContinuous: _selectors2.default.offer.getIsPricingContinuous,
        hasOnlyWeeklyPricing: _selectors2.default.offer.getHasOnlyWeeklyPricing,
        serversBySite: _selectors2.default.offer.getServersGroupedBySite,
        cart: _selectors2.default.cart.getCartContents,
        showCart: _selectors2.default.cart.showCart,
        readyForaddToCart: _selectors2.default.cart.readyForaddToCart,
        serverAliases: _selectors2.default.user.getServerAliases,
        myself: _selectors2.default.user.getMyself
    });
};

Cart.mapDispatch = function (dispatch) {
    return {
        updateStartDate: function updateStartDate(index, startDate) {
            return dispatch(_cart2.default.updateItemStartDate(index, startDate));
        },
        updateDateRange: function updateDateRange(index, startDate, endDate) {
            return dispatch(_cart2.default.updateItemDateRange(index, startDate, endDate));
        },
        updateEndDate: function updateEndDate(index, endDate) {
            return dispatch(_cart2.default.updateItemEndDate(index, endDate));
        },
        updateMonthCount: function updateMonthCount(index, monthCount) {
            return dispatch(_cart2.default.updateItemMonthCount(index, monthCount));
        },
        updateWeekCount: function updateWeekCount(index, weekCount) {
            return dispatch(_cart2.default.updateItemWeekCount(index, weekCount));
        },
        updateSeats: function updateSeats(index, seats) {
            return dispatch(_cart2.default.updateItemSeats(index, seats));
        },
        updateSiteIndex: function updateSiteIndex(index, siteIndex) {
            return dispatch(_cart2.default.updateItemSiteIndex(index, siteIndex));
        },
        updateServer: function updateServer(index, siteIndex, serverIndex) {
            return dispatch(_cart2.default.updateItemServer(index, siteIndex, serverIndex));
        },
        removeItemFromCart: function removeItemFromCart(index, cartId) {
            return dispatch(_cart2.default.removeItemFromCart(index, cartId));
        }
    };
};

exports.default = (0, _ReduxStore.attach)(Cart);

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactSelectPlus = __webpack_require__(92);

var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

var _SeatInput = __webpack_require__(1018);

var _SeatInput2 = _interopRequireDefault(_SeatInput);

var _DurationInput = __webpack_require__(1019);

var _DurationInput2 = _interopRequireDefault(_DurationInput);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartItem = function (_Component) {
    _inherits(CartItem, _Component);

    function CartItem() {
        _classCallCheck(this, CartItem);

        return _possibleConstructorReturn(this, (CartItem.__proto__ || Object.getPrototypeOf(CartItem)).apply(this, arguments));
    }

    _createClass(CartItem, [{
        key: 'onServerChange',
        value: function onServerChange(option) {
            var indices = option.value.split(',');

            var _indices = _slicedToArray(indices, 2),
                siteIndex = _indices[0],
                serverIndex = _indices[1];

            this.props.updateServer(parseInt(siteIndex, 10), parseInt(serverIndex, 10));
        }
    }, {
        key: '_selectValue',
        value: function _selectValue() {
            var _props$item = this.props.item,
                siteIndex = _props$item.siteIndex,
                serverIndex = _props$item.serverIndex;

            return siteIndex + ',' + serverIndex;
        }
    }, {
        key: '_getOptions',
        value: function _getOptions() {
            var _this2 = this;

            return this.props.serversBySite.map(function (site, siteIndex) {
                return {
                    label: site.name + ' - ' + site.mentorId,
                    options: site.servers.map(function (server, serverIndex) {
                        var result = { value: siteIndex + ',' + serverIndex };

                        if (_this2.props.serverAliases[server.id]) {
                            result.label = _this2.props.serverAliases[server.id];
                        } else {
                            var platform = server.platform ? ' - ' + server.platform.variant : '';
                            result.label = '' + server.mentorId + platform;
                        }

                        return result;
                    })
                };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var soldTo = this.props.offer.account.soldTo;
            var usesEndDatePicker = this.props.offer.enterprise_deal || _utils2.default.isDateRangeSoldTO(soldTo) || this.props.offer.dailyPricingEnabled;
            var isDateRangeValid = this.props.item.startDate && this.props.item.endDate && (0, _moment2.default)(this.props.item.endDate).isAfter((0, _moment2.default)(this.props.item.startDate));

            return _react2.default.createElement(
                'tr',
                { className: 'cart-item' },
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'b',
                        { className: 'display-block text-lg' },
                        this.props.item.pricing.product.name
                    ),
                    _react2.default.createElement(
                        'b',
                        { className: 'text-mute text-sm' },
                        '#',
                        this.props.item.pricing.product.mentorId
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-left' },
                    _react2.default.createElement(_reactSelectPlus2.default, {
                        className: 'site-server-input',
                        clearable: false,
                        onChange: function onChange(o) {
                            return _this3.onServerChange(o);
                        },
                        value: this._selectValue(),
                        options: this._getOptions()
                    })
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-center', width: '108' },
                    _react2.default.createElement(_SeatInput2.default, {
                        seats: this.props.item.seats,
                        updateSeats: this.props.updateSeats
                    })
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-center' },
                    _react2.default.createElement(_DurationInput2.default, {
                        monthCount: this.props.item.monthCount,
                        weekCount: this.props.item.weekCount,
                        maxMonths: this.props.item.pricing.monthly.length > 0 ? Math.max.apply(Math, _toConsumableArray(this.props.item.pricing.monthly.map(function (m) {
                            return m.amount;
                        }))) : 0,
                        minMonths: this.props.item.pricing.monthly.length > 0 ? Math.min.apply(Math, _toConsumableArray(this.props.item.pricing.monthly.map(function (m) {
                            return m.amount;
                        }))) : 0,
                        offerEnd: this.props.offer.validTo,
                        showWeeks: this.props.offer.weeklyPricingEnabled,
                        startDate: this.props.item.startDate,
                        endDate: this.props.item.endDate,
                        enterprise_deal: this.props.offer.enterprise_deal,
                        updateMonthCount: this.props.updateMonthCount,
                        updateWeekCount: this.props.updateWeekCount,
                        updateStartDate: this.props.updateStartDate,
                        updateDateRange: this.props.updateDateRange,
                        updateEndDate: this.props.updateEndDate,
                        isPricingContinuous: this.props.isPricingContinuous,
                        hasOnlyWeeklyPricing: this.props.hasOnlyWeeklyPricing,
                        prices: this.props.item.pricing,
                        soldto: this.props.offer.account.soldTo,
                        dailyPricingEnabled: this.props.offer.dailyPricingEnabled
                    })
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-center' },
                    _react2.default.createElement(
                        'div',
                        { className: 'price-indicator' },
                        _react2.default.createElement(
                            'b',
                            { className: 'text-info text-lg' },
                            _utils2.default.formatPrice(this.props.item.seatCost)
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'text-xs text-uppercase text-mute' },
                            '/',
                            _strings2.default.seat
                        )
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-center' },
                    _react2.default.createElement(
                        'div',
                        { className: 'subtotal-indicator' },
                        _react2.default.createElement(
                            'b',
                            { className: 'text-info text-lg' },
                            _utils2.default.formatPrice(this.props.item.subtotal)
                        )
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right' },
                    _react2.default.createElement(
                        'div',
                        { className: 'button-group' },
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'add-to-cart-text',
                                'aria-label': _strings2.default.addToCart,
                                hidden: this.props.item.addedToCart || usesEndDatePicker && !isDateRangeValid || this.props.item.monthCount <= 0 && this.props.item.weekCount <= 0,
                                onClick: function onClick() {
                                    return _this3.props.addItemToCart();
                                }
                            },
                            _strings2.default.addToCart
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-item-remove ' + (this.props.item.addedToCart ? 'adjusted' : '') },
                            _react2.default.createElement(
                                'button',
                                {
                                    type: 'button',
                                    className: 'close cart-remove-icon',
                                    'aria-label': _strings2.default.remove,
                                    onClick: function onClick() {
                                        return _this3.props.removeItemFromCart();
                                    } },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'text-danger remove-text' },
                                    _strings2.default.remove
                                ),
                                _react2.default.createElement(
                                    'svg',
                                    { className: 'remove-icon', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' },
                                    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', fill: 'red' }),
                                    _react2.default.createElement('line', { x1: '8', y1: '8', x2: '16', y2: '16', stroke: 'white', strokeWidth: '2' }),
                                    _react2.default.createElement('line', { x1: '16', y1: '8', x2: '8', y2: '16', stroke: 'white', strokeWidth: '2' })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CartItem;
}(_react.Component);

CartItem.propTypes = {
    item: _MapPropTypes2.default.CartItemProps.isRequired,
    offer: _MapPropTypes2.default.OfferProps.isRequired,
    isPricingContinuous: _propTypes2.default.bool.isRequired,
    hasOnlyWeeklyPricing: _propTypes2.default.bool.isRequired,
    serverAliases: _propTypes2.default.object,
    serversBySite: _propTypes2.default.arrayOf(_MapPropTypes2.default.SiteProps).isRequired,
    myself: _MapPropTypes2.default.UserProps,
    removeItemFromCart: _propTypes2.default.func.isRequired,
    updateMonthCount: _propTypes2.default.func.isRequired,
    updateSeats: _propTypes2.default.func.isRequired,
    updateServer: _propTypes2.default.func.isRequired,
    updateStartDate: _propTypes2.default.func.isRequired,
    updateDateRange: _propTypes2.default.func.isRequired,
    updateWeekCount: _propTypes2.default.func.isRequired,
    updateEndDate: _propTypes2.default.func.isRequired,
    addItemToCart: _propTypes2.default.func.isRequired,
    readyForaddToCart: _propTypes2.default.bool,
    editCart: _propTypes2.default.bool
};
exports.default = CartItem;

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeatInput = function (_Component) {
    _inherits(SeatInput, _Component);

    function SeatInput() {
        _classCallCheck(this, SeatInput);

        return _possibleConstructorReturn(this, (SeatInput.__proto__ || Object.getPrototypeOf(SeatInput)).apply(this, arguments));
    }

    _createClass(SeatInput, [{
        key: '_handleSeatChange',
        value: function _handleSeatChange(event) {
            this.props.updateSeats(parseInt(event.target.value, 10));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement('input', {
                value: this.props.seats,
                onChange: function onChange(e) {
                    return _this2._handleSeatChange(e);
                },
                type: 'number',
                step: '1',
                className: 'form-control seat-input',
                min: '1',
                max: '999999'
            });
        }
    }]);

    return SeatInput;
}(_react.Component);

SeatInput.propTypes = {
    updateSeats: _propTypes2.default.func.isRequired,
    seats: _propTypes2.default.number.isRequired
};
exports.default = SeatInput;

/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFlatpickr = __webpack_require__(552);

var _reactFlatpickr2 = _interopRequireDefault(_reactFlatpickr);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrap = __webpack_require__(64);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _Label = __webpack_require__(253);

var _Label2 = _interopRequireDefault(_Label);

var _Continuous = __webpack_require__(1024);

var _Continuous2 = _interopRequireDefault(_Continuous);

var _ContinuousWeekly = __webpack_require__(1025);

var _ContinuousWeekly2 = _interopRequireDefault(_ContinuousWeekly);

var _NonContinuous = __webpack_require__(1026);

var _NonContinuous2 = _interopRequireDefault(_NonContinuous);

var _fc = __webpack_require__(1027);

__webpack_require__(1030);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _DATE_ADVANCE_MAX = 90;
var _WEEK_WRAP = 4;
var _WEEK_MAX = 52;

var DurationInput = function (_Component) {
    _inherits(DurationInput, _Component);

    function DurationInput() {
        _classCallCheck(this, DurationInput);

        var _this = _possibleConstructorReturn(this, (DurationInput.__proto__ || Object.getPrototypeOf(DurationInput)).call(this));

        _this.state = { forceOverflowVisible: false };
        return _this;
    }

    _createClass(DurationInput, [{
        key: '_checkOverflow',
        value: function _checkOverflow(months, weeks) {
            var offerEnd = (0, _moment2.default)(this.props.offerEnd);
            var desiredEnd = (0, _moment2.default)(this.props.startDate).add(months, 'months').add(weeks, 'weeks');
            var overflowEntered = desiredEnd > offerEnd;

            this.setState({ forceOverflowVisible: overflowEntered });

            return overflowEntered;
        }
    }, {
        key: '_handleMonthCountChange',
        value: function _handleMonthCountChange(newValue) {
            var wasReset = false;

            if (newValue > this._getMaxMonths()) {
                wasReset = true;
                newValue = this.props.monthCount;
                this.props.updateWeekCount(0);
            }

            if (newValue != 0 && newValue < this._getMinMonths()) {
                wasReset = true;
                newValue = this.props.monthCount;
            }

            this._checkOverflow(newValue, this.props.weekCount);
            this.props.updateMonthCount(newValue);

            return wasReset;
        }
    }, {
        key: '_handleWeekCountChange',
        value: function _handleWeekCountChange(newValue, isContinousPricing) {
            if (isContinousPricing) {
                var maxWeeks = this._getMaxWeeks();

                if (!this.props.hasOnlyWeeklyPricing && newValue >= maxWeeks) {
                    var addMonths = Math.floor(newValue / maxWeeks);
                    var wasReset = this._handleMonthCountChange(this.props.monthCount + addMonths);

                    newValue = wasReset ? maxWeeks - 1 : newValue % maxWeeks;
                }

                this._checkOverflow(this.props.monthCount, newValue);
            }
            this.props.updateWeekCount(newValue);
        }
    }, {
        key: '_shouldClearCustomEndDate',
        value: function _shouldClearCustomEndDate(newStartDate) {
            var soldTo = (this.props.soldto || '').trim();
            var usesEndDatePicker = this.props.enterprise_deal || soldTo.length > 0 && this._isRenderEndDatePicker(soldTo) || this.props.dailyPricingEnabled;

            return Boolean(usesEndDatePicker && this.props.endDate && (0, _moment2.default)(this.props.endDate).isBefore(newStartDate.clone().add(1, 'day')));
        }
    }, {
        key: '_handleStartDateChange',
        value: function _handleStartDateChange(event) {
            var newStartDate = (0, _moment2.default)(event[0]).startOf('day');
            var startDate = newStartDate.toISOString();

            if (this._shouldClearCustomEndDate(newStartDate)) {
                this.props.updateDateRange(startDate, '');
            } else {
                this.props.updateStartDate(startDate);
            }

            if (this._getMaxMonths() < this.props.monthCount) {
                this.props.updateMonthCount(this._getMaxMonths());
            }
        }
    }, {
        key: '_handleEndDateChange',
        value: function _handleEndDateChange(event) {
            this.props.updateEndDate(event[0].toISOString());
            // if (this._getMaxMonths() < this.props.monthCount) {
            //     this.props.updateMonthCount(this._getMaxMonths());
            // }
        }
    }, {
        key: '_getMaxMonths',
        value: function _getMaxMonths() {
            var offerEnd = (0, _moment2.default)(this.props.offerEnd);
            var offerDelta = _moment2.default.duration((0, _moment2.default)(offerEnd).diff((0, _moment2.default)(this.props.startDate)));
            var offerMax = Math.ceil(offerDelta.asMonths());

            if (offerMax < this.props.maxMonths) {
                return offerMax;
            }

            return this.props.maxMonths;
        }
    }, {
        key: '_getMinMonths',
        value: function _getMinMonths() {
            return this.props.minMonths;
        }
    }, {
        key: '_getMaxWeeks',
        value: function _getMaxWeeks() {
            if (this.props.hasOnlyWeeklyPricing) {
                return _WEEK_MAX;
            }

            if (this.props.monthCount === this.props.maxMonths) {
                return 0;
            }

            return _WEEK_WRAP;
        }
    }, {
        key: '_durationOverflow',
        value: function _durationOverflow() {
            return this.state.forceOverflowVisible || (0, _moment2.default)(this.props.startDate).add(this.props.monthCount, 'months') > (0, _moment2.default)(this.props.offerEnd);
        }
    }, {
        key: '_getEndDate',
        value: function _getEndDate() {
            var result = (0, _moment2.default)(this.props.startDate).add(this.props.monthCount, 'months');

            if (this.props.showWeeks) {
                result = result.add(this.props.weekCount, 'weeks');
            }

            return result.format('L');
        }
    }, {
        key: '_getMaxStartDate',
        value: function _getMaxStartDate() {
            var offerEnd = (0, _moment2.default)(this.props.offerEnd);
            var advanceMax = (0, _moment2.default)().add(_DATE_ADVANCE_MAX, 'days');

            if (advanceMax > offerEnd) {
                return offerEnd.toISOString();
            }

            return advanceMax.toISOString();
        }
    }, {
        key: '_getMaxEndDate',
        value: function _getMaxEndDate() {
            var startDate = (0, _moment2.default)(this.props.startDate);
            var endDate = startDate.clone();
            if (this.props.hasOnlyWeeklyPricing) {
                // If offer has only weekly pricing, set max end date to 4 weeks from start date
                endDate = endDate.add(4, 'w').toISOString();
            } else if (this.props.dailyPricingEnabled) {
                // If offer has only daily pricing, calculate the end date by adding 12 months to the startDate
                endDate = endDate.add(12, 'months');
            } else {
                // Calculate the end date by adding maxMonths to the startDate
                endDate = endDate.add(this.props.maxMonths, 'months');
            }
            // Ensure the end date does not exceed the offer end date
            var offerEndDate = (0, _moment2.default)(this.props.offerEnd);
            var restrictedEndDate = endDate.isAfter(offerEndDate) ? offerEndDate : endDate;
            return restrictedEndDate.toISOString();
        }
    }, {
        key: '_renderDatePicker',
        value: function _renderDatePicker() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactFlatpickr2.default, {
                    onChange: function onChange(e) {
                        return _this2._handleStartDateChange(e);
                    },
                    placeholder: _strings2.default.chooseDate,
                    className: 'form-control datepicker m-r-xs flatpickr-input required',
                    value: this.props.startDate,
                    options: {
                        maxDate: this._getMaxStartDate(),
                        minDate: (0, _moment2.default)().startOf('day').toISOString(),
                        dateFormat: _utils.FLATPICKR_FORMAT
                    }
                }),
                _react2.default.createElement(_Label2.default, { s: 'startDate' })
            );
        }
    }, {
        key: '_renderEndDatePicker',
        value: function _renderEndDatePicker() {
            var _this3 = this;

            var jumpDate = this.props.endDate ? (0, _moment2.default)(this.props.endDate).startOf('day').toDate() : (0, _moment2.default)(this.props.startDate).startOf('day').add(1, 'day').toDate();

            return _react2.default.createElement(
                'div',
                { style: { paddingLeft: "0.5em" } },
                _react2.default.createElement(_reactFlatpickr2.default, {
                    key: this.props.startDate,
                    onChange: function onChange(e) {
                        return _this3._handleEndDateChange(e);
                    },
                    placeholder: _strings2.default.chooseDate,
                    className: 'form-control datepicker m-r-xs flatpickr-input required',
                    value: this.props.endDate,
                    options: {
                        maxDate: this._getMaxEndDate(),
                        minDate: (0, _moment2.default)(this.props.startDate).startOf('day').add(1, 'day').toDate(),
                        dateFormat: _utils.FLATPICKR_FORMAT,
                        onReady: function onReady(_, __, instance) {
                            return instance.jumpToDate(jumpDate);
                        },
                        onOpen: function onOpen(_, __, instance) {
                            return instance.jumpToDate(jumpDate);
                        }
                    }
                }),
                _react2.default.createElement(_Label2.default, { s: 'endDate' })
            );
        }
    }, {
        key: '_renderOverflowWarning',
        value: function _renderOverflowWarning() {
            if (!this._isRenderEndDatePicker(this.props.soldto.trim()) && !this.props.enterprise_deal && !this.props.dailyPricingEnabled) {
                if (this._durationOverflow()) {
                    var key = String(Math.random());
                    var tooltip = _react2.default.createElement(
                        _reactBootstrap.Tooltip,
                        { id: key },
                        _strings2.default.durationOverflow
                    );

                    return _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            _reactBootstrap.OverlayTrigger,
                            {
                                key: key,
                                placement: 'right',
                                trigger: ['hover', 'focus'],
                                overlay: tooltip
                            },
                            _react2.default.createElement(
                                'span',
                                { className: 'label label-default text-center display-block overflow-warning' },
                                'End Date: ' + this._getEndDate() + '       ',
                                _react2.default.createElement(_fc.FcExpired, null)
                            )
                        )
                    );
                } else {
                    return _react2.default.createElement(
                        'span',
                        { className: 'label label-default text-center display-block overflow-warning' },
                        'End Date: ',
                        this._getEndDate()
                    );
                }
            }
            return null;
        }
    }, {
        key: '_isRenderEndDatePicker',
        value: function _isRenderEndDatePicker(soldTo) {
            var eligibleSoldTos = "201876".split(',');
            return eligibleSoldTos.includes(soldTo);
        }
    }, {
        key: '_renderInput',
        value: function _renderInput() {
            var _this4 = this;

            var baseAttr = {
                showWeeks: this.props.showWeeks,
                monthCount: this.props.monthCount,
                weekCount: this.props.weekCount,
                updateMonthCount: function updateMonthCount(newValue) {
                    return _this4._handleMonthCountChange(newValue);
                },
                maxMonths: this._getMaxMonths(),
                minMonths: this - this._getMinMonths(),
                maxWeeks: this._getMaxWeeks(),
                onBlur: function onBlur() {
                    return _this4.setState({ forceOverflowVisible: false });
                },
                prices: this.props.prices
            };
            var soldTo = this.props.soldto.trim();

            if (this.props.enterprise_deal || soldTo.length > 0 && this._isRenderEndDatePicker(soldTo) || this.props.dailyPricingEnabled) {
                return this._renderEndDatePicker();
            }

            if (this.props.hasOnlyWeeklyPricing) {
                return _react2.default.createElement(_ContinuousWeekly2.default, _extends({}, baseAttr, {
                    updateWeekCount: function updateWeekCount(newValue) {
                        return _this4._handleWeekCountChange(newValue, true);
                    }
                }));
            }

            if (this.props.isPricingContinuous) {
                return _react2.default.createElement(_Continuous2.default, _extends({}, baseAttr, {
                    updateWeekCount: function updateWeekCount(newValue) {
                        return _this4._handleWeekCountChange(newValue, true);
                    }
                }));
            }

            return _react2.default.createElement(_NonContinuous2.default, _extends({}, baseAttr, {
                updateWeekCount: function updateWeekCount(newValue) {
                    return _this4._handleWeekCountChange(newValue, false);
                }
            }));
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                { className: 'duration-input' },
                _react2.default.createElement(
                    'div',
                    { className: 'row row-flush m-b-xs' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-6' },
                        this._renderDatePicker()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-6' },
                        this._renderInput()
                    )
                ),
                this._renderOverflowWarning()
            );
        }
    }]);

    return DurationInput;
}(_react.Component);

DurationInput.propTypes = {
    hasOnlyWeeklyPricing: _propTypes2.default.bool.isRequired,
    isPricingContinuous: _propTypes2.default.bool.isRequired,
    maxMonths: _propTypes2.default.number.isRequired,
    minMonths: _propTypes2.default.number.isRequired,
    monthCount: _propTypes2.default.number.isRequired,
    offerEnd: _propTypes2.default.string.isRequired,
    prices: _MapPropTypes2.default.PricingProps.isRequired,
    showWeeks: _propTypes2.default.bool.isRequired,
    startDate: _propTypes2.default.string.isRequired,
    updateMonthCount: _propTypes2.default.func.isRequired,
    updateStartDate: _propTypes2.default.func.isRequired,
    updateDateRange: _propTypes2.default.func.isRequired,
    updateEndDate: _propTypes2.default.func.isRequired,
    updateWeekCount: _propTypes2.default.func.isRequired,
    weekCount: _propTypes2.default.number.isRequired,
    soldto: _propTypes2.default.string,
    endDate: _propTypes2.default.string,
    enterprise_deal: _propTypes2.default.bool,
    dailyPricingEnabled: _propTypes2.default.bool
};
exports.default = DurationInput;

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _Label = __webpack_require__(253);

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Continuous = function (_Component) {
    _inherits(Continuous, _Component);

    function Continuous(props) {
        _classCallCheck(this, Continuous);

        return _possibleConstructorReturn(this, (Continuous.__proto__ || Object.getPrototypeOf(Continuous)).call(this, props));
    }

    _createClass(Continuous, [{
        key: '_renderMonthInput',
        value: function _renderMonthInput() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', {
                    value: this.props.monthCount,
                    onChange: function onChange(e) {
                        return _this2.props.updateMonthCount(parseInt(e.target.value, 10));
                    },
                    onBlur: function onBlur() {
                        return _this2.props.onBlur();
                    },
                    type: 'number',
                    className: 'form-control m-l-xs',
                    step: '1',
                    min: this.props.showWeeks ? 0 : this.props.minMonths,
                    max: this.props.maxMonths
                }),
                _react2.default.createElement(_Label2.default, { s: 'months' })
            );
        }
    }, {
        key: '_renderWeekInput',
        value: function _renderWeekInput() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', {
                    value: this.props.weekCount,
                    onChange: function onChange(e) {
                        return _this3.props.updateWeekCount(parseInt(e.target.value, 10));
                    },
                    onBlur: function onBlur() {
                        return _this3.props.onBlur();
                    },
                    type: 'number',
                    className: 'form-control m-l-xs',
                    step: '1',
                    min: '0',
                    max: this.props.maxWeeks
                }),
                _react2.default.createElement(_Label2.default, { s: 'weeks' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'row m-a-0' },
                _react2.default.createElement(
                    'div',
                    {
                        className: this.props.showWeeks ? 'col-xs-6 p-a-0' : 'col-xs-12'
                    },
                    this._renderMonthInput()
                ),
                this.props.showWeeks && _react2.default.createElement(
                    'div',
                    { className: 'p-a-0 p-l-xs col-xs-6' },
                    this._renderWeekInput()
                )
            );
        }
    }]);

    return Continuous;
}(_react.Component);

Continuous.propTypes = {
    maxMonths: _propTypes2.default.number.isRequired,
    minMonths: _propTypes2.default.number.isRequired,
    maxWeeks: _propTypes2.default.number.isRequired,
    monthCount: _propTypes2.default.number.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    prices: _MapPropTypes2.default.PricingProps.isRequired,
    showWeeks: _propTypes2.default.bool,
    updateMonthCount: _propTypes2.default.func.isRequired,
    updateWeekCount: _propTypes2.default.func,
    weekCount: _propTypes2.default.number
};
exports.default = Continuous;

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _Label = __webpack_require__(253);

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContinuousWeekly = function (_Component) {
    _inherits(ContinuousWeekly, _Component);

    function ContinuousWeekly(props) {
        _classCallCheck(this, ContinuousWeekly);

        return _possibleConstructorReturn(this, (ContinuousWeekly.__proto__ || Object.getPrototypeOf(ContinuousWeekly)).call(this, props));
    }

    _createClass(ContinuousWeekly, [{
        key: '_renderWeekInput',
        value: function _renderWeekInput() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', {
                    value: this.props.weekCount || 1,
                    onChange: function onChange(e) {
                        return _this2.props.updateWeekCount(parseInt(e.target.value, 10));
                    },
                    onBlur: function onBlur() {
                        return _this2.props.onBlur();
                    },
                    type: 'number',
                    className: 'form-control m-l-xs',
                    step: '1',
                    min: '1',
                    max: this.props.maxWeeks
                }),
                _react2.default.createElement(_Label2.default, { s: 'weeks' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'row m-a-0' },
                this.props.showWeeks && _react2.default.createElement(
                    'div',
                    { className: 'p-a-0 col-xs-12' },
                    this._renderWeekInput()
                )
            );
        }
    }]);

    return ContinuousWeekly;
}(_react.Component);

ContinuousWeekly.propTypes = {
    maxMonths: _propTypes2.default.number.isRequired, // unused
    maxWeeks: _propTypes2.default.number.isRequired,
    monthCount: _propTypes2.default.number.isRequired, // unused
    onBlur: _propTypes2.default.func.isRequired,
    prices: _MapPropTypes2.default.PricingProps.isRequired, // unused
    showWeeks: _propTypes2.default.bool,
    updateMonthCount: _propTypes2.default.func.isRequired, // unused
    updateWeekCount: _propTypes2.default.func,
    weekCount: _propTypes2.default.number
};
exports.default = ContinuousWeekly;

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NonContinuous = function (_Component) {
    _inherits(NonContinuous, _Component);

    function NonContinuous(props) {
        _classCallCheck(this, NonContinuous);

        return _possibleConstructorReturn(this, (NonContinuous.__proto__ || Object.getPrototypeOf(NonContinuous)).call(this, props));
    }

    _createClass(NonContinuous, [{
        key: '_getValue',
        value: function _getValue() {
            if (this.props.weekCount) {
                return '1 week';
            }
            return this.props.monthCount + ' month';
        }
    }, {
        key: '_onChange',
        value: function _onChange(value) {
            var _value$split = value.split(' '),
                _value$split2 = _slicedToArray(_value$split, 2),
                amount = _value$split2[0],
                increment = _value$split2[1];

            var months = increment === 'week' ? 0 : Number(amount);
            var weeks = increment === 'month' ? 0 : Number(amount);

            this.props.updateWeekCount(weeks);
            this.props.updateMonthCount(months);
        }
    }, {
        key: '_renderOptions',
        value: function _renderOptions() {
            var result = [];

            this.props.showWeeks && this.props.prices.weekly.forEach(function (price) {
                var value = price.amount + ' week';
                result.push(_react2.default.createElement(
                    'option',
                    { key: value, value: value },
                    price.amount,
                    ' ',
                    _strings2.default.weekAbbr
                ));
            });

            this.props.prices.monthly.forEach(function (price) {
                var value = price.amount + ' month';
                result.push(_react2.default.createElement(
                    'option',
                    { key: value, value: value },
                    price.amount,
                    ' ',
                    _strings2.default.monthAbbr
                ));
            });

            return result;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                    'div',
                    { className: 'm-l-xs col-xs-12' },
                    _react2.default.createElement(
                        'select',
                        {
                            className: 'form-control p-y-sm',
                            value: this._getValue(),
                            onChange: function onChange(e) {
                                return _this2._onChange(e.target.value);
                            }
                        },
                        this._renderOptions()
                    )
                )
            );
        }
    }]);

    return NonContinuous;
}(_react.Component);

NonContinuous.propTypes = {
    maxMonths: _propTypes2.default.number.isRequired, // unused
    maxWeeks: _propTypes2.default.number.isRequired, // unused
    monthCount: _propTypes2.default.number.isRequired,
    onBlur: _propTypes2.default.func.isRequired, // unused
    prices: _MapPropTypes2.default.PricingProps.isRequired,
    showWeeks: _propTypes2.default.bool,
    updateMonthCount: _propTypes2.default.func.isRequired,
    updateWeekCount: _propTypes2.default.func,
    weekCount: _propTypes2.default.number
};
exports.default = NonContinuous;

/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["FcAbout"] = FcAbout;
/* harmony export (immutable) */ __webpack_exports__["FcAcceptDatabase"] = FcAcceptDatabase;
/* harmony export (immutable) */ __webpack_exports__["FcAddColumn"] = FcAddColumn;
/* harmony export (immutable) */ __webpack_exports__["FcAddDatabase"] = FcAddDatabase;
/* harmony export (immutable) */ __webpack_exports__["FcAddImage"] = FcAddImage;
/* harmony export (immutable) */ __webpack_exports__["FcAddRow"] = FcAddRow;
/* harmony export (immutable) */ __webpack_exports__["FcAddressBook"] = FcAddressBook;
/* harmony export (immutable) */ __webpack_exports__["FcAdvance"] = FcAdvance;
/* harmony export (immutable) */ __webpack_exports__["FcAdvertising"] = FcAdvertising;
/* harmony export (immutable) */ __webpack_exports__["FcAlarmClock"] = FcAlarmClock;
/* harmony export (immutable) */ __webpack_exports__["FcAlphabeticalSortingAz"] = FcAlphabeticalSortingAz;
/* harmony export (immutable) */ __webpack_exports__["FcAlphabeticalSortingZa"] = FcAlphabeticalSortingZa;
/* harmony export (immutable) */ __webpack_exports__["FcAndroidOs"] = FcAndroidOs;
/* harmony export (immutable) */ __webpack_exports__["FcAnswers"] = FcAnswers;
/* harmony export (immutable) */ __webpack_exports__["FcApproval"] = FcApproval;
/* harmony export (immutable) */ __webpack_exports__["FcApprove"] = FcApprove;
/* harmony export (immutable) */ __webpack_exports__["FcAreaChart"] = FcAreaChart;
/* harmony export (immutable) */ __webpack_exports__["FcAssistant"] = FcAssistant;
/* harmony export (immutable) */ __webpack_exports__["FcAudioFile"] = FcAudioFile;
/* harmony export (immutable) */ __webpack_exports__["FcAutomatic"] = FcAutomatic;
/* harmony export (immutable) */ __webpack_exports__["FcAutomotive"] = FcAutomotive;
/* harmony export (immutable) */ __webpack_exports__["FcBadDecision"] = FcBadDecision;
/* harmony export (immutable) */ __webpack_exports__["FcBarChart"] = FcBarChart;
/* harmony export (immutable) */ __webpack_exports__["FcBbc"] = FcBbc;
/* harmony export (immutable) */ __webpack_exports__["FcBearish"] = FcBearish;
/* harmony export (immutable) */ __webpack_exports__["FcBinoculars"] = FcBinoculars;
/* harmony export (immutable) */ __webpack_exports__["FcBiohazard"] = FcBiohazard;
/* harmony export (immutable) */ __webpack_exports__["FcBiomass"] = FcBiomass;
/* harmony export (immutable) */ __webpack_exports__["FcBiotech"] = FcBiotech;
/* harmony export (immutable) */ __webpack_exports__["FcBookmark"] = FcBookmark;
/* harmony export (immutable) */ __webpack_exports__["FcBriefcase"] = FcBriefcase;
/* harmony export (immutable) */ __webpack_exports__["FcBrokenLink"] = FcBrokenLink;
/* harmony export (immutable) */ __webpack_exports__["FcBullish"] = FcBullish;
/* harmony export (immutable) */ __webpack_exports__["FcBusinessContact"] = FcBusinessContact;
/* harmony export (immutable) */ __webpack_exports__["FcBusiness"] = FcBusiness;
/* harmony export (immutable) */ __webpack_exports__["FcBusinessman"] = FcBusinessman;
/* harmony export (immutable) */ __webpack_exports__["FcBusinesswoman"] = FcBusinesswoman;
/* harmony export (immutable) */ __webpack_exports__["FcButtingIn"] = FcButtingIn;
/* harmony export (immutable) */ __webpack_exports__["FcCableRelease"] = FcCableRelease;
/* harmony export (immutable) */ __webpack_exports__["FcCalculator"] = FcCalculator;
/* harmony export (immutable) */ __webpack_exports__["FcCalendar"] = FcCalendar;
/* harmony export (immutable) */ __webpack_exports__["FcCallTransfer"] = FcCallTransfer;
/* harmony export (immutable) */ __webpack_exports__["FcCallback"] = FcCallback;
/* harmony export (immutable) */ __webpack_exports__["FcCamcorderPro"] = FcCamcorderPro;
/* harmony export (immutable) */ __webpack_exports__["FcCamcorder"] = FcCamcorder;
/* harmony export (immutable) */ __webpack_exports__["FcCameraAddon"] = FcCameraAddon;
/* harmony export (immutable) */ __webpack_exports__["FcCameraIdentification"] = FcCameraIdentification;
/* harmony export (immutable) */ __webpack_exports__["FcCamera"] = FcCamera;
/* harmony export (immutable) */ __webpack_exports__["FcCancel"] = FcCancel;
/* harmony export (immutable) */ __webpack_exports__["FcCandleSticks"] = FcCandleSticks;
/* harmony export (immutable) */ __webpack_exports__["FcCapacitor"] = FcCapacitor;
/* harmony export (immutable) */ __webpack_exports__["FcCdLogo"] = FcCdLogo;
/* harmony export (immutable) */ __webpack_exports__["FcCellPhone"] = FcCellPhone;
/* harmony export (immutable) */ __webpack_exports__["FcChargeBattery"] = FcChargeBattery;
/* harmony export (immutable) */ __webpack_exports__["FcCheckmark"] = FcCheckmark;
/* harmony export (immutable) */ __webpack_exports__["FcCircuit"] = FcCircuit;
/* harmony export (immutable) */ __webpack_exports__["FcClapperboard"] = FcClapperboard;
/* harmony export (immutable) */ __webpack_exports__["FcClearFilters"] = FcClearFilters;
/* harmony export (immutable) */ __webpack_exports__["FcClock"] = FcClock;
/* harmony export (immutable) */ __webpack_exports__["FcCloseUpMode"] = FcCloseUpMode;
/* harmony export (immutable) */ __webpack_exports__["FcCloth"] = FcCloth;
/* harmony export (immutable) */ __webpack_exports__["FcCollaboration"] = FcCollaboration;
/* harmony export (immutable) */ __webpack_exports__["FcCollapse"] = FcCollapse;
/* harmony export (immutable) */ __webpack_exports__["FcCollect"] = FcCollect;
/* harmony export (immutable) */ __webpack_exports__["FcComboChart"] = FcComboChart;
/* harmony export (immutable) */ __webpack_exports__["FcCommandLine"] = FcCommandLine;
/* harmony export (immutable) */ __webpack_exports__["FcComments"] = FcComments;
/* harmony export (immutable) */ __webpack_exports__["FcCompactCamera"] = FcCompactCamera;
/* harmony export (immutable) */ __webpack_exports__["FcConferenceCall"] = FcConferenceCall;
/* harmony export (immutable) */ __webpack_exports__["FcContacts"] = FcContacts;
/* harmony export (immutable) */ __webpack_exports__["FcCopyleft"] = FcCopyleft;
/* harmony export (immutable) */ __webpack_exports__["FcCopyright"] = FcCopyright;
/* harmony export (immutable) */ __webpack_exports__["FcCrystalOscillator"] = FcCrystalOscillator;
/* harmony export (immutable) */ __webpack_exports__["FcCurrencyExchange"] = FcCurrencyExchange;
/* harmony export (immutable) */ __webpack_exports__["FcCursor"] = FcCursor;
/* harmony export (immutable) */ __webpack_exports__["FcCustomerSupport"] = FcCustomerSupport;
/* harmony export (immutable) */ __webpack_exports__["FcDam"] = FcDam;
/* harmony export (immutable) */ __webpack_exports__["FcDataBackup"] = FcDataBackup;
/* harmony export (immutable) */ __webpack_exports__["FcDataConfiguration"] = FcDataConfiguration;
/* harmony export (immutable) */ __webpack_exports__["FcDataEncryption"] = FcDataEncryption;
/* harmony export (immutable) */ __webpack_exports__["FcDataProtection"] = FcDataProtection;
/* harmony export (immutable) */ __webpack_exports__["FcDataRecovery"] = FcDataRecovery;
/* harmony export (immutable) */ __webpack_exports__["FcDataSheet"] = FcDataSheet;
/* harmony export (immutable) */ __webpack_exports__["FcDatabase"] = FcDatabase;
/* harmony export (immutable) */ __webpack_exports__["FcDebian"] = FcDebian;
/* harmony export (immutable) */ __webpack_exports__["FcDebt"] = FcDebt;
/* harmony export (immutable) */ __webpack_exports__["FcDecision"] = FcDecision;
/* harmony export (immutable) */ __webpack_exports__["FcDeleteColumn"] = FcDeleteColumn;
/* harmony export (immutable) */ __webpack_exports__["FcDeleteDatabase"] = FcDeleteDatabase;
/* harmony export (immutable) */ __webpack_exports__["FcDeleteRow"] = FcDeleteRow;
/* harmony export (immutable) */ __webpack_exports__["FcDepartment"] = FcDepartment;
/* harmony export (immutable) */ __webpack_exports__["FcDeployment"] = FcDeployment;
/* harmony export (immutable) */ __webpack_exports__["FcDiploma1"] = FcDiploma1;
/* harmony export (immutable) */ __webpack_exports__["FcDiploma2"] = FcDiploma2;
/* harmony export (immutable) */ __webpack_exports__["FcDisapprove"] = FcDisapprove;
/* harmony export (immutable) */ __webpack_exports__["FcDisclaimer"] = FcDisclaimer;
/* harmony export (immutable) */ __webpack_exports__["FcDislike"] = FcDislike;
/* harmony export (immutable) */ __webpack_exports__["FcDisplay"] = FcDisplay;
/* harmony export (immutable) */ __webpack_exports__["FcDoNotInhale"] = FcDoNotInhale;
/* harmony export (immutable) */ __webpack_exports__["FcDoNotInsert"] = FcDoNotInsert;
/* harmony export (immutable) */ __webpack_exports__["FcDoNotMix"] = FcDoNotMix;
/* harmony export (immutable) */ __webpack_exports__["FcDocument"] = FcDocument;
/* harmony export (immutable) */ __webpack_exports__["FcDonate"] = FcDonate;
/* harmony export (immutable) */ __webpack_exports__["FcDoughnutChart"] = FcDoughnutChart;
/* harmony export (immutable) */ __webpack_exports__["FcDownLeft"] = FcDownLeft;
/* harmony export (immutable) */ __webpack_exports__["FcDownRight"] = FcDownRight;
/* harmony export (immutable) */ __webpack_exports__["FcDown"] = FcDown;
/* harmony export (immutable) */ __webpack_exports__["FcDownload"] = FcDownload;
/* harmony export (immutable) */ __webpack_exports__["FcDribbble"] = FcDribbble;
/* harmony export (immutable) */ __webpack_exports__["FcDvdLogo"] = FcDvdLogo;
/* harmony export (immutable) */ __webpack_exports__["FcEditImage"] = FcEditImage;
/* harmony export (immutable) */ __webpack_exports__["FcElectricalSensor"] = FcElectricalSensor;
/* harmony export (immutable) */ __webpack_exports__["FcElectricalThreshold"] = FcElectricalThreshold;
/* harmony export (immutable) */ __webpack_exports__["FcElectricity"] = FcElectricity;
/* harmony export (immutable) */ __webpack_exports__["FcElectroDevices"] = FcElectroDevices;
/* harmony export (immutable) */ __webpack_exports__["FcElectronics"] = FcElectronics;
/* harmony export (immutable) */ __webpack_exports__["FcEmptyBattery"] = FcEmptyBattery;
/* harmony export (immutable) */ __webpack_exports__["FcEmptyFilter"] = FcEmptyFilter;
/* harmony export (immutable) */ __webpack_exports__["FcEmptyTrash"] = FcEmptyTrash;
/* harmony export (immutable) */ __webpack_exports__["FcEndCall"] = FcEndCall;
/* harmony export (immutable) */ __webpack_exports__["FcEngineering"] = FcEngineering;
/* harmony export (immutable) */ __webpack_exports__["FcEnteringHeavenAlive"] = FcEnteringHeavenAlive;
/* harmony export (immutable) */ __webpack_exports__["FcExpand"] = FcExpand;
/* harmony export (immutable) */ __webpack_exports__["FcExpired"] = FcExpired;
/* harmony export (immutable) */ __webpack_exports__["FcExport"] = FcExport;
/* harmony export (immutable) */ __webpack_exports__["FcExternal"] = FcExternal;
/* harmony export (immutable) */ __webpack_exports__["FcFactoryBreakdown"] = FcFactoryBreakdown;
/* harmony export (immutable) */ __webpack_exports__["FcFactory"] = FcFactory;
/* harmony export (immutable) */ __webpack_exports__["FcFaq"] = FcFaq;
/* harmony export (immutable) */ __webpack_exports__["FcFeedIn"] = FcFeedIn;
/* harmony export (immutable) */ __webpack_exports__["FcFeedback"] = FcFeedback;
/* harmony export (immutable) */ __webpack_exports__["FcFile"] = FcFile;
/* harmony export (immutable) */ __webpack_exports__["FcFilingCabinet"] = FcFilingCabinet;
/* harmony export (immutable) */ __webpack_exports__["FcFilledFilter"] = FcFilledFilter;
/* harmony export (immutable) */ __webpack_exports__["FcFilmReel"] = FcFilmReel;
/* harmony export (immutable) */ __webpack_exports__["FcFilm"] = FcFilm;
/* harmony export (immutable) */ __webpack_exports__["FcFinePrint"] = FcFinePrint;
/* harmony export (immutable) */ __webpack_exports__["FcFlashAuto"] = FcFlashAuto;
/* harmony export (immutable) */ __webpack_exports__["FcFlashOff"] = FcFlashOff;
/* harmony export (immutable) */ __webpack_exports__["FcFlashOn"] = FcFlashOn;
/* harmony export (immutable) */ __webpack_exports__["FcFlowChart"] = FcFlowChart;
/* harmony export (immutable) */ __webpack_exports__["FcFolder"] = FcFolder;
/* harmony export (immutable) */ __webpack_exports__["FcFrame"] = FcFrame;
/* harmony export (immutable) */ __webpack_exports__["FcFullBattery"] = FcFullBattery;
/* harmony export (immutable) */ __webpack_exports__["FcFullTrash"] = FcFullTrash;
/* harmony export (immutable) */ __webpack_exports__["FcGallery"] = FcGallery;
/* harmony export (immutable) */ __webpack_exports__["FcGenealogy"] = FcGenealogy;
/* harmony export (immutable) */ __webpack_exports__["FcGenericSortingAsc"] = FcGenericSortingAsc;
/* harmony export (immutable) */ __webpack_exports__["FcGenericSortingDesc"] = FcGenericSortingDesc;
/* harmony export (immutable) */ __webpack_exports__["FcGlobe"] = FcGlobe;
/* harmony export (immutable) */ __webpack_exports__["FcGoodDecision"] = FcGoodDecision;
/* harmony export (immutable) */ __webpack_exports__["FcGoogle"] = FcGoogle;
/* harmony export (immutable) */ __webpack_exports__["FcGraduationCap"] = FcGraduationCap;
/* harmony export (immutable) */ __webpack_exports__["FcGrid"] = FcGrid;
/* harmony export (immutable) */ __webpack_exports__["FcHeadset"] = FcHeadset;
/* harmony export (immutable) */ __webpack_exports__["FcHeatMap"] = FcHeatMap;
/* harmony export (immutable) */ __webpack_exports__["FcHighBattery"] = FcHighBattery;
/* harmony export (immutable) */ __webpack_exports__["FcHighPriority"] = FcHighPriority;
/* harmony export (immutable) */ __webpack_exports__["FcHome"] = FcHome;
/* harmony export (immutable) */ __webpack_exports__["FcIcons8Cup"] = FcIcons8Cup;
/* harmony export (immutable) */ __webpack_exports__["FcIdea"] = FcIdea;
/* harmony export (immutable) */ __webpack_exports__["FcImageFile"] = FcImageFile;
/* harmony export (immutable) */ __webpack_exports__["FcImport"] = FcImport;
/* harmony export (immutable) */ __webpack_exports__["FcInTransit"] = FcInTransit;
/* harmony export (immutable) */ __webpack_exports__["FcInfo"] = FcInfo;
/* harmony export (immutable) */ __webpack_exports__["FcInspection"] = FcInspection;
/* harmony export (immutable) */ __webpack_exports__["FcIntegratedWebcam"] = FcIntegratedWebcam;
/* harmony export (immutable) */ __webpack_exports__["FcInternal"] = FcInternal;
/* harmony export (immutable) */ __webpack_exports__["FcInvite"] = FcInvite;
/* harmony export (immutable) */ __webpack_exports__["FcIpad"] = FcIpad;
/* harmony export (immutable) */ __webpack_exports__["FcIphone"] = FcIphone;
/* harmony export (immutable) */ __webpack_exports__["FcKey"] = FcKey;
/* harmony export (immutable) */ __webpack_exports__["FcKindle"] = FcKindle;
/* harmony export (immutable) */ __webpack_exports__["FcLandscape"] = FcLandscape;
/* harmony export (immutable) */ __webpack_exports__["FcLeave"] = FcLeave;
/* harmony export (immutable) */ __webpack_exports__["FcLeftDown"] = FcLeftDown;
/* harmony export (immutable) */ __webpack_exports__["FcLeftDown2"] = FcLeftDown2;
/* harmony export (immutable) */ __webpack_exports__["FcLeftUp"] = FcLeftUp;
/* harmony export (immutable) */ __webpack_exports__["FcLeftUp2"] = FcLeftUp2;
/* harmony export (immutable) */ __webpack_exports__["FcLeft"] = FcLeft;
/* harmony export (immutable) */ __webpack_exports__["FcLibrary"] = FcLibrary;
/* harmony export (immutable) */ __webpack_exports__["FcLightAtTheEndOfTunnel"] = FcLightAtTheEndOfTunnel;
/* harmony export (immutable) */ __webpack_exports__["FcLikePlaceholder"] = FcLikePlaceholder;
/* harmony export (immutable) */ __webpack_exports__["FcLike"] = FcLike;
/* harmony export (immutable) */ __webpack_exports__["FcLineChart"] = FcLineChart;
/* harmony export (immutable) */ __webpack_exports__["FcLink"] = FcLink;
/* harmony export (immutable) */ __webpack_exports__["FcLinux"] = FcLinux;
/* harmony export (immutable) */ __webpack_exports__["FcList"] = FcList;
/* harmony export (immutable) */ __webpack_exports__["FcLockLandscape"] = FcLockLandscape;
/* harmony export (immutable) */ __webpack_exports__["FcLockPortrait"] = FcLockPortrait;
/* harmony export (immutable) */ __webpack_exports__["FcLock"] = FcLock;
/* harmony export (immutable) */ __webpack_exports__["FcLowBattery"] = FcLowBattery;
/* harmony export (immutable) */ __webpack_exports__["FcLowPriority"] = FcLowPriority;
/* harmony export (immutable) */ __webpack_exports__["FcMakeDecision"] = FcMakeDecision;
/* harmony export (immutable) */ __webpack_exports__["FcManager"] = FcManager;
/* harmony export (immutable) */ __webpack_exports__["FcMediumPriority"] = FcMediumPriority;
/* harmony export (immutable) */ __webpack_exports__["FcMenu"] = FcMenu;
/* harmony export (immutable) */ __webpack_exports__["FcMiddleBattery"] = FcMiddleBattery;
/* harmony export (immutable) */ __webpack_exports__["FcMindMap"] = FcMindMap;
/* harmony export (immutable) */ __webpack_exports__["FcMinus"] = FcMinus;
/* harmony export (immutable) */ __webpack_exports__["FcMissedCall"] = FcMissedCall;
/* harmony export (immutable) */ __webpack_exports__["FcMms"] = FcMms;
/* harmony export (immutable) */ __webpack_exports__["FcMoneyTransfer"] = FcMoneyTransfer;
/* harmony export (immutable) */ __webpack_exports__["FcMultipleCameras"] = FcMultipleCameras;
/* harmony export (immutable) */ __webpack_exports__["FcMultipleDevices"] = FcMultipleDevices;
/* harmony export (immutable) */ __webpack_exports__["FcMultipleInputs"] = FcMultipleInputs;
/* harmony export (immutable) */ __webpack_exports__["FcMultipleSmartphones"] = FcMultipleSmartphones;
/* harmony export (immutable) */ __webpack_exports__["FcMusic"] = FcMusic;
/* harmony export (immutable) */ __webpack_exports__["FcNegativeDynamic"] = FcNegativeDynamic;
/* harmony export (immutable) */ __webpack_exports__["FcNeutralDecision"] = FcNeutralDecision;
/* harmony export (immutable) */ __webpack_exports__["FcNeutralTrading"] = FcNeutralTrading;
/* harmony export (immutable) */ __webpack_exports__["FcNews"] = FcNews;
/* harmony export (immutable) */ __webpack_exports__["FcNext"] = FcNext;
/* harmony export (immutable) */ __webpack_exports__["FcNfcSign"] = FcNfcSign;
/* harmony export (immutable) */ __webpack_exports__["FcNightLandscape"] = FcNightLandscape;
/* harmony export (immutable) */ __webpack_exports__["FcNightPortrait"] = FcNightPortrait;
/* harmony export (immutable) */ __webpack_exports__["FcNoIdea"] = FcNoIdea;
/* harmony export (immutable) */ __webpack_exports__["FcNoVideo"] = FcNoVideo;
/* harmony export (immutable) */ __webpack_exports__["FcNook"] = FcNook;
/* harmony export (immutable) */ __webpack_exports__["FcNumericalSorting12"] = FcNumericalSorting12;
/* harmony export (immutable) */ __webpack_exports__["FcNumericalSorting21"] = FcNumericalSorting21;
/* harmony export (immutable) */ __webpack_exports__["FcOk"] = FcOk;
/* harmony export (immutable) */ __webpack_exports__["FcOldTimeCamera"] = FcOldTimeCamera;
/* harmony export (immutable) */ __webpack_exports__["FcOnlineSupport"] = FcOnlineSupport;
/* harmony export (immutable) */ __webpack_exports__["FcOpenedFolder"] = FcOpenedFolder;
/* harmony export (immutable) */ __webpack_exports__["FcOrgUnit"] = FcOrgUnit;
/* harmony export (immutable) */ __webpack_exports__["FcOrganization"] = FcOrganization;
/* harmony export (immutable) */ __webpack_exports__["FcOvertime"] = FcOvertime;
/* harmony export (immutable) */ __webpack_exports__["FcPackage"] = FcPackage;
/* harmony export (immutable) */ __webpack_exports__["FcPaid"] = FcPaid;
/* harmony export (immutable) */ __webpack_exports__["FcPanorama"] = FcPanorama;
/* harmony export (immutable) */ __webpack_exports__["FcParallelTasks"] = FcParallelTasks;
/* harmony export (immutable) */ __webpack_exports__["FcPhoneAndroid"] = FcPhoneAndroid;
/* harmony export (immutable) */ __webpack_exports__["FcPhone"] = FcPhone;
/* harmony export (immutable) */ __webpack_exports__["FcPhotoReel"] = FcPhotoReel;
/* harmony export (immutable) */ __webpack_exports__["FcPicture"] = FcPicture;
/* harmony export (immutable) */ __webpack_exports__["FcPieChart"] = FcPieChart;
/* harmony export (immutable) */ __webpack_exports__["FcPlanner"] = FcPlanner;
/* harmony export (immutable) */ __webpack_exports__["FcPlus"] = FcPlus;
/* harmony export (immutable) */ __webpack_exports__["FcPodiumWithAudience"] = FcPodiumWithAudience;
/* harmony export (immutable) */ __webpack_exports__["FcPodiumWithSpeaker"] = FcPodiumWithSpeaker;
/* harmony export (immutable) */ __webpack_exports__["FcPodiumWithoutSpeaker"] = FcPodiumWithoutSpeaker;
/* harmony export (immutable) */ __webpack_exports__["FcPortraitMode"] = FcPortraitMode;
/* harmony export (immutable) */ __webpack_exports__["FcPositiveDynamic"] = FcPositiveDynamic;
/* harmony export (immutable) */ __webpack_exports__["FcPrevious"] = FcPrevious;
/* harmony export (immutable) */ __webpack_exports__["FcPrint"] = FcPrint;
/* harmony export (immutable) */ __webpack_exports__["FcPrivacy"] = FcPrivacy;
/* harmony export (immutable) */ __webpack_exports__["FcProcess"] = FcProcess;
/* harmony export (immutable) */ __webpack_exports__["FcPuzzle"] = FcPuzzle;
/* harmony export (immutable) */ __webpack_exports__["FcQuestions"] = FcQuestions;
/* harmony export (immutable) */ __webpack_exports__["FcRadarPlot"] = FcRadarPlot;
/* harmony export (immutable) */ __webpack_exports__["FcRating"] = FcRating;
/* harmony export (immutable) */ __webpack_exports__["FcRatings"] = FcRatings;
/* harmony export (immutable) */ __webpack_exports__["FcReadingEbook"] = FcReadingEbook;
/* harmony export (immutable) */ __webpack_exports__["FcReading"] = FcReading;
/* harmony export (immutable) */ __webpack_exports__["FcReddit"] = FcReddit;
/* harmony export (immutable) */ __webpack_exports__["FcRedo"] = FcRedo;
/* harmony export (immutable) */ __webpack_exports__["FcRefresh"] = FcRefresh;
/* harmony export (immutable) */ __webpack_exports__["FcRegisteredTrademark"] = FcRegisteredTrademark;
/* harmony export (immutable) */ __webpack_exports__["FcRemoveImage"] = FcRemoveImage;
/* harmony export (immutable) */ __webpack_exports__["FcReuse"] = FcReuse;
/* harmony export (immutable) */ __webpack_exports__["FcRightDown"] = FcRightDown;
/* harmony export (immutable) */ __webpack_exports__["FcRightDown2"] = FcRightDown2;
/* harmony export (immutable) */ __webpack_exports__["FcRightUp"] = FcRightUp;
/* harmony export (immutable) */ __webpack_exports__["FcRightUp2"] = FcRightUp2;
/* harmony export (immutable) */ __webpack_exports__["FcRight"] = FcRight;
/* harmony export (immutable) */ __webpack_exports__["FcRotateCamera"] = FcRotateCamera;
/* harmony export (immutable) */ __webpack_exports__["FcRotateToLandscape"] = FcRotateToLandscape;
/* harmony export (immutable) */ __webpack_exports__["FcRotateToPortrait"] = FcRotateToPortrait;
/* harmony export (immutable) */ __webpack_exports__["FcRuler"] = FcRuler;
/* harmony export (immutable) */ __webpack_exports__["FcRules"] = FcRules;
/* harmony export (immutable) */ __webpack_exports__["FcSafe"] = FcSafe;
/* harmony export (immutable) */ __webpack_exports__["FcSalesPerformance"] = FcSalesPerformance;
/* harmony export (immutable) */ __webpack_exports__["FcScatterPlot"] = FcScatterPlot;
/* harmony export (immutable) */ __webpack_exports__["FcSearch"] = FcSearch;
/* harmony export (immutable) */ __webpack_exports__["FcSelfServiceKiosk"] = FcSelfServiceKiosk;
/* harmony export (immutable) */ __webpack_exports__["FcSelfie"] = FcSelfie;
/* harmony export (immutable) */ __webpack_exports__["FcSerialTasks"] = FcSerialTasks;
/* harmony export (immutable) */ __webpack_exports__["FcServiceMark"] = FcServiceMark;
/* harmony export (immutable) */ __webpack_exports__["FcServices"] = FcServices;
/* harmony export (immutable) */ __webpack_exports__["FcSettings"] = FcSettings;
/* harmony export (immutable) */ __webpack_exports__["FcShare"] = FcShare;
/* harmony export (immutable) */ __webpack_exports__["FcShipped"] = FcShipped;
/* harmony export (immutable) */ __webpack_exports__["FcShop"] = FcShop;
/* harmony export (immutable) */ __webpack_exports__["FcSignature"] = FcSignature;
/* harmony export (immutable) */ __webpack_exports__["FcSimCardChip"] = FcSimCardChip;
/* harmony export (immutable) */ __webpack_exports__["FcSimCard"] = FcSimCard;
/* harmony export (immutable) */ __webpack_exports__["FcSlrBackSide"] = FcSlrBackSide;
/* harmony export (immutable) */ __webpack_exports__["FcSmartphoneTablet"] = FcSmartphoneTablet;
/* harmony export (immutable) */ __webpack_exports__["FcSms"] = FcSms;
/* harmony export (immutable) */ __webpack_exports__["FcSoundRecordingCopyright"] = FcSoundRecordingCopyright;
/* harmony export (immutable) */ __webpack_exports__["FcSpeaker"] = FcSpeaker;
/* harmony export (immutable) */ __webpack_exports__["FcSportsMode"] = FcSportsMode;
/* harmony export (immutable) */ __webpack_exports__["FcStackOfPhotos"] = FcStackOfPhotos;
/* harmony export (immutable) */ __webpack_exports__["FcStart"] = FcStart;
/* harmony export (immutable) */ __webpack_exports__["FcStatistics"] = FcStatistics;
/* harmony export (immutable) */ __webpack_exports__["FcSteam"] = FcSteam;
/* harmony export (immutable) */ __webpack_exports__["FcStumbleupon"] = FcStumbleupon;
/* harmony export (immutable) */ __webpack_exports__["FcSupport"] = FcSupport;
/* harmony export (immutable) */ __webpack_exports__["FcSurvey"] = FcSurvey;
/* harmony export (immutable) */ __webpack_exports__["FcSwitchCamera"] = FcSwitchCamera;
/* harmony export (immutable) */ __webpack_exports__["FcSynchronize"] = FcSynchronize;
/* harmony export (immutable) */ __webpack_exports__["FcTabletAndroid"] = FcTabletAndroid;
/* harmony export (immutable) */ __webpack_exports__["FcTemplate"] = FcTemplate;
/* harmony export (immutable) */ __webpack_exports__["FcTimeline"] = FcTimeline;
/* harmony export (immutable) */ __webpack_exports__["FcTodoList"] = FcTodoList;
/* harmony export (immutable) */ __webpack_exports__["FcTouchscreenSmartphone"] = FcTouchscreenSmartphone;
/* harmony export (immutable) */ __webpack_exports__["FcTrademark"] = FcTrademark;
/* harmony export (immutable) */ __webpack_exports__["FcTreeStructure"] = FcTreeStructure;
/* harmony export (immutable) */ __webpack_exports__["FcTwoSmartphones"] = FcTwoSmartphones;
/* harmony export (immutable) */ __webpack_exports__["FcUndo"] = FcUndo;
/* harmony export (immutable) */ __webpack_exports__["FcUnlock"] = FcUnlock;
/* harmony export (immutable) */ __webpack_exports__["FcUpLeft"] = FcUpLeft;
/* harmony export (immutable) */ __webpack_exports__["FcUpRight"] = FcUpRight;
/* harmony export (immutable) */ __webpack_exports__["FcUp"] = FcUp;
/* harmony export (immutable) */ __webpack_exports__["FcUpload"] = FcUpload;
/* harmony export (immutable) */ __webpack_exports__["FcUsb"] = FcUsb;
/* harmony export (immutable) */ __webpack_exports__["FcVideoCall"] = FcVideoCall;
/* harmony export (immutable) */ __webpack_exports__["FcVideoFile"] = FcVideoFile;
/* harmony export (immutable) */ __webpack_exports__["FcVideoProjector"] = FcVideoProjector;
/* harmony export (immutable) */ __webpack_exports__["FcViewDetails"] = FcViewDetails;
/* harmony export (immutable) */ __webpack_exports__["FcVip"] = FcVip;
/* harmony export (immutable) */ __webpack_exports__["FcVlc"] = FcVlc;
/* harmony export (immutable) */ __webpack_exports__["FcVoicePresentation"] = FcVoicePresentation;
/* harmony export (immutable) */ __webpack_exports__["FcVoicemail"] = FcVoicemail;
/* harmony export (immutable) */ __webpack_exports__["FcWebcam"] = FcWebcam;
/* harmony export (immutable) */ __webpack_exports__["FcWiFiLogo"] = FcWiFiLogo;
/* harmony export (immutable) */ __webpack_exports__["FcWikipedia"] = FcWikipedia;
/* harmony export (immutable) */ __webpack_exports__["FcWorkflow"] = FcWorkflow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(557);
// THIS FILE IS AUTO GENERATED

function FcAbout (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#2196F3","d":"M37,40H11l-6,6V12c0-3.3,2.7-6,6-6h26c3.3,0,6,2.7,6,6v22C43,37.3,40.3,40,37,40z"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"22","y":"20","width":"4","height":"11"}},{"tag":"circle","attr":{"cx":"24","cy":"15","r":"2"}}]}]})(props);
};
function FcAcceptDatabase (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z"}}]},{"tag":"circle","attr":{"fill":"#43A047","cx":"38","cy":"38","r":"10"}},{"tag":"polygon","attr":{"fill":"#DCEDC8","points":"42.5,33.3 36.8,39 34.1,36.3 32,38.5 36.8,43.3 44.6,35.5"}}]})(props);
};
function FcAddColumn (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M30,5H18c-2.2,0-4,1.8-4,4v30c0,2.2,1.8,4,4,4h12c2.2,0,4-1.8,4-4V9C34,6.8,32.2,5,30,5z M18,39V9h12l0,30 H18z"}},{"tag":"circle","attr":{"fill":"#43A047","cx":"38","cy":"38","r":"10"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"36","y":"32","width":"4","height":"12"}},{"tag":"rect","attr":{"x":"32","y":"36","width":"12","height":"4"}}]}]})(props);
};
function FcAddDatabase (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z"}}]},{"tag":"circle","attr":{"fill":"#43A047","cx":"38","cy":"38","r":"10"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"36","y":"32","width":"4","height":"12"}},{"tag":"rect","attr":{"x":"32","y":"36","width":"12","height":"4"}}]}]})(props);
};
function FcAddImage (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#8CBCD6","d":"M40,41H8c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v26C44,39.2,42.2,41,40,41z"}},{"tag":"circle","attr":{"fill":"#B3DDF5","cx":"35","cy":"16","r":"3"}},{"tag":"polygon","attr":{"fill":"#9AC9E3","points":"20,16 9,32 31,32"}},{"tag":"polygon","attr":{"fill":"#B3DDF5","points":"31,22 23,32 39,32"}},{"tag":"circle","attr":{"fill":"#43A047","cx":"38","cy":"38","r":"10"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"36","y":"32","width":"4","height":"12"}},{"tag":"rect","attr":{"x":"32","y":"36","width":"12","height":"4"}}]}]})(props);
};
function FcAddRow (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M43,30V18c0-2.2-1.8-4-4-4H9c-2.2,0-4,1.8-4,4v12c0,2.2,1.8,4,4,4h30C41.2,34,43,32.2,43,30z M9,18h30v12 L9,30V18z"}},{"tag":"circle","attr":{"fill":"#43A047","cx":"38","cy":"38","r":"10"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"32","y":"36","width":"12","height":"4"}},{"tag":"rect","attr":{"x":"36","y":"32","width":"4","height":"12"}}]}]})(props);
};
function FcAddressBook (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#673AB7","d":"M38,44H12V4h26c2.2,0,4,1.8,4,4v32C42,42.2,40.2,44,38,44z"}},{"tag":"path","attr":{"fill":"#311B92","d":"M10,4h2v40h-2c-2.2,0-4-1.8-4-4V8C6,5.8,7.8,4,10,4z"}},{"tag":"path","attr":{"fill":"#fff","d":"M36,24.2c-0.1,4.8-3.1,6.9-5.3,6.7c-0.6-0.1-2.1-0.1-2.9-1.6c-0.8,1-1.8,1.6-3.1,1.6c-2.6,0-3.3-2.5-3.4-3.1 c-0.1-0.7-0.2-1.4-0.1-2.2c0.1-1,1.1-6.5,5.7-6.5c2.2,0,3.5,1.1,3.7,1.3L30,27.2c0,0.3-0.2,1.6,1.1,1.6c2.1,0,2.4-3.9,2.4-4.6 c0.1-1.2,0.3-8.2-7-8.2c-6.9,0-7.9,7.4-8,9.2c-0.5,8.5,6,8.5,7.2,8.5c1.7,0,3.7-0.7,3.9-0.8l0.4,2c-0.3,0.2-2,1.1-4.4,1.1 c-2.2,0-10.1-0.4-9.8-10.8C16.1,23.1,17.4,14,26.6,14C35.8,14,36,22.1,36,24.2z M24.1,25.5c-0.1,1,0,1.8,0.2,2.3 c0.2,0.5,0.6,0.8,1.2,0.8c0.1,0,0.3,0,0.4-0.1c0.2-0.1,0.3-0.1,0.5-0.3c0.2-0.1,0.3-0.3,0.5-0.6c0.2-0.2,0.3-0.6,0.4-1l0.5-5.4 c-0.2-0.1-0.5-0.1-0.7-0.1c-0.5,0-0.9,0.1-1.2,0.3c-0.3,0.2-0.6,0.5-0.9,0.8c-0.2,0.4-0.4,0.8-0.6,1.3S24.2,24.8,24.1,25.5z"}}]})(props);
};
function FcAdvance (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"polygon","attr":{"points":"46.1,24 33,35 33,13"}},{"tag":"rect","attr":{"x":"10","y":"20","width":"4","height":"8"}},{"tag":"rect","attr":{"x":"4","y":"20","width":"4","height":"8"}},{"tag":"rect","attr":{"x":"16","y":"20","width":"4","height":"8"}},{"tag":"rect","attr":{"x":"22","y":"20","width":"14","height":"8"}}]}]})(props);
};
function FcAdvertising (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#90CAF9"},"child":[{"tag":"path","attr":{"d":"M17.4,33H15v-4h4l0.4,1.5C19.7,31.8,18.7,33,17.4,33z"}},{"tag":"path","attr":{"d":"M37,36c0,0-11.8-7-18-7V15c5.8,0,18-7,18-7V36z"}}]},{"tag":"g","attr":{"fill":"#283593"},"child":[{"tag":"circle","attr":{"cx":"9","cy":"22","r":"5"}},{"tag":"path","attr":{"d":"M40,19h-3v6h3c1.7,0,3-1.3,3-3S41.7,19,40,19z"}},{"tag":"path","attr":{"d":"M18.6,41.2c-0.9,0.6-2.5,1.2-4.6,1.4c-0.6,0.1-1.2-0.3-1.4-1L8.2,27.9c0,0,8.8-6.2,8.8,1.1 c0,5.5,1.5,8.4,2.2,9.5c0.5,0.7,0.5,1.6,0,2.3C19,41,18.8,41.1,18.6,41.2z"}}]},{"tag":"path","attr":{"fill":"#3F51B5","d":"M9,29h10V15H9c-1.1,0-2,0.9-2,2v10C7,28.1,7.9,29,9,29z"}},{"tag":"path","attr":{"fill":"#42A5F5","d":"M38,38L38,38c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v28C40,37.1,39.1,38,38,38z"}}]})(props);
};
function FcAlarmClock (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"path","attr":{"d":"M38.5,44.6l-4-4l2.1-2.1l4,4c0.6,0.6,0.6,1.5,0,2.1l0,0C40.1,45.1,39.1,45.1,38.5,44.6z"}},{"tag":"path","attr":{"d":"M9.5,44.6l4-4l-2.1-2.1l-4,4c-0.6,0.6-0.6,1.5,0,2.1l0,0C7.9,45.1,8.9,45.1,9.5,44.6z"}}]},{"tag":"circle","attr":{"fill":"#C62828","cx":"24","cy":"24","r":"20"}},{"tag":"circle","attr":{"fill":"#eee","cx":"24","cy":"24","r":"16"}},{"tag":"rect","attr":{"x":"19","y":"22.1","transform":"matrix(-.707 -.707 .707 -.707 12.904 62.537)","fill":"#E53935","width":".8","height":"13"}},{"tag":"rect","attr":{"x":"23","y":"11","width":"2","height":"13"}},{"tag":"rect","attr":{"x":"26.1","y":"22.7","transform":"matrix(-.707 .707 -.707 -.707 65.787 27.25)","width":"2.3","height":"9.2"}},{"tag":"circle","attr":{"cx":"24","cy":"24","r":"2"}},{"tag":"circle","attr":{"fill":"#C62828","cx":"24","cy":"24","r":"1"}},{"tag":"rect","attr":{"x":"22","y":"1","fill":"#37474F","width":"4","height":"3"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"path","attr":{"d":"M44.4,16.2c2.5-3.5,2.1-8.4-1-11.5c-3.1-3.1-8-3.5-11.5-1L44.4,16.2z"}},{"tag":"path","attr":{"d":"M3.6,16.2c-2.5-3.5-2.1-8.4,1-11.5c3.1-3.1,8-3.5,11.5-1L3.6,16.2z"}}]}]})(props);
};
function FcAlphabeticalSortingAz (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#546E7A","points":"38,33 38,5 34,5 34,33 28,33 36,43 44,33"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"path","attr":{"d":"M16.8,17.2h-5.3l-1.1,3H6.9L12.6,5h2.9l5.7,15.2h-3.2L16.8,17.2z M12.2,14.5H16l-1.9-5.7L12.2,14.5z"}},{"tag":"path","attr":{"d":"M12.4,40.5H20V43H8.4v-1.9L16,30.3H8.4v-2.5h11.4v1.7L12.4,40.5z"}}]}]})(props);
};
function FcAlphabeticalSortingZa (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"path","attr":{"d":"M16.8,40h-5.3l-1.1,3H6.9l5.7-15.2h2.9L21.1,43h-3.2L16.8,40z M12.2,37.3H16l-1.9-5.7L12.2,37.3z"}},{"tag":"path","attr":{"d":"M12.4,17.7H20v2.5H8.4v-1.9L16,7.5H8.4V5h11.4v1.7L12.4,17.7z"}}]},{"tag":"polygon","attr":{"fill":"#546E7A","points":"38,33 38,5 34,5 34,33 28,33 36,43 44,33"}}]})(props);
};
function FcAndroidOs (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#7CB342","d":"M12,29.001c0,1.104-0.896,2-2,2l0,0c-1.104,0-2-0.896-2-2v-9c0-1.104,0.896-2,2-2l0,0c1.104,0,2,0.896,2,2\r\n\t\tV29.001z"}},{"tag":"path","attr":{"fill":"#7CB342","d":"M40,29.001c0,1.104-0.896,2-2,2l0,0c-1.104,0-2-0.896-2-2v-9c0-1.104,0.896-2,2-2l0,0c1.104,0,2,0.896,2,2\r\n\t\tV29.001z"}},{"tag":"path","attr":{"fill":"#7CB342","d":"M22,40c0,1.104-0.896,2-2,2l0,0c-1.104,0-2-0.896-2-2v-9c0-1.104,0.896-2,2-2l0,0c1.104,0,2,0.896,2,2V40z"}},{"tag":"path","attr":{"fill":"#7CB342","d":"M30,40c0,1.104-0.896,2-2,2l0,0c-1.104,0-2-0.896-2-2v-9c0-1.104,0.896-2,2-2l0,0c1.104,0,2,0.896,2,2V40z"}},{"tag":"path","attr":{"fill":"#7CB342","d":"M14,18.001V33c0,1.104,0.896,2,2,2h16c1.104,0,2-0.896,2-2V18.001H14z"}},{"tag":"path","attr":{"fill":"#7CB342","d":"M24,8c-6,0-9.655,3.645-10,8h20C33.654,11.645,30,8,24,8z M20,13.598c-0.552,0-1-0.448-1-1s0.448-1,1-1\r\n\t\ts1,0.448,1,1S20.552,13.598,20,13.598z M28,13.598c-0.553,0-1-0.448-1-1s0.447-1,1-1s1,0.448,1,1S28.553,13.598,28,13.598z"}},{"tag":"line","attr":{"fill":"none","stroke":"#7CB342","strokeWidth":"2","strokeLinecap":"round","x1":"30","y1":"7","x2":"28.334","y2":"9.499"}},{"tag":"line","attr":{"fill":"none","stroke":"#7CB342","strokeWidth":"2","strokeLinecap":"round","x1":"18","y1":"7","x2":"19.333","y2":"9.082"}}]}]})(props);
};
function FcAnswers (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#42A5F5","points":"36,44 8,44 8,8 28,8 36,16"}},{"tag":"polygon","attr":{"fill":"#90CAF9","points":"40,40 12,40 12,4 32,4 40,12"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"38.5,13 31,13 31,5.5"}},{"tag":"path","attr":{"fill":"#1976D2","d":"M23.4,29.9c0-0.2,0-0.4,0.1-0.6s0.2-0.3,0.3-0.5s0.3-0.2,0.5-0.3s0.4-0.1,0.6-0.1s0.5,0,0.7,0.1 s0.4,0.2,0.5,0.3s0.2,0.3,0.3,0.5s0.1,0.4,0.1,0.6s0,0.4-0.1,0.6s-0.2,0.3-0.3,0.5s-0.3,0.2-0.5,0.3s-0.4,0.1-0.7,0.1 s-0.5,0-0.6-0.1s-0.4-0.2-0.5-0.3s-0.2-0.3-0.3-0.5S23.4,30.1,23.4,29.9z M26.1,26.8h-2.3L23.4,17h3L26.1,26.8z"}}]})(props);
};
function FcApproval (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#8BC34A","points":"24,3 28.7,6.6 34.5,5.8 36.7,11.3 42.2,13.5 41.4,19.3 45,24 41.4,28.7 42.2,34.5 36.7,36.7 34.5,42.2 28.7,41.4 24,45 19.3,41.4 13.5,42.2 11.3,36.7 5.8,34.5 6.6,28.7 3,24 6.6,19.3 5.8,13.5 11.3,11.3 13.5,5.8 19.3,6.6"}},{"tag":"polygon","attr":{"fill":"#CCFF90","points":"34.6,14.6 21,28.2 15.4,22.6 12.6,25.4 21,33.8 37.4,17.4"}}]})(props);
};
function FcApprove (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"path","attr":{"d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"path","attr":{"d":"M24,4C15.2,4,8,11.2,8,20c0,1.2,0,3.5,0,3.5l2.1,0.6V19l19.5-6.3l8.2,6.3v5.1l2.1-0.6c0,0,0-2.3,0-3.5 C40,12.5,34.6,4,24,4z"}}]},{"tag":"polygon","attr":{"fill":"#4CAF50","points":"32.6,18.6 22.3,28.9 17.4,24 14.6,26.8 22.3,34.5 35.4,21.4"}}]})(props);
};
function FcAreaChart (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"42,37 6,37 6,25 16,10 30,17 42,6"}},{"tag":"polygon","attr":{"fill":"#00BCD4","points":"42,42 6,42 6,32 16,24 30,26 42,17"}}]})(props);
};
function FcAssistant (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFA726"},"child":[{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}}]},{"tag":"path","attr":{"fill":"#FFB74D","d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"path","attr":{"fill":"#FF5722","d":"M24,3C14.6,3,7,10.6,7,20c0,1.2,0,3.4,0,3.4L9,25v-3l21-9.8l9,9.8v3l2-1.6c0,0,0-2.1,0-3.4 C41,12,35.3,3,24,3z"}},{"tag":"g","attr":{"fill":"#784719"},"child":[{"tag":"circle","attr":{"cx":"31","cy":"26","r":"2"}},{"tag":"circle","attr":{"cx":"17","cy":"26","r":"2"}}]},{"tag":"path","attr":{"fill":"#757575","d":"M43,24c-0.6,0-1,0.4-1,1v-7c0-8.8-7.2-16-16-16h-7c-0.6,0-1,0.4-1,1s0.4,1,1,1h7c7.7,0,14,6.3,14,14v10 c0,0.6,0.4,1,1,1s1-0.4,1-1v2c0,3.9-3.1,7-7,7H24c-0.6,0-1,0.4-1,1s0.4,1,1,1h11c5,0,9-4,9-9v-5C44,24.4,43.6,24,43,24z"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"path","attr":{"d":"M43,22h-1c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-4C45,22.9,44.1,22,43,22z"}},{"tag":"circle","attr":{"cx":"24","cy":"38","r":"2"}}]}]})(props);
};
function FcAudioFile (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"204","fill":"none","width":"48","height":"48"}},{"tag":"polygon","attr":{"fill":"#90CAF9","points":"244,45 212,45 212,3 234,3 244,13"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"242.5,14 233,14 233,4.5"}},{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"circle","attr":{"cx":"227","cy":"30","r":"4"}},{"tag":"polygon","attr":{"points":"234,21 229,19 229,30 231,30 231,22.9 234,24"}}]},{"tag":"polygon","attr":{"fill":"#90CAF9","points":"40,45 8,45 8,3 30,3 40,13"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"38.5,14 29,14 29,4.5"}},{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"circle","attr":{"cx":"23","cy":"30","r":"4"}},{"tag":"polygon","attr":{"points":"30,21 25,19 25,30 27,30 27,22.9 30,24"}}]}]})(props);
};
function FcAutomatic (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#3F51B5","d":"M39,43H9c-2.2,0-4-1.8-4-4V9c0-2.2,1.8-4,4-4h30c2.2,0,4,1.8,4,4v30C43,41.2,41.2,43,39,43z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M33.6,25.4c0.1-0.4,0.1-0.9,0.1-1.4s0-0.9-0.1-1.4l2.8-2c0.3-0.2,0.4-0.6,0.2-0.9l-2.7-4.6 c-0.2-0.3-0.5-0.4-0.8-0.3L30,16.3c-0.7-0.6-1.5-1-2.4-1.4l-0.3-3.4c0-0.3-0.3-0.6-0.6-0.6h-5.3c-0.3,0-0.6,0.3-0.6,0.6L20.4,15 c-0.9,0.3-1.6,0.8-2.4,1.4l-3.1-1.4c-0.3-0.1-0.7,0-0.8,0.3l-2.7,4.6c-0.2,0.3-0.1,0.7,0.2,0.9l2.8,2c-0.1,0.4-0.1,0.9-0.1,1.4 s0,0.9,0.1,1.4l-2.8,2c-0.3,0.2-0.4,0.6-0.2,0.9l2.7,4.6c0.2,0.3,0.5,0.4,0.8,0.3l3.1-1.4c0.7,0.6,1.5,1,2.4,1.4l0.3,3.4 c0,0.3,0.3,0.6,0.6,0.6h5.3c0.3,0,0.6-0.3,0.6-0.6l0.3-3.4c0.9-0.3,1.6-0.8,2.4-1.4l3.1,1.4c0.3,0.1,0.7,0,0.8-0.3l2.7-4.6 c0.2-0.3,0.1-0.7-0.2-0.9L33.6,25.4z M24,29c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5C29,26.8,26.8,29,24,29z"}}]})(props);
};
function FcAutomotive (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"none","stroke":"#F44336","strokeWidth":"4","strokeMiterlimit":"10","d":"M7,20v-8c0-2.2,1.8-4,4-4h14c1.2,0,2.4,0.6,3.2,1.6 L35,18"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"circle","attr":{"cx":"35","cy":"37","r":"5"}},{"tag":"circle","attr":{"cx":"13","cy":"37","r":"5"}}]},{"tag":"path","attr":{"fill":"#F44336","d":"M40.2,17L33,14H7c-1.2,0-2,0.8-2,2v10c0,1.2,0.8,2,2,2h1c0-2.8,2.2-5,5-5s5,2.2,5,5h12c0-2.8,2.2-5,5-5 s5,2.2,5,5h1c1.2,0,2-0.8,2-2v-5.2C43,19.2,41.8,17.6,40.2,17z"}},{"tag":"g","attr":{"fill":"#546E7A"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"37","r":"3"}},{"tag":"circle","attr":{"cx":"35","cy":"37","r":"2"}},{"tag":"circle","attr":{"cx":"13","cy":"37","r":"2"}},{"tag":"path","attr":{"d":"M30.4,39c-0.3-0.6-0.4-1.3-0.4-2s0.2-1.4,0.4-2H17.6c0.3,0.6,0.4,1.3,0.4,2s-0.2,1.4-0.4,2H30.4z"}}]}]})(props);
};
function FcBadDecision (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"path","attr":{"d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"path","attr":{"d":"M24,4C15.2,4,8,11.2,8,20c0,1.2,0,3.5,0,3.5l2.1,0.6V19l19.5-6.3l8.2,6.3v5.1l2.1-0.6c0,0,0-2.3,0-3.5 C40,12.5,34.6,4,24,4z"}}]},{"tag":"rect","attr":{"x":"16","y":"24","fill":"#F44336","width":"16","height":"4"}}]})(props);
};
function FcBarChart (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"rect","attr":{"x":"19","y":"22","width":"10","height":"20"}},{"tag":"rect","attr":{"x":"6","y":"12","width":"10","height":"30"}},{"tag":"rect","attr":{"x":"32","y":"6","width":"10","height":"36"}}]}]})(props);
};
function FcBbc (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M0,17v14h14V17H0z M34,17v14h14V17H34z M17,17v14h14V17H17z"}},{"tag":"path","attr":{"fill":"#FFFFFF","d":"M8.2,23.7c0,0,1.3-0.5,1.3-2c0,0,0.2-2.4-3-2.7H3v10h4c0,0,3.4,0,3.4-2.8C10.4,26.2,10.5,24.3,8.2,23.7z\r\n\t M4.8,20.6h1.4c1.5,0.1,1.4,1.2,1.4,1.2c0,1.4-1.6,1.4-1.6,1.4H4.8V20.6z M6.7,27.5H4.8v-2.7h1.9c1.9,0,1.9,1.3,1.9,1.3\r\n\tC8.5,27.5,6.7,27.5,6.7,27.5z M25.2,23.7c0,0,1.3-0.5,1.3-2c0,0,0.2-2.4-3-2.7H20v10h4c0,0,3.4,0,3.4-2.8\r\n\tC27.4,26.2,27.5,24.3,25.2,23.7z M21.8,20.6h1.4c1.5,0.1,1.4,1.2,1.4,1.2c0,1.4-1.6,1.4-1.6,1.4h-1.2V20.6z M23.7,27.5h-1.9v-2.7\r\n\th1.9c1.9,0,1.9,1.3,1.9,1.3C25.5,27.5,23.7,27.5,23.7,27.5z M45.3,28.1c0,0-2.9,1.8-6.3,0.4c0,0-2.9-1.1-3-4.5c0,0-0.1-3.5,3.7-4.7\r\n\tc0,0,1-0.4,2.8-0.2c0,0,1.1,0.1,2.7,0.8v1.8c0,0-1.7-1.1-3.7-1.1c0,0-3.6-0.1-3.8,3.5c0,0-0.1,3.3,3.7,3.4c0,0,1.6,0.2,3.8-1.2\r\n\tL45.3,28.1L45.3,28.1z"}}]})(props);
};
function FcBearish (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#F44336"},"child":[{"tag":"rect","attr":{"x":"40","y":"34","width":"4","height":"10"}},{"tag":"rect","attr":{"x":"34","y":"29","width":"4","height":"15"}},{"tag":"rect","attr":{"x":"28","y":"33","width":"4","height":"11"}},{"tag":"rect","attr":{"x":"22","y":"25","width":"4","height":"19"}},{"tag":"rect","attr":{"x":"16","y":"28","width":"4","height":"16"}},{"tag":"rect","attr":{"x":"10","y":"24","width":"4","height":"20"}},{"tag":"rect","attr":{"x":"4","y":"19","width":"4","height":"25"}}]},{"tag":"g","attr":{"fill":"#D32F2F"},"child":[{"tag":"polygon","attr":{"points":"34,13.2 30,17.2 20,7.2 15,12.2 7.4,4.6 4.6,7.4 15,17.8 20,12.8 30,22.8 34,18.8 40.1,24.9 42.9,22.1"}},{"tag":"polygon","attr":{"points":"44,26 35,26 44,17"}}]}]})(props);
};
function FcBinoculars (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"circle","attr":{"cx":"33","cy":"16","r":"6"}},{"tag":"circle","attr":{"cx":"15","cy":"16","r":"6"}},{"tag":"path","attr":{"d":"M46.7,25l-15.3,3H16.7L1.4,25l4.3-7.9c1.1-1.9,3.1-3.1,5.3-3.1h26.2c2.2,0,4.2,1.2,5.3,3.1L46.7,25z"}},{"tag":"circle","attr":{"cx":"38","cy":"30","r":"10"}},{"tag":"circle","attr":{"cx":"10","cy":"30","r":"10"}},{"tag":"circle","attr":{"cx":"24","cy":"28","r":"5"}}]},{"tag":"circle","attr":{"fill":"#546E7A","cx":"24","cy":"28","r":"2"}},{"tag":"g","attr":{"fill":"#a0f"},"child":[{"tag":"circle","attr":{"cx":"38","cy":"30","r":"7"}},{"tag":"circle","attr":{"cx":"10","cy":"30","r":"7"}}]},{"tag":"g","attr":{"fill":"#CE93D8"},"child":[{"tag":"path","attr":{"d":"M41.7,27.7c-1-1.1-2.3-1.7-3.7-1.7s-2.8,0.6-3.7,1.7c-0.4,0.4-0.3,1,0.1,1.4c0.4,0.4,1,0.3,1.4-0.1 c1.2-1.3,3.3-1.3,4.5,0c0.2,0.2,0.5,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3C42.1,28.7,42.1,28.1,41.7,27.7z"}},{"tag":"path","attr":{"d":"M10,26c-1.4,0-2.8,0.6-3.7,1.7c-0.4,0.4-0.3,1,0.1,1.4c0.4,0.4,1,0.3,1.4-0.1c1.2-1.3,3.3-1.3,4.5,0 c0.2,0.2,0.5,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0.1-1.4C12.8,26.6,11.4,26,10,26z"}}]}]})(props);
};
function FcBiohazard (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#00A344","d":"M24,13c-7.2,0-13,5.8-13,13s5.8,13,13,13s13-5.8,13-13S31.2,13,24,13z M24,35c-5,0-9-4-9-9s4-9,9-9s9,4,9,9 S29,35,24,35z"}},{"tag":"path","attr":{"fill":"#00C853","d":"M8.5,25.4c4-2.2,9-1.1,11.5,2.5c0.1,0.1,0.2,0.1,0.3,0.1l1.2-0.7c0.1-0.1,0.2-0.2,0.1-0.3 c0-0.2-0.1-0.4-0.1-0.6c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2l0,0 c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1 c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1,0c0.2-0.1,0.4-0.2,0.5-0.2c0.1,0,0.2-0.1,0.2-0.3v-1.3c0-0.1-0.1-0.2-0.2-0.2 c-4.5-0.4-8-4.1-8-8.6c0-4.1,3-7.6,6.9-8.4c0.1,0,0.2-0.1,0.2-0.3V4.8c0-0.1-0.1-0.2-0.2-0.2C16.4,5.5,12,10.4,12,16.3 c0,1.3,0.2,2.6,0.6,3.8c-1.2,0.2-2.5,0.7-3.6,1.3c-5.2,3-7.3,9.2-5.2,14.5C3.9,36,4,36,4.1,36l0.3-0.2c0.1-0.1,0.2-0.2,0.1-0.3 C3.3,31.7,4.8,27.4,8.5,25.4L8.5,25.4z M39,21.4c-1.2-0.7-2.4-1.1-3.6-1.3c0.4-1.2,0.6-2.4,0.6-3.8c0-5.9-4.4-10.8-10.2-11.7 c-0.1,0-0.2,0.1-0.2,0.2v0.4c0,0.1,0.1,0.2,0.2,0.3c4,0.8,6.9,4.3,6.9,8.4c0,4.5-3.5,8.2-8,8.6c-0.1,0-0.2,0.1-0.2,0.2v1.3 c0,0.1,0.1,0.2,0.2,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0 c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.2,0,0.4-0.1,0.6c0,0.1,0,0.2,0.1,0.3l1.2,0.7c0.1,0.1,0.2,0,0.3-0.1c2.6-3.6,7.6-4.8,11.5-2.5 c3.6,2.1,5.2,6.3,3.9,10.1c0,0.1,0,0.2,0.1,0.3l0.3,0.2c0.1,0.1,0.2,0,0.3-0.1C46.3,30.5,44.2,24.3,39,21.4L39,21.4z M30.8,40.3 c-4-2.2-5.5-7.1-3.5-11.1c0.1-0.1,0-0.2-0.1-0.3L26,28.2c-0.1-0.1-0.2,0-0.3,0c-0.2,0.1-0.3,0.3-0.5,0.3c0,0,0,0,0,0 c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.3,0.1-0.4,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0 c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2-0.1c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c-0.2-0.1-0.3-0.2-0.5-0.3 c-0.1-0.1-0.2-0.1-0.3,0l-1.2,0.7c-0.1,0.1-0.1,0.2-0.1,0.3c1.9,4,0.4,8.8-3.5,11.1c-3.6,2.1-8.2,1.3-10.9-1.7 c-0.1-0.1-0.2-0.1-0.3-0.1l-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3c3.6,4.5,10.2,5.8,15.4,2.8c1.2-0.7,2.2-1.5,3-2.4 c0.8,0.9,1.8,1.8,3,2.4c5.2,3,11.7,1.6,15.4-2.8c0.1-0.1,0-0.2-0.1-0.3L42,38.5c-0.1-0.1-0.2,0-0.3,0.1C39,41.5,34.4,42.3,30.8,40.3 L30.8,40.3z"}}]})(props);
};
function FcBiomass (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#9CCC65","d":"M32,15V7H16v8L6.2,40c-0.6,1.5,0.5,3,2.1,3h31.5c1.6,0,2.6-1.6,2.1-3L32,15z"}},{"tag":"path","attr":{"fill":"#8BC34A","d":"M32,9H16c-1.1,0-2-0.9-2-2v0c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2v0C34,8.1,33.1,9,32,9z"}},{"tag":"path","attr":{"fill":"#2E7D32","d":"M28,30c0,4.4-4,8-4,8s-4-3.6-4-8s4-8,4-8S28,25.6,28,30z"}},{"tag":"path","attr":{"fill":"#388E3C","d":"M31.1,32.6c-2,4-7.1,5.4-7.1,5.4s-2-5,0-8.9s7.1-5.4,7.1-5.4S33.1,28.6,31.1,32.6z"}},{"tag":"path","attr":{"fill":"#43A047","d":"M16.9,32.6c2,4,7.1,5.4,7.1,5.4s2-5,0-8.9s-7.1-5.4-7.1-5.4S14.9,28.6,16.9,32.6z"}}]})(props);
};
function FcBiotech (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#AD1457","d":"M36,4c0,9.3-6,13.2-12.8,17.8C16.1,26.5,8,31.8,8,44h4c0-10.1,6.5-14.4,13.4-18.9C32.2,20.6,40,15.4,40,4 H36z"}},{"tag":"path","attr":{"fill":"#AD1457","d":"M38,41H11c-0.6,0-1-0.4-1-1s0.4-1,1-1h27c0.6,0,1,0.4,1,1S38.6,41,38,41z"}},{"tag":"path","attr":{"fill":"#AD1457","d":"M36,37H12c-0.6,0-1-0.4-1-1s0.4-1,1-1h24c0.6,0,1,0.4,1,1S36.6,37,36,37z"}},{"tag":"path","attr":{"fill":"#AD1457","d":"M34,33H14c-0.6,0-1-0.4-1-1s0.4-1,1-1h20c0.6,0,1,0.4,1,1S34.6,33,34,33z"}},{"tag":"path","attr":{"fill":"#AD1457","d":"M29,29H19c-0.6,0-1-0.4-1-1s0.4-1,1-1h10c0.6,0,1,0.4,1,1S29.6,29,29,29z"}},{"tag":"path","attr":{"fill":"#E91E63","d":"M37,9H10C9.4,9,9,8.6,9,8s0.4-1,1-1h27c0.6,0,1,0.4,1,1S37.6,9,37,9z"}},{"tag":"path","attr":{"fill":"#E91E63","d":"M36,13H12c-0.6,0-1-0.4-1-1s0.4-1,1-1h24c0.6,0,1,0.4,1,1S36.6,13,36,13z"}},{"tag":"path","attr":{"fill":"#E91E63","d":"M34,17H14c-0.6,0-1-0.4-1-1s0.4-1,1-1h20c0.6,0,1,0.4,1,1S34.6,17,34,17z"}},{"tag":"path","attr":{"fill":"#E91E63","d":"M29,21H19c-0.6,0-1-0.4-1-1s0.4-1,1-1h10c0.6,0,1,0.4,1,1S29.6,21,29,21z"}},{"tag":"path","attr":{"fill":"#E91E63","d":"M40,44h-4c0-10.1-6.5-14.4-13.4-18.9C15.8,20.6,8,15.4,8,4h4c0,9.3,6,13.2,12.8,17.8 C31.9,26.5,40,31.8,40,44z"}}]})(props);
};
function FcBookmark (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F44336","d":"M37,43l-13-6l-13,6V9c0-2.2,1.8-4,4-4h18c2.2,0,4,1.8,4,4V43z"}}]})(props);
};
function FcBriefcase (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#424242","d":"M27,7h-6c-1.7,0-3,1.3-3,3v3h2v-3c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v3h2v-3C30,8.3,28.7,7,27,7z"}},{"tag":"path","attr":{"fill":"#E65100","d":"M40,43H8c-2.2,0-4-1.8-4-4V15c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,41.2,42.2,43,40,43z"}},{"tag":"path","attr":{"fill":"#FF6E40","d":"M40,28H8c-2.2,0-4-1.8-4-4v-9c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v9C44,26.2,42.2,28,40,28z"}},{"tag":"path","attr":{"fill":"#FFF3E0","d":"M26,26h-4c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v2C27,25.6,26.6,26,26,26z"}}]})(props);
};
function FcBrokenLink (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"path","attr":{"d":"M17.5,27c-1.1,1.2-2.7,2-4.5,2h-3c-3.3,0-6-2.7-6-6s2.7-6,6-6h3c1.8,0,3.4,0.8,4.5,2h4.7 c-1.5-3.5-5.1-6-9.2-6h-3C4.5,13,0,17.5,0,23s4.5,10,10,10h3c4.1,0,7.6-2.5,9.2-6H17.5z"}},{"tag":"path","attr":{"d":"M38,13h-3c-4.1,0-7.6,2.5-9.2,6h4.7c1.1-1.2,2.7-2,4.5-2h3c3.3,0,6,2.7,6,6s-2.7,6-6,6h-3 c-1.8,0-3.4-0.8-4.5-2h-4.7c1.5,3.5,5.1,6,9.2,6h3c5.5,0,10-4.5,10-10S43.5,13,38,13z"}}]},{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"polygon","attr":{"points":"19.5,4 16,6 22.1,14.1 23.4,13.3"}},{"tag":"polygon","attr":{"points":"28.5,4 32,6 25.9,14.1 24.6,13.3"}},{"tag":"polygon","attr":{"points":"28.5,44 32,42 25.9,33.9 24.6,34.7"}},{"tag":"polygon","attr":{"points":"19.5,44 16,42 22.1,33.9 23.4,34.7"}}]}]})(props);
};
function FcBullish (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#4CAF50"},"child":[{"tag":"rect","attr":{"x":"40","y":"21","width":"4","height":"23"}},{"tag":"rect","attr":{"x":"34","y":"28","width":"4","height":"16"}},{"tag":"rect","attr":{"x":"28","y":"23","width":"4","height":"21"}},{"tag":"rect","attr":{"x":"22","y":"29","width":"4","height":"15"}},{"tag":"rect","attr":{"x":"16","y":"32","width":"4","height":"12"}},{"tag":"rect","attr":{"x":"10","y":"30","width":"4","height":"14"}},{"tag":"rect","attr":{"x":"4","y":"34","width":"4","height":"10"}}]},{"tag":"g","attr":{"fill":"#388E3C"},"child":[{"tag":"polygon","attr":{"points":"40.1,9.1 34,15.2 30,11.2 20,21.2 15,16.2 4.6,26.6 7.4,29.4 15,21.8 20,26.8 30,16.8 34,20.8 42.9,11.9"}},{"tag":"polygon","attr":{"points":"44,8 35,8 44,17"}}]}]})(props);
};
function FcBusinessContact (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#673AB7","d":"M40,7H8c-2.2,0-4,1.8-4,4v26c0,2.2,1.8,4,4,4h5v-1.3c-0.6-0.3-1-1-1-1.7c0-1.1,0.9-2,2-2s2,0.9,2,2 c0,0.7-0.4,1.4-1,1.7V41h18v-1.3c-0.6-0.3-1-1-1-1.7c0-1.1,0.9-2,2-2s2,0.9,2,2c0,0.7-0.4,1.4-1,1.7V41h5c2.2,0,4-1.8,4-4V11 C44,8.8,42.2,7,40,7z"}},{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"18","r":"4"}},{"tag":"path","attr":{"d":"M31,28c0,0-1.9-4-7-4c-5.1,0-7,4-7,4v2h14V28z"}}]}]})(props);
};
function FcBusiness (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#263238"},"child":[{"tag":"path","attr":{"d":"M11,44H9c-0.6,0-1-0.4-1-1v-2h4v2C12,43.6,11.6,44,11,44z"}},{"tag":"path","attr":{"d":"M39,44h-2c-0.6,0-1-0.4-1-1v-2h4v2C40,43.6,39.6,44,39,44z"}}]},{"tag":"path","attr":{"fill":"#37474F","d":"M27,7h-6c-1.7,0-3,1.3-3,3v3h2v-3c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v3h2v-3C30,8.3,28.7,7,27,7z"}},{"tag":"path","attr":{"fill":"#78909C","d":"M40,43H8c-2.2,0-4-1.8-4-4V15c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,41.2,42.2,43,40,43z"}}]})(props);
};
function FcBusinessman (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#FF9800","points":"24,37 19,31 19,25 29,25 29,31"}},{"tag":"g","attr":{"fill":"#FFA726"},"child":[{"tag":"circle","attr":{"cx":"33","cy":"19","r":"2"}},{"tag":"circle","attr":{"cx":"15","cy":"19","r":"2"}}]},{"tag":"path","attr":{"fill":"#FFB74D","d":"M33,13c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C33,18.9,33,14.1,33,13z"}},{"tag":"path","attr":{"fill":"#424242","d":"M24,4c-6.1,0-10,4.9-10,11c0,0.8,0,2.3,0,2.3l2,1.7v-5l12-4l4,4v5l2-1.7c0,0,0-1.5,0-2.3c0-4-1-8-6-9l-1-2 H24z"}},{"tag":"g","attr":{"fill":"#784719"},"child":[{"tag":"circle","attr":{"cx":"28","cy":"19","r":"1"}},{"tag":"circle","attr":{"cx":"20","cy":"19","r":"1"}}]},{"tag":"polygon","attr":{"fill":"#fff","points":"24,43 19,31 24,32 29,31"}},{"tag":"polygon","attr":{"fill":"#D32F2F","points":"23,35 22.3,39.5 24,43.5 25.7,39.5 25,35 26,34 24,32 22,34"}},{"tag":"path","attr":{"fill":"#546E7A","d":"M29,31L29,31l-5,12l-5-12c0,0-11,2-11,13h32C40,33,29,31,29,31z"}}]})(props);
};
function FcBusinesswoman (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"16","y":"15","fill":"#BF360C","width":"16","height":"18"}},{"tag":"path","attr":{"fill":"#78909C","d":"M40,44H8c0-11,11-13,11-13h10C29,31,40,33,40,44z"}},{"tag":"path","attr":{"fill":"#FF9800","d":"M24,37c-2.2,0-5-6-5-6v-6h10v6C29,31,26.2,37,24,37z"}},{"tag":"path","attr":{"fill":"#FFB74D","d":"M33,14c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C33,19.9,33,15.1,33,14z"}},{"tag":"path","attr":{"fill":"#FF5722","d":"M24,4C17.9,4,9,7.4,9,27.3l7,4.7V19l12-7l4,5v15l7-6c0-4-0.7-20-11-20l-1-2H24z"}},{"tag":"path","attr":{"fill":"#FFB74D","d":"M24,38c-4.4,0-5-7-5-7s2.5,4,5,4s5-4,5-4S28.4,38,24,38z"}},{"tag":"circle","attr":{"fill":"#784719","cx":"28","cy":"21","r":"1"}},{"tag":"circle","attr":{"fill":"#784719","cx":"20","cy":"21","r":"1"}}]})(props);
};
function FcButtingIn (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#CFD8DC","d":"M24,3C12.4,3,3,12.4,3,24c0,11.6,9.4,21,21,21c0.3,0,0.7,0,1-0.1V3.1C24.7,3,24.3,3,24,3z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M25,3.1v41.9c4.1-0.2,7.9-1.5,11-3.7V6.8C32.9,4.6,29.1,3.2,25,3.1z"}},{"tag":"path","attr":{"fill":"#FFB74D","d":"M20.5,13C14.1,13.3,8.9,18.7,9,25.1c0,2.8,1,5.4,2.7,7.5c1.4,1.7,2.3,3.9,2.3,6.1v3.8c3,1.6,6.4,2.5,10,2.5 c0.3,0,0.7,0,1-0.1c0.7,0,1.3-0.1,2-0.2v-9.4c3.6-2.1,6-5.9,6-10.4C33,18.2,27.4,12.7,20.5,13z"}},{"tag":"path","attr":{"fill":"#FFB74D","d":"M29,38.6L25,38v-9h8l-0.7,7C32.1,37.6,30.7,38.8,29,38.6z"}},{"tag":"polygon","attr":{"fill":"#FFB74D","points":"39,29 32,31 31,26 32,22"}},{"tag":"circle","attr":{"fill":"#784719","cx":"29.5","cy":"25.5","r":"1.5"}},{"tag":"path","attr":{"fill":"#FF5722","d":"M21,12c-7.2,0-13,5.8-13,13c0,7.6,5.1,9,6,13l4-3v-8l5-2l1-4c3.2,0,6-3.9,6-6.1C27.9,13,24.4,12,21,12z"}},{"tag":"circle","attr":{"fill":"#FFB74D","cx":"19","cy":"27","r":"3"}},{"tag":"path","attr":{"fill":"#CFD8DC","d":"M45,24c0-7.1-3.6-13.4-9-17.2v34.4C41.4,37.4,45,31.1,45,24z"}},{"tag":"path","attr":{"fill":"#FF9800","d":"M20,44.6c1.3,0.2,2.6,0.4,4,0.4c0.3,0,0.7,0,1-0.1c0.7,0,1.3-0.1,2-0.2v-6.5l-7-1V44.6z"}}]})(props);
};
function FcCableRelease (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M34.9,29.1c-2.7-2.7-7.1-2.7-9.8,0l-4,4c-1.7,1.7-4.5,1.7-6.2,0c-1.7-1.7-1.7-4.5,0-6.2l4.5-4.5l-2.8-2.8 l-4.5,4.5c-3.3,3.3-3.3,8.6,0,11.8c3.3,3.3,8.6,3.3,11.8,0l4-4c1.2-1.1,3-1.1,4.2,0c1.1,1.2,1.1,3,0,4.2L27,41.2l2.8,2.8l5.1-5.1 C37.6,36.2,37.6,31.8,34.9,29.1z"}},{"tag":"path","attr":{"fill":"#0277BD","d":"M16.1,22.9L16.1,22.9c-2.8-2.8-2.8-7.3,0-10l6.8-6.8c2.8-2.8,7.3-2.8,10,0l0,0c2.8,2.8,2.8,7.3,0,10 l-6.8,6.8C23.3,25.7,18.9,25.7,16.1,22.9z"}},{"tag":"circle","attr":{"fill":"#B3E5FC","cx":"28","cy":"11","r":"4"}}]})(props);
};
function FcCalculator (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#616161","d":"M40,16H8v24c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V16z"}},{"tag":"path","attr":{"fill":"#424242","d":"M36,4H12C9.8,4,8,5.8,8,8v9h32V8C40,5.8,38.2,4,36,4z"}},{"tag":"path","attr":{"fill":"#9CCC65","d":"M36,14H12c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h24c0.6,0,1,0.4,1,1v5C37,13.6,36.6,14,36,14z"}},{"tag":"g","attr":{"fill":"#33691E"},"child":[{"tag":"rect","attr":{"x":"33","y":"10","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"29","y":"10","width":"2","height":"2"}}]},{"tag":"path","attr":{"fill":"#FF5252","d":"M36,23h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C37,22.6,36.6,23,36,23z"}},{"tag":"g","attr":{"fill":"#E0E0E0"},"child":[{"tag":"path","attr":{"d":"M15,23h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C16,22.6,15.6,23,15,23z"}},{"tag":"path","attr":{"d":"M22,23h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C23,22.6,22.6,23,22,23z"}},{"tag":"path","attr":{"d":"M29,23h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C30,22.6,29.6,23,29,23z"}},{"tag":"path","attr":{"d":"M15,29h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C16,28.6,15.6,29,15,29z"}},{"tag":"path","attr":{"d":"M22,29h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C23,28.6,22.6,29,22,29z"}},{"tag":"path","attr":{"d":"M29,29h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C30,28.6,29.6,29,29,29z"}},{"tag":"path","attr":{"d":"M15,35h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C16,34.6,15.6,35,15,35z"}},{"tag":"path","attr":{"d":"M22,35h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C23,34.6,22.6,35,22,35z"}},{"tag":"path","attr":{"d":"M29,35h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C30,34.6,29.6,35,29,35z"}},{"tag":"path","attr":{"d":"M15,41h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C16,40.6,15.6,41,15,41z"}},{"tag":"path","attr":{"d":"M22,41h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C23,40.6,22.6,41,22,41z"}},{"tag":"path","attr":{"d":"M29,41h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C30,40.6,29.6,41,29,41z"}}]},{"tag":"g","attr":{"fill":"#BDBDBD"},"child":[{"tag":"path","attr":{"d":"M36,29h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C37,28.6,36.6,29,36,29z"}},{"tag":"path","attr":{"d":"M36,35h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C37,34.6,36.6,35,36,35z"}},{"tag":"path","attr":{"d":"M36,41h-3c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h3c0.6,0,1,0.4,1,1v2C37,40.6,36.6,41,36,41z"}}]}]})(props);
};
function FcCalendar (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#CFD8DC","d":"M5,38V14h38v24c0,2.2-1.8,4-4,4H9C6.8,42,5,40.2,5,38z"}},{"tag":"path","attr":{"fill":"#F44336","d":"M43,10v6H5v-6c0-2.2,1.8-4,4-4h30C41.2,6,43,7.8,43,10z"}},{"tag":"g","attr":{"fill":"#B71C1C"},"child":[{"tag":"circle","attr":{"cx":"33","cy":"10","r":"3"}},{"tag":"circle","attr":{"cx":"15","cy":"10","r":"3"}}]},{"tag":"g","attr":{"fill":"#B0BEC5"},"child":[{"tag":"path","attr":{"d":"M33,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C35,3.9,34.1,3,33,3z"}},{"tag":"path","attr":{"d":"M15,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C17,3.9,16.1,3,15,3z"}}]},{"tag":"g","attr":{"fill":"#90A4AE"},"child":[{"tag":"rect","attr":{"x":"13","y":"20","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"19","y":"20","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"25","y":"20","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"31","y":"20","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"13","y":"26","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"19","y":"26","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"25","y":"26","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"31","y":"26","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"13","y":"32","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"19","y":"32","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"25","y":"32","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"31","y":"32","width":"4","height":"4"}}]}]})(props);
};
function FcCallTransfer (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#009688","d":"M39.2,8.4l-1.8,1.8c-6.3,6.5-5.4,22,0,27.6l1.8,1.8c0.5,0.5,1.3,0.5,1.8,0l3.6-3.7c0.5-0.5,0.5-1.3,0-1.8 l-3.4-3.4h-4.8c-1.3-1.3-1.3-12.1,0-13.4h4.8l3.3-3.4c0.5-0.5,0.5-1.3,0-1.8L41,8.4C40.5,7.9,39.7,7.9,39.2,8.4z"}},{"tag":"path","attr":{"fill":"#009688","d":"M11.2,8.4l-1.8,1.8c-6.3,6.5-5.4,22,0,27.6l1.8,1.8c0.5,0.5,1.3,0.5,1.8,0l3.6-3.7c0.5-0.5,0.5-1.3,0-1.8 l-3.4-3.4H8.5c-1.3-1.3-1.3-12.1,0-13.4h4.8l3.3-3.4c0.5-0.5,0.5-1.3,0-1.8L13,8.4C12.5,7.9,11.7,7.9,11.2,8.4z"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"polygon","attr":{"points":"25.3,18.6 30.7,24 25.3,29.4"}},{"tag":"rect","attr":{"x":"16","y":"22","width":"11","height":"4"}}]}]})(props);
};
function FcCallback (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#2196F3","d":"M26.4,33.9c0,0,4-2.6,4.8-3c0.8-0.4,1.7-0.6,2.2-0.2c0.8,0.5,7.5,4.9,8.1,5.3c0.6,0.4,0.8,1.5,0.1,2.6 c-0.8,1.1-4.3,5.5-5.8,5.4c-1.5,0-8.4,0.4-20.3-11.4C3.6,20.7,4,13.8,4,12.3c0-1.5,4.3-5.1,5.4-5.8c1.1-0.8,2.2-0.5,2.6,0.1 c0.4,0.6,4.8,7.3,5.3,8.1c0.3,0.5,0.2,1.4-0.2,2.2c-0.4,0.8-3,4.8-3,4.8s0.7,2.8,5,7.2C23.5,33.2,26.4,33.9,26.4,33.9z"}},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"path","attr":{"d":"M35,9H25v4h10c1.1,0,2,0.9,2,2v10h4V15C41,11.7,38.3,9,35,9z"}},{"tag":"polygon","attr":{"points":"28,16 21.3,11 28,6"}}]}]})(props);
};
function FcCamcorderPro (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"27","y":"8","fill":"#37474F","width":"10","height":"4"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M27,8h-9.7c-1.5,0-2.8,0.8-3.5,2.1l-3.3,6L14,18l3.3-6H27v7.2h4V12C31,9.8,29.2,8,27,8z"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M30,40H6c-2.2,0-4-1.8-4-4V20c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v16C34,38.2,32.2,40,30,40z"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M38,35l5,5h3V18h-3l-5,5V35z"}},{"tag":"path","attr":{"fill":"#546E7A","d":"M22,35H8c-1.1,0-2-0.9-2-2V23c0-1.1,0.9-2,2-2h14c1.1,0,2,0.9,2,2v10C24,34.1,23.1,35,22,35z"}},{"tag":"rect","attr":{"x":"34","y":"23","fill":"#455A64","width":"4","height":"12"}},{"tag":"path","attr":{"fill":"#263238","d":"M41,13h-4c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h4c1.7,0,3,1.3,3,3v0C44,11.7,42.7,13,41,13z"}},{"tag":"rect","attr":{"x":"8","y":"23","fill":"#03A9F4","width":"14","height":"10"}},{"tag":"polygon","attr":{"fill":"#4FC3F7","points":"13.5,25.5 9,32 18,32"}},{"tag":"g","attr":{"fill":"#B3E5FC"},"child":[{"tag":"circle","attr":{"cx":"19.5","cy":"25.5","r":"1.5"}},{"tag":"polygon","attr":{"points":"17.5,27.6 14,32 21,32"}}]}]})(props);
};
function FcCamcorder (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#607D8B","d":"M20,42H10c-2.2,0-4-1.8-4-4V15c0-5,4-9,9-9h0c5,0,9,4,9,9v23C24,40.2,22.2,42,20,42z"}},{"tag":"circle","attr":{"fill":"#455A64","cx":"15","cy":"15","r":"7"}},{"tag":"circle","attr":{"fill":"#42A5F5","cx":"15","cy":"15","r":"5.2"}},{"tag":"path","attr":{"fill":"#90CAF9","d":"M18.3,13c-0.8-0.9-2-1.5-3.3-1.5S12.6,12,11.7,13c-0.3,0.4-0.3,0.9,0.1,1.2c0.4,0.3,0.9,0.3,1.2-0.1 c1-1.2,2.9-1.2,3.9,0c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.4-0.1,0.6-0.2C18.6,13.9,18.6,13.3,18.3,13z"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M40,31H28c-1.1,0-2-0.9-2-2V19c0-1.1,0.9-2,2-2h12c1.1,0,2,0.9,2,2v10C42,30.1,41.1,31,40,31z"}},{"tag":"rect","attr":{"x":"24","y":"19","fill":"#455A64","width":"2","height":"10"}},{"tag":"rect","attr":{"x":"28","y":"19","fill":"#03A9F4","width":"12","height":"10"}},{"tag":"polygon","attr":{"fill":"#4FC3F7","points":"33,22.2 29,28 37,28"}},{"tag":"g","attr":{"fill":"#B3E5FC"},"child":[{"tag":"circle","attr":{"cx":"37.5","cy":"21.5","r":"1"}},{"tag":"polygon","attr":{"points":"36,24.2 33,28 39,28"}}]},{"tag":"circle","attr":{"fill":"#455A64","cx":"15","cy":"35","r":"3"}},{"tag":"circle","attr":{"fill":"#F44336","cx":"15","cy":"35","r":"2"}}]})(props);
};
function FcCameraAddon (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#512DA8","d":"M33.9,12.1H14.2L17.6,7c0.4-0.6,1-0.9,1.7-0.9h9.6c0.7,0,1.3,0.3,1.7,0.9L33.9,12.1z"}},{"tag":"path","attr":{"fill":"#8667C4","d":"M14,11H8V9.2C8,8.5,8.5,8,9.2,8h3.6C13.5,8,14,8.5,14,9.2V11z"}},{"tag":"path","attr":{"fill":"#5E35B1","d":"M40,42H8c-2.2,0-4-1.8-4-4V14c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,40.2,42.2,42,40,42z"}},{"tag":"circle","attr":{"fill":"#512DA8","cx":"24","cy":"26","r":"12"}},{"tag":"circle","attr":{"fill":"#B388FF","cx":"24","cy":"26","r":"9"}},{"tag":"path","attr":{"fill":"#C7A7FF","d":"M28.8,23c-1.2-1.4-3-2.2-4.8-2.2s-3.6,0.8-4.8,2.2c-0.5,0.5-0.4,1.3,0.1,1.8c0.5,0.5,1.3,0.4,1.8-0.1 c1.5-1.7,4.3-1.7,5.8,0c0.3,0.3,0.6,0.4,1,0.4c0.3,0,0.6-0.1,0.9-0.3C29.2,24.4,29.3,23.5,28.8,23z"}},{"tag":"ellipse","attr":{"fill":"#8667C4","cx":"11","cy":"13.5","rx":"2","ry":"1.5"}},{"tag":"path","attr":{"fill":"#8BC34A","d":"M48,33.8c0-1.3-1.1-2.4-2.4-2.4H42c-0.4,0-0.7-0.5-0.4-0.8c0.4-0.6,0.5-1.3,0.4-2.1 c-0.2-1.2-1.1-2.1-2.3-2.4C37.7,25.7,36,27.1,36,29c0,0.6,0.2,1.1,0.4,1.6c0.2,0.4,0,0.8-0.5,0.8h-3.6c-1.3,0-2.4,1.1-2.4,2.4V37 c0,0.4,0.5,0.7,0.8,0.4c0.6-0.4,1.3-0.5,2.1-0.4c1.2,0.2,2.1,1.1,2.4,2.3c0.4,1.9-1.1,3.6-2.9,3.6c-0.6,0-1.1-0.2-1.6-0.4 c-0.4-0.2-0.8,0-0.8,0.5v2.6c0,1.3,1.1,2.4,2.4,2.4h13.2c1.3,0,2.4-1.1,2.4-2.4V33.8z"}}]})(props);
};
function FcCameraIdentification (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#512DA8","d":"M33.9,12.1H14.2L17.6,7c0.4-0.6,1-0.9,1.7-0.9h9.6c0.7,0,1.3,0.3,1.7,0.9L33.9,12.1z"}},{"tag":"path","attr":{"fill":"#8667C4","d":"M14,11H8V9.2C8,8.5,8.5,8,9.2,8h3.6C13.5,8,14,8.5,14,9.2V11z"}},{"tag":"path","attr":{"fill":"#5E35B1","d":"M40,42H8c-2.2,0-4-1.8-4-4V14c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,40.2,42.2,42,40,42z"}},{"tag":"circle","attr":{"fill":"#512DA8","cx":"24","cy":"26","r":"12"}},{"tag":"circle","attr":{"fill":"#B388FF","cx":"24","cy":"26","r":"9"}},{"tag":"g","attr":{"fill":"#616161"},"child":[{"tag":"rect","attr":{"x":"42.2","y":"38.3","transform":"matrix(.707 -.707 .707 .707 -18.002 43.46)","width":"2.4","height":"10.4"}},{"tag":"circle","attr":{"cx":"35","cy":"35","r":"10"}}]},{"tag":"rect","attr":{"x":"43.9","y":"42.4","transform":"matrix(.707 -.707 .707 .707 -18.709 45.167)","fill":"#37474F","width":"2.4","height":"5.6"}},{"tag":"circle","attr":{"fill":"#64B5F6","cx":"35","cy":"35","r":"8"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M39.3,31.4c-1.1-1.3-2.6-2-4.2-2s-3.2,0.7-4.2,2c-0.2,0.3-0.2,0.6,0.1,0.9c0.3,0.2,0.6,0.2,0.9-0.1 c0.8-1,2-1.5,3.3-1.5s2.5,0.6,3.3,1.5c0.1,0.1,0.3,0.2,0.5,0.2c0.1,0,0.3,0,0.4-0.1C39.5,32.1,39.5,31.7,39.3,31.4z"}},{"tag":"path","attr":{"fill":"#C7A7FF","d":"M29,23c-1.2-1.4-3-2.2-4.8-2.2c-1.8,0-3.6,0.8-4.8,2.2c-0.5,0.5-0.4,1.3,0.1,1.8c0.5,0.5,1.3,0.4,1.8-0.1 c1.5-1.7,4.3-1.7,5.8,0c0.3,0.3,0.6,0.4,1,0.4c0.3,0,0.6-0.1,0.9-0.3C29.4,24.4,29.5,23.5,29,23z"}},{"tag":"ellipse","attr":{"fill":"#8667C4","cx":"11","cy":"13.5","rx":"2","ry":"1.5"}}]})(props);
};
function FcCamera (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#512DA8","d":"M33.9,12.1H14.2L17.6,7c0.4-0.6,1-0.9,1.7-0.9h9.6c0.7,0,1.3,0.3,1.7,0.9L33.9,12.1z"}},{"tag":"path","attr":{"fill":"#8667C4","d":"M14,11H8V9.2C8,8.5,8.5,8,9.2,8h3.6C13.5,8,14,8.5,14,9.2V11z"}},{"tag":"path","attr":{"fill":"#5E35B1","d":"M40,42H8c-2.2,0-4-1.8-4-4V14c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,40.2,42.2,42,40,42z"}},{"tag":"circle","attr":{"fill":"#512DA8","cx":"24","cy":"26","r":"12"}},{"tag":"circle","attr":{"fill":"#B388FF","cx":"24","cy":"26","r":"9"}},{"tag":"path","attr":{"fill":"#C7A7FF","d":"M29,23c-1.2-1.4-3-2.2-4.8-2.2c-1.8,0-3.6,0.8-4.8,2.2c-0.5,0.5-0.4,1.3,0.1,1.8c0.5,0.5,1.3,0.4,1.8-0.1 c1.5-1.7,4.3-1.7,5.8,0c0.3,0.3,0.6,0.4,1,0.4c0.3,0,0.6-0.1,0.9-0.3C29.4,24.4,29.5,23.5,29,23z"}},{"tag":"ellipse","attr":{"fill":"#8667C4","cx":"11","cy":"13.5","rx":"2","ry":"1.5"}}]})(props);
};
function FcCancel (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#D50000","d":"M24,6C14.1,6,6,14.1,6,24s8.1,18,18,18s18-8.1,18-18S33.9,6,24,6z M24,10c3.1,0,6,1.1,8.4,2.8L12.8,32.4 C11.1,30,10,27.1,10,24C10,16.3,16.3,10,24,10z M24,38c-3.1,0-6-1.1-8.4-2.8l19.6-19.6C36.9,18,38,20.9,38,24C38,31.7,31.7,38,24,38 z"}}]})(props);
};
function FcCandleSticks (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#546E7A"},"child":[{"tag":"rect","attr":{"x":"38","y":"4","width":"2","height":"20"}},{"tag":"rect","attr":{"x":"15","y":"7","width":"2","height":"17"}},{"tag":"rect","attr":{"x":"8","y":"27","width":"2","height":"17"}},{"tag":"rect","attr":{"x":"28","y":"19","width":"2","height":"22"}}]},{"tag":"path","attr":{"fill":"#4CAF50","d":"M36,7h6c1.1,0,2,0.9,2,2v10c0,1.1-0.9,2-2,2h-6c-1.1,0-2-0.9-2-2V9C34,7.9,34.9,7,36,7z"}},{"tag":"path","attr":{"fill":"#4CAF50","d":"M13,10h6c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2h-6c-1.1,0-2-0.9-2-2v-7C11,10.9,11.9,10,13,10z"}},{"tag":"path","attr":{"fill":"#F44336","d":"M6,30h6c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2H6c-1.1,0-2-0.9-2-2v-7C4,30.9,4.9,30,6,30z"}},{"tag":"path","attr":{"fill":"#F44336","d":"M26,22h6c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2h-6c-1.1,0-2-0.9-2-2V24C24,22.9,24.9,22,26,22z"}}]})(props);
};
function FcCapacitor (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FF9800"},"child":[{"tag":"rect","attr":{"y":"27","width":"25","height":"4"}},{"tag":"rect","attr":{"y":"17","width":"25","height":"4"}}]},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"path","attr":{"d":"M46,35c1.1,0,2-0.9,2-2V15c0-1.1-0.9-2-2-2H27v22H46z"}},{"tag":"path","attr":{"d":"M21,13c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h2V13H21z"}}]},{"tag":"path","attr":{"fill":"#303F9F","d":"M25,33c1.1,0,2,0.9,2,2V13c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2v22C23,33.9,23.9,33,25,33z"}}]})(props);
};
function FcCdLogo (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#2196F3","d":"M17.814,18H20.2c0.5,0,0.8,0.4,0.8,0.8v16.4c0,0.399-0.4,0.8-0.8,0.8h-2.384c-0.4,0-0.8-0.4-0.8-0.8V18.8\r\n\t\tC16.916,18.3,17.314,18,17.814,18z"}},{"tag":"path","attr":{"fill":"#2196F3","d":"M14.2,11h-3.3c-0.5,0-0.9,0.403-0.9,0.807V17H2.2C1.6,17,1,17.605,1,18.21v16.58C1,35.396,1.6,36,2.2,36h12\r\n\t\tc0.4,0,0.8-0.305,0.8-0.809V11.807C15,11.403,14.7,11,14.2,11z M10,31.283c0,0.398-0.4,0.8-0.8,0.8H6.8c-0.4,0-0.8-0.399-0.8-0.8\r\n\t\tV21.8C6,21.4,6.3,21,6.8,21h2.4c0.5,0,0.8,0.4,0.8,0.8V31.283z"}},{"tag":"path","attr":{"fill":"#2196F3","d":"M33.2,25c0.5,0,0.8,0.6,0.8,0.8v9.4c0,0.399-0.422,0.8-0.8,0.8h-9.4c-0.425,0-0.8-0.4-0.8-0.8v-2.386\r\n\t\tc0-0.5,0.4-0.799,0.8-0.799L30,32v-3h-6.2c-0.331,0-0.8-0.4-0.8-0.801V18.8c0-0.5,0.4-0.8,0.8-0.8h9.4c0.399,0,0.8,0.4,0.8,0.8v2.4\r\n\t\tc0,0.3-0.266,0.8-0.8,0.8H27v3H33.2z"}},{"tag":"path","attr":{"fill":"#2196F3","d":"M48,28v7.2c0,0.399-0.4,0.8-0.801,0.8H36.8c-0.2,0-0.8-0.4-0.8-0.8V18.8c0-0.5,0.432-0.8,0.831-0.8H47.2\r\n\t\tc0,0,0.8,0,0.8,0.8V25h-4v-2.2c0,0,0.1-0.8-0.8-0.8h-2.4c-0.5,0-0.8,0.4-0.8,0.8v8.4c0,0.399,0.5,0.8,0.8,0.8h2.4\r\n\t\tc0.399,0,0.8-0.4,0.8-0.8V28H48z"}}]},{"tag":"g","attr":{},"child":[{"tag":"polygon","attr":{"fill":"#0D47A1","points":"45.799,15.98 46.9,15.98 46.9,12.881 48,12.881 48,11.98 44.799,11.98 44.799,12.881 \r\n\t\t45.799,12.881 \t"}},{"tag":"path","attr":{"fill":"#0D47A1","d":"M44.014,14.476h-1.143v0.095c0,0.382-0.096,0.573-0.572,0.573c-0.475,0-0.57-0.191-0.57-0.762v-0.668\r\n\t\tc0-0.572,0-0.762,0.57-0.762c0.381,0,0.572,0.095,0.572,0.477v0.095h1.047v-0.095c0-1.047-0.381-1.429-1.523-1.429h-0.287\r\n\t\tc-1.141,0-1.523,0.382-1.523,1.618v0.764c0,1.142,0.381,1.618,1.523,1.618h0.383c1.047,0,1.428-0.477,1.428-1.43v-0.095H44.014z"}},{"tag":"polygon","attr":{"fill":"#0D47A1","points":"29.516,12 28.717,14.9 27.816,12 26.217,12 26.217,16 27.316,16 27.316,13 28.115,16 29.217,16 \r\n\t\t30.115,13.1 30.115,16 31.115,16 31.115,12 \t"}},{"tag":"path","attr":{"fill":"#0D47A1","d":"M38.713,12h-0.9h-0.898l-1.199,4h1.199l0.199-0.7h0.602h0.799l0.199,0.7h1.199L38.713,12z M37.914,14.5\r\n\t\th-0.4l0.4-1.7l0,0l0,0l0.398,1.7H37.914z"}},{"tag":"path","attr":{"fill":"#0D47A1","d":"M33.92,12h-0.199H32.02v4h1.102v-1.1h0.6h0.199c1.102,0,1.5-0.4,1.5-1.4v-0.3C35.42,12.3,35.02,12,33.92,12\r\n\t\tz M34.32,13.6c0,0.4-0.1,0.5-0.4,0.5h-0.199h-0.6v-1.2h0.6h0.1c0.4,0,0.5,0.1,0.5,0.4V13.6z"}},{"tag":"path","attr":{"fill":"#0D47A1","d":"M23.594,12h-0.286h-0.286c-1.143,0-1.523,0.382-1.523,1.618v0.762c0,1.144,0.381,1.62,1.523,1.62h0.286\r\n\t\th0.286c1.143,0,1.523-0.477,1.523-1.62v-0.762C25.117,12.382,24.737,12,23.594,12z M23.975,14.19c0,0.571,0,0.763-0.571,0.763\r\n\t\th-0.095h-0.095c-0.571,0-0.571-0.191-0.571-0.763v-0.572c0-0.57,0-0.762,0.571-0.762h0.095h0.095c0.571,0,0.571,0.191,0.571,0.762\r\n\t\tV14.19z"}},{"tag":"path","attr":{"fill":"#0D47A1","d":"M20.422,14.477h-1.144v0.095c0,0.382-0.095,0.571-0.571,0.571c-0.476,0-0.571-0.189-0.571-0.762v-0.666\r\n\t\tc0-0.573,0-0.762,0.571-0.762c0.381,0,0.571,0.095,0.571,0.475v0.096h1.048v-0.096c0-1.047-0.381-1.428-1.523-1.428h-0.286\r\n\t\tc-1.143,0-1.524,0.381-1.524,1.618v0.763c0,1.143,0.381,1.619,1.524,1.619h0.381c1.048,0,1.429-0.477,1.429-1.429v-0.095H20.422z"}}]}]})(props);
};
function FcCellPhone (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#546E7A","d":"M12,40V10h20c2.2,0,4,1.8,4,4v26c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z"}},{"tag":"path","attr":{"fill":"#4FC3F7","d":"M32,13H16c-0.6,0-1,0.4-1,1v8c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1v-8C33,13.4,32.6,13,32,13z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M19,30h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C20,29.6,19.6,30,19,30z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M25,30h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C26,29.6,25.6,30,25,30z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M31,30h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C32,29.6,31.6,30,31,30z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M19,35h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C20,34.6,19.6,35,19,35z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M25,35h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C26,34.6,25.6,35,25,35z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M31,35h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C32,34.6,31.6,35,31,35z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M19,40h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C20,39.6,19.6,40,19,40z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M25,40h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C26,39.6,25.6,40,25,40z"}},{"tag":"path","attr":{"fill":"#B3E5FC","d":"M31,40h-2c-0.6,0-1-0.4-1-1v-1c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v1C32,39.6,31.6,40,31,40z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M16,10h-4V4c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2V10z"}}]})(props);
};
function FcChargeBattery (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#8BC34A"},"child":[{"tag":"path","attr":{"d":"M34,44H14c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v34C36,43.1,35.1,44,34,44z"}},{"tag":"path","attr":{"d":"M28,13h-8c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1v7C29,12.6,28.6,13,28,13z"}}]},{"tag":"polygon","attr":{"fill":"#FFEB3B","points":"30,24 24.5,24 26.7,13 18,26 23.5,26 21.3,37"}}]})(props);
};
function FcCheckmark (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#43A047","points":"40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"}}]})(props);
};
function FcCircuit (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#4CAF50","d":"M6,10v28c0,2.2,1.8,4,4,4h28c2.2,0,4-1.8,4-4V10c0-2.2-1.8-4-4-4H10C7.8,6,6,7.8,6,10z"}},{"tag":"g","attr":{"fill":"#FFC107"},"child":[{"tag":"path","attr":{"d":"M6.6,8l6,6c-0.4,0.6-0.6,1.3-0.6,2c0,2.2,1.8,4,4,4s4-1.8,4-4s-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6l-6-6 C7.4,6.9,6.9,7.4,6.6,8z M16,14.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5S15.2,14.5,16,14.5z"}},{"tag":"path","attr":{"d":"M41.4,40l-6-6c0.4-0.6,0.6-1.3,0.6-2c0-2.2-1.8-4-4-4s-4,1.8-4,4s1.8,4,4,4c0.7,0,1.4-0.2,2-0.6l6,6 C40.6,41.1,41.1,40.6,41.4,40z M32,33.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S32.8,33.5,32,33.5z"}},{"tag":"path","attr":{"d":"M16,36c2.2,0,4-1.8,4-4c0-0.7-0.2-1.4-0.6-2L30,19.4c0.6,0.4,1.3,0.6,2,0.6c2.2,0,4-1.8,4-4s-1.8-4-4-4 s-4,1.8-4,4c0,0.7,0.2,1.4,0.6,2L18,28.6c-0.6-0.4-1.3-0.6-2-0.6c-2.2,0-4,1.8-4,4S13.8,36,16,36z M32,14.5c0.8,0,1.5,0.7,1.5,1.5 s-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5S31.2,14.5,32,14.5z M16,30.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5 S15.2,30.5,16,30.5z"}}]}]})(props);
};
function FcClapperboard (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#3F51B5","d":"M43.4,8.3L4,15l-0.3-2c-0.4-2.2,1.1-4.2,3.3-4.6l31.6-5.3c2.2-0.4,4.2,1.1,4.6,3.3L43.4,8.3z"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M40,41H8c-2.2,0-4-1.8-4-4V15h40v22C44,39.2,42.2,41,40,41z"}},{"tag":"g","attr":{"fill":"#9FA8DA"},"child":[{"tag":"polygon","attr":{"points":"18.8,6.4 23.7,11.7 27.7,11 22.7,5.7"}},{"tag":"polygon","attr":{"points":"10.9,7.7 15.8,13 19.8,12.3 14.8,7.1"}},{"tag":"polygon","attr":{"points":"26.7,5.1 31.6,10.3 35.5,9.7 30.6,4.4"}},{"tag":"polygon","attr":{"points":"34.5,3.8 39.5,9 43.4,8.3 38.5,3.1"}}]},{"tag":"circle","attr":{"fill":"#9FA8DA","cx":"7.5","cy":"11.5","r":"1.5"}},{"tag":"g","attr":{"fill":"#9FA8DA"},"child":[{"tag":"polygon","attr":{"points":"40,15 36,21 40,21 44,15"}},{"tag":"polygon","attr":{"points":"32,15 28,21 32,21 36,15"}},{"tag":"polygon","attr":{"points":"24,15 20,21 24,21 28,15"}},{"tag":"polygon","attr":{"points":"16,15 12,21 16,21 20,15"}},{"tag":"polygon","attr":{"points":"8,15 4,21 8,21 12,15"}}]}]})(props);
};
function FcClearFilters (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#F57C00","points":"29,23 19,23 7,9 41,9"}},{"tag":"g","attr":{"fill":"#FF9800"},"child":[{"tag":"polygon","attr":{"points":"29,38 19,44 19,23 29,23"}},{"tag":"path","attr":{"d":"M41.5,9h-35C5.7,9,5,8.3,5,7.5v0C5,6.7,5.7,6,6.5,6h35C42.3,6,43,6.7,43,7.5v0C43,8.3,42.3,9,41.5,9z"}}]},{"tag":"circle","attr":{"fill":"#F44336","cx":"38","cy":"38","r":"10"}},{"tag":"rect","attr":{"x":"32","y":"36","fill":"#fff","width":"12","height":"4"}}]})(props);
};
function FcClock (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#00ACC1","cx":"24","cy":"24","r":"20"}},{"tag":"circle","attr":{"fill":"#eee","cx":"24","cy":"24","r":"16"}},{"tag":"rect","attr":{"x":"23","y":"11","width":"2","height":"13"}},{"tag":"rect","attr":{"x":"26.1","y":"22.7","transform":"matrix(-.707 .707 -.707 -.707 65.787 27.25)","width":"2.3","height":"9.2"}},{"tag":"circle","attr":{"cx":"24","cy":"24","r":"2"}},{"tag":"circle","attr":{"fill":"#00ACC1","cx":"24","cy":"24","r":"1"}}]})(props);
};
function FcCloseUpMode (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#2E7D32","d":"M5,24c0,18.9,14.8,19,17,19s4,0,4,0S24.1,26.5,5,24z"}},{"tag":"rect","attr":{"x":"22","y":"26","fill":"#388E3C","width":"4","height":"17"}},{"tag":"path","attr":{"fill":"#C62828","d":"M34,16c0,5.1-5.2,8.2-8,8.2s-2-3.1-2-8.2s5-9.2,5-9.2S34,10.9,34,16z"}},{"tag":"path","attr":{"fill":"#C62828","d":"M14,16c0,5.1,5.2,8.2,8,8.2s2-3.1,2-8.2s-5-9.2-5-9.2S14,10.9,14,16z"}},{"tag":"path","attr":{"fill":"#E53935","d":"M24,27c-2.2-1.6-1.9-4.5,2.4-8.8C30.8,13.8,32,7,32,7s5,3.4,5,9C37,21.9,31.3,27,24,27z"}},{"tag":"path","attr":{"fill":"#E53935","d":"M24,27c2.2-1.6,1.9-4.5-2.4-8.8C17.2,13.8,16,7,16,7s-5,3.4-5,9C11,21.9,16.7,27,24,27z"}},{"tag":"path","attr":{"fill":"#F44336","d":"M30,16c0,6.1-2.7,11-6,11s-6-4.9-6-11s6-11,6-11S30,9.9,30,16z"}},{"tag":"path","attr":{"fill":"#4CAF50","d":"M22,43c0,0,1.8,0,4,0s17-0.1,17-19C23.9,26.5,22,43,22,43z"}}]})(props);
};
function FcCloth (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF5722","d":"M6,10v28c0,2.2,1.8,4,4,4h28c2.2,0,4-1.8,4-4V10c0-2.2-1.8-4-4-4H10C7.8,6,6,7.8,6,10z"}},{"tag":"g","attr":{"fill":"#BF360C"},"child":[{"tag":"rect","attr":{"x":"6","y":"35","width":"36","height":"2"}},{"tag":"rect","attr":{"x":"6","y":"31","width":"36","height":"2"}},{"tag":"path","attr":{"d":"M6.1,39c0.2,0.8,0.6,1.5,1.2,2h33.2c0.6-0.5,1-1.2,1.2-2H6.1z"}},{"tag":"path","attr":{"d":"M6.1,9h35.7c-0.2-0.8-0.6-1.5-1.2-2H7.4C6.8,7.5,6.3,8.2,6.1,9z"}},{"tag":"rect","attr":{"x":"6","y":"23","width":"36","height":"2"}},{"tag":"rect","attr":{"x":"6","y":"27","width":"36","height":"2"}},{"tag":"rect","attr":{"x":"6","y":"15","width":"36","height":"2"}},{"tag":"rect","attr":{"x":"6","y":"11","width":"36","height":"2"}},{"tag":"rect","attr":{"x":"6","y":"19","width":"36","height":"2"}}]},{"tag":"g","attr":{"fill":"#FF8A65"},"child":[{"tag":"rect","attr":{"x":"27","y":"6","width":"2","height":"5"}},{"tag":"rect","attr":{"x":"27","y":"13","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"27","y":"29","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"31","y":"6","width":"2","height":"1"}},{"tag":"rect","attr":{"x":"19","y":"29","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"31","y":"9","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"23","y":"6","width":"2","height":"1"}},{"tag":"rect","attr":{"x":"23","y":"25","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"23","y":"9","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"19","y":"21","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"23","y":"17","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"23","y":"33","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"27","y":"21","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"39","y":"33","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"39","y":"17","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"39","y":"25","width":"2","height":"6"}},{"tag":"path","attr":{"d":"M39,6.1V7h1.6C40.2,6.6,39.6,6.3,39,6.1z"}},{"tag":"rect","attr":{"x":"31","y":"17","width":"2","height":"6"}},{"tag":"path","attr":{"d":"M40.6,41H39v0.9C39.6,41.7,40.2,41.4,40.6,41z"}},{"tag":"rect","attr":{"x":"35","y":"13","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"31","y":"33","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"35","y":"29","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"39","y":"9","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"35","y":"21","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"31","y":"25","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"35","y":"37","width":"2","height":"5"}},{"tag":"rect","attr":{"x":"35","y":"6","width":"2","height":"5"}},{"tag":"rect","attr":{"x":"31","y":"41","width":"2","height":"1"}},{"tag":"rect","attr":{"x":"23","y":"41","width":"2","height":"1"}},{"tag":"rect","attr":{"x":"27","y":"37","width":"2","height":"5"}},{"tag":"rect","attr":{"x":"19","y":"37","width":"2","height":"5"}},{"tag":"rect","attr":{"x":"7","y":"17","width":"2","height":"6"}},{"tag":"path","attr":{"d":"M9,41H7.4c0.5,0.4,1,0.7,1.6,0.9V41z"}},{"tag":"path","attr":{"d":"M7.4,7H9V6.1C8.4,6.3,7.8,6.6,7.4,7z"}},{"tag":"rect","attr":{"x":"7","y":"33","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"7","y":"25","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"7","y":"9","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"11","y":"29","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"15","y":"17","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"15","y":"33","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"15","y":"9","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"15","y":"6","width":"2","height":"1"}},{"tag":"rect","attr":{"x":"19","y":"6","width":"2","height":"5"}},{"tag":"rect","attr":{"x":"15","y":"25","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"15","y":"41","width":"2","height":"1"}},{"tag":"rect","attr":{"x":"11","y":"21","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"11","y":"6","width":"2","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"37","width":"2","height":"5"}},{"tag":"rect","attr":{"x":"19","y":"13","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"11","y":"13","width":"2","height":"6"}}]}]})(props);
};
function FcCollaboration (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#1565C0","d":"M25,22h13l6,6V11c0-2.2-1.8-4-4-4H25c-2.2,0-4,1.8-4,4v7C21,20.2,22.8,22,25,22z"}},{"tag":"path","attr":{"fill":"#2196F3","d":"M23,19H10l-6,6V8c0-2.2,1.8-4,4-4h15c2.2,0,4,1.8,4,4v7C27,17.2,25.2,19,23,19z"}},{"tag":"g","attr":{"fill":"#FFA726"},"child":[{"tag":"circle","attr":{"cx":"12","cy":"31","r":"5"}},{"tag":"circle","attr":{"cx":"36","cy":"31","r":"5"}}]},{"tag":"g","attr":{"fill":"#607D8B"},"child":[{"tag":"path","attr":{"d":"M20,42c0,0-2.2-4-8-4s-8,4-8,4v2h16V42z"}},{"tag":"path","attr":{"d":"M44,42c0,0-2.2-4-8-4s-8,4-8,4v2h16V42z"}}]}]})(props);
};
function FcCollapse (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#2196F3","points":"5,30.9 8.1,34 24,18.1 39.9,34 43,30.9 24,12"}}]})(props);
};
function FcCollect (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#009688"},"child":[{"tag":"rect","attr":{"x":"22","y":"35","width":"4","height":"11"}},{"tag":"polygon","attr":{"points":"24,29.6 31,38 17,38"}}]},{"tag":"g","attr":{"fill":"#009688"},"child":[{"tag":"rect","attr":{"x":"22","y":"2","width":"4","height":"11"}},{"tag":"polygon","attr":{"points":"24,18.4 17,10 31,10"}}]},{"tag":"g","attr":{"fill":"#009688"},"child":[{"tag":"rect","attr":{"x":"2","y":"22","width":"11","height":"4"}},{"tag":"polygon","attr":{"points":"18.4,24 10,31 10,17"}}]},{"tag":"g","attr":{"fill":"#009688"},"child":[{"tag":"rect","attr":{"x":"35","y":"22","width":"11","height":"4"}},{"tag":"polygon","attr":{"points":"29.6,24 38,17 38,31"}}]},{"tag":"circle","attr":{"fill":"#F44336","cx":"24","cy":"24","r":"3"}}]})(props);
};
function FcComboChart (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"rect","attr":{"x":"37","y":"18","width":"6","height":"24"}},{"tag":"rect","attr":{"x":"29","y":"26","width":"6","height":"16"}},{"tag":"rect","attr":{"x":"21","y":"22","width":"6","height":"20"}},{"tag":"rect","attr":{"x":"13","y":"32","width":"6","height":"10"}},{"tag":"rect","attr":{"x":"5","y":"28","width":"6","height":"14"}}]},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"circle","attr":{"cx":"8","cy":"16","r":"3"}},{"tag":"circle","attr":{"cx":"16","cy":"18","r":"3"}},{"tag":"circle","attr":{"cx":"24","cy":"11","r":"3"}},{"tag":"circle","attr":{"cx":"32","cy":"13","r":"3"}},{"tag":"circle","attr":{"cx":"40","cy":"9","r":"3"}},{"tag":"polygon","attr":{"points":"39.1,7.2 31.8,10.9 23.5,8.8 15.5,15.8 8.5,14.1 7.5,17.9 16.5,20.2 24.5,13.2 32.2,15.1 40.9,10.8"}}]}]})(props);
};
function FcCommandLine (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#CFD8DC","d":"M41,6H7C6.4,6,6,6.4,6,7v35h36V7C42,6.4,41.6,6,41,6z"}}]},{"tag":"rect","attr":{"x":"8","y":"13","fill":"#263238","width":"32","height":"27"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#76FF03","d":"M22,27.6c-0.1,1.1-0.4,1.9-1,2.5c-0.6,0.6-1.4,0.9-2.5,0.9c-1.1,0-2-0.4-2.6-1.1c-0.6-0.7-0.9-1.8-0.9-3.1\r\n\t\tv-1.6c0-1.3,0.3-2.4,0.9-3.1c0.6-0.7,1.5-1.1,2.6-1.1c1.1,0,1.9,0.3,2.5,0.9c0.6,0.6,0.9,1.4,1,2.6h-2c0-0.7-0.1-1.2-0.3-1.4\r\n\t\tc-0.2-0.3-0.6-0.4-1.1-0.4c-0.5,0-0.9,0.2-1.2,0.6c-0.2,0.4-0.3,1-0.4,1.8v1.8c0,1,0.1,1.6,0.3,2c0.2,0.4,0.6,0.5,1.1,0.5\r\n\t\tc0.5,0,0.9-0.1,1.1-0.4c0.2-0.3,0.3-0.7,0.3-1.4H22z"}},{"tag":"path","attr":{"fill":"#76FF03","d":"M24,24c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7\r\n\t\tc0,0.3-0.1,0.5-0.3,0.7S25.3,25,25,25c-0.3,0-0.5-0.1-0.7-0.3S24,24.3,24,24z"}},{"tag":"path","attr":{"fill":"#76FF03","d":"M24,30c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7\r\n\t\tc0,0.3-0.1,0.5-0.3,0.7S25.3,31,25,31c-0.3,0-0.5-0.1-0.7-0.3S24,30.3,24,30z"}},{"tag":"path","attr":{"fill":"#76FF03","d":"M28,21h2l3,10h-2L28,21z"}}]},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"fill":"#90A4AE","cx":"13.5","cy":"9.5","r":"1.5"}},{"tag":"circle","attr":{"fill":"#90A4AE","cx":"9.5","cy":"9.5","r":"1.5"}}]}]})(props);
};
function FcComments (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#8BC34A","d":"M37,39H11l-6,6V11c0-3.3,2.7-6,6-6h26c3.3,0,6,2.7,6,6v22C43,36.3,40.3,39,37,39z"}}]})(props);
};
function FcCompactCamera (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#607D8B","d":"M40,39H8c-2.2,0-4-1.8-4-4V13c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v22C44,37.2,42.2,39,40,39z"}},{"tag":"circle","attr":{"fill":"#455A64","cx":"29","cy":"24","r":"12"}},{"tag":"circle","attr":{"fill":"#42A5F5","cx":"29","cy":"24","r":"9"}},{"tag":"path","attr":{"fill":"#90CAF9","d":"M33.8,21c-1.2-1.4-3-2.2-4.8-2.2s-3.6,0.8-4.8,2.2c-0.5,0.5-0.4,1.3,0.1,1.8c0.5,0.5,1.3,0.4,1.8-0.1 c1.5-1.7,4.3-1.7,5.8,0c0.3,0.3,0.6,0.4,1,0.4c0.3,0,0.6-0.1,0.9-0.3C34.2,22.4,34.3,21.5,33.8,21z"}},{"tag":"rect","attr":{"x":"8","y":"13","fill":"#ADD8FB","width":"6","height":"3"}}]})(props);
};
function FcConferenceCall (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#FFA726","cx":"12","cy":"21","r":"5"}},{"tag":"g","attr":{"fill":"#455A64"},"child":[{"tag":"path","attr":{"d":"M2,34.7c0,0,2.8-6.3,10-6.3s10,6.3,10,6.3V38H2V34.7z"}},{"tag":"path","attr":{"d":"M46,34.7c0,0-2.8-6.3-10-6.3s-10,6.3-10,6.3V38h20V34.7z"}}]},{"tag":"circle","attr":{"fill":"#FFB74D","cx":"24","cy":"17","r":"6"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M36,34.1c0,0-3.3-7.5-12-7.5s-12,7.5-12,7.5V38h24V34.1z"}},{"tag":"circle","attr":{"fill":"#FFA726","cx":"36","cy":"21","r":"5"}},{"tag":"circle","attr":{"fill":"#FFA726","cx":"12","cy":"21","r":"5"}},{"tag":"circle","attr":{"fill":"#FFA726","cx":"36","cy":"21","r":"5"}}]})(props);
};
function FcContacts (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF7043","d":"M38,44H12V4h26c2.2,0,4,1.8,4,4v32C42,42.2,40.2,44,38,44z"}},{"tag":"path","attr":{"fill":"#BF360C","d":"M10,4h2v40h-2c-2.2,0-4-1.8-4-4V8C6,5.8,7.8,4,10,4z"}},{"tag":"g","attr":{"fill":"#AB300B"},"child":[{"tag":"circle","attr":{"cx":"26","cy":"20","r":"4"}},{"tag":"path","attr":{"d":"M33,30c0,0-1.9-4-7-4c-5.1,0-7,4-7,4v2h14V30z"}}]}]})(props);
};
function FcCopyleft (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#9C27B0","cx":"24","cy":"24","r":"21"}},{"tag":"path","attr":{"fill":"#E1BEE7","d":"M19.3,28.1c0.3,1.3,0.2,4.1,4.6,4.1c0.9,0,4.8,0.2,4.7-7.2v-1.6c0-6.7-3.2-7.2-4.8-7.2 c-2.3,0-4.2,0.6-4.5,4.3h-4.8c0.1-1.2,0.8-8.2,9.3-8.2c4.2,0,9.7,2.5,9.7,11.2V25c0,9.6-6.5,11.2-9.6,11.2c-3.7,0-8.7-1.6-9.3-8.1 H19.3z"}}]})(props);
};
function FcCopyright (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#9C27B0","cx":"24","cy":"24","r":"21"}},{"tag":"path","attr":{"fill":"#E1BEE7","d":"M33.5,28.1c-0.6,6.4-5.6,8.1-9.3,8.1c-3.1,0-9.6-1.6-9.6-11.2v-1.5c0-8.7,5.5-11.2,9.7-11.2 c8.5,0,9.2,7,9.3,8.2h-4.8c-0.3-3.6-2.2-4.3-4.5-4.3c-1.6,0-4.8,0.5-4.8,7.2V25c-0.1,7.5,3.8,7.2,4.7,7.2c4.3,0,4.3-2.9,4.6-4.1 H33.5z"}}]})(props);
};
function FcCrystalOscillator (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FF9800"},"child":[{"tag":"rect","attr":{"x":"3","y":"28","width":"26","height":"4"}},{"tag":"rect","attr":{"x":"3","y":"16","width":"26","height":"4"}}]},{"tag":"path","attr":{"fill":"#2196F3","d":"M43,11H20v26h23c1.1,0,2-0.9,2-2V13C45,11.9,44.1,11,43,11z"}},{"tag":"path","attr":{"fill":"#64B5F6","d":"M20,9h-2v30h2c1.1,0,2-0.9,2-2V11C22,9.9,21.1,9,20,9z"}}]})(props);
};
function FcCurrencyExchange (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#3F51B5","cx":"18","cy":"18","r":"15"}},{"tag":"path","attr":{"fill":"#FFF59D","d":"M20.3,16v1.7h-3.8v1.4h3.8v1.7h-3.8c0,0.6,0.1,1.2,0.3,1.6c0.2,0.4,0.4,0.8,0.7,1c0.3,0.3,0.7,0.4,1.1,0.6 c0.4,0.1,0.9,0.2,1.4,0.2c0.4,0,0.7,0,1.1-0.1c0.4-0.1,0.7-0.1,1-0.3l0.4,2.7c-0.4,0.1-0.9,0.2-1.4,0.2c-0.5,0.1-1,0.1-1.5,0.1 c-0.9,0-1.8-0.1-2.6-0.4c-0.8-0.2-1.5-0.6-2-1.1c-0.6-0.5-1-1.1-1.4-1.9c-0.3-0.7-0.5-1.6-0.5-2.6h-1.9v-1.7h1.9v-1.4h-1.9V16h1.9 c0.1-1,0.3-1.8,0.6-2.6c0.4-0.7,0.8-1.4,1.4-1.9c0.6-0.5,1.3-0.9,2.1-1.1c0.8-0.3,1.7-0.4,2.6-0.4c0.4,0,0.9,0,1.3,0.1 c0.4,0.1,0.9,0.1,1.3,0.3l-0.4,2.7c-0.3-0.1-0.6-0.2-1-0.3c-0.4-0.1-0.7-0.1-1.1-0.1c-0.5,0-1,0.1-1.4,0.2c-0.4,0.1-0.8,0.3-1,0.6 c-0.3,0.3-0.5,0.6-0.7,1s-0.3,0.9-0.3,1.5H20.3z"}},{"tag":"circle","attr":{"fill":"#4CAF50","cx":"30","cy":"30","r":"15"}},{"tag":"path","attr":{"fill":"#fff","d":"M28.4,27c0.1,0.2,0.2,0.4,0.4,0.6c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.2,0.7,0.3,1.1,0.5c0.7,0.3,1.4,0.6,2,0.9 c0.6,0.3,1.1,0.7,1.5,1.1c0.4,0.4,0.8,0.9,1,1.4c0.2,0.5,0.4,1.2,0.4,1.9c0,0.7-0.1,1.3-0.3,1.8c-0.2,0.5-0.5,1-0.9,1.4 s-0.9,0.7-1.4,0.9c-0.6,0.2-1.2,0.4-1.8,0.5v2.2h-1.8v-2.2c-0.6-0.1-1.2-0.2-1.8-0.4s-1.1-0.5-1.5-1c-0.5-0.4-0.8-1-1.1-1.6 c-0.3-0.6-0.4-1.4-0.4-2.3h3.3c0,0.5,0.1,1,0.2,1.3c0.1,0.4,0.3,0.6,0.6,0.9c0.2,0.2,0.5,0.4,0.8,0.5c0.3,0.1,0.6,0.1,0.9,0.1 c0.4,0,0.7,0,0.9-0.1c0.3-0.1,0.5-0.2,0.7-0.4c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.1-0.5,0.1-0.8c0-0.3,0-0.6-0.1-0.8 c-0.1-0.2-0.2-0.5-0.4-0.7s-0.4-0.4-0.7-0.5c-0.3-0.2-0.7-0.3-1.1-0.5c-0.7-0.3-1.4-0.6-2-0.9c-0.6-0.3-1.1-0.7-1.5-1.1 c-0.4-0.4-0.8-0.9-1-1.4c-0.2-0.5-0.4-1.2-0.4-1.9c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.5-1,0.9-1.4c0.4-0.4,0.9-0.7,1.4-1 c0.5-0.2,1.2-0.4,1.8-0.5v-2.4h1.8v2.4c0.6,0.1,1.2,0.3,1.8,0.6c0.5,0.3,1,0.6,1.3,1.1c0.4,0.4,0.7,1,0.9,1.6c0.2,0.6,0.3,1.3,0.3,2 h-3.3c0-0.9-0.2-1.6-0.6-2c-0.4-0.4-0.9-0.7-1.5-0.7c-0.3,0-0.6,0.1-0.9,0.2c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.2-0.3,0.4-0.3,0.6 c-0.1,0.2-0.1,0.5-0.1,0.8C28.3,26.5,28.4,26.8,28.4,27z"}}]})(props);
};
function FcCursor (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E0E0E0","d":"M27.8,39.7c-0.1,0-0.2,0-0.4-0.1c-0.2-0.1-0.4-0.3-0.6-0.5l-3.7-8.6l-4.5,4.2C18.5,34.9,18.3,35,18,35 c-0.1,0-0.3,0-0.4-0.1C17.3,34.8,17,34.4,17,34l0-22c0-0.4,0.2-0.8,0.6-0.9C17.7,11,17.9,11,18,11c0.2,0,0.5,0.1,0.7,0.3l16,15 c0.3,0.3,0.4,0.7,0.3,1.1c-0.1,0.4-0.5,0.6-0.9,0.7l-6.3,0.6l3.9,8.5c0.1,0.2,0.1,0.5,0,0.8c-0.1,0.2-0.3,0.5-0.5,0.6l-2.9,1.3 C28.1,39.7,27.9,39.7,27.8,39.7z"}},{"tag":"path","attr":{"fill":"#212121","d":"M18,12l16,15l-7.7,0.7l4.5,9.8l-2.9,1.3l-4.3-9.9L18,34L18,12 M18,10c-0.3,0-0.5,0.1-0.8,0.2 c-0.7,0.3-1.2,1-1.2,1.8l0,22c0,0.8,0.5,1.5,1.2,1.8C17.5,36,17.8,36,18,36c0.5,0,1-0.2,1.4-0.5l3.4-3.2l3.1,7.3 c0.2,0.5,0.6,0.9,1.1,1.1c0.2,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5-0.1,0.8-0.2l2.9-1.3c0.5-0.2,0.9-0.6,1.1-1.1c0.2-0.5,0.2-1.1,0-1.5 l-3.3-7.2l4.9-0.4c0.8-0.1,1.5-0.6,1.7-1.3c0.3-0.7,0.1-1.6-0.5-2.1l-16-15C19,10.2,18.5,10,18,10L18,10z"}}]})(props);
};
function FcCustomerSupport (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFB74D","d":"M29,43v-4.6l2.6,0.5c2.9,0.6,5.6-1.5,5.8-4.4L38,28l2.9-1.2c1-0.4,1.4-1.6,0.8-2.6L38,18 c-0.6-7.6-4.9-15-16-15C10.6,3,5,11.4,5,20c0,3.7,1.3,6.9,3.3,9.6c1.8,2.5,2.7,5.5,2.7,8.5l0,4.8H29z"}},{"tag":"polygon","attr":{"fill":"#FF9800","points":"29,43 29,38.4 22,37 22,43"}},{"tag":"circle","attr":{"fill":"#784719","cx":"33.5","cy":"21.5","r":"1.5"}},{"tag":"path","attr":{"fill":"#FF5722","d":"M21.4,3C12.3,3,5,10.3,5,19.4c0,11.1,6,11.4,6,18.6l2.6-0.9c2.1-0.7,3.9-2.3,4.7-4.4l2.8-6.8L27,23v-6 c0,0,7-3.8,7-10.3C31,4.2,25.7,3,21.4,3z"}},{"tag":"g","attr":{"fill":"#546E7A"},"child":[{"tag":"path","attr":{"d":"M21,2.1c-0.6,0-1,0.4-1,1v13.9c0,0.6,0.4,1,1,1s1-0.4,1-1V3.1C22,2.5,21.6,2.1,21,2.1z"}},{"tag":"path","attr":{"d":"M36.9,31.9c-7.9,0-10.3-4.9-10.4-5.1c-0.2-0.5-0.8-0.7-1.3-0.5c-0.5,0.2-0.7,0.8-0.5,1.3 c0.1,0.3,3,6.3,12.2,6.3c0.6,0,1-0.4,1-1S37.4,31.9,36.9,31.9z"}}]},{"tag":"circle","attr":{"fill":"#37474F","cx":"37","cy":"33","r":"2"}},{"tag":"circle","attr":{"fill":"#37474F","cx":"21","cy":"23","r":"7"}},{"tag":"circle","attr":{"fill":"#546E7A","cx":"21","cy":"23","r":"4"}}]})(props);
};
function FcDam (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#81D4FA"},"child":[{"tag":"rect","attr":{"x":"24","y":"28","width":"18","height":"14"}},{"tag":"rect","attr":{"x":"6","y":"10","width":"12","height":"32"}}]},{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"path","attr":{"d":"M16,8h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2H8c0,1.1-0.9,2-2,2v2c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4 s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2C16.9,10,16,9.1,16,8z"}},{"tag":"path","attr":{"d":"M16,14h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2H8c0,1.1-0.9,2-2,2v2c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4 s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2C16.9,16,16,15.1,16,14z"}},{"tag":"path","attr":{"d":"M16,20h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2H8c0,1.1-0.9,2-2,2v2c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4 s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2C16.9,22,16,21.1,16,20z"}},{"tag":"path","attr":{"d":"M16,26h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2H8c0,1.1-0.9,2-2,2v2c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4 s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2C16.9,28,16,27.1,16,26z"}},{"tag":"path","attr":{"d":"M16,32h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2H8c0,1.1-0.9,2-2,2v2c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4 s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2C16.9,34,16,33.1,16,32z"}},{"tag":"path","attr":{"d":"M16,38h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2H8c0,1.1-0.9,2-2,2v2c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4 s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2C16.9,40,16,39.1,16,38z"}},{"tag":"path","attr":{"d":"M40,32h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2h-2c0,1.1-0.9,2-2,2v2 c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2 C40.9,34,40,33.1,40,32z"}},{"tag":"path","attr":{"d":"M40,26h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2h-2c0,1.1-0.9,2-2,2v2 c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2 C40.9,28,40,27.1,40,26z"}},{"tag":"path","attr":{"d":"M40,38h-2c0,1.1-0.9,2-2,2s-2-0.9-2-2h-2c0,1.1-0.9,2-2,2v2c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4 s2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4v-2C40.9,40,40,39.1,40,38z"}}]},{"tag":"path","attr":{"fill":"#455A64","d":"M25.1,9.2L31.5,42H18V6h3.2C23.1,6,24.8,7.4,25.1,9.2z"}}]})(props);
};
function FcDataBackup (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z"}}]},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"polygon","attr":{"points":"31,30 38,35.6 38,24.4"}},{"tag":"path","attr":{"d":"M38,28c-0.3,0-0.7,0-1,0.1v4c0.3-0.1,0.7-0.1,1-0.1c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6 c0-0.3,0-0.6,0.1-0.9l-3.4-2.7C28.3,35.5,28,36.7,28,38c0,5.5,4.5,10,10,10s10-4.5,10-10S43.5,28,38,28z"}}]}]})(props);
};
function FcDataConfiguration (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z"}}]},{"tag":"path","attr":{"fill":"#607D8B","d":"M45.2,38.1c0.1-0.4,0.1-0.8,0.1-1.1s0-0.8-0.1-1.1l2.3-1.7c0.2-0.2,0.3-0.5,0.2-0.7l-2.3-3.9 c-0.1-0.2-0.4-0.3-0.7-0.2l-2.6,1.2c-0.6-0.5-1.3-0.9-2-1.2l-0.3-2.9c0-0.3-0.3-0.5-0.5-0.5h-4.5c-0.3,0-0.5,0.2-0.5,0.5l-0.3,2.9 c-0.7,0.3-1.4,0.7-2,1.2l-2.6-1.2c-0.3-0.1-0.6,0-0.7,0.2l-2.3,3.9c-0.1,0.2-0.1,0.6,0.2,0.7l2.3,1.7c-0.1,0.4-0.1,0.8-0.1,1.1 s0,0.8,0.1,1.1l-2.3,1.7c-0.2,0.2-0.3,0.5-0.2,0.7l2.3,3.9c0.1,0.2,0.4,0.3,0.7,0.2l2.6-1.2c0.6,0.5,1.3,0.9,2,1.2l0.3,2.9 c0,0.3,0.3,0.5,0.5,0.5h4.5c0.3,0,0.5-0.2,0.5-0.5l0.3-2.9c0.7-0.3,1.4-0.7,2-1.2l2.6,1.2c0.3,0.1,0.6,0,0.7-0.2l2.3-3.9 c0.1-0.2,0.1-0.6-0.2-0.7L45.2,38.1z M37,42.2c-2.9,0-5.2-2.3-5.2-5.2c0-2.9,2.3-5.2,5.2-5.2c2.9,0,5.2,2.3,5.2,5.2 C42.2,39.9,39.9,42.2,37,42.2z"}},{"tag":"path","attr":{"fill":"#455A64","d":"M37,31c-3.3,0-6,2.7-6,6c0,3.3,2.7,6,6,6s6-2.7,6-6C43,33.7,40.3,31,37,31z M37,40c-1.7,0-3-1.3-3-3 c0-1.7,1.3-3,3-3s3,1.3,3,3C40,38.7,38.7,40,37,40z"}}]})(props);
};
function FcDataEncryption (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h25.1c1.3-1.3,4.9-0.9,4.9-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M34.4,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-2.4C40,33.5,37.5,31,34.4,31z"}}]},{"tag":"g","attr":{"fill":"#FFA000"},"child":[{"tag":"polygon","attr":{"points":"43,46 41,48 39,48 37,46 37,35.4 43,35.4 43,40 42,41 43,42 43,43 42,44 43,45"}},{"tag":"path","attr":{"d":"M47.5,28.5c-0.3-0.9-1-1.6-2-1.8C44.2,26.4,42.2,26,40,26s-4.2,0.4-5.5,0.6c-1,0.2-1.7,0.9-2,1.8 C32.3,29.4,32,30.6,32,32c0,1.4,0.3,2.6,0.5,3.5c0.3,0.9,1,1.6,2,1.8c1.3,0.3,3.2,0.6,5.5,0.6s4.2-0.4,5.5-0.6c1-0.2,1.7-0.9,2-1.8 c0.3-0.9,0.5-2.1,0.5-3.5C48,30.6,47.7,29.4,47.5,28.5z M42.9,31h-5.7c-0.6,0-1.1-0.5-1.1-1.1v-1.4c0-0.3,1.8-0.6,4-0.6 s4,0.3,4,0.6v1.4C44,30.5,43.5,31,42.9,31z"}}]},{"tag":"rect","attr":{"x":"39","y":"37.1","fill":"#D68600","width":"1","height":"10.9"}}]})(props);
};
function FcDataProtection (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h25.1c1.3-1.3,4.9-0.9,4.9-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M34.4,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-2.4C40,33.5,37.5,31,34.4,31z"}}]},{"tag":"path","attr":{"fill":"#009688","d":"M46,25H32c-1.1,0-2,0.9-2,2v11.8c0,1.3,0.6,2.4,1.6,3.2l7.4,5.5l7.4-5.5c1-0.8,1.6-1.9,1.6-3.2V27 C48,25.9,47.1,25,46,25z"}}]})(props);
};
function FcDataRecovery (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z"}}]},{"tag":"g","attr":{"fill":"#F44336"},"child":[{"tag":"rect","attr":{"x":"35","y":"28","width":"6","height":"20"}},{"tag":"rect","attr":{"x":"28","y":"35","width":"20","height":"6"}}]}]})(props);
};
function FcDataSheet (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M39,16v7h-6v-7h-2v7h-6v-7h-2v7h-7v2h7v6h-7v2h7v6h-7v2h25V16H39z M39,25v6h-6v-6H39z M25,25h6v6h-6V25z M25,33h6v6h-6V33z M33,39v-6h6v6H33z"}},{"tag":"polygon","attr":{"fill":"#00BCD4","points":"40,8 8,8 8,40 16,40 16,16 40,16"}},{"tag":"path","attr":{"fill":"#0097A7","d":"M7,7v34h10V17h24V7H7z M9,23v-6h6v6H9z M15,25v6H9v-6H15z M17,9h6v6h-6V9z M25,9h6v6h-6V9z M15,9v6H9V9H15z M9,39v-6h6v6H9z M39,15h-6V9h6V15z"}}]})(props);
};
function FcDatabase (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z"}}]}]})(props);
};
function FcDebian (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E91E63","d":"M26.763,24.548c-0.614,0.01,0.117,0.317,0.918,0.44c0.22-0.172,0.419-0.348,0.6-0.515\r\n\tC27.781,24.592,27.274,24.594,26.763,24.548 M30.054,23.727c0.364-0.5,0.631-1.055,0.723-1.624c-0.082,0.405-0.303,0.755-0.51,1.128\r\n\tc-1.146,0.721-0.108-0.43,0-0.865C29.035,23.913,30.098,23.293,30.054,23.727 M31.269,20.568c0.073-1.105-0.219-0.756-0.317-0.336\r\n\tC31.068,20.294,31.156,21.013,31.269,20.568 M24.439,5.478c0.327,0.058,0.706,0.104,0.653,0.183\r\n\tC25.449,5.582,25.531,5.51,24.439,5.478 M25.093,5.66l-0.232,0.047l0.215-0.017L25.093,5.66 M35.294,20.986\r\n\tc0.038,0.991-0.29,1.472-0.585,2.322l-0.529,0.266c-0.435,0.841,0.041,0.535-0.268,1.202c-0.679,0.603-2.055,1.883-2.496,2.004\r\n\tc-0.321-0.009,0.218-0.382,0.289-0.526c-0.906,0.62-0.728,0.934-2.113,1.313l-0.041-0.09c-3.419,1.607-8.166-1.576-8.103-5.928\r\n\tc-0.037,0.275-0.104,0.209-0.18,0.32c-0.175-2.237,1.033-4.486,3.073-5.403c1.995-0.987,4.335-0.58,5.763,0.75\r\n\tc-0.785-1.028-2.348-2.119-4.199-2.017c-1.814,0.029-3.51,1.182-4.077,2.434c-0.929,0.585-1.038,2.256-1.441,2.563\r\n\tc-0.545,4.003,1.024,5.733,3.68,7.768c0.417,0.282,0.118,0.326,0.175,0.541c-0.883-0.412-1.69-1.037-2.354-1.801\r\n\tc0.353,0.517,0.733,1.017,1.223,1.41c-0.831-0.279-1.942-2.013-2.267-2.084c1.435,2.567,5.818,4.502,8.113,3.541\r\n\tc-1.062,0.04-2.412,0.021-3.604-0.42c-0.501-0.257-1.183-0.791-1.062-0.893c3.133,1.171,6.369,0.887,9.078-1.286\r\n\tc0.689-0.537,1.443-1.449,1.662-1.464c-0.327,0.493,0.057,0.239-0.197,0.674c0.688-1.109-0.299-0.449,0.711-1.913l0.373,0.512\r\n\tc-0.139-0.917,1.143-2.033,1.012-3.489c0.291-0.445,0.326,0.478,0.015,1.502c0.434-1.136,0.113-1.317,0.224-2.254\r\n\tc0.121,0.315,0.279,0.648,0.359,0.981c-0.281-1.097,0.289-1.848,0.433-2.485c-0.142-0.063-0.435,0.485-0.503-0.812\r\n\tc0.01-0.562,0.156-0.295,0.214-0.435c-0.111-0.064-0.4-0.496-0.577-1.323c0.127-0.193,0.342,0.506,0.516,0.533\r\n\tc-0.112-0.655-0.304-1.159-0.313-1.665c-0.51-1.061-0.181,0.143-0.592-0.458c-0.543-1.687,0.449-0.39,0.514-1.156\r\n\tc0.82,1.188,1.289,3.029,1.504,3.792c-0.164-0.93-0.428-1.832-0.752-2.704c0.249,0.108-0.401-1.911,0.324-0.575\r\n\tc-0.772-2.848-3.314-5.511-5.65-6.76c0.286,0.262,0.646,0.591,0.517,0.642c-1.163-0.69-0.959-0.745-1.124-1.041\r\n\tc-0.946-0.383-1.01,0.034-1.636,0c-1.786-0.943-2.129-0.845-3.772-1.437l0.078,0.349c-1.184-0.394-1.379,0.146-2.657,0.002\r\n\tc-0.078-0.062,0.41-0.219,0.811-0.278c-1.143,0.15-1.09-0.228-2.208,0.042c0.277-0.197,0.566-0.322,0.861-0.486\r\n\tc-0.932,0.059-2.226,0.542-1.825,0.103c-1.521,0.676-4.22,1.63-5.735,3.051l-0.047-0.322c-0.694,0.835-3.028,2.492-3.215,3.57\r\n\tl-0.185,0.043c-0.361,0.613-0.595,1.305-0.881,1.935c-0.474,0.806-0.692,0.311-0.626,0.436c-0.929,1.883-1.39,3.467-1.79,4.768\r\n\tc0.284,0.424,0.007,2.558,0.113,4.264c-0.467,8.429,5.916,16.609,12.891,18.5c1.023,0.365,2.542,0.354,3.836,0.39\r\n\tc-1.525-0.438-1.722-0.232-3.209-0.749c-1.074-0.506-1.308-1.082-2.066-1.74l0.3,0.53c-1.49-0.526-0.867-0.652-2.078-1.034\r\n\tl0.321-0.424c-0.482-0.032-1.279-0.811-1.497-1.241l-0.528,0.021c-0.634-0.783-0.972-1.348-0.948-1.785l-0.17,0.305\r\n\tc-0.194-0.332-2.335-2.937-1.224-2.33c-0.207-0.188-0.481-0.307-0.779-0.85l0.227-0.258c-0.535-0.686-0.983-1.568-0.949-1.86\r\n\tc0.284,0.384,0.482,0.454,0.679,0.522c-1.351-3.349-1.426-0.187-2.448-3.409l0.216-0.019c-0.166-0.246-0.265-0.521-0.399-0.785\r\n\tl0.094-0.938c-0.972-1.125-0.272-4.781-0.132-6.783c0.097-0.816,0.811-1.684,1.354-3.045l-0.332-0.055\r\n\tc0.632-1.104,3.612-4.433,4.99-4.26c0.669-0.841-0.132-0.002-0.263-0.215c1.469-1.52,1.93-1.073,2.92-1.349\r\n\tc1.068-0.633-0.917,0.251-0.41-0.239c1.848-0.473,1.31-1.073,3.718-1.311c0.254,0.145-0.59,0.223-0.8,0.41\r\n\tc1.538-0.753,4.87-0.584,7.034,0.417c2.511,1.173,5.33,4.642,5.443,7.904l0.126,0.035c-0.063,1.298,0.198,2.798-0.257,4.175\r\n\tL35.294,20.986 M20.072,25.389l-0.086,0.431c0.403,0.547,0.724,1.142,1.237,1.567C20.853,26.664,20.577,26.364,20.072,25.389\r\n\t M21.023,25.353c-0.213-0.237-0.34-0.518-0.48-0.802c0.135,0.495,0.411,0.922,0.669,1.357L21.023,25.353 M37.877,21.688\r\n\tl-0.088,0.226c-0.166,1.174-0.523,2.332-1.068,3.412C37.324,24.189,37.714,22.947,37.877,21.688 M24.56,5.185\r\n\tC24.974,5.031,25.579,5.101,26.019,5c-0.573,0.048-1.144,0.079-1.706,0.151L24.56,5.185 M10.007,12.923\r\n\tc0.095,0.882-0.667,1.229,0.167,0.644C10.623,12.562,10,13.286,10.007,12.923 M9.028,17.016c0.191-0.592,0.226-0.943,0.3-1.285\r\n\tC8.797,16.41,9.084,16.553,9.028,17.016"}}]})(props);
};
function FcDebt (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFB74D","d":"M10,12c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S12.8,12,10,12z"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M2,22v8l3,2l1,14h8l1-14l3-2v-8c0-4.4-3.6-8-8-8h0C5.6,14,2,17.6,2,22z"}},{"tag":"g","attr":{"fill":"#263238"},"child":[{"tag":"path","attr":{"d":"M22.4,40.4c-0.6,2.5-1,3.6-2.4,3.6c-0.6,0-1.2-0.5-1.9-1.1c-1-0.8-2.2-1.9-4.1-1.9v2c1.1,0,1.9,0.7,2.8,1.4 c0.9,0.7,1.9,1.6,3.2,1.6c3.1,0,3.8-2.9,4.4-5.2C25,38.2,25.4,37,27,37v-2C23.7,35,22.9,38.1,22.4,40.4z"}},{"tag":"polygon","attr":{"points":"14.4,40 10,40 10,44 14.1,44"}}]},{"tag":"circle","attr":{"fill":"#4CAF50","cx":"36","cy":"36","r":"10"}},{"tag":"path","attr":{"fill":"#fff","d":"M35,34c0.1,0.2,0.1,0.3,0.3,0.4c0.1,0.1,0.3,0.2,0.5,0.4c0.2,0.1,0.5,0.2,0.8,0.3c0.5,0.2,0.9,0.4,1.3,0.6 c0.4,0.2,0.7,0.4,1,0.7c0.3,0.3,0.5,0.6,0.7,0.9c0.2,0.4,0.2,0.8,0.2,1.3c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.4-0.3,0.7-0.6,0.9 c-0.3,0.3-0.6,0.5-0.9,0.6c-0.4,0.2-0.8,0.3-1.2,0.3v1.5h-1.2v-1.5c-0.4,0-0.8-0.1-1.2-0.3c-0.4-0.2-0.7-0.4-1-0.6 c-0.3-0.3-0.5-0.6-0.7-1.1c-0.2-0.4-0.3-0.9-0.3-1.5h2.2c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.2,0.4,0.4,0.6c0.2,0.1,0.3,0.2,0.5,0.3 c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.3,0.1-0.5 c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.1-0.3-0.3-0.4c-0.1-0.1-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.2-0.7-0.3c-0.5-0.2-0.9-0.4-1.3-0.6 c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.3-0.5-0.6-0.7-0.9c-0.2-0.4-0.2-0.8-0.2-1.3c0-0.4,0.1-0.8,0.2-1.2c0.1-0.3,0.3-0.7,0.6-0.9 c0.3-0.3,0.6-0.5,0.9-0.6c0.4-0.2,0.8-0.3,1.2-0.3v-1.6h1.2v1.6c0.4,0.1,0.8,0.2,1.2,0.4c0.4,0.2,0.6,0.4,0.9,0.7 c0.2,0.3,0.4,0.6,0.6,1c0.1,0.4,0.2,0.9,0.2,1.4h-2.2c0-0.6-0.1-1-0.4-1.3c-0.2-0.3-0.6-0.4-1-0.4c-0.2,0-0.4,0-0.6,0.1 c-0.2,0.1-0.3,0.2-0.4,0.3C35.1,32.7,35,32.8,35,33s-0.1,0.3-0.1,0.5C34.9,33.7,34.9,33.9,35,34z"}}]})(props);
};
function FcDecision (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"path","attr":{"d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"path","attr":{"d":"M24,4C15.2,4,8,11.2,8,20c0,1.2,0,3.5,0,3.5l2.1,0.6V19l19.5-6.3l8.2,6.3v5.1l2.1-0.6c0,0,0-2.3,0-3.5 C40,12.5,34.6,4,24,4z"}}]},{"tag":"path","attr":{"fill":"#0277BD","d":"M21.8,29.6c0-6.6,5.1-6.2,5.1-10.2c0-1-0.3-3-2.9-3c-2.8,0-3,2.3-3,2.8h-3.8c0-1,0.4-6,6.8-6 c6.5,0,6.7,5.1,6.7,6c0,4.9-5.4,5.6-5.4,10.3H21.8z M21.5,34.5c0-0.3,0.1-2.1,2.1-2.1c2,0,2.2,1.8,2.2,2.1c0,0.6-0.3,2-2.2,2 C21.8,36.5,21.5,35.1,21.5,34.5z"}}]})(props);
};
function FcDeleteColumn (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M30,5H18c-2.2,0-4,1.8-4,4v30c0,2.2,1.8,4,4,4h12c2.2,0,4-1.8,4-4V9C34,6.8,32.2,5,30,5z M18,39V9h12l0,30 H18z"}},{"tag":"circle","attr":{"fill":"#F44336","cx":"38","cy":"38","r":"10"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"36.5","y":"32","transform":"matrix(-.707 .707 -.707 -.707 91.74 38)","width":"3","height":"12"}},{"tag":"rect","attr":{"x":"36.5","y":"32","transform":"matrix(-.707 -.707 .707 -.707 38 91.74)","width":"3","height":"12"}}]}]})(props);
};
function FcDeleteDatabase (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#D1C4E9"},"child":[{"tag":"path","attr":{"d":"M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z"}},{"tag":"path","attr":{"d":"M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z"}},{"tag":"path","attr":{"d":"M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z"}}]},{"tag":"circle","attr":{"fill":"#F44336","cx":"38","cy":"38","r":"10"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"36.5","y":"32","transform":"matrix(-.707 .707 -.707 -.707 91.74 38)","width":"3","height":"12"}},{"tag":"rect","attr":{"x":"36.5","y":"32","transform":"matrix(-.707 -.707 .707 -.707 38 91.74)","width":"3","height":"12"}}]}]})(props);
};
function FcDeleteRow (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M43,30V18c0-2.2-1.8-4-4-4H9c-2.2,0-4,1.8-4,4v12c0,2.2,1.8,4,4,4h30C41.2,34,43,32.2,43,30z M9,18h30v12 L9,30V18z"}},{"tag":"circle","attr":{"fill":"#F44336","cx":"38","cy":"38","r":"10"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"36.5","y":"32","transform":"matrix(-.707 .707 -.707 -.707 91.74 38)","width":"3","height":"12"}},{"tag":"rect","attr":{"x":"36.5","y":"32","transform":"matrix(-.707 -.707 .707 -.707 38 91.74)","width":"3","height":"12"}}]}]})(props);
};
function FcDepartment (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#C5CAE9","points":"42,42 6,42 6,9 24,2 42,9"}},{"tag":"rect","attr":{"x":"6","y":"42","fill":"#9FA8DA","width":"36","height":"2"}},{"tag":"rect","attr":{"x":"20","y":"35","fill":"#BF360C","width":"8","height":"9"}},{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"rect","attr":{"x":"31","y":"27","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"21","y":"27","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"27","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"31","y":"35","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"35","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"31","y":"19","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"21","y":"19","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"19","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"31","y":"11","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"21","y":"11","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"11","width":"6","height":"5"}}]}]})(props);
};
function FcDeployment (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#B0BEC5","d":"M37,42H5V32h32c2.8,0,5,2.2,5,5v0C42,39.8,39.8,42,37,42z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M10,34c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S11.7,34,10,34z M10,38c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1 s1,0.4,1,1C11,37.6,10.6,38,10,38z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M19,34c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S20.7,34,19,34z M19,38c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1 s1,0.4,1,1C20,37.6,19.6,38,19,38z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M37,34c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S38.7,34,37,34z M37,38c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1 s1,0.4,1,1C38,37.6,37.6,38,37,38z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M28,34c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S29.7,34,28,34z M28,38c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1 s1,0.4,1,1C29,37.6,28.6,38,28,38z"}},{"tag":"path","attr":{"fill":"#FF9800","d":"M35,31H11c-1.1,0-2-0.9-2-2V7c0-1.1,0.9-2,2-2h24c1.1,0,2,0.9,2,2v22C37,30.1,36.1,31,35,31z"}},{"tag":"path","attr":{"fill":"#8A5100","d":"M26.5,13h-7c-0.8,0-1.5-0.7-1.5-1.5v0c0-0.8,0.7-1.5,1.5-1.5h7c0.8,0,1.5,0.7,1.5,1.5v0 C28,12.3,27.3,13,26.5,13z"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M37,31H5v2h32c2.2,0,4,1.8,4,4s-1.8,4-4,4H5v2h32c3.3,0,6-2.7,6-6S40.3,31,37,31z"}}]})(props);
};
function FcDiploma1 (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"4","y":"9","fill":"#E8EAF6","width":"40","height":"30"}},{"tag":"g","attr":{"fill":"#5C6BC0"},"child":[{"tag":"polygon","attr":{"points":"30,34 32.8,34 27.8,29 25,31.8 30,36.8"}},{"tag":"polygon","attr":{"points":"18,34 15.2,34 20.2,29 23,31.8 18,36.8"}}]},{"tag":"rect","attr":{"x":"11","y":"15","fill":"#9FA8DA","width":"26","height":"4"}},{"tag":"path","attr":{"fill":"#9FA8DA","d":"M24,23c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S26.8,23,24,23z M24,31c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3 S25.7,31,24,31z"}},{"tag":"path","attr":{"fill":"#9FA8DA","d":"M3,8v32h42V8H3z M43,35c-1.7,0-3,1.3-3,3H8c0-1.7-1.3-3-3-3V13c1.7,0,3-1.3,3-3h32c0,1.7,1.3,3,3,3V35z"}}]})(props);
};
function FcDiploma2 (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"9","y":"4","fill":"#FBE9E7","width":"30","height":"40"}},{"tag":"g","attr":{"fill":"#F4511E"},"child":[{"tag":"polygon","attr":{"points":"30,37 32.8,37 27.8,32 25,34.8 30,39.8"}},{"tag":"polygon","attr":{"points":"18,37 15.2,37 20.2,32 23,34.8 18,39.8"}}]},{"tag":"rect","attr":{"x":"15","y":"13","fill":"#FF8A65","width":"18","height":"4"}},{"tag":"rect","attr":{"x":"15","y":"20","fill":"#FF8A65","width":"18","height":"2"}},{"tag":"path","attr":{"fill":"#FF8A65","d":"M24,26c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S26.8,26,24,26z M24,34c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3 S25.7,34,24,34z"}},{"tag":"path","attr":{"fill":"#FF8A65","d":"M8,3v42h32V3H8z M38,40c-1.7,0-3,1.3-3,3H13c0-1.7-1.3-3-3-3V8c1.7,0,3-1.3,3-3h22c0,1.7,1.3,3,3,3V40z"}}]})(props);
};
function FcDisapprove (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"path","attr":{"d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"path","attr":{"d":"M24,4C15.2,4,8,11.2,8,20c0,1.2,0,3.5,0,3.5l2.1,0.6V19l19.5-6.3l8.2,6.3v5.1l2.1-0.6c0,0,0-2.3,0-3.5 C40,12.5,34.6,4,24,4z"}}]},{"tag":"g","attr":{"fill":"#F44336"},"child":[{"tag":"rect","attr":{"x":"22","y":"16.8","transform":"matrix(.707 -.707 .707 .707 -11.355 24.586)","width":"4","height":"18.5"}},{"tag":"rect","attr":{"x":"22","y":"16.8","transform":"matrix(.707 .707 -.707 .707 25.414 -9.355)","width":"4","height":"18.5"}}]}]})(props);
};
function FcDisclaimer (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"path","attr":{"d":"M13,22H8v-8.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5V22z"}},{"tag":"path","attr":{"d":"M20,22h-5V7.5C15,6.1,16.1,5,17.5,5h0C18.9,5,20,6.1,20,7.5V22z"}},{"tag":"path","attr":{"d":"M27,22h-5V5.5C22,4.1,23.1,3,24.5,3h0C25.9,3,27,4.1,27,5.5V22z"}},{"tag":"path","attr":{"d":"M34,22h-5V8.5C29,7.1,30.1,6,31.5,6h0C32.9,6,34,7.1,34,8.5V22z"}},{"tag":"path","attr":{"d":"M32.1,43L27.1,38l10-10c1.4-1.4,3.6-1.4,4.9,0l0,0c1.4,1.4,1.4,3.6,0,4.9L32.1,43z"}},{"tag":"path","attr":{"d":"M29,21c0,0.6-0.4,1-1,1s-1-0.4-1-1h-5c0,0.6-0.4,1-1,1s-1-0.4-1-1h-5c0,0.6-0.4,1-1,1s-1-0.4-1-1H8v16 c0,4.4,3.6,8,8,8h11.2c3.7,0,6.8-3,6.8-6.8V21H29z"}}]},{"tag":"g","attr":{"fill":"#F44336"},"child":[{"tag":"rect","attr":{"x":"20.2","y":"25.5","transform":"matrix(.707 -.707 .707 .707 -16.897 25.224)","width":"3.5","height":"15"}},{"tag":"rect","attr":{"x":"20.2","y":"25.6","transform":"matrix(.707 .707 -.707 .707 29.811 -5.877)","width":"3.5","height":"15"}}]}]})(props);
};
function FcDislike (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F44336","d":"M34,9c-4.2,0-7.9,2.1-10,5.4C21.9,11.1,18.2,9,14,9C7.4,9,2,14.4,2,21c0,11.9,22,24,22,24s22-12,22-24 C46,14.4,40.6,9,34,9z"}},{"tag":"rect","attr":{"x":"22","y":"-2.9","transform":"matrix(.707 -.707 .707 .707 -9.941 24)","fill":"#37474F","width":"4","height":"53.7"}}]})(props);
};
function FcDisplay (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#80DEEA","d":"M40,41H8c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v26C44,39.2,42.2,41,40,41z"}},{"tag":"g","attr":{"fill":"#2962FF"},"child":[{"tag":"polygon","attr":{"points":"36,17 31,17 29,15 31,13 36,13 38,15"}},{"tag":"polygon","attr":{"points":"36,35 31,35 29,33 31,31 36,31 38,33"}},{"tag":"polygon","attr":{"points":"37,30 37,18 39,16 41,18 41,30 39,32"}},{"tag":"polygon","attr":{"points":"26,30 26,18 28,16 30,18 30,30 28,32"}},{"tag":"polygon","attr":{"points":"17,17 12,17 10,15 12,13 17,13 19,15"}},{"tag":"polygon","attr":{"points":"17,35 12,35 10,33 12,31 17,31 19,33"}},{"tag":"polygon","attr":{"points":"18,30 18,18 20,16 22,18 22,30 20,32"}},{"tag":"polygon","attr":{"points":"7,30 7,18 9,16 11,18 11,30 9,32"}}]}]})(props);
};
function FcDoNotInhale (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFA726","d":"M33.5,20C31.2,17.7,30,13.9,30,9c0-3.2,0-3,0-3H18c0,0,0-0.2,0,3c0,4.9-1.2,8.7-3.5,11 C12.1,20.2,9,22,9,25.4c0,4.5,5.1,4.6,6,4.6c1.2,0,6.1,4,8,4c0,0,0.7,0,1,0s1,0,1,0c1.9,0,6.8-4,8-4c0.9,0,6-0.1,6-4.6 C39,22,35.9,20.2,33.5,20z"}},{"tag":"path","attr":{"fill":"#FFA726","d":"M33.5,20C31.2,17.7,30,13.9,30,9c0-3.2,0-3,0-3H18c0,0,0-0.2,0,3c0,4.9-1.2,8.7-3.5,11 C12.1,20.2,9,22,9,25.4c0,4.5,5.1,4.6,6,4.6c1.2,0,6.1,4,8,4c0,0,0.7,0,1,0s1,0,1,0c1.9,0,6.8-4,8-4c0.9,0,6-0.1,6-4.6 C39,22,35.9,20.2,33.5,20z"}},{"tag":"path","attr":{"fill":"#FFB74D","d":"M26,9c0-3.2,0-3,0-3h-4c0,0,0-0.2,0,3c0,4.9-3,19-3,19s1.6,2,5,2s5-2,5-2S26,13.9,26,9z"}},{"tag":"path","attr":{"fill":"#CC861E","d":"M23,34c-3.3,0-6.4-3.1-8-4c0,0,0.7,0,1.8,0C19.9,30,21.3,34,23,34z"}},{"tag":"path","attr":{"fill":"#CC861E","d":"M25,34c3.3,0,6.4-3.1,8-4c0,0-0.7,0-1.8,0C28.1,30,26.7,34,25,34z"}},{"tag":"rect","attr":{"x":"22","y":"-2.9","transform":"matrix(.707 -.707 .707 .707 -9.941 24)","fill":"#37474F","width":"4","height":"53.7"}},{"tag":"g","attr":{"fill":"#FF5722"},"child":[{"tag":"polygon","attr":{"points":"18,35 22,39 14,39"}},{"tag":"rect","attr":{"x":"17","y":"38","width":"2","height":"4"}},{"tag":"polygon","attr":{"points":"30,35 34,39 26,39"}},{"tag":"rect","attr":{"x":"29","y":"38","width":"2","height":"4"}}]}]})(props);
};
function FcDoNotInsert (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#7CB342"},"child":[{"tag":"polygon","attr":{"points":"31,29 24,36 17,29"}},{"tag":"rect","attr":{"x":"22","y":"7","width":"4","height":"25"}},{"tag":"path","attr":{"d":"M42,18c-3.3,0-6,2.7-6,6v12c0,1.1-0.9,2-2,2H14c-1.1,0-2-0.9-2-2V24c0-3.3-2.7-6-6-6H4v4h2c1.1,0,2,0.9,2,2 v12c0,3.3,2.7,6,6,6h20c3.3,0,6-2.7,6-6V24c0-1.1,0.9-2,2-2h2v-4H42z"}}]},{"tag":"rect","attr":{"x":"22","y":"-2.9","transform":"matrix(.707 -.707 .707 .707 -9.941 24)","fill":"#37474F","width":"4","height":"53.7"}}]})(props);
};
function FcDoNotMix (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#00BCD4","points":"26.9,42 17,42 17,32.1"}},{"tag":"polygon","attr":{"fill":"#00BCD4","points":"30,6 30,26.2 19.8,36.4 22.6,39.2 34,27.8 34,6"}},{"tag":"polygon","attr":{"fill":"#2196F3","points":"15.9,31 6,31 6,21.1"}},{"tag":"polygon","attr":{"fill":"#2196F3","points":"20.2,14 8.8,25.4 11.6,28.2 21.8,18 41,18 41,14"}},{"tag":"rect","attr":{"x":"22","y":"-2.9","transform":"matrix(.707 -.707 .707 .707 -9.941 24)","fill":"#37474F","width":"4","height":"53.7"}}]})(props);
};
function FcDocument (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#90CAF9","points":"40,45 8,45 8,3 30,3 40,13"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"38.5,14 29,14 29,4.5"}},{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"rect","attr":{"x":"16","y":"21","width":"17","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"25","width":"13","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"29","width":"17","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"33","width":"13","height":"2"}}]}]})(props);
};
function FcDonate (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#E69329","points":"11.7,21.6 16.8,31.5 26.3,27.6 30.7,14.9 15.9,15.7"}},{"tag":"circle","attr":{"fill":"#546E7A","cx":"15","cy":"36","r":"7.8"}},{"tag":"g","attr":{"fill":"#90A4AE"},"child":[{"tag":"path","attr":{"d":"M15,27c-5,0-9,4-9,9c0,5,4,9,9,9s9-4,9-9C24,31,20,27,15,27z M15,43c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7 s7,3.1,7,7C22,39.9,18.9,43,15,43z"}},{"tag":"rect","attr":{"x":"14","y":"33","width":"2","height":"8"}}]},{"tag":"g","attr":{"fill":"#FFB74D"},"child":[{"tag":"path","attr":{"d":"M12.9,36L12.9,36c1,1.9,3.2,2.7,5.1,1.7l16.5-8.5c1-0.5,1.7-1.2,2.2-1.9c1.7-3.2,5.6-10.7,8.2-17.2 l-18.2,8.7L21.9,26l-6.8,3.6C12.5,30.9,11.7,33.8,12.9,36z"}},{"tag":"path","attr":{"d":"M30.2,3L13.7,9.3c-0.7,0.2-1.5,1-2.2,1.7l-5.6,7.5c-1,1.5-1.2,3.4-0.5,5.1c0.4,1,1.7,3.4,3.1,6.1 c1.6-1.7,3.9-2.7,6.5-2.7c0.4,0,0.9,0,1.3,0.1l-2.1-4.2l4.6-4.1h8c0,0,15.5-2.2,18.2-8.7L30.2,3z"}}]},{"tag":"path","attr":{"fill":"#FFCDD2","d":"M18.2,36c-1.3,0.6-2.8,0-3.3-1.3c-0.6-1.3,0-2.8,1.3-3.3C17.4,30.8,19.4,35.4,18.2,36z"}}]})(props);
};
function FcDoughnutChart (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#00BCD4","d":"M24,30c-3.3,0-6-2.7-6-6s2.7-6,6-6V5C13.5,5,5,13.5,5,24s8.5,19,19,19c4.4,0,8.5-1.5,11.8-4.1l-8-10.2 C26.7,29.5,25.4,30,24,30z"}},{"tag":"path","attr":{"fill":"#448AFF","d":"M30,24h13c0-10.5-8.5-19-19-19v13C27.3,18,30,20.7,30,24z"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M43,24H30c0,1.9-0.9,3.6-2.3,4.7l8,10.2C40.2,35.4,43,30,43,24z"}}]})(props);
};
function FcDownLeft (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"4,29 18,17.3 18,40.7"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M42,21V8h-8v13c0,2.2-1.8,4-4,4H13v8h17C36.6,33,42,27.6,42,21z"}}]})(props);
};
function FcDownRight (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"44,29 30,17.3 30,40.7"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M6,21V8h8v13c0,2.2,1.8,4,4,4h17v8H18C11.4,33,6,27.6,6,21z"}}]})(props);
};
function FcDown (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"24,44 12.3,30 35.7,30"}},{"tag":"rect","attr":{"x":"20","y":"6","width":"8","height":"27"}}]}]})(props);
};
function FcDownload (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"polygon","attr":{"points":"24,37.1 13,24 35,24"}},{"tag":"rect","attr":{"x":"20","y":"4","width":"8","height":"4"}},{"tag":"rect","attr":{"x":"20","y":"10","width":"8","height":"4"}},{"tag":"rect","attr":{"x":"20","y":"16","width":"8","height":"11"}},{"tag":"rect","attr":{"x":"6","y":"40","width":"36","height":"4"}}]}]})(props);
};
function FcDribbble (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF4081","d":"M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"}},{"tag":"path","attr":{"fill":"#FFFFFF","d":"M33.061,26.273c-0.703-0.221-1.464,0.175-1.686,0.895c-0.824,2.658-2.316,5.419-2.993,5.57\r\n\tc-0.507,0-1.236-0.43-1.958-1.44c1.674-3.594,2.551-8.106,2.551-11.118c0-8.413-2.124-10.18-3.908-10.18\r\n\tc-3.757,0-3.8,9.912-3.8,10.012c0,1.166,0.042,2.248,0.121,3.256c-0.518-0.189-1.113-0.319-1.77-0.319\r\n\tc-3.86,0-5.618,3.809-5.618,7.347C14,33.63,15.871,37,20.046,37c1.972,0,3.634-1.291,4.975-3.221\r\n\tc1.188,1.235,2.432,1.696,3.36,1.696c2.923,0,4.858-5.233,5.556-7.486C34.16,27.27,33.767,26.502,33.061,26.273z M20.048,34.264\r\n\tc-3.031,0-3.36-2.775-3.36-3.969c0-0.188,0.034-4.611,2.932-4.611c1.144,0,2.022,0.885,2.022,0.885\r\n\tc0.065,0.07,0.137,0.131,0.212,0.184c0.375,1.904,0.904,3.426,1.516,4.632C22.366,33.123,21.203,34.264,20.048,34.264z\r\n\t M24.901,27.926c-0.559-1.93-0.946-4.521-0.946-7.914c0-3.126,0.666-6.068,1.219-7.073c0.424,0.644,1.115,2.65,1.115,7.241\r\n\tC26.289,22.616,25.75,25.446,24.901,27.926z"}}]})(props);
};
function FcDvdLogo (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#42A5F5","d":"M24.002,27c-12.154,0-22,1.343-22,3.006c0,1.653,9.845,2.994,22,2.994c12.156,0,22-1.341,22-2.994\r\n\tC46.002,28.343,36.158,27,24.002,27z M24.002,30.972c-2.863,0-5.191-0.494-5.191-1.104c0-0.609,2.329-1.104,5.191-1.104\r\n\tc2.862,0,5.193,0.495,5.193,1.104C29.195,30.478,26.864,30.972,24.002,30.972z"}},{"tag":"path","attr":{"fill":"#1565C0","d":"M21.29,15l2.371,6.43L29.25,15h9.486c4.647,0,7.906,2.148,7.158,4.904c-0.745,2.756-5.178,4.904-9.803,4.904\r\n\th-6.295c0,0,0.141-0.043,0.172-0.126c0.246-0.944,1.707-6.264,1.725-6.347c0.02-0.102-0.105-0.133-0.105-0.133h4.572\r\n\tc0,0-0.088-0.006-0.125,0.133c-0.023,0.078-0.947,3.429-1.145,4.176c-0.023,0.094-0.162,0.139-0.162,0.139h1.094\r\n\tc2.594,0,5.047-0.828,5.563-2.748c0.473-1.752-1.244-2.746-4.039-2.746h-1.014l-4.375,0.004l-10.043,9.932l-3.845-9.754\r\n\tc0,0-0.036-0.066-0.065-0.147c-0.014-0.026-0.108-0.106-0.206-0.063c-0.065,0.036-0.074,0.117-0.066,0.146\r\n\tc0.036,0.066,0.042,0.08,0.048,0.111c0.569,0.93,0.467,2.009,0.33,2.52c-0.774,2.75-5.186,4.904-9.812,4.904H2.002\r\n\tc0,0,0.149-0.043,0.172-0.126c0.254-0.946,1.717-6.294,1.726-6.347c0.018-0.09-0.099-0.133-0.099-0.133h4.604\r\n\tc0,0-0.132,0.037-0.158,0.131c-0.024,0.078-0.954,3.432-1.151,4.178c-0.023,0.094-0.178,0.139-0.178,0.139h1.118\r\n\tc2.597,0,5.032-0.828,5.547-2.748c0.472-1.752-1.23-2.746-4.021-2.746H8.539h-4.45c0,0,0.125-0.059,0.147-0.139\r\n\tc0.123-0.443,0.497-1.834,0.515-1.899C4.771,15.047,4.646,15,4.646,15H21.29L21.29,15z"}}]})(props);
};
function FcEditImage (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#8CBCD6","d":"M31,41H8c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v17C44,35.2,38.2,41,31,41z"}},{"tag":"circle","attr":{"fill":"#B3DDF5","cx":"35","cy":"16","r":"3"}},{"tag":"polygon","attr":{"fill":"#9AC9E3","points":"20,16 9,32 31,32"}},{"tag":"polygon","attr":{"fill":"#B3DDF5","points":"31,22 23,32 39,32"}},{"tag":"path","attr":{"fill":"#E57373","d":"M47.7,29.1l-2.8-2.8c-0.4-0.4-1.1-0.4-1.6,0L42,27.6l4.4,4.4l1.3-1.3C48.1,30.3,48.1,29.6,47.7,29.1z"}},{"tag":"rect","attr":{"x":"27.1","y":"35.1","transform":"matrix(.707 -.707 .707 .707 -16.508 36.511)","fill":"#FF9800","width":"17.4","height":"6.2"}},{"tag":"rect","attr":{"x":"41.5","y":"27.8","transform":"matrix(-.707 .707 -.707 -.707 95.395 22.352)","fill":"#B0BEC5","width":"3.1","height":"6.2"}},{"tag":"polygon","attr":{"fill":"#FFC107","points":"27.5,42.2 26,48 31.8,46.5"}},{"tag":"polygon","attr":{"fill":"#37474F","points":"26.7,45 26,48 29,47.3"}}]})(props);
};
function FcElectricalSensor (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#B2EBF2","cx":"32","cy":"24","r":"9"}},{"tag":"path","attr":{"fill":"#4DD0E1","d":"M32,12c-6.6,0-12,5.4-12,12c0,6.6,5.4,12,12,12s12-5.4,12-12C44,17.4,38.6,12,32,12z M32,32 c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S36.4,32,32,32z"}},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"25.4,22 19.8,5.1 13.6,27.7 11.4,22 4,22 4,26 8.6,26 14.4,40.3 20.2,18.9 22.6,26 30,26 30,22"}},{"tag":"circle","attr":{"cx":"32","cy":"24","r":"4"}}]}]})(props);
};
function FcElectricalThreshold (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"3","y":"12","fill":"#80DEEA","width":"42","height":"24"}},{"tag":"rect","attr":{"x":"3","y":"23","fill":"#03A9F4","width":"42","height":"2"}},{"tag":"path","attr":{"fill":"none","stroke":"#3F51B5","strokeWidth":"4","strokeMiterlimit":"10","d":"M4,18l4.5-1.5c0.9-0.3,1.9,0.1,2.3,0.9l8.7,14.3 c0.7,1.2,2.4,1.3,3.2,0.2l2.3-2.8c0.5-0.6,1.4-0.9,2.2-0.6l3,1c1,0.3,2.1-0.2,2.5-1.1l4.3-10.1c0.5-1.1,1.9-1.6,2.9-0.9l4,2.7"}}]})(props);
};
function FcElectricity (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#00BCD4","d":"M33.7,5L22,17l15,5L21.3,36.7l5.1,2.8L12,43l2.7-14.8l2.9,5.1L27,24l-15-5L25,5H33.7z"}}]})(props);
};
function FcElectroDevices (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#3F51B5","d":"M39,43H9c-2.2,0-4-1.8-4-4V9c0-2.2,1.8-4,4-4h30c2.2,0,4,1.8,4,4v30C43,41.2,41.2,43,39,43z"}},{"tag":"path","attr":{"fill":"#80DEEA","d":"M33.2,5l-9.8,10.1L36,19.3L22.8,31.7l4.3,2.4L15,37l2.3-12.5l2.4,4.3l8-7.8L15,16.8L25.9,5H33.2z"}}]})(props);
};
function FcElectronics (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF9800","d":"M44,18v-4H34V4h-4v10h-4V4h-4v10h-4V4h-4v10H4v4h10v4H4v4h10v4H4v4h10v10h4V34h4v10h4V34h4v10h4V34h10v-4H34 v-4h10v-4H34v-4H44z"}},{"tag":"path","attr":{"fill":"#4CAF50","d":"M8,12v24c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V12c0-2.2-1.8-4-4-4H12C9.8,8,8,9.8,8,12z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M31,31H17c-1.1,0-2-0.9-2-2V19c0-1.1,0.9-2,2-2h14c1.1,0,2,0.9,2,2v10C33,30.1,32.1,31,31,31z"}}]})(props);
};
function FcEmptyBattery (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#CFD8DC"},"child":[{"tag":"path","attr":{"d":"M34,44H14c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v34C36,43.1,35.1,44,34,44z"}},{"tag":"path","attr":{"d":"M28,13h-8c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1v7C29,12.6,28.6,13,28,13z"}}]}]})(props);
};
function FcEmptyFilter (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"polygon","attr":{"points":"29,23 19,23 7,9 41,9"}},{"tag":"polygon","attr":{"points":"29,38 19,44 19,23 29,23"}},{"tag":"path","attr":{"d":"M41.5,9h-35C5.7,9,5,8.3,5,7.5v0C5,6.7,5.7,6,6.5,6h35C42.3,6,43,6.7,43,7.5v0C43,8.3,42.3,9,41.5,9z"}}]}]})(props);
};
function FcEmptyTrash (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#B39DDB","d":"M30.6,44H17.4c-2,0-3.7-1.4-4-3.4L9,11h30l-4.5,29.6C34.2,42.6,32.5,44,30.6,44z"}},{"tag":"path","attr":{"fill":"#7E57C2","d":"M38,13H10c-1.1,0-2-0.9-2-2v0c0-1.1,0.9-2,2-2h28c1.1,0,2,0.9,2,2v0C40,12.1,39.1,13,38,13z"}}]})(props);
};
function FcEndCall (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F44336","d":"M43.5,16.8l-2.3-2.3c-8.1-7.9-27.5-6.8-34.5,0l-2.3,2.3c-0.6,0.6-0.6,1.6,0,2.3l4.6,4.5 c0.6,0.6,1.7,0.6,2.3,0l5.1-4.9L16,13.4c1.6-1.6,14.4-1.6,16,0l-0.3,5.5l4.9,4.7c0.6,0.6,1.7,0.6,2.3,0l4.6-4.5 C44.2,18.4,44.2,17.4,43.5,16.8z"}},{"tag":"g","attr":{"fill":"#B71C1C"},"child":[{"tag":"polygon","attr":{"points":"24,40.5 16,31 32,31"}},{"tag":"rect","attr":{"x":"21","y":"24","width":"6","height":"7.5"}}]}]})(props);
};
function FcEngineering (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#EF6C00","d":"M37.4,24.6l-11.6-2.2l-3.9-11.2l-3.8,1.3L22,23.6l-7.8,9l3,2.6l7.8-9l11.6,2.2L37.4,24.6z"}},{"tag":"g","attr":{"fill":"#FF9800"},"child":[{"tag":"path","attr":{"d":"M24,19c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5s5-2.2,5-5C29,21.2,26.8,19,24,19z M24,26c-1.1,0-2-0.9-2-2 c0-1.1,0.9-2,2-2s2,0.9,2,2C26,25.1,25.1,26,24,26z"}},{"tag":"path","attr":{"d":"M40.7,27c0.2-1,0.3-2,0.3-3c0-1-0.1-2-0.3-3l3.3-2.4c0.4-0.3,0.6-0.9,0.3-1.4L40,9.8 c-0.3-0.5-0.8-0.7-1.3-0.4L35,11c-1.5-1.3-3.3-2.3-5.2-3l-0.4-4.1c-0.1-0.5-0.5-0.9-1-0.9h-8.6c-0.5,0-1,0.4-1,0.9L18.2,8 c-1.9,0.7-3.7,1.7-5.2,3L9.3,9.3C8.8,9.1,8.2,9.3,8,9.8l-4.3,7.4c-0.3,0.5-0.1,1.1,0.3,1.4L7.3,21C7.1,22,7,23,7,24 c0,1,0.1,2,0.3,3L4,29.4c-0.4,0.3-0.6,0.9-0.3,1.4L8,38.2c0.3,0.5,0.8,0.7,1.3,0.4L13,37c1.5,1.3,3.3,2.3,5.2,3l0.4,4.1 c0.1,0.5,0.5,0.9,1,0.9h8.6c0.5,0,1-0.4,1-0.9l0.4-4.1c1.9-0.7,3.7-1.7,5.2-3l3.7,1.7c0.5,0.2,1.1,0,1.3-0.4l4.3-7.4 c0.3-0.5,0.1-1.1-0.3-1.4L40.7,27z M24,35c-6.1,0-11-4.9-11-11c0-6.1,4.9-11,11-11s11,4.9,11,11C35,30.1,30.1,35,24,35z"}}]}]})(props);
};
function FcEnteringHeavenAlive (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"17","y":"29","fill":"#039BE5","width":"14","height":"2"}},{"tag":"rect","attr":{"x":"13","y":"33","fill":"#039BE5","width":"22","height":"2"}},{"tag":"rect","attr":{"x":"9","y":"37","fill":"#039BE5","width":"30","height":"2"}},{"tag":"rect","attr":{"x":"5","y":"41","fill":"#039BE5","width":"38","height":"2"}},{"tag":"path","attr":{"fill":"#81D4FA","d":"M35,13c-0.4,0-0.8,0-1.2,0.1C32.9,8.5,28.9,5,24,5c-4.1,0-7.6,2.5-9.2,6c-0.3,0-0.5,0-0.8,0 c-4.4,0-8,3.6-8,8s3.6,8,8,8c2.4,0,18.5,0,21,0c3.9,0,7-3.1,7-7C42,16.1,38.9,13,35,13z"}},{"tag":"path","attr":{"fill":"#039BE5","d":"M28,21c0-2.2-1.8-4-4-4s-4,1.8-4,4c0,0.5,0,6,0,6h8C28,27,28,21.5,28,21z"}}]})(props);
};
function FcExpand (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#2196F3","points":"43,17.1 39.9,14 24,29.9 8.1,14 5,17.1 24,36"}}]})(props);
};
function FcExpired (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#00ACC1","cx":"17","cy":"17","r":"14"}},{"tag":"circle","attr":{"fill":"#eee","cx":"17","cy":"17","r":"11"}},{"tag":"rect","attr":{"x":"16","y":"8","width":"2","height":"9"}},{"tag":"rect","attr":{"x":"18.2","y":"16","transform":"matrix(-.707 .707 -.707 -.707 46.834 19.399)","width":"2.4","height":"6.8"}},{"tag":"circle","attr":{"cx":"17","cy":"17","r":"2"}},{"tag":"circle","attr":{"fill":"#00ACC1","cx":"17","cy":"17","r":"1"}},{"tag":"path","attr":{"fill":"#FFC107","d":"M11.9,42l14.4-24.1c0.8-1.3,2.7-1.3,3.4,0L44.1,42c0.8,1.3-0.2,3-1.7,3H13.6C12.1,45,11.1,43.3,11.9,42z"}},{"tag":"path","attr":{"fill":"#263238","d":"M26.4,39.9c0-0.2,0-0.4,0.1-0.6s0.2-0.3,0.3-0.5s0.3-0.2,0.5-0.3s0.4-0.1,0.6-0.1s0.5,0,0.7,0.1 s0.4,0.2,0.5,0.3s0.2,0.3,0.3,0.5s0.1,0.4,0.1,0.6s0,0.4-0.1,0.6s-0.2,0.3-0.3,0.5s-0.3,0.2-0.5,0.3s-0.4,0.1-0.7,0.1 s-0.5,0-0.6-0.1s-0.4-0.2-0.5-0.3s-0.2-0.3-0.3-0.5S26.4,40.1,26.4,39.9z M29.2,36.8h-2.3L26.5,27h3L29.2,36.8z"}}]})(props);
};
function FcExport (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFCCBC","d":"M7,40V8c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H11C8.8,44,7,42.2,7,40z"}},{"tag":"g","attr":{"fill":"#FF5722"},"child":[{"tag":"polygon","attr":{"points":"42.7,24 32,33 32,15"}},{"tag":"rect","attr":{"x":"14","y":"21","width":"23","height":"6"}}]}]})(props);
};
function FcExternal (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#B2DFDB","cx":"24","cy":"31","r":"14"}},{"tag":"g","attr":{"fill":"#009688"},"child":[{"tag":"polygon","attr":{"points":"24,3.3 33,14 15,14"}},{"tag":"rect","attr":{"x":"21","y":"11","width":"6","height":"23"}}]}]})(props);
};
function FcFactoryBreakdown (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#E64A19","points":"29,23 29,17 21,21 21,23 17,23 17,27 13,27 13,23 5,23 5,43 33,43 33,23"}},{"tag":"rect","attr":{"x":"25","y":"27","fill":"#992B0A","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"9","y":"35","fill":"#992B0A","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"25","y":"35","fill":"#992B0A","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"17","y":"35","fill":"#992B0A","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"17","y":"27","fill":"#992B0A","width":"4","height":"4"}},{"tag":"polygon","attr":{"fill":"#BF360C","points":"41.2,5 38,5 38,7 36,7 36,9 33.7,9 32,43 43,43"}}]})(props);
};
function FcFactory (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#BF360C","d":"M41.2,5h-7.3L32,43h11L41.2,5z"}},{"tag":"path","attr":{"fill":"#E64A19","d":"M33,23h-4v-6l-12,6v-6L5,23v20h28V23z"}},{"tag":"rect","attr":{"x":"9","y":"27","fill":"#FFC107","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"17","y":"27","fill":"#FFC107","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"25","y":"27","fill":"#FFC107","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"9","y":"35","fill":"#FFC107","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"17","y":"35","fill":"#FFC107","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"25","y":"35","fill":"#FFC107","width":"4","height":"4"}}]})(props);
};
function FcFaq (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#558B2F","d":"M15,40h23l6,6V25c0-2.2-1.8-4-4-4H15c-2.2,0-4,1.8-4,4v11C11,38.2,12.8,40,15,40z"}},{"tag":"path","attr":{"fill":"#1B5E20","d":"M28.8,32.8h-3.6l-0.7,2.1h-2.2l3.7-10h1.9l3.7,10h-2.2L28.8,32.8z M25.7,31.2h2.5L27,27.4L25.7,31.2z"}},{"tag":"path","attr":{"fill":"#8BC34A","d":"M33,25H10l-6,6V8c0-2.2,1.8-4,4-4h25c2.2,0,4,1.8,4,4v13C37,23.2,35.2,25,33,25z"}},{"tag":"path","attr":{"fill":"#fff","d":"M25.4,14.2c0,1-0.2,1.8-0.5,2.5c-0.3,0.7-0.7,1.3-1.3,1.7l1.7,1.3L24,20.9l-2.2-1.7c-0.2,0-0.5,0.1-0.8,0.1 c-0.6,0-1.2-0.1-1.8-0.3c-0.5-0.2-1-0.6-1.4-1c-0.4-0.4-0.7-1-0.9-1.6c-0.2-0.6-0.3-1.3-0.3-2.1v-0.4c0-0.8,0.1-1.5,0.3-2.1 c0.2-0.6,0.5-1.2,0.9-1.6c0.4-0.4,0.8-0.8,1.4-1c0.5-0.2,1.1-0.3,1.8-0.3c0.6,0,1.2,0.1,1.8,0.3c0.5,0.2,1,0.6,1.4,1 c0.4,0.4,0.7,1,0.9,1.6c0.2,0.6,0.3,1.3,0.3,2.1V14.2z M23.2,13.7c0-1.1-0.2-1.9-0.6-2.4c-0.4-0.6-0.9-0.8-1.6-0.8 c-0.7,0-1.3,0.3-1.6,0.8c-0.4,0.6-0.6,1.4-0.6,2.4v0.5c0,0.5,0.1,1,0.2,1.4c0.1,0.4,0.2,0.8,0.4,1c0.2,0.3,0.4,0.5,0.7,0.6 c0.3,0.1,0.6,0.2,0.9,0.2c0.7,0,1.3-0.3,1.6-0.8c0.4-0.6,0.6-1.4,0.6-2.5V13.7z"}}]})(props);
};
function FcFeedIn (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#2196F3","d":"M38,24v12c0,1.1-0.9,2-2,2H12c-1.1,0-2-0.9-2-2V24c0-3.3-2.7-6-6-6h0v4h0c1.1,0,2,0.9,2,2v12 c0,3.3,2.7,6,6,6h24c3.3,0,6-2.7,6-6V24c0-1.1,0.9-2,2-2h0v-4h0C40.7,18,38,20.7,38,24z"}},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"38.6,5.6 29,15.2 29,28 33,28 33,16.8 41.4,8.4"}},{"tag":"polygon","attr":{"points":"6.6,8.4 15,16.8 15,28 19,28 19,15.2 9.4,5.6"}},{"tag":"polygon","attr":{"points":"37,27 31,33 25,27"}},{"tag":"polygon","attr":{"points":"23,27 17,33 11,27"}}]}]})(props);
};
function FcFeedback (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#78909C","d":"M40,41H8c-2.2,0-4-1.8-4-4l0-20.9c0-1.3,0.6-2.5,1.7-3.3L24,0l18.3,12.8c1.1,0.7,1.7,2,1.7,3.3V37 C44,39.2,42.2,41,40,41z"}},{"tag":"rect","attr":{"x":"12","y":"11","fill":"#fff","width":"24","height":"22"}},{"tag":"polygon","attr":{"fill":"#9C27B0","points":"24,13.6 18,21.4 30,21.4"}},{"tag":"path","attr":{"fill":"#CFD8DC","d":"M40,41H8c-2.2,0-4-1.8-4-4l0-20l20,13l20-13v20C44,39.2,42.2,41,40,41z"}},{"tag":"polygon","attr":{"fill":"#9C27B0","points":"24,28 26,26.7 26,20 22,20 22,26.7"}}]})(props);
};
function FcFile (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#90CAF9","points":"40,45 8,45 8,3 30,3 40,13"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"38.5,14 29,14 29,4.5"}}]})(props);
};
function FcFilingCabinet (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"12","y":"44","fill":"#263238","width":"4","height":"2"}},{"tag":"rect","attr":{"x":"32","y":"44","fill":"#263238","width":"4","height":"2"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M8,41V7c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v34c0,2.2-1.8,4-4,4H12C9.8,45,8,43.2,8,41z"}},{"tag":"path","attr":{"fill":"#B0BEC5","d":"M12,17V8c0-0.6,0.4-1,1-1h22c0.6,0,1,0.4,1,1v9H12z"}},{"tag":"rect","attr":{"x":"12","y":"19","fill":"#B0BEC5","width":"24","height":"10"}},{"tag":"path","attr":{"fill":"#B0BEC5","d":"M12,40v-9h24v9c0,0.6-0.4,1-1,1H13C12.4,41,12,40.6,12,40z"}},{"tag":"rect","attr":{"x":"20","y":"11","fill":"#546E7A","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"20","y":"23","fill":"#546E7A","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"20","y":"35","fill":"#546E7A","width":"8","height":"2"}}]})(props);
};
function FcFilledFilter (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#F57C00","points":"29,23 19,23 7,9 41,9"}},{"tag":"g","attr":{"fill":"#FF9800"},"child":[{"tag":"polygon","attr":{"points":"29,38 19,44 19,23 29,23"}},{"tag":"path","attr":{"d":"M41.5,9h-35C5.7,9,5,8.3,5,7.5v0C5,6.7,5.7,6,6.5,6h35C42.3,6,43,6.7,43,7.5v0C43,8.3,42.3,9,41.5,9z"}}]}]})(props);
};
function FcFilmReel (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#3F51B5","d":"M43,39V24h-4v15c0,5,4,9,9,9v-4C45.2,44,43,41.8,43,39z"}},{"tag":"circle","attr":{"fill":"#90A4AE","cx":"24","cy":"24","r":"19"}},{"tag":"circle","attr":{"fill":"#37474F","cx":"24","cy":"24","r":"2"}},{"tag":"g","attr":{"fill":"#253278"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"14","r":"5"}},{"tag":"circle","attr":{"cx":"24","cy":"34","r":"5"}},{"tag":"circle","attr":{"cx":"34","cy":"24","r":"5"}},{"tag":"circle","attr":{"cx":"14","cy":"24","r":"5"}}]}]})(props);
};
function FcFilm (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#3F51B5","d":"M45,9H3v30h42V9z M22,37v-4h4v4H22z M30,37v-4h4v4H30z M38,37v-4h4v4H38z M14,37v-4h4v4H14z M6,37v-4h4v4H6 z M22,15v-4h4v4H22z M30,15v-4h4v4H30z M38,15v-4h4v4H38z M14,15v-4h4v4H14z M6,15v-4h4v4H6z"}}]})(props);
};
function FcFinePrint (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#90CAF9","points":"33,42 5,42 5,4 24,4 33,13"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"31.5,14 23,14 23,5.5"}},{"tag":"rect","attr":{"x":"38.3","y":"34.8","transform":"matrix(.707 -.707 .707 .707 -17.177 40.055)","fill":"#616161","width":"2.8","height":"12"}},{"tag":"circle","attr":{"fill":"#616161","cx":"28","cy":"29","r":"11"}},{"tag":"circle","attr":{"fill":"#90CAF9","cx":"28","cy":"29","r":"9"}},{"tag":"rect","attr":{"x":"39.5","y":"37.6","transform":"matrix(.707 -.707 .707 .707 -17.661 41.223)","fill":"#37474F","width":"2.8","height":"8.7"}},{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"path","attr":{"d":"M30,31h-9.7c0.4,1.6,1.3,3,2.5,4H30V31z"}},{"tag":"path","attr":{"d":"M20.3,27H30v-4h-7.3C21.5,24,20.7,25.4,20.3,27z"}},{"tag":"path","attr":{"d":"M20.1,20H11v2h7.3C18.8,21.3,19.4,20.6,20.1,20z"}},{"tag":"path","attr":{"d":"M17.1,24H11v2h5.4C16.6,25.3,16.8,24.6,17.1,24z"}},{"tag":"path","attr":{"d":"M16,29c0-0.3,0-0.7,0.1-1H11v2h5.1C16,29.7,16,29.3,16,29z"}},{"tag":"path","attr":{"d":"M16.4,32H11v2h6.1C16.8,33.4,16.6,32.7,16.4,32z"}}]}]})(props);
};
function FcFlashAuto (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#FFC107","points":"33,22 23.6,22 30,5 19,5 13,26 21.6,26 17,45"}},{"tag":"path","attr":{"fill":"#F44336","d":"M40.8,14.5h-4.3L35.6,17H33l4.5-12h2.3l4.5,12h-2.6L40.8,14.5z M37.1,12.5h3L38.6,8L37.1,12.5z"}}]})(props);
};
function FcFlashOff (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#FFC107","points":"33,22 23.6,22 30,5 19,5 13,26 21.6,26 17,45"}},{"tag":"rect","attr":{"x":"22","y":"-2.9","transform":"matrix(.707 -.707 .707 .707 -9.941 24)","fill":"#37474F","width":"4","height":"53.7"}}]})(props);
};
function FcFlashOn (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#FFC107","points":"33,22 23.6,22 30,5 19,5 13,26 21.6,26 17,45"}}]})(props);
};
function FcFlowChart (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#CFD8DC","points":"35,36 39,36 39,22 26,22 26,13 22,13 22,22 9,22 9,36 13,36 13,26 22,26 22,36 26,36 26,26 35,26"}},{"tag":"rect","attr":{"x":"17","y":"6","fill":"#3F51B5","width":"14","height":"10"}},{"tag":"rect","attr":{"x":"32","y":"32","fill":"#00BCD4","width":"10","height":"10"}},{"tag":"rect","attr":{"x":"6","y":"32","fill":"#00BCD4","width":"10","height":"10"}},{"tag":"rect","attr":{"x":"19","y":"32","fill":"#00BCD4","width":"10","height":"10"}}]})(props);
};
function FcFolder (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFA000","d":"M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v8h40v-4C44,13.8,42.2,12,40,12z"}},{"tag":"path","attr":{"fill":"#FFCA28","d":"M40,12H8c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V16C44,13.8,42.2,12,40,12z"}}]})(props);
};
function FcFrame (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#3949AB","d":"M40.6,40.1h-1.4c-0.2,0-0.3,0-0.5,0l-3.1-0.4c-2.4-0.3-4.9-0.2-7.3,0.4l-3.6,0.9c-0.5,0.1-1.1,0.1-1.6,0 L19.6,40c-2.4-0.6-4.8-0.7-7.3-0.4l-3.1,0.4c-0.2,0-0.3,0-0.5,0H7.4c-1.9,0-3.4-1.5-3.4-3.4v0c0-0.4,0.1-0.9,0.2-1.3l0.2-0.6 c1-2.5,1.1-5.3,0.4-7.9l-0.6-2c-0.2-0.7-0.2-1.3,0-2l0.3-0.8c0.9-2.7,0.8-5.7-0.2-8.4l-0.1-0.3C4.1,13.1,4,12.7,4,12.3v-1 c0-1.9,1.5-3.4,3.4-3.4l1.4,0c0.2,0,0.3,0,0.5,0l3.1,0.4c2.4,0.3,4.9,0.2,7.3-0.4l3.6-0.9c0.5-0.1,1.1-0.1,1.6,0L28.4,8 c2.4,0.6,4.8,0.7,7.3,0.4l3.1-0.4c0.2,0,0.3,0,0.5,0l1.4,0c1.9,0,3.4,1.5,3.4,3.4v1c0,0.4-0.1,0.9-0.2,1.3l-0.1,0.3 c-1.1,2.7-1.2,5.6-0.2,8.4l0.3,0.8c0.2,0.6,0.2,1.3,0,2l-0.6,2c-0.7,2.6-0.6,5.4,0.4,7.9l0.2,0.6c0.2,0.4,0.2,0.8,0.2,1.3v0 C44,38.6,42.5,40.1,40.6,40.1z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M38,36H10c-0.6,0-1-0.4-1-1V13c0-0.6,0.4-1,1-1h28c0.6,0,1,0.4,1,1v22C39,35.6,38.6,36,38,36z"}}]})(props);
};
function FcFullBattery (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#8BC34A"},"child":[{"tag":"path","attr":{"d":"M34,44H14c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v34C36,43.1,35.1,44,34,44z"}},{"tag":"path","attr":{"d":"M28,13h-8c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1v7C29,12.6,28.6,13,28,13z"}}]}]})(props);
};
function FcFullTrash (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#FF8A65","points":"24,21.3 12.7,10 26,1.7 38.3,10"}},{"tag":"polygon","attr":{"fill":"#FFAB91","points":"24,21.3 12.7,10 17,4.7 38.3,10"}},{"tag":"path","attr":{"fill":"#B39DDB","d":"M30.6,44H17.4c-2,0-3.7-1.4-4-3.4L9,11h30l-4.5,29.6C34.2,42.6,32.5,44,30.6,44z"}},{"tag":"path","attr":{"fill":"#7E57C2","d":"M38,13H10c-1.1,0-2-0.9-2-2v0c0-1.1,0.9-2,2-2h28c1.1,0,2,0.9,2,2v0C40,12.1,39.1,13,38,13z"}}]})(props);
};
function FcGallery (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E65100","d":"M41,42H13c-2.2,0-4-1.8-4-4V18c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v20C45,40.2,43.2,42,41,42z"}},{"tag":"path","attr":{"fill":"#F57C00","d":"M35,36H7c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v20C39,34.2,37.2,36,35,36z"}},{"tag":"circle","attr":{"fill":"#FFF9C4","cx":"30","cy":"16","r":"3"}},{"tag":"polygon","attr":{"fill":"#942A09","points":"17,17.9 8,31 26,31"}},{"tag":"polygon","attr":{"fill":"#BF360C","points":"28,23.5 22,31 34,31"}}]})(props);
};
function FcGenealogy (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#CFD8DC","points":"40,9 40,7 31,7 31,12 24,12 15,12 15,23 8,23 8,25 15,25 15,36 24,36 31,36 31,41 40,41 40,39 33,39 33,31 40,31 40,29 31,29 31,34 24,34 17,34 17,14 24,14 31,14 31,19 40,19 40,17 33,17 33,9"}},{"tag":"rect","attr":{"x":"4","y":"20","fill":"#00BCD4","width":"8","height":"8"}},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"rect","attr":{"x":"36","y":"14","width":"8","height":"8"}},{"tag":"rect","attr":{"x":"36","y":"4","width":"8","height":"8"}},{"tag":"rect","attr":{"x":"20","y":"9","width":"8","height":"8"}},{"tag":"rect","attr":{"x":"20","y":"31","width":"8","height":"8"}},{"tag":"rect","attr":{"x":"36","y":"36","width":"8","height":"8"}},{"tag":"rect","attr":{"x":"36","y":"26","width":"8","height":"8"}}]}]})(props);
};
function FcGenericSortingAsc (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"6","y":"6","fill":"#2196F3","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"14","fill":"#2196F3","width":"12","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"22","fill":"#2196F3","width":"20","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"30","fill":"#2196F3","width":"28","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"38","fill":"#2196F3","width":"36","height":"4"}}]})(props);
};
function FcGenericSortingDesc (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"6","y":"38","fill":"#2196F3","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"30","fill":"#2196F3","width":"12","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"22","fill":"#2196F3","width":"20","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"14","fill":"#2196F3","width":"28","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"6","fill":"#2196F3","width":"36","height":"4"}}]})(props);
};
function FcGlobe (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#7CB342","d":"M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z"}},{"tag":"path","attr":{"fill":"#0277BD","d":"M45,24c0,11.7-9.5,21-21,21S3,35.7,3,24S12.3,3,24,3S45,12.3,45,24z M23.8,33.7c0-0.4-0.2-0.6-0.6-0.8 c-1.3-0.4-2.5-0.4-3.6-1.5c-0.2-0.4-0.2-0.8-0.4-1.3c-0.4-0.4-1.5-0.6-2.1-0.8c-0.8,0-1.7,0-2.7,0c-0.4,0-1.1,0-1.5,0 c-0.6-0.2-1.1-1.1-1.5-1.7c0-0.2,0-0.6-0.4-0.6c-0.4-0.2-0.8,0.2-1.3,0c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.6,0.4-1.3,0.8-1.7 c0.6-0.4,1.3,0.2,1.9,0.2c0.2,0,0.2,0,0.4,0.2c0.6,0.2,0.8,1,0.8,1.7c0,0.2,0,0.4,0,0.4c0,0.2,0.2,0.2,0.4,0.2 c0.2-1.1,0.2-2.1,0.4-3.2c0-1.3,1.3-2.5,2.3-2.9c0.4-0.2,0.6,0.2,1.1,0c1.3-0.4,4.4-1.7,3.8-3.4c-0.4-1.5-1.7-2.9-3.4-2.7 c-0.4,0.2-0.6,0.4-1,0.6c-0.6,0.4-1.9,1.7-2.5,1.7c-1.1-0.2-1.1-1.7-0.8-2.3c0.2-0.8,2.1-3.6,3.4-3.1c0.2,0.2,0.6,0.6,0.8,0.8 c0.4,0.2,1.1,0.2,1.7,0.2c0.2,0,0.4,0,0.6-0.2c0.2-0.2,0.2-0.2,0.2-0.4c0-0.6-0.6-1.3-1-1.7c-0.4-0.4-1.1-0.8-1.7-1.1 c-2.1-0.6-5.5,0.2-7.1,1.7s-2.9,4-3.8,6.1c-0.4,1.3-0.8,2.9-1,4.4c-0.2,1-0.4,1.9,0.2,2.9c0.6,1.3,1.9,2.5,3.2,3.4 c0.8,0.6,2.5,0.6,3.4,1.7c0.6,0.8,0.4,1.9,0.4,2.9c0,1.3,0.8,2.3,1.3,3.4c0.2,0.6,0.4,1.5,0.6,2.1c0,0.2,0.2,1.5,0.2,1.7 c1.3,0.6,2.3,1.3,3.8,1.7c0.2,0,1-1.3,1-1.5c0.6-0.6,1.1-1.5,1.7-1.9c0.4-0.2,0.8-0.4,1.3-0.8c0.4-0.4,0.6-1.3,0.8-1.9 C23.8,35.1,24,34.3,23.8,33.7z M24.2,14.3c0.2,0,0.4-0.2,0.8-0.4c0.6-0.4,1.3-1.1,1.9-1.5c0.6-0.4,1.3-1.1,1.7-1.5 c0.6-0.4,1.1-1.3,1.3-1.9c0.2-0.4,0.8-1.3,0.6-1.9c-0.2-0.4-1.3-0.6-1.7-0.8c-1.7-0.4-3.1-0.6-4.8-0.6c-0.6,0-1.5,0.2-1.7,0.8 c-0.2,1.1,0.6,0.8,1.5,1.1c0,0,0.2,1.7,0.2,1.9c0.2,1-0.4,1.7-0.4,2.7c0,0.6,0,1.7,0.4,2.1L24.2,14.3z M41.8,29 c0.2-0.4,0.2-1.1,0.4-1.5c0.2-1,0.2-2.1,0.2-3.1c0-2.1-0.2-4.2-0.8-6.1c-0.4-0.6-0.6-1.3-0.8-1.9c-0.4-1.1-1-2.1-1.9-2.9 c-0.8-1.1-1.9-4-3.8-3.1c-0.6,0.2-1,1-1.5,1.5c-0.4,0.6-0.8,1.3-1.3,1.9c-0.2,0.2-0.4,0.6-0.2,0.8c0,0.2,0.2,0.2,0.4,0.2 c0.4,0.2,0.6,0.2,1,0.4c0.2,0,0.4,0.2,0.2,0.4c0,0,0,0.2-0.2,0.2c-1,1.1-2.1,1.9-3.1,2.9c-0.2,0.2-0.4,0.6-0.4,0.8 c0,0.2,0.2,0.2,0.2,0.4c0,0.2-0.2,0.2-0.4,0.4c-0.4,0.2-0.8,0.4-1.1,0.6c-0.2,0.4,0,1.1-0.2,1.5c-0.2,1.1-0.8,1.9-1.3,2.9 c-0.4,0.6-0.6,1.3-1,1.9c0,0.8-0.2,1.5,0.2,2.1c1,1.5,2.9,0.6,4.4,1.3c0.4,0.2,0.8,0.2,1.1,0.6c0.6,0.6,0.6,1.7,0.8,2.3 c0.2,0.8,0.4,1.7,0.8,2.5c0.2,1,0.6,2.1,0.8,2.9c1.9-1.5,3.6-3.1,4.8-5.2C40.6,32.4,41.2,30.7,41.8,29z"}}]})(props);
};
function FcGoodDecision (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"path","attr":{"d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"path","attr":{"d":"M24,4C15.2,4,8,11.2,8,20c0,1.2,0,3.5,0,3.5l2.1,0.6V19l19.5-6.3l8.2,6.3v5.1l2.1-0.6c0,0,0-2.3,0-3.5 C40,12.5,34.6,4,24,4z"}}]},{"tag":"g","attr":{"fill":"#4CAF50"},"child":[{"tag":"rect","attr":{"x":"22","y":"16","width":"4","height":"18"}},{"tag":"rect","attr":{"x":"15","y":"23","width":"18","height":"4"}}]}]})(props);
};
function FcGoogle (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFC107","d":"M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12\r\n\tc0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24\r\n\tc0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"}},{"tag":"path","attr":{"fill":"#FF3D00","d":"M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657\r\n\tC34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"}},{"tag":"path","attr":{"fill":"#4CAF50","d":"M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36\r\n\tc-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"}},{"tag":"path","attr":{"fill":"#1976D2","d":"M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571\r\n\tc0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"}}]})(props);
};
function FcGraduationCap (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"rect","attr":{"x":"9","y":"20","width":"30","height":"13"}},{"tag":"ellipse","attr":{"cx":"24","cy":"33","rx":"15","ry":"6"}}]},{"tag":"path","attr":{"fill":"#78909C","d":"M23.1,8.2L0.6,18.1c-0.8,0.4-0.8,1.5,0,1.9l22.5,9.9c0.6,0.2,1.2,0.2,1.8,0l22.5-9.9c0.8-0.4,0.8-1.5,0-1.9 L24.9,8.2C24.3,7.9,23.7,7.9,23.1,8.2z"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"path","attr":{"d":"M43.2,20.4l-20-3.4c-0.5-0.1-1.1,0.3-1.2,0.8c-0.1,0.5,0.3,1.1,0.8,1.2L42,22.2V37c0,0.6,0.4,1,1,1 s1-0.4,1-1V21.4C44,20.9,43.6,20.5,43.2,20.4z"}},{"tag":"circle","attr":{"cx":"43","cy":"37","r":"2"}},{"tag":"path","attr":{"d":"M46,40c0,1.7-3,6-3,6s-3-4.3-3-6s1.3-3,3-3S46,38.3,46,40z"}}]}]})(props);
};
function FcGrid (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M7,7v34h34V7H7z M39,15h-6V9h6V15z M25,15V9h6v6H25z M31,17v6h-6v-6H31z M23,15h-6V9h6V15z M23,17v6h-6v-6 H23z M15,23H9v-6h6V23z M15,25v6H9v-6H15z M17,25h6v6h-6V25z M23,33v6h-6v-6H23z M25,33h6v6h-6V33z M25,31v-6h6v6H25z M33,25h6v6h-6 V25z M33,23v-6h6v6H33z M15,9v6H9V9H15z M9,33h6v6H9V33z M33,39v-6h6v6H33z"}}]})(props);
};
function FcHeadset (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#0097A7","d":"M24,5C14.1,5,6,13.1,6,23v15h4V23c0-7.7,6.3-14,14-14s14,6.3,14,14v15h4V23C42,13.1,33.9,5,24,5z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M38,43h-4V31h4c2.2,0,4,1.8,4,4v4C42,41.2,40.2,43,38,43z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M10,43h4V31h-4c-2.2,0-4,1.8-4,4v4C6,41.2,7.8,43,10,43z"}}]})(props);
};
function FcHeatMap (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#CFD8DC","points":"9,39 9,6 7,6 7,41 42,41 42,39"}},{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"circle","attr":{"cx":"14","cy":"11","r":"2"}},{"tag":"circle","attr":{"cx":"32","cy":"11","r":"2"}},{"tag":"circle","attr":{"cx":"39","cy":"11","r":"2"}},{"tag":"circle","attr":{"cx":"23","cy":"11","r":"4"}},{"tag":"circle","attr":{"cx":"14","cy":"33","r":"2"}},{"tag":"circle","attr":{"cx":"30","cy":"33","r":"2"}},{"tag":"circle","attr":{"cx":"22","cy":"33","r":"3"}},{"tag":"circle","attr":{"cx":"38","cy":"33","r":"4"}},{"tag":"circle","attr":{"cx":"14","cy":"22","r":"2"}},{"tag":"circle","attr":{"cx":"39","cy":"22","r":"2"}},{"tag":"circle","attr":{"cx":"32","cy":"22","r":"3"}}]}]})(props);
};
function FcHighBattery (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#CFD8DC"},"child":[{"tag":"path","attr":{"d":"M34,44H14c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v34C36,43.1,35.1,44,34,44z"}},{"tag":"path","attr":{"d":"M28,13h-8c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1v7C29,12.6,28.6,13,28,13z"}}]},{"tag":"path","attr":{"fill":"#8BC34A","d":"M34,44H14c-1.1,0-2-0.9-2-2V13h24v29C36,43.1,35.1,44,34,44z"}}]})(props);
};
function FcHighPriority (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F44336","d":"M21.2,44.8l-18-18c-1.6-1.6-1.6-4.1,0-5.7l18-18c1.6-1.6,4.1-1.6,5.7,0l18,18c1.6,1.6,1.6,4.1,0,5.7l-18,18 C25.3,46.4,22.7,46.4,21.2,44.8z"}},{"tag":"path","attr":{"fill":"#fff","d":"M21.6,32.7c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.5-0.4,0.8-0.5s0.6-0.2,1-0.2 s0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.8,0.5c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.6,0.2,0.9s-0.1,0.6-0.2,0.9s-0.3,0.5-0.5,0.7 c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.6,0.2-1,0.2s-0.7-0.1-1-0.2s-0.5-0.3-0.8-0.5c-0.2-0.2-0.4-0.4-0.5-0.7S21.6,33.1,21.6,32.7z M25.8,28.1h-3.6L21.7,13h4.6L25.8,28.1z"}}]})(props);
};
function FcHome (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#E8EAF6","points":"42,39 6,39 6,23 24,6 42,23"}},{"tag":"g","attr":{"fill":"#C5CAE9"},"child":[{"tag":"polygon","attr":{"points":"39,21 34,16 34,9 39,9"}},{"tag":"rect","attr":{"x":"6","y":"39","width":"36","height":"5"}}]},{"tag":"polygon","attr":{"fill":"#B71C1C","points":"24,4.3 4,22.9 6,25.1 24,8.4 42,25.1 44,22.9"}},{"tag":"rect","attr":{"x":"18","y":"28","fill":"#D84315","width":"12","height":"16"}},{"tag":"rect","attr":{"x":"21","y":"17","fill":"#01579B","width":"6","height":"6"}},{"tag":"path","attr":{"fill":"#FF8A65","d":"M27.5,35.5c-0.3,0-0.5,0.2-0.5,0.5v2c0,0.3,0.2,0.5,0.5,0.5S28,38.3,28,38v-2C28,35.7,27.8,35.5,27.5,35.5z"}}]})(props);
};
function FcIcons8Cup (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#4CAF50","d":"M40,14H8l3.8,28.3c0.1,1,1,1.7,2,1.7h20.5c1,0,1.8-0.7,2-1.7L40,14z"}},{"tag":"g","attr":{"fill":"#81C784"},"child":[{"tag":"path","attr":{"d":"M42,14H6v-3c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4V14z"}},{"tag":"path","attr":{"d":"M37.2,10H10.8l1.7-4.7c0.3-0.8,1-1.3,1.9-1.3h19.2c0.8,0,1.6,0.5,1.9,1.3L37.2,10z"}}]},{"tag":"path","attr":{"fill":"#E8F5E9","d":"M28,28.5c1.2-1.1,2-2.7,2-4.5c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6c0,1.8,0.8,3.4,2,4.5c-1.2,1.1-2,2.7-2,4.5 c0,3.3,2.7,6,6,6c3.3,0,6-2.7,6-6C30,31.2,29.2,29.6,28,28.5z M24,36c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3 C27,34.7,25.7,36,24,36z M24,27c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3C27,25.7,25.7,27,24,27z"}}]})(props);
};
function FcIdea (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#FFF59D","cx":"24","cy":"22","r":"20"}},{"tag":"path","attr":{"fill":"#FBC02D","d":"M37,22c0-7.7-6.6-13.8-14.5-12.9c-6,0.7-10.8,5.5-11.4,11.5c-0.5,4.6,1.4,8.7,4.6,11.3 c1.4,1.2,2.3,2.9,2.3,4.8V37h12v-0.1c0-1.8,0.8-3.6,2.2-4.8C35.1,29.7,37,26.1,37,22z"}},{"tag":"path","attr":{"fill":"#FFF59D","d":"M30.6,20.2l-3-2c-0.3-0.2-0.8-0.2-1.1,0L24,19.8l-2.4-1.6c-0.3-0.2-0.8-0.2-1.1,0l-3,2 c-0.2,0.2-0.4,0.4-0.4,0.7s0,0.6,0.2,0.8l3.8,4.7V37h2V26c0-0.2-0.1-0.4-0.2-0.6l-3.3-4.1l1.5-1l2.4,1.6c0.3,0.2,0.8,0.2,1.1,0 l2.4-1.6l1.5,1l-3.3,4.1C25.1,25.6,25,25.8,25,26v11h2V26.4l3.8-4.7c0.2-0.2,0.3-0.5,0.2-0.8S30.8,20.3,30.6,20.2z"}},{"tag":"circle","attr":{"fill":"#5C6BC0","cx":"24","cy":"44","r":"3"}},{"tag":"path","attr":{"fill":"#9FA8DA","d":"M26,45h-4c-2.2,0-4-1.8-4-4v-5h12v5C30,43.2,28.2,45,26,45z"}},{"tag":"g","attr":{"fill":"#5C6BC0"},"child":[{"tag":"path","attr":{"d":"M30,41l-11.6,1.6c0.3,0.7,0.9,1.4,1.6,1.8l9.4-1.3C29.8,42.5,30,41.8,30,41z"}},{"tag":"polygon","attr":{"points":"18,38.7 18,40.7 30,39 30,37"}}]}]})(props);
};
function FcImageFile (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#90CAF9","points":"40,45 8,45 8,3 30,3 40,13"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"38.5,14 29,14 29,4.5"}},{"tag":"polygon","attr":{"fill":"#1565C0","points":"21,23 14,33 28,33"}},{"tag":"polygon","attr":{"fill":"#1976D2","points":"28,26.4 23,33 33,33"}},{"tag":"circle","attr":{"fill":"#1976D2","cx":"31.5","cy":"24.5","r":"1.5"}}]})(props);
};
function FcImport (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F8BBD0","d":"M7,40V8c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H11C8.8,44,7,42.2,7,40z"}},{"tag":"g","attr":{"fill":"#E91E63"},"child":[{"tag":"polygon","attr":{"points":"13.3,24 24,15 24,33"}},{"tag":"rect","attr":{"x":"19","y":"21","width":"23","height":"6"}}]}]})(props);
};
function FcInTransit (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFC107","d":"M44,36H30V16c0-1.1,0.9-2,2-2h8c0.6,0,1.2,0.3,1.6,0.8l6,7.7c0.3,0.4,0.4,0.8,0.4,1.2V32 C48,34.2,46.2,36,44,36z"}},{"tag":"g","attr":{"fill":"#9575CD"},"child":[{"tag":"path","attr":{"d":"M8,36h22V13c0-2.2-1.8-4-4-4H4v23C4,34.2,5.8,36,8,36z"}},{"tag":"rect","attr":{"y":"9","width":"10","height":"2"}},{"tag":"rect","attr":{"y":"14","width":"10","height":"2"}},{"tag":"rect","attr":{"y":"19","width":"10","height":"2"}},{"tag":"rect","attr":{"y":"24","width":"10","height":"2"}}]},{"tag":"g","attr":{"fill":"#7E57C2"},"child":[{"tag":"rect","attr":{"x":"4","y":"11","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"4","y":"16","width":"12","height":"2"}},{"tag":"rect","attr":{"x":"4","y":"21","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"4","y":"26","width":"4","height":"2"}}]},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"circle","attr":{"cx":"39","cy":"36","r":"5"}},{"tag":"circle","attr":{"cx":"16","cy":"36","r":"5"}}]},{"tag":"g","attr":{"fill":"#78909C"},"child":[{"tag":"circle","attr":{"cx":"39","cy":"36","r":"2.5"}},{"tag":"circle","attr":{"cx":"16","cy":"36","r":"2.5"}}]},{"tag":"path","attr":{"fill":"#455A64","d":"M44,26h-3.6c-0.3,0-0.5-0.1-0.7-0.3l-1.4-1.4c-0.2-0.2-0.4-0.3-0.7-0.3H34c-0.6,0-1-0.4-1-1v-6 c0-0.6,0.4-1,1-1h5.5c0.3,0,0.6,0.1,0.8,0.4l4.5,5.4c0.1,0.2,0.2,0.4,0.2,0.6V25C45,25.6,44.6,26,44,26z"}}]})(props);
};
function FcInfo (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#2196F3","cx":"24","cy":"24","r":"21"}},{"tag":"rect","attr":{"x":"22","y":"22","fill":"#fff","width":"4","height":"11"}},{"tag":"circle","attr":{"fill":"#fff","cx":"24","cy":"16.5","r":"2.5"}}]})(props);
};
function FcInspection (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#455A64","d":"M36,4H26c0,1.1-0.9,2-2,2s-2-0.9-2-2H12C9.8,4,8,5.8,8,8v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V8 C40,5.8,38.2,4,36,4z"}},{"tag":"path","attr":{"fill":"#fff","d":"M36,41H12c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h24c0.6,0,1,0.4,1,1v32C37,40.6,36.6,41,36,41z"}},{"tag":"g","attr":{"fill":"#90A4AE"},"child":[{"tag":"path","attr":{"d":"M26,4c0,1.1-0.9,2-2,2s-2-0.9-2-2h-7v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V4H26z"}},{"tag":"path","attr":{"d":"M24,0c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S26.2,0,24,0z M24,6c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2 S25.1,6,24,6z"}}]},{"tag":"polygon","attr":{"fill":"#4CAF50","points":"30.6,18.6 21.6,27.6 17.4,23.3 14.9,25.8 21.7,32.5 33.1,21.1"}}]})(props);
};
function FcIntegratedWebcam (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#607D8B","d":"M38,42H10c-2.2,0-4-1.8-4-4V10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v28C42,40.2,40.2,42,38,42z"}},{"tag":"circle","attr":{"fill":"#455A64","cx":"24","cy":"24","r":"12"}},{"tag":"circle","attr":{"fill":"#42A5F5","cx":"24","cy":"24","r":"9"}},{"tag":"path","attr":{"fill":"#90CAF9","d":"M28.8,21c-1.2-1.4-3-2.2-4.8-2.2s-3.6,0.8-4.8,2.2c-0.5,0.5-0.4,1.3,0.1,1.8c0.5,0.5,1.3,0.4,1.8-0.1 c1.5-1.7,4.3-1.7,5.8,0c0.3,0.3,0.6,0.4,1,0.4c0.3,0,0.6-0.1,0.9-0.3C29.2,22.4,29.3,21.5,28.8,21z"}}]})(props);
};
function FcInternal (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#B3E5FC","cx":"24","cy":"30","r":"15"}},{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"polygon","attr":{"points":"24,38.7 15,28 33,28"}},{"tag":"rect","attr":{"x":"21","y":"5","width":"6","height":"26"}}]}]})(props);
};
function FcInvite (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#78909C","d":"M40,41H8c-2.2,0-4-1.8-4-4l0-20.9c0-1.3,0.6-2.5,1.7-3.3L24,0l18.3,12.8c1.1,0.7,1.7,2,1.7,3.3V37 C44,39.2,42.2,41,40,41z"}},{"tag":"rect","attr":{"x":"12","y":"11","fill":"#fff","width":"24","height":"22"}},{"tag":"path","attr":{"fill":"#CFD8DC","d":"M40,41H8c-2.2,0-4-1.8-4-4l0-20l20,13l20-13v20C44,39.2,42.2,41,40,41z"}},{"tag":"g","attr":{"fill":"#4CAF50"},"child":[{"tag":"rect","attr":{"x":"22","y":"14","width":"4","height":"12"}},{"tag":"rect","attr":{"x":"18","y":"18","width":"12","height":"4"}}]}]})(props);
};
function FcIpad (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E38939","d":"M8,41V7c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v34c0,2.2-1.8,4-4,4H12C9.8,45,8,43.2,8,41z"}},{"tag":"path","attr":{"fill":"#FFF3E0","d":"M36,6H12c-0.6,0-1,0.4-1,1v31c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1V7C37,6.4,36.6,6,36,6z"}},{"tag":"circle","attr":{"fill":"#A6642A","cx":"24","cy":"42","r":"1.5"}}]})(props);
};
function FcIphone (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E38939","d":"M12,40V8c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z"}},{"tag":"path","attr":{"fill":"#FFF3E0","d":"M32,7H16c-0.6,0-1,0.4-1,1v29c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8C33,7.4,32.6,7,32,7z"}},{"tag":"circle","attr":{"fill":"#A6642A","cx":"24","cy":"41","r":"1.5"}}]})(props);
};
function FcKey (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFA000"},"child":[{"tag":"polygon","attr":{"points":"30,41 26,45 22,45 18,41 18,21 30,21 30,29 28,31 30,33 30,35 28,37 30,39"}},{"tag":"path","attr":{"d":"M38,7.8C37.5,6,36,4.7,34.3,4.2C31.9,3.7,28.2,3,24,3s-7.9,0.7-10.3,1.2C12,4.7,10.5,6,10,7.8 c-0.5,1.7-1,4.1-1,6.7c0,2.6,0.5,5,1,6.7c0.5,1.8,1.9,3.1,3.7,3.5C16.1,25.3,19.8,26,24,26s7.9-0.7,10.3-1.2 c1.8-0.4,3.2-1.8,3.7-3.5c0.5-1.7,1-4.1,1-6.7C39,11.9,38.5,9.5,38,7.8z M29,13H19c-1.1,0-2-0.9-2-2V9c0-0.6,3.1-1,7-1s7,0.4,7,1v2 C31,12.1,30.1,13,29,13z"}}]},{"tag":"rect","attr":{"x":"23","y":"26","fill":"#D68600","width":"2","height":"19"}}]})(props);
};
function FcKindle (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M8,41V7c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v34c0,2.2-1.8,4-4,4H12C9.8,45,8,43.2,8,41z"}},{"tag":"path","attr":{"fill":"#eee","d":"M35,6H13c-0.6,0-1,0.4-1,1v29c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V7C36,6.4,35.6,6,35,6z"}},{"tag":"rect","attr":{"x":"20","y":"40","fill":"#546E7A","width":"8","height":"2"}},{"tag":"g","attr":{"fill":"#A1A1A1"},"child":[{"tag":"rect","attr":{"x":"16","y":"11","width":"16","height":"3"}},{"tag":"rect","attr":{"x":"16","y":"18","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"22","width":"12","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"26","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"30","width":"12","height":"2"}}]}]})(props);
};
function FcLandscape (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FF9800"},"child":[{"tag":"rect","attr":{"x":"36.1","y":"8.1","transform":"matrix(.707 .707 -.707 .707 21.201 -25.184)","width":"9.9","height":"9.9"}},{"tag":"rect","attr":{"x":"36","y":"8","width":"10","height":"10"}}]},{"tag":"circle","attr":{"fill":"#FFEB3B","cx":"41","cy":"13","r":"3"}},{"tag":"polygon","attr":{"fill":"#2E7D32","points":"16.5,18 0,42 33,42"}},{"tag":"polygon","attr":{"fill":"#4CAF50","points":"33.6,24 19.2,42 48,42"}}]})(props);
};
function FcLeave (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFCDD2","d":"M5,38V14h38v24c0,2.2-1.8,4-4,4H9C6.8,42,5,40.2,5,38z"}},{"tag":"path","attr":{"fill":"#F44336","d":"M43,10v6H5v-6c0-2.2,1.8-4,4-4h30C41.2,6,43,7.8,43,10z"}},{"tag":"g","attr":{"fill":"#B71C1C"},"child":[{"tag":"circle","attr":{"cx":"33","cy":"10","r":"3"}},{"tag":"circle","attr":{"cx":"15","cy":"10","r":"3"}}]},{"tag":"g","attr":{"fill":"#BDBDBD"},"child":[{"tag":"path","attr":{"d":"M33,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C35,3.9,34.1,3,33,3z"}},{"tag":"path","attr":{"d":"M15,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C17,3.9,16.1,3,15,3z"}}]},{"tag":"path","attr":{"fill":"#F44336","d":"M22.2,35.3c0-0.2,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.5s0.3-0.3,0.5-0.3c0.2-0.1,0.5-0.1,0.7-0.1 s0.5,0,0.7,0.1c0.2,0.1,0.4,0.2,0.6,0.3s0.3,0.3,0.4,0.5c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.4,0.5 c-0.2,0.1-0.3,0.3-0.6,0.3S24.3,37,24,37s-0.5,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.2-0.1-0.3-0.3-0.4-0.5 C22.3,35.8,22.2,35.6,22.2,35.3z M25.3,31h-2.6l-0.4-11h3.3L25.3,31z"}}]})(props);
};
function FcLeftDown (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"7,41 7,23 25,41"}},{"tag":"rect","attr":{"x":"22.6","y":"5","transform":"matrix(.707 .707 -.707 .707 22.912 -12.567)","fill":"#3F51B5","width":"8","height":"32.7"}}]})(props);
};
function FcLeftDown2 (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"19,44 30.7,30 7.3,30"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M27,6h13v8H27c-2.2,0-4,1.8-4,4v17h-8V18C15,11.4,20.4,6,27,6z"}}]})(props);
};
function FcLeftUp (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"7,7 25,7 7,25"}},{"tag":"rect","attr":{"x":"22.6","y":"10.3","transform":"matrix(-.707 .707 -.707 -.707 64.28 26.626)","fill":"#3F51B5","width":"8","height":"32.7"}}]})(props);
};
function FcLeftUp2 (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"19,4 30.7,18 7.3,18"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M27,42h13v-8H27c-2.2,0-4-1.8-4-4V13h-8v17C15,36.6,20.4,42,27,42z"}}]})(props);
};
function FcLeft (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"4,24 18,12.3 18,35.7"}},{"tag":"rect","attr":{"x":"15","y":"20","width":"27","height":"8"}}]}]})(props);
};
function FcLibrary (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FF9800"},"child":[{"tag":"rect","attr":{"x":"1","y":"38","width":"46","height":"2"}},{"tag":"rect","attr":{"x":"25","y":"18","width":"4","height":"16"}},{"tag":"rect","attr":{"x":"31","y":"18","width":"4","height":"16"}},{"tag":"rect","attr":{"x":"37","y":"18","width":"4","height":"16"}},{"tag":"rect","attr":{"x":"19","y":"18","width":"4","height":"16"}},{"tag":"rect","attr":{"x":"13","y":"18","width":"4","height":"16"}},{"tag":"rect","attr":{"x":"7","y":"18","width":"4","height":"16"}},{"tag":"polygon","attr":{"points":"43,16 5,16 5,13 24,4 43,13"}},{"tag":"rect","attr":{"x":"5","y":"34","width":"38","height":"2"}}]},{"tag":"g","attr":{"fill":"#EF6C00"},"child":[{"tag":"rect","attr":{"x":"25","y":"16","width":"4","height":"2"}},{"tag":"rect","attr":{"x":"31","y":"16","width":"4","height":"2"}},{"tag":"rect","attr":{"x":"37","y":"16","width":"4","height":"2"}},{"tag":"rect","attr":{"x":"19","y":"16","width":"4","height":"2"}},{"tag":"rect","attr":{"x":"13","y":"16","width":"4","height":"2"}},{"tag":"rect","attr":{"x":"7","y":"16","width":"4","height":"2"}},{"tag":"rect","attr":{"x":"3","y":"36","width":"42","height":"2"}},{"tag":"circle","attr":{"cx":"24","cy":"11","r":"2"}}]}]})(props);
};
function FcLightAtTheEndOfTunnel (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#3F51B5","d":"M6,10v28c0,2.2,1.8,4,4,4h28c2.2,0,4-1.8,4-4V10c0-2.2-1.8-4-4-4H10C7.8,6,6,7.8,6,10z"}},{"tag":"path","attr":{"fill":"#CCF2F6","d":"M27.9,28.9h-5.8l-8.4,7.2l6-7.2v-2.4l-3,0.8l3-1.9v-1.5c0-0.8,0.1-1.7,0.6-2.4l-7.5-8.3l8.7,7.2 c0.7-0.7,1.5-1.1,2.5-1.2l0.6-7.3l1.1,7.3c0.3,0,0.6,0.1,0.8,0.1l1.2-1.2l-0.3,1.7c0.3,0.1,0.4,0.3,0.7,0.6l4.4-2.8l-3.6,3.9 c0.3,0.4,0.6,1,0.7,1.7l2.2,0.1l-2.2,0.8c0,0.3,0,1.5,0,1.5l2.6,1.4l-2.6-0.3c0,0,0,1.8,0,2.2l6.2,7.1L27.9,28.9z"}}]})(props);
};
function FcLikePlaceholder (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFCDD2","d":"M34,9c-4.2,0-7.9,2.1-10,5.4C21.9,11.1,18.2,9,14,9C7.4,9,2,14.4,2,21c0,11.9,22,24,22,24s22-12,22-24 C46,14.4,40.6,9,34,9z"}}]})(props);
};
function FcLike (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F44336","d":"M34,9c-4.2,0-7.9,2.1-10,5.4C21.9,11.1,18.2,9,14,9C7.4,9,2,14.4,2,21c0,11.9,22,24,22,24s22-12,22-24 C46,14.4,40.6,9,34,9z"}}]})(props);
};
function FcLineChart (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"circle","attr":{"cx":"8","cy":"38","r":"3"}},{"tag":"circle","attr":{"cx":"16","cy":"40","r":"3"}},{"tag":"circle","attr":{"cx":"24","cy":"33","r":"3"}},{"tag":"circle","attr":{"cx":"32","cy":"35","r":"3"}},{"tag":"circle","attr":{"cx":"40","cy":"31","r":"3"}},{"tag":"polygon","attr":{"points":"39.1,29.2 31.8,32.9 23.5,30.8 15.5,37.8 8.5,36.1 7.5,39.9 16.5,42.2 24.5,35.2 32.2,37.1 40.9,32.8"}}]},{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"circle","attr":{"cx":"8","cy":"20","r":"3"}},{"tag":"circle","attr":{"cx":"16","cy":"22","r":"3"}},{"tag":"circle","attr":{"cx":"24","cy":"15","r":"3"}},{"tag":"circle","attr":{"cx":"32","cy":"20","r":"3"}},{"tag":"circle","attr":{"cx":"40","cy":"8","r":"3"}},{"tag":"path","attr":{"d":"M38.3,6.9c-2.1,3.2-5.3,8-6.9,10.4c-1.2-0.7-3.1-2-6.4-4l-1.3-0.8l-8.3,7.3l-7-1.7l-1,3.9l9,2.3l7.7-6.7 c2.6,1.6,5.8,3.6,6.5,4.1l0.5,0.5l0.9-0.1c1.1-0.1,1.1-0.1,9.5-12.9L38.3,6.9z"}}]}]})(props);
};
function FcLink (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"path","attr":{"d":"M38,13h-3c-5.5,0-10,4.5-10,10s4.5,10,10,10h3c5.5,0,10-4.5,10-10S43.5,13,38,13z M38,29h-3 c-3.3,0-6-2.7-6-6s2.7-6,6-6h3c3.3,0,6,2.7,6,6S41.3,29,38,29z"}},{"tag":"path","attr":{"d":"M13,13h-3C4.5,13,0,17.5,0,23s4.5,10,10,10h3c5.5,0,10-4.5,10-10S18.5,13,13,13z M13,29h-3 c-3.3,0-6-2.7-6-6s2.7-6,6-6h3c3.3,0,6,2.7,6,6S16.3,29,13,29z"}}]},{"tag":"path","attr":{"fill":"#42A5F5","d":"M33,21H15c-1.1,0-2,0.9-2,2s0.9,2,2,2h18c1.1,0,2-0.9,2-2S34.1,21,33,21z"}}]})(props);
};
function FcLinux (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 2 48 48","enableBackground":"new 0 2 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#ECEFF1","points":"20.1,18.2 20.2,20.5 18.6,23.5 16.1,28.4 15.6,32.5 17.4,38.3 21.5,40.6 27.7,40.6 33.5,36.2 \r\n\t36.1,29.3 30.1,22 28.4,17.9 "}},{"tag":"path","attr":{"fill":"#263238","d":"M34.3,23.9c-1.6-2.3-2.9-3.7-3.6-6.6c-0.7-2.9,0.2-2.1-0.4-4.6c-0.3-1.3-0.8-2.2-1.3-2.9\r\n\tc-0.6-0.7-1.3-1.1-1.7-1.2c-0.9-0.5-3-1.3-5.6,0.1c-2.7,1.4-2.4,4.4-1.9,10.5c0,0.4-0.1,0.9-0.3,1.3c-0.4,0.9-1.1,1.7-1.7,2.4\r\n\tc-0.7,1-1.4,2-1.9,3.1c-1.2,2.3-2.3,5.2-2,6.3c0.5-0.1,6.8,9.5,6.8,9.7c0.4-0.1,2.1-0.1,3.6-0.1c2.1-0.1,3.3-0.2,5,0.2\r\n\tc0-0.3-0.1-0.6-0.1-0.9c0-0.6,0.1-1.1,0.2-1.8c0.1-0.5,0.2-1,0.3-1.6c-1,0.9-2.8,1.9-4.5,2.2c-1.5,0.3-4-0.2-5.2-1.7\r\n\tc0.1,0,0.3,0,0.4-0.1c0.3-0.1,0.6-0.2,0.7-0.4c0.3-0.5,0.1-1-0.1-1.3c-0.2-0.3-1.7-1.4-2.4-2c-0.7-0.6-1.1-0.9-1.5-1.3\r\n\tc0,0-0.6-0.6-0.8-0.8c-0.2-0.2-0.3-0.4-0.4-0.5c-0.2-0.5-0.3-1.1-0.2-1.9c0.1-1.1,0.5-2,1-3c0.2-0.4,0.7-1.2,0.7-1.2\r\n\ts-1.7,4.2-0.8,5.5c0,0,0.1-1.3,0.5-2.6c0.3-0.9,0.8-2.2,1.4-2.9s2.1-3.3,2.2-4.9c0-0.7,0.1-1.4,0.1-1.9c-0.4-0.4,6.6-1.4,7-0.3\r\n\tc0.1,0.4,1.5,4,2.3,5.9c0.4,0.9,0.9,1.7,1.2,2.7c0.3,1.1,0.5,2.6,0.5,4.1c0,0.3,0,0.8-0.1,1.3c0.2,0,4.1-4.2-0.5-7.7\r\n\tc0,0,2.8,1.3,2.9,3.9c0.1,2.1-0.8,3.8-1,4.1c0.1,0,2.1,0.9,2.2,0.9c0.4,0,1.2-0.3,1.2-0.3c0.1-0.3,0.4-1.1,0.4-1.4\r\n\tC37.6,29.9,35.9,26.2,34.3,23.9z"}},{"tag":"g","attr":{},"child":[{"tag":"ellipse","attr":{"fill":"#ECEFF1","cx":"21.6","cy":"15.3","rx":"1.3","ry":"2"}},{"tag":"ellipse","attr":{"fill":"#ECEFF1","cx":"26.1","cy":"15.2","rx":"1.7","ry":"2.3"}}]},{"tag":"g","attr":{},"child":[{"tag":"ellipse","attr":{"transform":"matrix(-0.1254 -0.9921 0.9921 -0.1254 8.9754 38.9969)","fill":"#212121","cx":"21.7","cy":"15.5","rx":"1.2","ry":"0.7"}},{"tag":"ellipse","attr":{"fill":"#212121","cx":"26","cy":"15.6","rx":"1","ry":"1.3"}}]},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#FFC107","d":"M39.3,37.6c-0.4-0.2-1.1-0.5-1.7-1.4c-0.3-0.5-0.2-1.9-0.7-2.5c-0.3-0.4-0.7-0.2-0.8-0.2\r\n\t\tc-0.9,0.2-3,1.6-4.4,0c-0.2-0.2-0.5-0.5-1-0.5c-0.5,0-0.7,0.2-0.9,0.6s-0.2,0.7-0.2,1.7c0,0.8,0,1.7-0.1,2.4\r\n\t\tc-0.2,1.7-0.5,2.7-0.5,3.7c0,1.1,0.3,1.8,0.7,2.1c0.3,0.3,0.8,0.5,1.9,0.5c1.1,0,1.8-0.4,2.5-1.1c0.5-0.5,0.9-0.7,2.3-1.7\r\n\t\tc1.1-0.7,2.8-1.6,3.1-1.9c0.2-0.2,0.5-0.3,0.5-0.9C40,37.9,39.6,37.7,39.3,37.6z"}},{"tag":"path","attr":{"fill":"#FFC107","d":"M19.2,37.9c-1-1.6-1.1-1.9-1.8-2.9c-0.6-1-1.9-2.9-2.7-2.9c-0.6,0-0.9,0.3-1.3,0.7\r\n\t\tc-0.4,0.4-0.8,1.3-1.5,1.8c-0.6,0.5-2.3,0.4-2.7,1c-0.4,0.6,0.4,1.5,0.4,3c0,0.6-0.5,1-0.6,1.4c-0.1,0.5-0.2,0.8,0,1.2\r\n\t\tc0.4,0.6,0.9,0.8,4.3,1.5c1.8,0.4,3.5,1.4,4.6,1.5c1.1,0.1,3,0,3-2.7C21,39.9,20.1,39.5,19.2,37.9z"}},{"tag":"path","attr":{"fill":"#FFC107","d":"M21.1,19.8C20.5,19.4,20,19,20,18.4c0-0.6,0.4-0.8,1-1.3c0.1-0.1,1.2-1.1,2.3-1.1s2.4,0.7,2.9,0.9\r\n\t\tc0.9,0.2,1.8,0.4,1.7,1.1c-0.1,1-0.2,1.2-1.2,1.7c-0.7,0.2-2,1.3-2.9,1.3c-0.4,0-1,0-1.4-0.1C22.1,20.8,21.6,20.3,21.1,19.8z"}}]},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#634703","d":"M20.9,19c0.2,0.2,0.5,0.4,0.8,0.5c0.2,0.1,0.5,0.2,0.5,0.2c0.4,0,0.7,0,0.9,0c0.5,0,1.2-0.2,1.9-0.6\r\n\t\tc0.7-0.3,0.8-0.5,1.3-0.7c0.5-0.3,1-0.6,0.8-0.7c-0.2-0.1-0.4,0-1.1,0.4c-0.6,0.4-1.1,0.6-1.7,0.9c-0.3,0.1-0.7,0.3-1,0.3\r\n\t\tc-0.3,0-0.6,0-0.9,0c-0.3,0-0.5-0.1-0.8-0.2c-0.2-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.6-0.5-0.8-0.6c0,0-0.2,0-0.1,0.1\r\n\t\tC20.6,18.7,20.7,18.8,20.9,19z"}},{"tag":"path","attr":{"fill":"#634703","d":"M23.9,16.8c0.1,0.2,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.1,0.2,0.1c0.1-0.1,0-0.3-0.1-0.3\r\n\t\tC24.4,16.7,23.9,16.7,23.9,16.8z"}},{"tag":"path","attr":{"fill":"#634703","d":"M22.3,17c0,0.1,0.2,0.2,0.2,0.1c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.1-0.2-0.2-0.2\r\n\t\tC22.4,16.8,22.4,16.9,22.3,17z"}}]},{"tag":"path","attr":{"fill":"#455A64","d":"M32,34.7c0,0.1,0,0.2,0,0.3c0.2,0.4,0.7,0.5,1.1,0.5c0.6,0,1.2-0.4,1.5-0.8c0-0.1,0.1-0.2,0.2-0.3\r\n\tc0.2-0.3,0.3-0.5,0.4-0.6c0,0-0.1-0.1-0.1-0.2c-0.1-0.2-0.4-0.4-0.8-0.5c-0.3-0.1-0.8-0.2-1-0.2c-0.9-0.1-1.4,0.2-1.7,0.5\r\n\tc0,0,0.1,0,0.1,0.1c0.2,0.2,0.3,0.4,0.3,0.7C32.1,34.4,32,34.5,32,34.7z"}}]})(props);
};
function FcList (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"rect","attr":{"x":"6","y":"22","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"14","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"30","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"6","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"38","width":"4","height":"4"}}]},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"rect","attr":{"x":"14","y":"22","width":"28","height":"4"}},{"tag":"rect","attr":{"x":"14","y":"14","width":"28","height":"4"}},{"tag":"rect","attr":{"x":"14","y":"30","width":"28","height":"4"}},{"tag":"rect","attr":{"x":"14","y":"6","width":"28","height":"4"}},{"tag":"rect","attr":{"x":"14","y":"38","width":"28","height":"4"}}]}]})(props);
};
function FcLockLandscape (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M7,10h34c2.2,0,4,1.8,4,4v20c0,2.2-1.8,4-4,4H7c-2.2,0-4-1.8-4-4V14C3,11.8,4.8,10,7,10z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M42,34V14c0-0.6-0.4-1-1-1H7c-0.6,0-1,0.4-1,1v20c0,0.6,0.4,1,1,1h34C41.6,35,42,34.6,42,34z"}},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"path","attr":{"d":"M29,31H19c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1h10c0.6,0,1,0.4,1,1v6C30,30.6,29.6,31,29,31z"}},{"tag":"path","attr":{"d":"M24,17c-2.2,0-4,1.8-4,4v3h2v-3c0-1.1,0.9-2,2-2s2,0.9,2,2v3h2v-3C28,18.8,26.2,17,24,17z"}}]}]})(props);
};
function FcLockPortrait (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M10,41V7c0-2.2,1.8-4,4-4h20c2.2,0,4,1.8,4,4v34c0,2.2-1.8,4-4,4H14C11.8,45,10,43.2,10,41z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M34,6H14c-0.6,0-1,0.4-1,1v34c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1V7C35,6.4,34.6,6,34,6z"}},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"path","attr":{"d":"M29,30H19c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1h10c0.6,0,1,0.4,1,1v6C30,29.6,29.6,30,29,30z"}},{"tag":"path","attr":{"d":"M24,16c-2.2,0-4,1.8-4,4v3h2v-3c0-1.1,0.9-2,2-2s2,0.9,2,2v3h2v-3C28,17.8,26.2,16,24,16z"}}]}]})(props);
};
function FcLock (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#424242","d":"M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z"}},{"tag":"path","attr":{"fill":"#FB8C00","d":"M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"}},{"tag":"circle","attr":{"fill":"#C76E00","cx":"24","cy":"31","r":"3"}}]})(props);
};
function FcLowBattery (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#CFD8DC"},"child":[{"tag":"path","attr":{"d":"M34,44H14c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v34C36,43.1,35.1,44,34,44z"}},{"tag":"path","attr":{"d":"M28,13h-8c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1v7C29,12.6,28.6,13,28,13z"}}]},{"tag":"path","attr":{"fill":"#8BC34A","d":"M34,44H14c-1.1,0-2-0.9-2-2v-9h24v9C36,43.1,35.1,44,34,44z"}}]})(props);
};
function FcLowPriority (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#4CAF50","d":"M21.2,44.8l-18-18c-1.6-1.6-1.6-4.1,0-5.7l18-18c1.6-1.6,4.1-1.6,5.7,0l18,18c1.6,1.6,1.6,4.1,0,5.7l-18,18 C25.3,46.4,22.7,46.4,21.2,44.8z"}},{"tag":"g","attr":{"fill":"#FFEB3B"},"child":[{"tag":"polygon","attr":{"points":"24,33.4 17,25 31,25"}},{"tag":"rect","attr":{"x":"22","y":"14.8","width":"4","height":"12.3"}}]}]})(props);
};
function FcMakeDecision (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"path","attr":{"d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"path","attr":{"d":"M24,4C15.2,4,8,11.2,8,20c0,1.2,0,3.5,0,3.5l2.1,0.6V19l19.5-6.3l8.2,6.3v5.1l2.1-0.6c0,0,0-2.3,0-3.5 C40,12.5,34.6,4,24,4z"}}]},{"tag":"polygon","attr":{"fill":"#FF5722","points":"24,23.5 24,12.5 30.6,18"}},{"tag":"path","attr":{"fill":"#FF5722","d":"M28.9,24.4c0,0.2,0.1,0.4,0.1,0.6c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5c0.7,0,1.4,0.2,2,0.4v-4.2 c-0.6-0.1-1.3-0.2-2-0.2c-5,0-9,4-9,9s4,9,9,9s9-4,9-9c0-1.2-0.2-2.4-0.7-3.4L28.9,24.4z"}}]})(props);
};
function FcManager (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#FF9800","points":"24,37 19,31 19,25 29,25 29,31"}},{"tag":"g","attr":{"fill":"#FFA726"},"child":[{"tag":"circle","attr":{"cx":"33","cy":"19","r":"2"}},{"tag":"circle","attr":{"cx":"15","cy":"19","r":"2"}}]},{"tag":"path","attr":{"fill":"#FFB74D","d":"M33,13c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C33,18.9,33,14.1,33,13z"}},{"tag":"path","attr":{"fill":"#FF5722","d":"M24,4c-6.1,0-10,4.9-10,11c0,0.8,0,2.3,0,2.3l2,1.7v-5l12-4l4,4v5l2-1.7c0,0,0-1.5,0-2.3c0-4-1-8-6-9l-1-2 H24z"}},{"tag":"g","attr":{"fill":"#784719"},"child":[{"tag":"circle","attr":{"cx":"28","cy":"19","r":"1"}},{"tag":"circle","attr":{"cx":"20","cy":"19","r":"1"}}]},{"tag":"path","attr":{"fill":"#CFD8DC","d":"M29,31L29,31l-5,1l-5-1c0,0-11,2-11,13h32C40,33,29,31,29,31z"}},{"tag":"polygon","attr":{"fill":"#3F51B5","points":"23,35 22,44 26,44 25,35 26,34 24,32 22,34"}}]})(props);
};
function FcMediumPriority (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFC107","d":"M21.2,44.8l-18-18c-1.6-1.6-1.6-4.1,0-5.7l18-18c1.6-1.6,4.1-1.6,5.7,0l18,18c1.6,1.6,1.6,4.1,0,5.7l-18,18 C25.3,46.4,22.7,46.4,21.2,44.8z"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"24","r":"2"}},{"tag":"circle","attr":{"cx":"32","cy":"24","r":"2"}},{"tag":"circle","attr":{"cx":"16","cy":"24","r":"2"}}]}]})(props);
};
function FcMenu (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#607D8B"},"child":[{"tag":"rect","attr":{"x":"6","y":"22","width":"36","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"10","width":"36","height":"4"}},{"tag":"rect","attr":{"x":"6","y":"34","width":"36","height":"4"}}]}]})(props);
};
function FcMiddleBattery (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#CFD8DC"},"child":[{"tag":"path","attr":{"d":"M34,44H14c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v34C36,43.1,35.1,44,34,44z"}},{"tag":"path","attr":{"d":"M28,13h-8c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1v7C29,12.6,28.6,13,28,13z"}}]},{"tag":"path","attr":{"fill":"#8BC34A","d":"M34,44H14c-1.1,0-2-0.9-2-2V23h24v19C36,43.1,35.1,44,34,44z"}}]})(props);
};
function FcMindMap (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#CFD8DC","points":"39.4,23 38.6,19 26,21.6 26,8 22,8 22,20.3 8.1,11.3 5.9,14.7 21.1,24.5 9.4,39.8 12.6,42.2 23.9,27.4 32.3,40.1 35.7,37.9 27.3,25.4"}},{"tag":"circle","attr":{"fill":"#3F51B5","cx":"24","cy":"24","r":"7"}},{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"8","r":"5"}},{"tag":"circle","attr":{"cx":"39","cy":"21","r":"5"}},{"tag":"circle","attr":{"cx":"7","cy":"13","r":"5"}},{"tag":"circle","attr":{"cx":"11","cy":"41","r":"5"}},{"tag":"circle","attr":{"cx":"34","cy":"39","r":"5"}}]}]})(props);
};
function FcMinus (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"8","y":"21","fill":"#5C6BC0","width":"32","height":"6"}}]})(props);
};
function FcMissedCall (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#F44336"},"child":[{"tag":"polygon","attr":{"points":"30.3,12.9 24,19.2 15.7,10.9 12.9,13.7 24,24.8 33.1,15.7"}},{"tag":"polygon","attr":{"points":"36,19 27,10 36,10"}}]},{"tag":"path","attr":{"fill":"#009688","d":"M44.5,30.8l-2.4-2.4c-8.5-8.3-28.9-7.1-36.2,0l-2.4,2.4c-0.7,0.7-0.7,1.7,0,2.4l4.8,4.7 c0.7,0.7,1.7,0.7,2.4,0l5.3-5.1l-0.4-5.6c1.7-1.7,15.1-1.7,16.8,0L32.1,33l5.1,4.9c0.7,0.7,1.7,0.7,2.4,0l4.8-4.7 C45.2,32.5,45.2,31.4,44.5,30.8z"}}]})(props);
};
function FcMms (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E91E63","d":"M37,39H11l-6,6V11c0-3.3,2.7-6,6-6h26c3.3,0,6,2.7,6,6v22C43,36.3,40.3,39,37,39z"}},{"tag":"polygon","attr":{"fill":"#F48FB1","points":"20,16.5 10,31 30,31"}},{"tag":"g","attr":{"fill":"#F8BBD0"},"child":[{"tag":"circle","attr":{"cx":"34","cy":"15","r":"3"}},{"tag":"polygon","attr":{"points":"30,21 22,31 38,31"}}]}]})(props);
};
function FcMoneyTransfer (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#78909C","d":"M40,41H8c-2.2,0-4-1.8-4-4l0-20.9c0-1.3,0.6-2.5,1.7-3.3L24,0l18.3,12.8c1.1,0.7,1.7,2,1.7,3.3V37 C44,39.2,42.2,41,40,41z"}},{"tag":"rect","attr":{"x":"14","y":"1","fill":"#AED581","width":"20","height":"31"}},{"tag":"g","attr":{"fill":"#558B2F"},"child":[{"tag":"path","attr":{"d":"M13,0v33h22V0H13z M33,31H15V2h18V31z"}},{"tag":"path","attr":{"d":"M34,3c0,1.7-0.3,3-2,3c-1.7,0-3-1.3-3-3s1.3-2,3-2C33.7,1,34,1.3,34,3z"}},{"tag":"path","attr":{"d":"M16,1c1.7,0,3,0.3,3,2s-1.3,3-3,3s-2-1.3-2-3S14.3,1,16,1z"}},{"tag":"circle","attr":{"cx":"24","cy":"8","r":"2"}},{"tag":"circle","attr":{"cx":"24","cy":"20","r":"6"}}]},{"tag":"path","attr":{"fill":"#CFD8DC","d":"M40,41H8c-2.2,0-4-1.8-4-4l0-20l20,13l20-13v20C44,39.2,42.2,41,40,41z"}}]})(props);
};
function FcMultipleCameras (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#455A64","d":"M42,41H12c-2.2,0-4-1.8-4-4V17c0-2.2,1.8-4,4-4h30c2.2,0,4,1.8,4,4v20C46,39.2,44.2,41,42,41z"}},{"tag":"path","attr":{"fill":"#78909C","d":"M36,36H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h30c2.2,0,4,1.8,4,4v20C40,34.2,38.2,36,36,36z"}},{"tag":"circle","attr":{"fill":"#455A64","cx":"26","cy":"22","r":"10"}},{"tag":"circle","attr":{"fill":"#42A5F5","cx":"26","cy":"22","r":"7"}},{"tag":"path","attr":{"fill":"#90CAF9","d":"M29.7,19.7c-1-1.1-2.3-1.7-3.7-1.7s-2.8,0.6-3.7,1.7c-0.4,0.4-0.3,1,0.1,1.4c0.4,0.4,1,0.3,1.4-0.1 c1.2-1.3,3.3-1.3,4.5,0c0.2,0.2,0.5,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3C30.1,20.7,30.1,20.1,29.7,19.7z"}},{"tag":"rect","attr":{"x":"6","y":"12","fill":"#ADD8FB","width":"6","height":"3"}}]})(props);
};
function FcMultipleDevices (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#546E7A","d":"M4,28V8c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v20c0,2.2-1.8,4-4,4H8C5.8,32,4,30.2,4,28z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M36,7H8C7.4,7,7,7.4,7,8v20c0,0.6,0.4,1,1,1h28c0.6,0,1-0.4,1-1V8C37,7.4,36.6,7,36,7z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M38,33H6c-2.2,0-4-1.8-4-4v0h40v0C42,31.2,40.2,33,38,33z"}},{"tag":"path","attr":{"fill":"#E38939","d":"M24,40V16c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4H28C25.8,44,24,42.2,24,40z"}},{"tag":"path","attr":{"fill":"#FFF3E0","d":"M40,15H28c-0.6,0-1,0.4-1,1v22c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V16C41,15.4,40.6,15,40,15z"}},{"tag":"circle","attr":{"fill":"#A6642A","cx":"34","cy":"41.5","r":"1.5"}}]})(props);
};
function FcMultipleInputs (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90A4AE","d":"M40,35v5H8v-5H4v5c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4v-5H40z"}},{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"polygon","attr":{"points":"24,23.4 17,15 31,15"}},{"tag":"rect","attr":{"x":"22","y":"4","width":"4","height":"14"}},{"tag":"path","attr":{"d":"M31.5,26.9L30.8,28l3.5,1.9l0.6-1.2c1.6-3,2.6-4.7,3.5-5.2C39.3,23,41,23,44,23v-4 C36.3,19,35.6,19.4,31.5,26.9z"}},{"tag":"polygon","attr":{"points":"38.4,31 29.4,35 28,25"}},{"tag":"path","attr":{"d":"M16.5,26.9l0.6,1.2L13.6,30L13,28.8c-1.6-3-2.6-4.7-3.5-5.2C8.7,23,7,23,4,23v-4 C11.7,19,12.4,19.4,16.5,26.9z"}},{"tag":"polygon","attr":{"points":"20,25 18.6,35 9.6,31"}}]}]})(props);
};
function FcMultipleSmartphones (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#455A64","d":"M4,31V8c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v23c0,2.2-1.8,4-4,4H8C5.8,35,4,33.2,4,31z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M20,7H8C7.4,7,7,7.4,7,8v21c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V8C21,7.4,20.6,7,20,7z"}},{"tag":"circle","attr":{"fill":"#37474F","cx":"14","cy":"32.5","r":"1.5"}},{"tag":"path","attr":{"fill":"#546E7A","d":"M14,36V13c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v23c0,2.2-1.8,4-4,4H18C15.8,40,14,38.2,14,36z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M30,12H18c-0.6,0-1,0.4-1,1v21c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V13C31,12.4,30.6,12,30,12z"}},{"tag":"circle","attr":{"fill":"#37474F","cx":"24","cy":"37.5","r":"1.5"}},{"tag":"path","attr":{"fill":"#E38939","d":"M24,40V18c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v22c0,2.2-1.8,4-4,4H28C25.8,44,24,42.2,24,40z"}},{"tag":"path","attr":{"fill":"#FFF3E0","d":"M40,17H28c-0.6,0-1,0.4-1,1v20c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V18C41,17.4,40.6,17,40,17z"}},{"tag":"circle","attr":{"fill":"#A6642A","cx":"34","cy":"41.5","r":"1.5"}}]})(props);
};
function FcMusic (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#E91E63"},"child":[{"tag":"circle","attr":{"cx":"19","cy":"33","r":"9"}},{"tag":"polygon","attr":{"points":"24,6 24,33 28,33 28,14 39,17 39,10"}}]}]})(props);
};
function FcNegativeDynamic (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"rect","attr":{"x":"19","y":"22","width":"10","height":"20"}},{"tag":"rect","attr":{"x":"6","y":"8","width":"10","height":"34"}},{"tag":"rect","attr":{"x":"32","y":"30","width":"10","height":"12"}}]},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"42,12 32,22 42,22"}},{"tag":"rect","attr":{"x":"32","y":"6.9","transform":"matrix(.707 -.707 .707 .707 .059 28.142)","width":"4","height":"14.1"}}]}]})(props);
};
function FcNeutralDecision (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFCC80"},"child":[{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"path","attr":{"d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"path","attr":{"d":"M24,4C15.2,4,8,11.2,8,20c0,1.2,0,3.5,0,3.5l2.1,0.6V19l19.5-6.3l8.2,6.3v5.1l2.1-0.6c0,0,0-2.3,0-3.5 C40,12.5,34.6,4,24,4z"}}]},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"25","r":"2"}},{"tag":"circle","attr":{"cx":"32","cy":"25","r":"2"}},{"tag":"circle","attr":{"cx":"16","cy":"25","r":"2"}}]}]})(props);
};
function FcNeutralTrading (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"polygon","attr":{"points":"43.4,13 35,20 35,6"}},{"tag":"rect","attr":{"x":"4","y":"11","width":"34","height":"4"}}]},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"rect","attr":{"x":"40","y":"23","width":"4","height":"19"}},{"tag":"rect","attr":{"x":"34","y":"23","width":"4","height":"19"}},{"tag":"rect","attr":{"x":"28","y":"23","width":"4","height":"19"}},{"tag":"rect","attr":{"x":"22","y":"23","width":"4","height":"19"}},{"tag":"rect","attr":{"x":"16","y":"23","width":"4","height":"19"}},{"tag":"rect","attr":{"x":"10","y":"23","width":"4","height":"19"}},{"tag":"rect","attr":{"x":"4","y":"23","width":"4","height":"19"}}]}]})(props);
};
function FcNews (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF5722","d":"M32,15v28H10c-2.2,0-4-1.8-4-4V15H32z"}},{"tag":"path","attr":{"fill":"#FFCCBC","d":"M14,5v34c0,2.2-1.8,4-4,4h29c2.2,0,4-1.8,4-4V5H14z"}},{"tag":"g","attr":{"fill":"#FF5722"},"child":[{"tag":"rect","attr":{"x":"20","y":"10","width":"18","height":"4"}},{"tag":"rect","attr":{"x":"20","y":"17","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"30","y":"17","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"20","y":"21","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"30","y":"21","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"20","y":"25","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"30","y":"25","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"20","y":"29","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"30","y":"29","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"20","y":"33","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"30","y":"33","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"20","y":"37","width":"8","height":"2"}},{"tag":"rect","attr":{"x":"30","y":"37","width":"8","height":"2"}}]}]})(props);
};
function FcNext (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#2196F3","points":"17.1,5 14,8.1 29.9,24 14,39.9 17.1,43 36,24"}}]})(props);
};
function FcNfcSign (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#2196F3","d":"M37,42c-0.3,0-0.7-0.1-1-0.3c-1-0.5-1.3-1.8-0.8-2.7c0-0.1,3.7-6.8,3.7-15S35.3,9,35.3,9\r\n\tc-0.5-1-0.2-2.2,0.8-2.7c1-0.5,2.2-0.2,2.7,0.8c0.2,0.3,4.3,7.6,4.3,17s-4.1,16.7-4.3,17C38.4,41.6,37.7,42,37,42z M32.8,35.8\r\n\tc0.1-0.2,2.2-5,2.2-11.8c0-6.8-2.1-11.6-2.2-11.8c-0.4-1-1.6-1.5-2.6-1c-1,0.4-1.5,1.6-1,2.6c0,0,1.8,4.3,1.8,10.2\r\n\tc0,5.9-1.8,10.2-1.8,10.2c-0.4,1,0,2.2,1,2.6c0.3,0.1,0.5,0.2,0.8,0.2C31.8,37,32.5,36.6,32.8,35.8z M23.3,33c0.6-0.1,1.1-0.5,1.4-1\r\n\tc0.1-0.2,2.3-3.9,2.3-8c0-4.1-2.2-7.9-2.3-8c-0.6-1-1.8-1.3-2.7-0.7c-1,0.6-1.3,1.8-0.7,2.7c0,0,1.7,3,1.7,6c0,1.3-0.3,2.7-0.7,3.7\r\n\tl-13-11.2c-0.5-0.4-1.2-0.6-1.8-0.4c-0.6,0.2-1.2,0.6-1.4,1.3C6.1,17.5,5,20.5,5,24c0,3.5,1.1,6.5,1.1,6.7c0.4,1,1.5,1.6,2.6,1.2\r\n\tc1-0.4,1.6-1.5,1.2-2.6c0,0-0.9-2.6-0.9-5.3c0-0.8,0.1-1.6,0.2-2.3l12.5,10.8c0.4,0.3,0.8,0.5,1.3,0.5C23.1,33,23.2,33,23.3,33z"}}]})(props);
};
function FcNightLandscape (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#673AB7","points":"16.5,18 0,42 33,42"}},{"tag":"polygon","attr":{"fill":"#9575CD","points":"33.6,24 19.2,42 48,42"}},{"tag":"path","attr":{"fill":"#40C4FF","d":"M42.9,6.3C43.6,7.4,44,8.6,44,10c0,3.9-3.1,7-7,7c-0.7,0-1.3-0.1-1.9-0.3c1.2,2,3.4,3.3,5.9,3.3 c3.9,0,7-3.1,7-7C48,9.8,45.9,7.1,42.9,6.3z"}}]})(props);
};
function FcNightPortrait (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#40C4FF","d":"M42.9,6.3C43.6,7.4,44,8.6,44,10c0,3.9-3.1,7-7,7c-0.7,0-1.3-0.1-1.9-0.3c1.2,2,3.4,3.3,5.9,3.3 c3.9,0,7-3.1,7-7C48,9.8,45.9,7.1,42.9,6.3z"}},{"tag":"g","attr":{"fill":"#B39DDB"},"child":[{"tag":"circle","attr":{"cx":"31","cy":"19","r":"2"}},{"tag":"circle","attr":{"cx":"13","cy":"19","r":"2"}},{"tag":"polygon","attr":{"points":"22,37 17,31 17,25 27,25 27,31"}}]},{"tag":"path","attr":{"fill":"#D1C4E9","d":"M31,13c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C31,18.9,31,14.1,31,13z"}},{"tag":"g","attr":{"fill":"#673AB7"},"child":[{"tag":"circle","attr":{"cx":"26","cy":"19","r":"1"}},{"tag":"circle","attr":{"cx":"18","cy":"19","r":"1"}},{"tag":"path","attr":{"d":"M22,4c-6.1,0-10,4.9-10,11c0,0.8,0,2.3,0,2.3l2,1.7v-5l12-4l4,4v5l2-1.7c0,0,0-1.5,0-2.3c0-4-1-8-6-9l-1-2 H22z"}},{"tag":"path","attr":{"d":"M27,31L27,31c0,0-2,1-5,1s-5-1-5-1S6,33,6,44h32C38,33,27,31,27,31z"}}]}]})(props);
};
function FcNoIdea (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FBC02D","d":"M37,22c0-7.7-6.6-13.8-14.5-12.9c-6,0.7-10.8,5.5-11.4,11.5c-0.5,4.6,1.4,8.7,4.6,11.3 c1.4,1.2,2.3,2.9,2.3,4.8V37h12v-0.1c0-1.8,0.8-3.6,2.2-4.8C35.1,29.7,37,26.1,37,22z"}},{"tag":"path","attr":{"fill":"#FFF59D","d":"M30.6,20.2l-3-2c-0.3-0.2-0.8-0.2-1.1,0L24,19.8l-2.4-1.6c-0.3-0.2-0.8-0.2-1.1,0l-3,2 c-0.2,0.2-0.4,0.4-0.4,0.7s0,0.6,0.2,0.8l3.8,4.7V37h2V26c0-0.2-0.1-0.4-0.2-0.6l-3.3-4.1l1.5-1l2.4,1.6c0.3,0.2,0.8,0.2,1.1,0 l2.4-1.6l1.5,1l-3.3,4.1C25.1,25.6,25,25.8,25,26v11h2V26.4l3.8-4.7c0.2-0.2,0.3-0.5,0.2-0.8S30.8,20.3,30.6,20.2z"}},{"tag":"circle","attr":{"fill":"#5C6BC0","cx":"24","cy":"44","r":"3"}},{"tag":"path","attr":{"fill":"#9FA8DA","d":"M26,45h-4c-2.2,0-4-1.8-4-4v-5h12v5C30,43.2,28.2,45,26,45z"}},{"tag":"g","attr":{"fill":"#5C6BC0"},"child":[{"tag":"path","attr":{"d":"M30,41l-11.6,1.6c0.3,0.7,0.9,1.4,1.6,1.8l9.4-1.3C29.8,42.5,30,41.8,30,41z"}},{"tag":"polygon","attr":{"points":"18,38.7 18,40.7 30,39 30,37"}}]},{"tag":"rect","attr":{"x":"22","y":"-2.9","transform":"matrix(.707 -.707 .707 .707 -9.941 24)","fill":"#37474F","width":"4","height":"53.7"}}]})(props);
};
function FcNoVideo (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#4CAF50","d":"M8,12h22c2.2,0,4,1.8,4,4v16c0,2.2-1.8,4-4,4H8c-2.2,0-4-1.8-4-4V16C4,13.8,5.8,12,8,12z"}},{"tag":"polygon","attr":{"fill":"#388E3C","points":"44,35 34,29 34,19 44,13"}},{"tag":"line","attr":{"fill":"none","stroke":"#212121","strokeWidth":"4","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"5","y1":"5","x2":"43","y2":"43"}}]})(props);
};
function FcNook (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90A4AE","d":"M8,39V9c0-3.3,2.7-6,6-6h20c3.3,0,6,2.7,6,6v30c0,3.3-2.7,6-6,6H14C10.7,45,8,42.3,8,39z"}},{"tag":"path","attr":{"fill":"#ECEFF1","d":"M34,7H14c-1.1,0-2,0.9-2,2v26c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V9C36,7.9,35.1,7,34,7z"}},{"tag":"g","attr":{"fill":"#B0BEC5"},"child":[{"tag":"rect","attr":{"x":"16","y":"12","width":"16","height":"3"}},{"tag":"rect","attr":{"x":"16","y":"19","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"23","width":"12","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"27","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"31","width":"12","height":"2"}}]},{"tag":"path","attr":{"fill":"none","stroke":"#eee","strokeWidth":"2","strokeMiterlimit":"10","d":"M22,43v-1c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v1"}}]})(props);
};
function FcNumericalSorting12 (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#546E7A","points":"38,33 38,5 34,5 34,33 28,33 36,43 44,33"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"path","attr":{"d":"M16.4,20h-3V8.6L9.9,9.7V7.3L16,5.1h0.3V20z"}},{"tag":"path","attr":{"d":"M19.4,43H9.2v-2l4.8-5.1c0.4-0.4,0.7-0.8,0.9-1.1c0.2-0.3,0.5-0.6,0.6-0.9c0.2-0.3,0.3-0.5,0.3-0.8 c0.1-0.2,0.1-0.5,0.1-0.7c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.4-0.6c-0.3,0-0.7,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5 c-0.2,0.2-0.3,0.5-0.4,0.8s-0.1,0.6-0.1,1h-3c0-0.7,0.1-1.3,0.4-1.9c0.2-0.6,0.6-1.1,1-1.6c0.5-0.4,1-0.8,1.6-1.1 c0.6-0.3,1.4-0.4,2.2-0.4c0.8,0,1.5,0.1,2.1,0.3c0.6,0.2,1.1,0.5,1.5,0.8s0.7,0.8,0.9,1.3s0.3,1.1,0.3,1.8c0,0.5-0.1,1-0.2,1.4 S18.3,34.5,18,35s-0.6,0.9-1,1.4c-0.4,0.5-0.9,1-1.4,1.5L13,40.6h6.4V43z"}}]}]})(props);
};
function FcNumericalSorting21 (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#546E7A","points":"38,33 38,5 34,5 34,33 28,33 36,43 44,33"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"path","attr":{"d":"M19.2,20H9v-2l4.8-5.1c0.4-0.4,0.7-0.8,0.9-1.1c0.2-0.3,0.5-0.6,0.6-0.9c0.2-0.3,0.3-0.5,0.3-0.8 c0.1-0.2,0.1-0.5,0.1-0.7c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.4-0.6c-0.3,0-0.7,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5 c-0.2,0.2-0.3,0.5-0.4,0.8s-0.1,0.6-0.1,1h-3c0-0.7,0.1-1.3,0.4-1.9c0.2-0.6,0.6-1.1,1-1.6c0.5-0.4,1-0.8,1.6-1.1 c0.6-0.3,1.4-0.4,2.2-0.4c0.8,0,1.5,0.1,2.1,0.3c0.6,0.2,1.1,0.5,1.5,0.8s0.7,0.8,0.9,1.3c0.2,0.5,0.3,1.1,0.3,1.8 c0,0.5-0.1,1-0.2,1.4s-0.4,0.9-0.7,1.4s-0.6,0.9-1,1.4c-0.4,0.5-0.9,1-1.4,1.5l-2.6,2.8h6.4V20z"}},{"tag":"path","attr":{"d":"M16.2,43h-3V31.6l-3.5,1.1v-2.4l6.2-2.2h0.3V43z"}}]}]})(props);
};
function FcOk (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#4CAF50","cx":"24","cy":"24","r":"21"}},{"tag":"polygon","attr":{"fill":"#CCFF90","points":"34.6,14.6 21,28.2 15.4,22.6 12.6,25.4 21,33.8 37.4,17.4"}}]})(props);
};
function FcOldTimeCamera (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#546E7A","d":"M14,13H8v-1.8C8,10.5,8.5,10,9.2,10h3.6c0.7,0,1.2,0.5,1.2,1.2V13z"}},{"tag":"path","attr":{"fill":"#5E35B1","d":"M40,40H8c-2.2,0-4-1.8-4-4V22h40v14C44,38.2,42.2,40,40,40z"}},{"tag":"path","attr":{"fill":"#42257A","d":"M12.7,22c-0.4,1.3-0.7,2.6-0.7,4c0,6.6,5.4,12,12,12s12-5.4,12-12c0-1.4-0.3-2.7-0.7-4H12.7z"}},{"tag":"path","attr":{"fill":"#78909C","d":"M8,12h32c2.2,0,4,1.8,4,4v6H4v-6C4,13.8,5.8,12,8,12z"}},{"tag":"path","attr":{"fill":"#78909C","d":"M33.9,13.1H14.2L17.6,8c0.4-0.6,1-0.9,1.7-0.9h9.6c0.7,0,1.3,0.3,1.7,0.9L33.9,13.1z"}},{"tag":"path","attr":{"fill":"#455A64","d":"M35.3,22c-1.6-4.7-6.1-8-11.3-8s-9.7,3.3-11.3,8H35.3z"}},{"tag":"circle","attr":{"fill":"#B388FF","cx":"24","cy":"26","r":"9"}},{"tag":"path","attr":{"fill":"#C7A7FF","d":"M29,23c-1.2-1.4-3-2.2-4.8-2.2c-1.8,0-3.6,0.8-4.8,2.2c-0.5,0.5-0.4,1.3,0.1,1.8c0.5,0.5,1.3,0.4,1.8-0.1 c1.5-1.7,4.3-1.7,5.8,0c0.3,0.3,0.6,0.4,1,0.4c0.3,0,0.6-0.1,0.9-0.3C29.4,24.4,29.5,23.5,29,23z"}},{"tag":"rect","attr":{"x":"36","y":"15","fill":"#DBE2E5","width":"5","height":"4"}}]})(props);
};
function FcOnlineSupport (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"13","y":"30","fill":"#BF360C","width":"22","height":"12"}},{"tag":"g","attr":{"fill":"#FFA726"},"child":[{"tag":"circle","attr":{"cx":"10","cy":"26","r":"4"}},{"tag":"circle","attr":{"cx":"38","cy":"26","r":"4"}}]},{"tag":"path","attr":{"fill":"#FFB74D","d":"M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z"}},{"tag":"g","attr":{"fill":"#784719"},"child":[{"tag":"circle","attr":{"cx":"30","cy":"26","r":"2"}},{"tag":"circle","attr":{"cx":"18","cy":"26","r":"2"}}]},{"tag":"path","attr":{"fill":"#FF5722","d":"M24,2C15.5,2,3,7.8,3,35.6L13,42V24l16.8-9.8L35,21v21l10-8.2c0-5.6-0.9-29-15.4-29L28.2,2H24z"}},{"tag":"path","attr":{"fill":"#757575","d":"M45,24c-0.6,0-1,0.4-1,1v-7c0-8.8-7.2-16-16-16h-9c-0.6,0-1,0.4-1,1s0.4,1,1,1h9c7.7,0,14,6.3,14,14v10 c0,0.6,0.4,1,1,1s1-0.4,1-1v2c0,3.9-3.1,7-7,7H24c-0.6,0-1,0.4-1,1s0.4,1,1,1h13c5,0,9-4,9-9v-5C46,24.4,45.6,24,45,24z"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"path","attr":{"d":"M45,22h-1c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-4C47,22.9,46.1,22,45,22z"}},{"tag":"circle","attr":{"cx":"24","cy":"38","r":"2"}}]}]})(props);
};
function FcOpenedFolder (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFA000","d":"M38,12H22l-4-4H8c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h31c1.7,0,3-1.3,3-3V16C42,13.8,40.2,12,38,12z"}},{"tag":"path","attr":{"fill":"#FFCA28","d":"M42.2,18H15.3c-1.9,0-3.6,1.4-3.9,3.3L8,40h31.7c1.9,0,3.6-1.4,3.9-3.3l2.5-14C46.6,20.3,44.7,18,42.2,18z"}}]})(props);
};
function FcOrgUnit (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M10,10v28h28V10H10z M34,34H14V14h20V34z"}},{"tag":"rect","attr":{"x":"6","y":"6","fill":"#D81B60","width":"12","height":"12"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"rect","attr":{"x":"30","y":"6","width":"12","height":"12"}},{"tag":"rect","attr":{"x":"6","y":"30","width":"12","height":"12"}},{"tag":"rect","attr":{"x":"30","y":"30","width":"12","height":"12"}}]}]})(props);
};
function FcOrganization (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M42,42H6V10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4V42z"}},{"tag":"rect","attr":{"x":"6","y":"42","fill":"#64B5F6","width":"36","height":"2"}},{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"rect","attr":{"x":"31","y":"27","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"21","y":"27","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"27","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"31","y":"35","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"35","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"31","y":"19","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"21","y":"19","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"19","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"31","y":"11","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"21","y":"11","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"11","y":"11","width":"6","height":"5"}},{"tag":"rect","attr":{"x":"21","y":"35","width":"6","height":"9"}}]}]})(props);
};
function FcOvertime (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#CFD8DC","d":"M12,40V20h32v20c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z"}},{"tag":"path","attr":{"fill":"#78909C","d":"M44,16v6H12v-6c0-2.2,1.8-4,4-4h24C42.2,12,44,13.8,44,16z"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"circle","attr":{"cx":"37","cy":"16","r":"3"}},{"tag":"circle","attr":{"cx":"20","cy":"16","r":"3"}}]},{"tag":"g","attr":{"fill":"#B0BEC5"},"child":[{"tag":"path","attr":{"d":"M37,10c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2s2-0.9,2-2v-4C39,10.9,38.1,10,37,10z"}},{"tag":"path","attr":{"d":"M20,10c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2s2-0.9,2-2v-4C22,10.9,21.1,10,20,10z"}}]},{"tag":"rect","attr":{"x":"32","y":"34","fill":"#90A4AE","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"26","y":"34","fill":"#90A4AE","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"20","y":"34","fill":"#90A4AE","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"32","y":"28","fill":"#90A4AE","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"26","y":"28","fill":"#90A4AE","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"20","y":"28","fill":"#90A4AE","width":"4","height":"4"}},{"tag":"circle","attr":{"fill":"#F44336","cx":"16","cy":"15","r":"12"}},{"tag":"circle","attr":{"fill":"#eee","cx":"16","cy":"15","r":"9"}},{"tag":"rect","attr":{"x":"15","y":"8","width":"2","height":"7"}},{"tag":"rect","attr":{"x":"16.9","y":"14.2","transform":"matrix(-.707 .707 -.707 -.707 42.506 16.192)","width":"1.9","height":"5.4"}},{"tag":"circle","attr":{"cx":"16","cy":"15","r":"1.5"}}]})(props);
};
function FcPackage (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF9800","d":"M38,42H10c-2.2,0-4-1.8-4-4V10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v28C42,40.2,40.2,42,38,42z"}},{"tag":"path","attr":{"fill":"#8A5100","d":"M29.5,16h-11c-0.8,0-1.5-0.7-1.5-1.5v0c0-0.8,0.7-1.5,1.5-1.5h11c0.8,0,1.5,0.7,1.5,1.5v0 C31,15.3,30.3,16,29.5,16z"}}]})(props);
};
function FcPaid (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#2E7D32","d":"M25.4,5.6c-0.8-0.8-2-0.8-2.8,0l-12,12c-0.8,0.8-0.8,2,0,2.8C11,20.8,11.5,21,12,21s1-0.2,1.4-0.6l12-12 C26.2,7.6,26.2,6.4,25.4,5.6z"}},{"tag":"path","attr":{"fill":"#1B5E20","d":"M37.4,17.6l-12-12c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8l12,12C35,20.8,35.5,21,36,21s1-0.2,1.4-0.6 C38.2,19.6,38.2,18.4,37.4,17.6z"}},{"tag":"path","attr":{"fill":"#388E3C","d":"M37.4,41H10.6c-1,0-1.8-0.7-2-1.6L5,21h38l-3.7,18.4C39.1,40.3,38.3,41,37.4,41z"}},{"tag":"path","attr":{"fill":"#4CAF50","d":"M43,23H5c-1.1,0-2-0.9-2-2v-2c0-1.1,0.9-2,2-2h38c1.1,0,2,0.9,2,2v2C45,22.1,44.1,23,43,23z"}},{"tag":"polygon","attr":{"fill":"#DCEDC8","points":"30.8,24.8 22.9,32.7 19.2,28.9 17,31.1 22.9,37 33,26.9"}}]})(props);
};
function FcPanorama (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F57C00","d":"M4,9v32c0,0,8.4-3,20-3s20,3,20,3V9c0,0-6.7,3-20,3S4,9,4,9z"}},{"tag":"path","attr":{"fill":"#942A09","d":"M24,34c0.1,0,0.3,0,0.4,0L15,19L6.9,36.2C10.3,35.3,16.5,34,24,34z"}},{"tag":"path","attr":{"fill":"#BF360C","d":"M24,34c3.3,0,6.3,0.2,9,0.6l-8-11.8l-7.8,11.5C19.3,34.1,21.6,34,24,34z"}},{"tag":"path","attr":{"fill":"#E65100","d":"M40.7,36L35,26.5l-5,7.8C34.5,34.7,38.2,35.4,40.7,36z"}},{"tag":"ellipse","attr":{"fill":"#FFF9C4","cx":"36","cy":"19.5","rx":"2","ry":"2.5"}}]})(props);
};
function FcParallelTasks (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#90CAF9","points":"36,13 36,9 22,9 22,22 13,22 13,26 22,26 22,39 36,39 36,35 26,35 26,26 36,26 36,22 26,22 26,13"}},{"tag":"rect","attr":{"x":"6","y":"17","fill":"#D81B60","width":"10","height":"14"}},{"tag":"rect","attr":{"x":"32","y":"6","fill":"#2196F3","width":"10","height":"10"}},{"tag":"rect","attr":{"x":"32","y":"32","fill":"#2196F3","width":"10","height":"10"}},{"tag":"rect","attr":{"x":"32","y":"19","fill":"#2196F3","width":"10","height":"10"}}]})(props);
};
function FcPhoneAndroid (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M12,40V8c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M32,7H16c-0.6,0-1,0.4-1,1v29c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8C33,7.4,32.6,7,32,7z"}},{"tag":"rect","attr":{"x":"21","y":"40","fill":"#78909C","width":"6","height":"2"}}]})(props);
};
function FcPhone (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#009688","d":"M39.1,7l-3.7,0C22.2,7.2,7.1,24.1,7,35.4l0,3.7c0,1,0.8,1.9,1.9,1.9l7.5-0.1c1,0,1.9-0.9,1.9-1.9l0.2-8.2 l-4.7-4c0-2.6,10.5-13.1,13.2-13.2l4.3,4.7l7.9-0.2c1,0,1.9-0.9,1.9-1.9L41,8.9C41,7.8,40.2,7,39.1,7z"}}]})(props);
};
function FcPhotoReel (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#673AB7","d":"M10,9c-2.2,0-4,1.8-4,4v26c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V13c0-2.2-1.8-4-4-4"}},{"tag":"g","attr":{"fill":"#311B92"},"child":[{"tag":"rect","attr":{"x":"14","y":"13","width":"2","height":"26"}},{"tag":"path","attr":{"d":"M24,9V7c0-1.2-0.8-2-2-2h-8c-1.2,0-2,0.8-2,2v2H24z"}}]},{"tag":"path","attr":{"fill":"#D84315","d":"M30,13H16v26h14V13z M21,37h-3v-4h3V37z M21,19h-3v-4h3V19z M27,37h-3v-4h3V37z M24,19v-4h3v4H24z"}},{"tag":"path","attr":{"fill":"#FF5722","d":"M30,13v2h3v4h-3v14h3v4h-3v2h12V13H30z M39,37h-3v-4h3V37z M39,19h-3v-4h3V19z"}}]})(props);
};
function FcPicture (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F57C00","d":"M40,41H8c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v26C44,39.2,42.2,41,40,41z"}},{"tag":"circle","attr":{"fill":"#FFF9C4","cx":"35","cy":"16","r":"3"}},{"tag":"polygon","attr":{"fill":"#942A09","points":"20,16 9,32 31,32"}},{"tag":"polygon","attr":{"fill":"#BF360C","points":"31,22 23,32 39,32"}}]})(props);
};
function FcPieChart (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#00BCD4","d":"M24,6C14.1,6,6,14.1,6,24s8.1,18,18,18c5.2,0,9.9-2.2,13.1-5.7L24,24V6z"}},{"tag":"path","attr":{"fill":"#448AFF","d":"M42,24c0-9.9-8.1-18-18-18v18H42z"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M24,24l13.1,12.3c3-3.2,4.9-7.5,4.9-12.3H24z"}}]})(props);
};
function FcPlanner (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#CFD8DC","d":"M5,38V14h38v24c0,2.2-1.8,4-4,4H9C6.8,42,5,40.2,5,38z"}},{"tag":"path","attr":{"fill":"#F44336","d":"M43,10v6H5v-6c0-2.2,1.8-4,4-4h30C41.2,6,43,7.8,43,10z"}},{"tag":"g","attr":{"fill":"#B71C1C"},"child":[{"tag":"circle","attr":{"cx":"33","cy":"10","r":"3"}},{"tag":"circle","attr":{"cx":"15","cy":"10","r":"3"}}]},{"tag":"g","attr":{"fill":"#B0BEC5"},"child":[{"tag":"path","attr":{"d":"M33,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C35,3.9,34.1,3,33,3z"}},{"tag":"path","attr":{"d":"M15,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C17,3.9,16.1,3,15,3z"}}]},{"tag":"g","attr":{"fill":"#B0BEC5"},"child":[{"tag":"rect","attr":{"x":"13","y":"21","width":"6","height":"6"}},{"tag":"rect","attr":{"x":"21","y":"21","width":"6","height":"6"}},{"tag":"rect","attr":{"x":"29","y":"21","width":"6","height":"6"}},{"tag":"rect","attr":{"x":"13","y":"29","width":"6","height":"6"}},{"tag":"rect","attr":{"x":"21","y":"29","width":"6","height":"6"}}]},{"tag":"rect","attr":{"x":"29","y":"29","fill":"#F44336","width":"6","height":"6"}}]})(props);
};
function FcPlus (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#4CAF50","cx":"24","cy":"24","r":"21"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"21","y":"14","width":"6","height":"20"}},{"tag":"rect","attr":{"x":"14","y":"21","width":"20","height":"6"}}]}]})(props);
};
function FcPodiumWithAudience (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#B0BEC5","points":"41,12 7,12 6,16 11,19 9,16 39,16 37,19 42,16"}},{"tag":"polygon","attr":{"fill":"#78909C","points":"9,16 39,16 35,28 13,28"}},{"tag":"circle","attr":{"fill":"#FFB74D","cx":"24","cy":"28","r":"4"}},{"tag":"circle","attr":{"fill":"#FFB74D","cx":"36","cy":"28","r":"4"}},{"tag":"circle","attr":{"fill":"#FFB74D","cx":"12","cy":"28","r":"4"}},{"tag":"circle","attr":{"fill":"#FFB74D","cx":"18","cy":"37","r":"5"}},{"tag":"circle","attr":{"fill":"#FFB74D","cx":"30","cy":"37","r":"5"}}]})(props);
};
function FcPodiumWithSpeaker (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#FFB74D","cx":"24","cy":"11","r":"6"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M36,26.1c0,0-3.3-7.1-12-7.1s-12,7.1-12,7.1V30h24V26.1z"}},{"tag":"polygon","attr":{"fill":"#B0BEC5","points":"41,25 7,25 6,29 11,32 9,29 39,29 37,32 42,29"}},{"tag":"polygon","attr":{"fill":"#78909C","points":"9,29 39,29 35,41 13,41"}}]})(props);
};
function FcPodiumWithoutSpeaker (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#B0BEC5","points":"43,16 5,16 4,20 9,23 7,20 41,20 39,23 44,20"}},{"tag":"polygon","attr":{"fill":"#78909C","points":"7,20 41,20 37,36 11,36"}}]})(props);
};
function FcPortraitMode (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF9800","d":"M22,38c-4.8,0-5-7-5-7v-6h10v6C27,31,26.8,38,22,38z"}},{"tag":"g","attr":{"fill":"#FFA726"},"child":[{"tag":"circle","attr":{"cx":"31","cy":"19","r":"2"}},{"tag":"circle","attr":{"cx":"13","cy":"19","r":"2"}}]},{"tag":"path","attr":{"fill":"#FFB74D","d":"M31,13c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C31,18.9,31,14.1,31,13z"}},{"tag":"path","attr":{"fill":"#424242","d":"M22,4c-6.1,0-10,4.9-10,11c0,0.8,0,2.3,0,2.3l2,1.7v-5l12-4l4,4v5l2-1.7c0,0,0-1.5,0-2.3c0-4-1-8-6-9l-1-2 H22z"}},{"tag":"g","attr":{"fill":"#784719"},"child":[{"tag":"circle","attr":{"cx":"26","cy":"19","r":"1"}},{"tag":"circle","attr":{"cx":"18","cy":"19","r":"1"}}]},{"tag":"path","attr":{"fill":"#009688","d":"M27,31L27,31c0,0-1.8,2-5,2s-5-2-5-2S6,33,6,44h32C38,33,27,31,27,31z"}},{"tag":"g","attr":{"fill":"#FF9800"},"child":[{"tag":"rect","attr":{"x":"36.1","y":"6.1","transform":"matrix(.707 .707 -.707 .707 19.787 -25.77)","width":"9.9","height":"9.9"}},{"tag":"rect","attr":{"x":"36","y":"6","width":"10","height":"10"}}]},{"tag":"circle","attr":{"fill":"#FFEB3B","cx":"41","cy":"11","r":"3"}}]})(props);
};
function FcPositiveDynamic (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"rect","attr":{"x":"19","y":"22","width":"10","height":"20"}},{"tag":"rect","attr":{"x":"32","y":"8","width":"10","height":"34"}},{"tag":"rect","attr":{"x":"6","y":"30","width":"10","height":"12"}}]},{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"11,8 21,18 21,8"}},{"tag":"rect","attr":{"x":"11","y":"8.9","transform":"matrix(-.707 -.707 .707 -.707 10.879 36.506)","width":"4","height":"14.1"}}]}]})(props);
};
function FcPrevious (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#2196F3","points":"30.9,43 34,39.9 18.1,24 34,8.1 30.9,5 12,24"}}]})(props);
};
function FcPrint (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"9","y":"11","fill":"#424242","width":"30","height":"3"}},{"tag":"path","attr":{"fill":"#616161","d":"M4,25h40v-7c0-2.2-1.8-4-4-4H8c-2.2,0-4,1.8-4,4V25z"}},{"tag":"path","attr":{"fill":"#424242","d":"M8,36h32c2.2,0,4-1.8,4-4v-8H4v8C4,34.2,5.8,36,8,36z"}},{"tag":"circle","attr":{"fill":"#00E676","cx":"40","cy":"18","r":"1"}},{"tag":"rect","attr":{"x":"11","y":"4","fill":"#90CAF9","width":"26","height":"10"}},{"tag":"path","attr":{"fill":"#242424","d":"M37.5,31h-27C9.7,31,9,30.3,9,29.5v0c0-0.8,0.7-1.5,1.5-1.5h27c0.8,0,1.5,0.7,1.5,1.5v0 C39,30.3,38.3,31,37.5,31z"}},{"tag":"rect","attr":{"x":"11","y":"31","fill":"#90CAF9","width":"26","height":"11"}},{"tag":"rect","attr":{"x":"11","y":"29","fill":"#42A5F5","width":"26","height":"2"}},{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"rect","attr":{"x":"16","y":"33","width":"17","height":"2"}},{"tag":"rect","attr":{"x":"16","y":"37","width":"13","height":"2"}}]}]})(props);
};
function FcPrivacy (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#424242","d":"M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z"}},{"tag":"path","attr":{"fill":"#FB8C00","d":"M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"}},{"tag":"circle","attr":{"fill":"#EFEBE9","cx":"24","cy":"31","r":"6"}},{"tag":"circle","attr":{"fill":"#1E88E5","cx":"24","cy":"31","r":"3"}},{"tag":"circle","attr":{"fill":"#fff","cx":"26","cy":"29","r":"1"}}]})(props);
};
function FcProcess (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#9C27B0"},"child":[{"tag":"polygon","attr":{"points":"31,8 42.9,9.6 33.1,19.4"}},{"tag":"polygon","attr":{"points":"17,40 5.1,38.4 14.9,28.6"}},{"tag":"polygon","attr":{"points":"8,17 9.6,5.1 19.4,14.9"}},{"tag":"path","attr":{"d":"M9.3,21.2L5.1,22C5,22.7,5,23.3,5,24c0,4.6,1.6,9,4.6,12.4l3-2.6C10.3,31.1,9,27.6,9,24 C9,23.1,9.1,22.1,9.3,21.2z"}},{"tag":"path","attr":{"d":"M24,5c-5.4,0-10.2,2.3-13.7,5.9l2.8,2.8C15.9,10.8,19.7,9,24,9c0.9,0,1.9,0.1,2.8,0.3l0.7-3.9 C26.4,5.1,25.2,5,24,5z"}},{"tag":"path","attr":{"d":"M38.7,26.8l4.2-0.8c0.1-0.7,0.1-1.3,0.1-2c0-4.4-1.5-8.7-4.3-12.1l-3.1,2.5c2.2,2.7,3.4,6.1,3.4,9.5 C39,24.9,38.9,25.9,38.7,26.8z"}},{"tag":"path","attr":{"d":"M34.9,34.3C32.1,37.2,28.3,39,24,39c-0.9,0-1.9-0.1-2.8-0.3l-0.7,3.9c1.2,0.2,2.4,0.3,3.5,0.3 c5.4,0,10.2-2.3,13.7-5.9L34.9,34.3z"}},{"tag":"polygon","attr":{"points":"40,31 38.4,42.9 28.6,33.1"}}]}]})(props);
};
function FcPuzzle (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#8BC34A","d":"M39,15c0-2.2-1.8-4-4-4h-6c-0.7,0-1.1-0.8-0.7-1.4c0.6-1,0.9-2.2,0.6-3.5c-0.4-2-1.9-3.6-3.8-4 C21.8,1.4,19,3.9,19,7c0,1,0.3,1.8,0.7,2.6c0.4,0.6,0,1.4-0.8,1.4h-6c-2.2,0-4,1.8-4,4v7c0,0.7,0.8,1.1,1.4,0.7 c1-0.6,2.2-0.9,3.5-0.6c2,0.4,3.6,1.9,4,3.8c0.7,3.2-1.8,6.1-4.9,6.1c-1,0-1.8-0.3-2.6-0.7C9.8,30.9,9,31.3,9,32v6c0,2.2,1.8,4,4,4 h22c2.2,0,4-1.8,4-4V15z"}}]})(props);
};
function FcQuestions (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#42A5F5","points":"36,44 8,44 8,8 28,8 36,16"}},{"tag":"polygon","attr":{"fill":"#90CAF9","points":"40,40 12,40 12,4 32,4 40,12"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"38.5,13 31,13 31,5.5"}},{"tag":"path","attr":{"fill":"#1976D2","d":"M24.5,28.3c0-4.7,3.6-4.4,3.6-7.2c0-0.7-0.2-2.1-2-2.1c-2,0-2.1,1.6-2.1,2h-2.7c0-0.7,0.3-4.2,4.8-4.2 c4.6,0,4.7,3.6,4.7,4.3c0,3.5-3.8,4-3.8,7.3H24.5z M24.3,31.8c0-0.2,0-1.5,1.5-1.5c1.4,0,1.5,1.3,1.5,1.5c0,0.4-0.2,1.4-1.5,1.4 C24.5,33.2,24.3,32.2,24.3,31.8z"}}]})(props);
};
function FcRadarPlot (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#CFD8DC","d":"M38.4,13L24.1,6.4L4.6,12.1l8.8,13.2l-2.2,15.1h22.7l6.6-13.3L38.4,13z M32.1,37.5H14.7l1.8-12.9L9.4,13.9 l14.5-4.3L35.6,15l1.8,11.7L32.1,37.5z"}},{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"8","r":"4"}},{"tag":"circle","attr":{"cx":"37","cy":"14","r":"4"}},{"tag":"circle","attr":{"cx":"39","cy":"27","r":"4"}},{"tag":"circle","attr":{"cx":"7","cy":"13","r":"4"}},{"tag":"circle","attr":{"cx":"13","cy":"39","r":"4"}},{"tag":"circle","attr":{"cx":"15","cy":"25","r":"4"}},{"tag":"circle","attr":{"cx":"33","cy":"39","r":"4"}}]}]})(props);
};
function FcRating (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#F44336","cx":"24","cy":"24","r":"21"}},{"tag":"polygon","attr":{"fill":"#FFCA28","points":"24,11 27.9,18.9 36.6,20.2 30.3,26.3 31.8,35 24,30.9 16.2,35 17.7,26.3 11.4,20.2 20.1,18.9"}}]})(props);
};
function FcRatings (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#42A5F5","points":"36,44 8,44 8,8 28,8 36,16"}},{"tag":"polygon","attr":{"fill":"#90CAF9","points":"40,40 12,40 12,4 32,4 40,12"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"38.5,13 31,13 31,5.5"}},{"tag":"polygon","attr":{"fill":"#1976D2","points":"34,20 27,20 29.4,22.4 27,24.9 23,20.9 16.9,26.9 19.1,29.1 23,25.1 27,29.1 31.6,24.6 34,27"}}]})(props);
};
function FcReadingEbook (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#2196F3","d":"M33.5,27c-2.2-3-5.2-5-9.5-5s-7.3,2-9.5,5H33.5z"}},{"tag":"path","attr":{"fill":"#546E7A","d":"M34.1,43H13.9c-1.1,0-1.9-0.8-2-1.9l-0.8-13C11.1,27,12,26,13.1,26h21.8c1.2,0,2.1,1,2,2.1l-0.8,13 C36,42.2,35.2,43,34.1,43z"}},{"tag":"circle","attr":{"fill":"#B0BEC5","cx":"34","cy":"29","r":"1"}},{"tag":"g","attr":{"fill":"#FFB74D"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"12","r":"8"}},{"tag":"path","attr":{"d":"M16.1,42.4L15,43.5c-0.6,0.6-1.6,0.6-2.2,0l-3.3-3.3c-0.6-0.6-0.6-1.6,0-2.2l1.1-1.1c1.3-1.3,3.1-1.3,4.4,0 l1.1,1.1C17.3,39.3,17.3,41.2,16.1,42.4z"}},{"tag":"path","attr":{"d":"M31.9,38l1.1-1.1c1.3-1.3,3.1-1.3,4.4,0l1.1,1.1c0.6,0.6,0.6,1.6,0,2.2l-3.3,3.3c-0.6,0.6-1.6,0.6-2.2,0 l-1.1-1.1C30.7,41.2,30.7,39.3,31.9,38z"}}]}]})(props);
};
function FcReading (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#5C6BC0","d":"M40,40c-6.9,0-16,4-16,4V22c0,0,9-4,18-4L40,40z"}},{"tag":"path","attr":{"fill":"#7986CB","d":"M8,40c6.9,0,16,4,16,4V22c0,0-9-4-18-4L8,40z"}},{"tag":"g","attr":{"fill":"#FFB74D"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"12","r":"8"}},{"tag":"path","attr":{"d":"M41,32h1c0.6,0,1-0.4,1-1v-4c0-0.6-0.4-1-1-1h-1c-1.7,0-3,1.3-3,3v0C38,30.7,39.3,32,41,32z"}},{"tag":"path","attr":{"d":"M7,26H6c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1h1c1.7,0,3-1.3,3-3v0C10,27.3,8.7,26,7,26z"}}]}]})(props);
};
function FcReddit (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#FFFFFF","d":"M12.193,19.555c-1.94-1.741-4.79-1.727-6.365,0.029c-1.576,1.756-1.301,5.023,0.926,6.632L12.193,19.555z"}},{"tag":"path","attr":{"fill":"#FFFFFF","d":"M35.807,19.555c1.939-1.741,4.789-1.727,6.365,0.029c1.575,1.756,1.302,5.023-0.927,6.632L35.807,19.555z"}},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"fill":"#FFFFFF","cx":"38.32","cy":"10.475","r":"3.5"}}]},{"tag":"g","attr":{},"child":[{"tag":"ellipse","attr":{"fill":"#FFFFFF","cx":"24.085","cy":"28.611","rx":"18.085","ry":"12.946"}}]}]},{"tag":"g","attr":{},"child":[{"tag":"circle","attr":{"fill":"#D84315","cx":"30.365","cy":"26.39","r":"2.884"}},{"tag":"circle","attr":{"fill":"#D84315","cx":"17.635","cy":"26.39","r":"2.884"}}]},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M24.002,34.902c-3.252,0-6.14-0.745-8.002-1.902c1.024,2.044,4.196,4,8.002,4c3.802,0,6.976-1.956,7.998-4\r\n\t\tC30.143,34.157,27.254,34.902,24.002,34.902z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M41.83,27.026l-1.17-1.621c0.831-0.6,1.373-1.556,1.488-2.623c0.105-0.98-0.157-1.903-0.721-2.531\r\n\t\tc-0.571-0.637-1.391-0.99-2.307-0.994c-0.927,0.013-1.894,0.365-2.646,1.041l-1.336-1.488c1.123-1.008,2.545-1.523,3.991-1.553\r\n\t\tc1.488,0.007,2.833,0.596,3.786,1.658c0.942,1.05,1.387,2.537,1.221,4.081C43.961,24.626,43.121,26.096,41.83,27.026z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M6.169,27.026c-1.29-0.932-2.131-2.401-2.306-4.031c-0.166-1.543,0.279-3.03,1.221-4.079\r\n\t\tc0.953-1.062,2.297-1.651,3.785-1.658c0.009,0,0.018,0,0.027,0c1.441,0,2.849,0.551,3.965,1.553l-1.336,1.488\r\n\t\tc-0.753-0.676-1.689-1.005-2.646-1.041c-0.916,0.004-1.735,0.357-2.306,0.994c-0.563,0.628-0.826,1.55-0.721,2.53\r\n\t\tc0.115,1.067,0.657,2.023,1.488,2.624L6.169,27.026z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M25,16.84h-2c0-2.885,0-10.548,4.979-10.548c2.154,0,3.193,1.211,3.952,2.096\r\n\t\tc0.629,0.734,0.961,1.086,1.616,1.086h1.37v2h-1.37c-1.604,0-2.453-0.99-3.135-1.785c-0.67-0.781-1.198-1.398-2.434-1.398\r\n\t\tC25.975,8.292,25,11.088,25,16.84z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M24.085,16.95c9.421,0,17.085,5.231,17.085,11.661c0,6.431-7.664,11.662-17.085,11.662S7,35.042,7,28.611\r\n\t\tC7,22.181,14.664,16.95,24.085,16.95 M24.085,14.95C13.544,14.95,5,21.066,5,28.611c0,7.546,8.545,13.662,19.085,13.662\r\n\t\tc10.54,0,19.085-6.116,19.085-13.662C43.17,21.066,34.625,14.95,24.085,14.95L24.085,14.95z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M38.32,7.975c1.379,0,2.5,1.122,2.5,2.5s-1.121,2.5-2.5,2.5s-2.5-1.122-2.5-2.5S36.941,7.975,38.32,7.975\r\n\t\t M38.32,5.975c-2.484,0-4.5,2.015-4.5,4.5s2.016,4.5,4.5,4.5c2.486,0,4.5-2.015,4.5-4.5S40.807,5.975,38.32,5.975L38.32,5.975z"}}]}]})(props);
};
function FcRedo (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"polygon","attr":{"points":"43,18 29,6.3 29,29.7"}},{"tag":"path","attr":{"d":"M20,14h12v8H20c-2.8,0-5,2.2-5,5s2.2,5,5,5h3v8h-3c-7.2,0-13-5.8-13-13S12.8,14,20,14z"}}]}]})(props);
};
function FcRefresh (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"path","attr":{"d":"M13,13c0-3.3,2.7-6,6-6h10c3.3,0,6,2.7,6,6h4c0-5.5-4.5-10-10-10H19C13.5,3,9,7.5,9,13v11.2h4V13z"}},{"tag":"polygon","attr":{"points":"4.6,22 11,30.4 17.4,22"}}]},{"tag":"g","attr":{"fill":"#1565C0"},"child":[{"tag":"path","attr":{"d":"M35,35c0,3.3-2.7,6-6,6H19c-3.3,0-6-2.7-6-6H9c0,5.5,4.5,10,10,10h10c5.5,0,10-4.5,10-10V23h-4V35z"}},{"tag":"polygon","attr":{"points":"30.6,26 37,17.6 43.4,26"}}]}]})(props);
};
function FcRegisteredTrademark (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#9C27B0","cx":"24","cy":"24","r":"21"}},{"tag":"path","attr":{"fill":"#E1BEE7","d":"M25,26.8h-4.5v9h-4V12.5h8.2c1.3,0,2.5,0.2,3.6,0.5c1,0.3,1.9,0.8,2.6,1.3c0.7,0.6,1.3,1.3,1.6,2.2 s0.6,1.9,0.6,3c0,1.6-0.4,2.9-1.1,3.9c-0.8,1-1.8,1.9-3.1,2.4l5.2,9.7v0.2h-4.3L25,26.8z M20.5,23.6h4.2c0.7,0,1.4-0.1,1.9-0.3 c0.5-0.2,1-0.5,1.4-0.8c0.4-0.3,0.6-0.7,0.8-1.2c0.2-0.5,0.3-1,0.3-1.6c0-0.6-0.1-1.1-0.3-1.6c-0.2-0.5-0.4-0.9-0.8-1.2 c-0.4-0.3-0.8-0.6-1.4-0.8c-0.5-0.2-1.2-0.3-2-0.3h-4.1V23.6z"}}]})(props);
};
function FcRemoveImage (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#8CBCD6","d":"M40,41H8c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v26C44,39.2,42.2,41,40,41z"}},{"tag":"circle","attr":{"fill":"#B3DDF5","cx":"35","cy":"16","r":"3"}},{"tag":"polygon","attr":{"fill":"#9AC9E3","points":"20,16 9,32 31,32"}},{"tag":"polygon","attr":{"fill":"#B3DDF5","points":"31,22 23,32 39,32"}},{"tag":"circle","attr":{"fill":"#F44336","cx":"38","cy":"38","r":"10"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"rect","attr":{"x":"36.5","y":"32","transform":"matrix(-.707 .707 -.707 -.707 91.74 38)","width":"3","height":"12"}},{"tag":"rect","attr":{"x":"36.5","y":"32","transform":"matrix(-.707 -.707 .707 -.707 38 91.74)","width":"3","height":"12"}}]}]})(props);
};
function FcReuse (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#455A64","points":"12.1,42 17.2,42 16.5,18.2 10.9,20.2"}},{"tag":"circle","attr":{"fill":"#FFB74D","cx":"36.5","cy":"10","r":"5"}},{"tag":"polygon","attr":{"fill":"#607D8B","points":"11,42 6,42 7.8,18.6 14.2,20.9"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M31.7,15.9c-0.6-2-1.3-4-2.5-5.8c-1.3-1.6-3.2-3.1-6.1-2c-3.1,1.3-9.2,3.6-11.2,4.5 c-2.3,1.1-4.1,2.7-4.1,5.9c0,3.4,4.3,5.3,4.3,5.3l14.7-6.1l1.7,4.5l5.3,0.1C33.8,22.4,32.3,17.9,31.7,15.9z"}},{"tag":"path","attr":{"fill":"#B39DDB","d":"M37.9,42h-7.9c-1,0-1.8-0.7-2-1.7l-2.6-17.1h17l-2.6,17.1C39.8,41.3,38.9,42,37.9,42z"}},{"tag":"path","attr":{"fill":"#7E57C2","d":"M42,24H26c-0.6,0-1-0.4-1-1v0c0-0.6,0.4-1,1-1h16c0.6,0,1,0.4,1,1v0C43,23.6,42.6,24,42,24z"}}]})(props);
};
function FcRightDown (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"41,41 23,41 41,23"}},{"tag":"rect","attr":{"x":"17.4","y":"5","transform":"matrix(.707 -.707 .707 .707 -8.854 21.374)","fill":"#3F51B5","width":"8","height":"32.7"}}]})(props);
};
function FcRightDown2 (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"29,44 17.3,30 40.7,30"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M21,6H8v8h13c2.2,0,4,1.8,4,4v17h8V18C33,11.4,27.6,6,21,6z"}}]})(props);
};
function FcRightUp (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"41,7 41,25 23,7"}},{"tag":"rect","attr":{"x":"17.4","y":"10.3","transform":"matrix(-.707 -.707 .707 -.707 17.661 60.567)","fill":"#3F51B5","width":"8","height":"32.7"}}]})(props);
};
function FcRightUp2 (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"29,4 17.3,18 40.7,18"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M21,42H8v-8h13c2.2,0,4-1.8,4-4V13h8v17C33,36.6,27.6,42,21,42z"}}]})(props);
};
function FcRight (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"44,24 30,35.7 30,12.3"}},{"tag":"rect","attr":{"x":"6","y":"20","width":"27","height":"8"}}]}]})(props);
};
function FcRotateCamera (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#5E35B1"},"child":[{"tag":"path","attr":{"d":"M33.9,12.1H14.2L17.6,7c0.4-0.6,1-0.9,1.7-0.9h9.6c0.7,0,1.3,0.3,1.7,0.9L33.9,12.1z"}},{"tag":"path","attr":{"d":"M14,11H8V9.2C8,8.5,8.5,8,9.2,8h3.6C13.5,8,14,8.5,14,9.2V11z"}},{"tag":"path","attr":{"d":"M40,42H8c-2.2,0-4-1.8-4-4V14c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,40.2,42.2,42,40,42z"}}]},{"tag":"path","attr":{"fill":"#E8EAF6","d":"M34,25c0-5.5-4.5-10-10-10s-10,4.5-10,10s4.5,10,10,10v-2c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8h-3.5 l4.5,5.6l4.5-5.6H34z"}}]})(props);
};
function FcRotateToLandscape (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M10,41V7c0-2.2,1.8-4,4-4h20c2.2,0,4,1.8,4,4v34c0,2.2-1.8,4-4,4H14C11.8,45,10,43.2,10,41z"}},{"tag":"path","attr":{"fill":"#F3E5F5","d":"M34,6H14c-0.6,0-1,0.4-1,1v34c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1V7C35,6.4,34.6,6,34,6z"}},{"tag":"polygon","attr":{"fill":"#9C27B0","points":"22,34 27.9,27 16.1,27"}},{"tag":"path","attr":{"fill":"#9C27B0","d":"M26,16c-3.3,0-6,2.7-6,6v6h4v-6c0-1.1,0.9-2,2-2s2,0.9,2,2v2h4v-2C32,18.7,29.3,16,26,16z"}}]})(props);
};
function FcRotateToPortrait (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M41,38H7c-2.2,0-4-1.8-4-4V14c0-2.2,1.8-4,4-4h34c2.2,0,4,1.8,4,4v20C45,36.2,43.2,38,41,38z"}},{"tag":"path","attr":{"fill":"#F3E5F5","d":"M6,14v20c0,0.6,0.4,1,1,1h34c0.6,0,1-0.4,1-1V14c0-0.6-0.4-1-1-1H7C6.4,13,6,13.4,6,14z"}},{"tag":"polygon","attr":{"fill":"#9C27B0","points":"26,15 20.1,22 31.9,22"}},{"tag":"path","attr":{"fill":"#9C27B0","d":"M24,21v6c0,1.1-0.9,2-2,2s-2-0.9-2-2v-2h-4v2c0,3.3,2.7,6,6,6s6-2.7,6-6v-6H24z"}}]})(props);
};
function FcRuler (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"16.7","y":"1.6","transform":"matrix(-.707 -.707 .707 -.707 24 57.941)","fill":"#FFA000","width":"14.6","height":"44.8"}},{"tag":"g","attr":{"fill":"#9E6400"},"child":[{"tag":"rect","attr":{"x":"17.9","y":"20.2","transform":"matrix(-.707 -.707 .707 -.707 21.177 51.125)","width":"6.6","height":"2"}},{"tag":"rect","attr":{"x":"22.3","y":"15.2","transform":"matrix(-.707 -.707 .707 -.707 29.833 44.71)","width":"3.7","height":"2"}},{"tag":"rect","attr":{"x":"25.9","y":"12.2","transform":"matrix(-.707 -.707 .707 -.707 40.49 43.125)","width":"6.6","height":"2"}},{"tag":"rect","attr":{"x":"31.2","y":"6.3","transform":"matrix(.707 -.707 .707 .707 3.643 25.147)","width":"2","height":"3.7"}},{"tag":"rect","attr":{"x":"6.3","y":"31.2","transform":"matrix(-.707 -.707 .707 -.707 -8.794 60.71)","width":"3.7","height":"2"}},{"tag":"rect","attr":{"x":"9.9","y":"28.2","transform":"matrix(-.707 -.707 .707 -.707 1.863 59.125)","width":"6.6","height":"2"}},{"tag":"rect","attr":{"x":"14.3","y":"23.2","transform":"matrix(-.707 -.707 .707 -.707 10.52 52.71)","width":"3.7","height":"2"}}]}]})(props);
};
function FcRules (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#42A5F5","d":"M39,45H9c0,0-3-0.1-3-8h36C42,44.9,39,45,39,45z"}},{"tag":"rect","attr":{"x":"8","y":"3","fill":"#90CAF9","width":"32","height":"34"}},{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"rect","attr":{"x":"18","y":"15","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"18","y":"19","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"18","y":"23","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"18","y":"27","width":"16","height":"2"}},{"tag":"rect","attr":{"x":"18","y":"31","width":"16","height":"2"}}]},{"tag":"g","attr":{"fill":"#1976D2"},"child":[{"tag":"rect","attr":{"x":"14","y":"15","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"14","y":"19","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"14","y":"23","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"14","y":"27","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"14","y":"31","width":"2","height":"2"}}]}]})(props);
};
function FcSafe (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"8","y":"39","fill":"#455A64","width":"6","height":"3"}},{"tag":"rect","attr":{"x":"34","y":"39","fill":"#455A64","width":"6","height":"3"}},{"tag":"path","attr":{"fill":"#78909C","d":"M40,41H8c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v26C44,39.2,42.2,41,40,41z"}},{"tag":"path","attr":{"fill":"#90A4AE","d":"M40,38H8c-0.6,0-1-0.4-1-1V11c0-0.6,0.4-1,1-1h32c0.6,0,1,0.4,1,1v26C41,37.6,40.6,38,40,38z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M29,14c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10s10-4.5,10-10C39,18.5,34.5,14,29,14z M29,31 c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7s7,3.1,7,7C36,27.9,32.9,31,29,31z"}},{"tag":"g","attr":{"fill":"#B0BEC5"},"child":[{"tag":"path","attr":{"d":"M35.3,19.1l0.4-0.4c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-0.4,0.4C34.4,18.1,34.9,18.6,35.3,19.1z"}},{"tag":"path","attr":{"d":"M22.7,19.1c0.4-0.5,0.9-1,1.4-1.4l-0.4-0.4c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L22.7,19.1z"}},{"tag":"path","attr":{"d":"M21,24c0-0.3,0-0.7,0.1-1h-0.6c-0.6,0-1,0.4-1,1s0.4,1,1,1h0.6C21,24.7,21,24.3,21,24z"}},{"tag":"path","attr":{"d":"M29,16c0.3,0,0.7,0,1,0.1v-0.6c0-0.6-0.4-1-1-1s-1,0.4-1,1v0.6C28.3,16,28.7,16,29,16z"}},{"tag":"path","attr":{"d":"M35.3,28.9c-0.4,0.5-0.9,1-1.4,1.4l0.4,0.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4 L35.3,28.9z"}},{"tag":"path","attr":{"d":"M22.7,28.9l-0.4,0.4c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l0.4-0.4 C23.6,29.9,23.1,29.4,22.7,28.9z"}},{"tag":"path","attr":{"d":"M37.5,23h-0.6c0,0.3,0.1,0.7,0.1,1s0,0.7-0.1,1h0.6c0.6,0,1-0.4,1-1S38.1,23,37.5,23z"}},{"tag":"path","attr":{"d":"M29,32c-0.3,0-0.7,0-1-0.1v0.6c0,0.6,0.4,1,1,1s1-0.4,1-1v-0.6C29.7,32,29.3,32,29,32z"}}]},{"tag":"path","attr":{"fill":"#455A64","d":"M12,20c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2s2-0.9,2-2v-8C14,20.9,13.1,20,12,20z"}},{"tag":"path","attr":{"fill":"#CFD8DC","d":"M12,18c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2s2-0.9,2-2v-8C14,18.9,13.1,18,12,18z"}}]})(props);
};
function FcSalesPerformance (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#FFA000"},"child":[{"tag":"path","attr":{"d":"M38,13c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,12.1,41.3,13,38,13 z"}},{"tag":"path","attr":{"d":"M38,10c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,9.1,41.3,10,38,10z"}},{"tag":"path","attr":{"d":"M38,16c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,15.1,41.3,16,38,16 z"}},{"tag":"path","attr":{"d":"M38,19c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,18.1,41.3,19,38,19 z"}},{"tag":"path","attr":{"d":"M38,22c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,21.1,41.3,22,38,22 z"}},{"tag":"path","attr":{"d":"M38,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,24.1,41.3,25,38,25 z"}},{"tag":"path","attr":{"d":"M38,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,27.1,41.3,28,38,28 z"}},{"tag":"path","attr":{"d":"M38,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,30.1,41.3,31,38,31 z"}},{"tag":"path","attr":{"d":"M38,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,33.1,41.3,34,38,34 z"}},{"tag":"path","attr":{"d":"M38,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,36.1,41.3,37,38,37 z"}},{"tag":"path","attr":{"d":"M38,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,39.1,41.3,40,38,40 z"}}]},{"tag":"g","attr":{"fill":"#FFC107"},"child":[{"tag":"ellipse","attr":{"cx":"38","cy":"8","rx":"6","ry":"2"}},{"tag":"path","attr":{"d":"M38,12c-2.8,0-5.1-0.6-5.8-1.5C32.1,10.7,32,10.8,32,11c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,11.4,40.8,12,38,12z"}},{"tag":"path","attr":{"d":"M38,15c-2.8,0-5.1-0.6-5.8-1.5C32.1,13.7,32,13.8,32,14c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,14.4,40.8,15,38,15z"}},{"tag":"path","attr":{"d":"M38,18c-2.8,0-5.1-0.6-5.8-1.5C32.1,16.7,32,16.8,32,17c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,17.4,40.8,18,38,18z"}},{"tag":"path","attr":{"d":"M38,21c-2.8,0-5.1-0.6-5.8-1.5C32.1,19.7,32,19.8,32,20c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,20.4,40.8,21,38,21z"}},{"tag":"path","attr":{"d":"M38,24c-2.8,0-5.1-0.6-5.8-1.5C32.1,22.7,32,22.8,32,23c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,23.4,40.8,24,38,24z"}},{"tag":"path","attr":{"d":"M38,27c-2.8,0-5.1-0.6-5.8-1.5C32.1,25.7,32,25.8,32,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,26.4,40.8,27,38,27z"}},{"tag":"path","attr":{"d":"M38,30c-2.8,0-5.1-0.6-5.8-1.5C32.1,28.7,32,28.8,32,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,29.4,40.8,30,38,30z"}},{"tag":"path","attr":{"d":"M38,33c-2.8,0-5.1-0.6-5.8-1.5C32.1,31.7,32,31.8,32,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,32.4,40.8,33,38,33z"}},{"tag":"path","attr":{"d":"M38,36c-2.8,0-5.1-0.6-5.8-1.5C32.1,34.7,32,34.8,32,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,35.4,40.8,36,38,36z"}},{"tag":"path","attr":{"d":"M38,39c-2.8,0-5.1-0.6-5.8-1.5C32.1,37.7,32,37.8,32,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,38.4,40.8,39,38,39z"}}]},{"tag":"g","attr":{"fill":"#FFA000"},"child":[{"tag":"path","attr":{"d":"M10,19c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,18.1,13.3,19,10,19 z"}},{"tag":"path","attr":{"d":"M10,16c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,15.1,13.3,16,10,16 z"}},{"tag":"path","attr":{"d":"M10,22c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,21.1,13.3,22,10,22 z"}},{"tag":"path","attr":{"d":"M10,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,24.1,13.3,25,10,25 z"}},{"tag":"path","attr":{"d":"M10,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,27.1,13.3,28,10,28 z"}},{"tag":"path","attr":{"d":"M10,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,30.1,13.3,31,10,31 z"}},{"tag":"path","attr":{"d":"M10,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,33.1,13.3,34,10,34 z"}},{"tag":"path","attr":{"d":"M10,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,36.1,13.3,37,10,37 z"}},{"tag":"path","attr":{"d":"M10,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,39.1,13.3,40,10,40 z"}}]},{"tag":"g","attr":{"fill":"#FFC107"},"child":[{"tag":"ellipse","attr":{"cx":"10","cy":"14","rx":"6","ry":"2"}},{"tag":"path","attr":{"d":"M10,18c-2.8,0-5.1-0.6-5.8-1.5C4.1,16.7,4,16.8,4,17c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,17.4,12.8,18,10,18z"}},{"tag":"path","attr":{"d":"M10,21c-2.8,0-5.1-0.6-5.8-1.5C4.1,19.7,4,19.8,4,20c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,20.4,12.8,21,10,21z"}},{"tag":"path","attr":{"d":"M10,24c-2.8,0-5.1-0.6-5.8-1.5C4.1,22.7,4,22.8,4,23c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,23.4,12.8,24,10,24z"}},{"tag":"path","attr":{"d":"M10,27c-2.8,0-5.1-0.6-5.8-1.5C4.1,25.7,4,25.8,4,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,26.4,12.8,27,10,27z"}},{"tag":"path","attr":{"d":"M10,30c-2.8,0-5.1-0.6-5.8-1.5C4.1,28.7,4,28.8,4,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,29.4,12.8,30,10,30z"}},{"tag":"path","attr":{"d":"M10,33c-2.8,0-5.1-0.6-5.8-1.5C4.1,31.7,4,31.8,4,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,32.4,12.8,33,10,33z"}},{"tag":"path","attr":{"d":"M10,36c-2.8,0-5.1-0.6-5.8-1.5C4.1,34.7,4,34.8,4,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,35.4,12.8,36,10,36z"}},{"tag":"path","attr":{"d":"M10,39c-2.8,0-5.1-0.6-5.8-1.5C4.1,37.7,4,37.8,4,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,38.4,12.8,39,10,39z"}}]},{"tag":"g","attr":{"fill":"#FFA000"},"child":[{"tag":"path","attr":{"d":"M24,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,27.1,27.3,28,24,28 z"}},{"tag":"path","attr":{"d":"M24,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,24.1,27.3,25,24,25 z"}},{"tag":"path","attr":{"d":"M24,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,30.1,27.3,31,24,31 z"}},{"tag":"path","attr":{"d":"M24,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,33.1,27.3,34,24,34 z"}},{"tag":"path","attr":{"d":"M24,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,36.1,27.3,37,24,37 z"}},{"tag":"path","attr":{"d":"M24,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,39.1,27.3,40,24,40 z"}}]},{"tag":"g","attr":{"fill":"#FFC107"},"child":[{"tag":"ellipse","attr":{"cx":"24","cy":"23","rx":"6","ry":"2"}},{"tag":"path","attr":{"d":"M24,27c-2.8,0-5.1-0.6-5.8-1.5C18.1,25.7,18,25.8,18,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,26.4,26.8,27,24,27z"}},{"tag":"path","attr":{"d":"M24,30c-2.8,0-5.1-0.6-5.8-1.5C18.1,28.7,18,28.8,18,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,29.4,26.8,30,24,30z"}},{"tag":"path","attr":{"d":"M24,33c-2.8,0-5.1-0.6-5.8-1.5C18.1,31.7,18,31.8,18,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,32.4,26.8,33,24,33z"}},{"tag":"path","attr":{"d":"M24,36c-2.8,0-5.1-0.6-5.8-1.5C18.1,34.7,18,34.8,18,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,35.4,26.8,36,24,36z"}},{"tag":"path","attr":{"d":"M24,39c-2.8,0-5.1-0.6-5.8-1.5C18.1,37.7,18,37.8,18,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,38.4,26.8,39,24,39z"}}]}]})(props);
};
function FcScatterPlot (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#CFD8DC","points":"9,39 9,6 7,6 7,41 42,41 42,39"}},{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"circle","attr":{"cx":"39","cy":"11","r":"3"}},{"tag":"circle","attr":{"cx":"31","cy":"13","r":"3"}},{"tag":"circle","attr":{"cx":"37","cy":"19","r":"3"}},{"tag":"circle","attr":{"cx":"34","cy":"26","r":"3"}},{"tag":"circle","attr":{"cx":"28","cy":"20","r":"3"}},{"tag":"circle","attr":{"cx":"26","cy":"28","r":"3"}},{"tag":"circle","attr":{"cx":"20","cy":"23","r":"3"}},{"tag":"circle","attr":{"cx":"21","cy":"33","r":"3"}},{"tag":"circle","attr":{"cx":"14","cy":"30","r":"3"}}]}]})(props);
};
function FcSearch (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#616161"},"child":[{"tag":"rect","attr":{"x":"34.6","y":"28.1","transform":"matrix(.707 -.707 .707 .707 -15.154 36.586)","width":"4","height":"17"}},{"tag":"circle","attr":{"cx":"20","cy":"20","r":"16"}}]},{"tag":"rect","attr":{"x":"36.2","y":"32.1","transform":"matrix(.707 -.707 .707 .707 -15.839 38.239)","fill":"#37474F","width":"4","height":"12.3"}},{"tag":"circle","attr":{"fill":"#64B5F6","cx":"20","cy":"20","r":"13"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M26.9,14.2c-1.7-2-4.2-3.2-6.9-3.2s-5.2,1.2-6.9,3.2c-0.4,0.4-0.3,1.1,0.1,1.4c0.4,0.4,1.1,0.3,1.4-0.1 C16,13.9,17.9,13,20,13s4,0.9,5.4,2.5c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.5-0.1,0.6-0.2C27.2,15.3,27.2,14.6,26.9,14.2z"}}]})(props);
};
function FcSelfServiceKiosk (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#546E7A","d":"M44,30H4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4V30z"}},{"tag":"path","attr":{"fill":"#64B5F6","d":"M40,27H8c-0.6,0-1-0.4-1-1V11c0-0.6,0.4-1,1-1h32c0.6,0,1,0.4,1,1v15C41,26.6,40.6,27,40,27z"}},{"tag":"path","attr":{"fill":"#78909C","d":"M40,41H8c-2.2,0-4-1.8-4-4v-7h40v7C44,39.2,42.2,41,40,41z"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"rect","attr":{"x":"27","y":"34","width":"12","height":"2"}},{"tag":"rect","attr":{"x":"9","y":"34","width":"12","height":"2"}},{"tag":"path","attr":{"d":"M18,35c0,1.1-1.3,2-3,2s-3-0.9-3-2H18z"}}]}]})(props);
};
function FcSelfie (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFB74D","d":"M32.9,22c0-0.3,0.1-0.7,0.1-1c0-1.1,0-5.9,0-7c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,0.3,0,0.7,0.1,1H32.9z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M40,44H8c-2.2,0-4-1.8-4-4V26c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v14C44,42.2,42.2,44,40,44z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M7,26v14c0,0.6,0.4,1,1,1h29c0.6,0,1-0.4,1-1V26c0-0.6-0.4-1-1-1H8C7.4,25,7,25.4,7,26z"}},{"tag":"rect","attr":{"x":"40","y":"30","fill":"#78909C","width":"2","height":"6"}},{"tag":"rect","attr":{"x":"19","y":"32","fill":"#BF360C","width":"8","height":"9"}},{"tag":"rect","attr":{"x":"20.5","y":"37.5","fill":"#FF9800","width":"5","height":"3.5"}},{"tag":"path","attr":{"fill":"#FFB74D","d":"M27.5,32c0-3.8-9-2.5-9,0c0,0.5,0,3,0,3.5c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5C27.5,35,27.5,32.5,27.5,32z"}},{"tag":"g","attr":{"fill":"#784719"},"child":[{"tag":"circle","attr":{"cx":"28","cy":"21","r":"1"}},{"tag":"circle","attr":{"cx":"20","cy":"21","r":"1"}},{"tag":"circle","attr":{"cx":"25","cy":"35.5","r":".5"}},{"tag":"circle","attr":{"cx":"21","cy":"35.5","r":".5"}}]},{"tag":"g","attr":{"fill":"#FF5722"},"child":[{"tag":"path","attr":{"d":"M23,27c-3,0-8,1.3-8,11l4,3v-6.5l6-3.5l2,2.5V41l4-3c0-2-0.8-10-6-10l-0.5-1H23z"}},{"tag":"path","attr":{"d":"M16,22v-3l12-7l4,5v5h6.8C38.3,15.8,36.1,6,28,6l-1-2h-3C18.5,4,10.7,6.8,9.2,22H16z"}}]}]})(props);
};
function FcSerialTasks (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#90CAF9","d":"M33,9H11v4h22c1.1,0,2,0.9,2,2v20H23v4h16V15C39,11.7,36.3,9,33,9z"}},{"tag":"rect","attr":{"x":"6","y":"6","fill":"#D81B60","width":"10","height":"10"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"rect","attr":{"x":"32","y":"17","width":"10","height":"10"}},{"tag":"rect","attr":{"x":"16","y":"32","width":"10","height":"10"}},{"tag":"circle","attr":{"cx":"26","cy":"11","r":"5"}},{"tag":"circle","attr":{"cx":"37","cy":"37","r":"5"}}]}]})(props);
};
function FcServiceMark (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#9C27B0","cx":"24","cy":"24","r":"21"}},{"tag":"g","attr":{"fill":"#E1BEE7"},"child":[{"tag":"path","attr":{"d":"M16.7,28.2c0-3.8-7.3-2.2-7.3-8.1c0-0.7,0.4-4.8,5.5-4.8c5.1,0,5.4,4.5,5.4,5.3h-3.5c0-0.4,0-2.5-2-2.5 c-1.8,0-1.9,1.7-1.9,2c0,3,7.4,2,7.4,8.1c0,2-1.1,4.8-5.3,4.8C10.3,33,9,29.6,9,27.3h3.5c0,0.5-0.2,2.8,2.5,2.8 C16.8,30.2,16.7,28.5,16.7,28.2z"}},{"tag":"path","attr":{"d":"M27.1,15.6L30.3,28l3.2-12.4h4.5v17.2h-3.5v-4.6l0.3-7.2l-3.4,11.8h-2.4l-3.4-11.8l0.3,7.2v4.6h-3.5V15.6 H27.1z"}}]}]})(props);
};
function FcServices (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E65100","d":"M25.6,34.4c0.1-0.4,0.1-0.9,0.1-1.4s0-0.9-0.1-1.4l2.8-2c0.3-0.2,0.4-0.6,0.2-0.9l-2.7-4.6 c-0.2-0.3-0.5-0.4-0.8-0.3L22,25.3c-0.7-0.6-1.5-1-2.4-1.4l-0.3-3.4c0-0.3-0.3-0.6-0.6-0.6h-5.3c-0.3,0-0.6,0.3-0.6,0.6L12.4,24 c-0.9,0.3-1.6,0.8-2.4,1.4l-3.1-1.4c-0.3-0.1-0.7,0-0.8,0.3l-2.7,4.6c-0.2,0.3-0.1,0.7,0.2,0.9l2.8,2c-0.1,0.4-0.1,0.9-0.1,1.4 s0,0.9,0.1,1.4l-2.8,2c-0.3,0.2-0.4,0.6-0.2,0.9l2.7,4.6c0.2,0.3,0.5,0.4,0.8,0.3l3.1-1.4c0.7,0.6,1.5,1,2.4,1.4l0.3,3.4 c0,0.3,0.3,0.6,0.6,0.6h5.3c0.3,0,0.6-0.3,0.6-0.6l0.3-3.4c0.9-0.3,1.6-0.8,2.4-1.4l3.1,1.4c0.3,0.1,0.7,0,0.8-0.3l2.7-4.6 c0.2-0.3,0.1-0.7-0.2-0.9L25.6,34.4z M16,38c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5C21,35.8,18.8,38,16,38z"}},{"tag":"path","attr":{"fill":"#FFA000","d":"M41.9,15.3C42,14.8,42,14.4,42,14s0-0.8-0.1-1.3l2.5-1.8c0.3-0.2,0.3-0.5,0.2-0.8l-2.5-4.3 c-0.2-0.3-0.5-0.4-0.8-0.2l-2.9,1.3c-0.7-0.5-1.4-0.9-2.2-1.3l-0.3-3.1C36,2.2,35.8,2,35.5,2h-4.9c-0.3,0-0.6,0.2-0.6,0.5l-0.3,3.1 c-0.8,0.3-1.5,0.7-2.2,1.3l-2.9-1.3c-0.3-0.1-0.6,0-0.8,0.2l-2.5,4.3c-0.2,0.3-0.1,0.6,0.2,0.8l2.5,1.8C24,13.2,24,13.6,24,14 s0,0.8,0.1,1.3l-2.5,1.8c-0.3,0.2-0.3,0.5-0.2,0.8l2.5,4.3c0.2,0.3,0.5,0.4,0.8,0.2l2.9-1.3c0.7,0.5,1.4,0.9,2.2,1.3l0.3,3.1 c0,0.3,0.3,0.5,0.6,0.5h4.9c0.3,0,0.6-0.2,0.6-0.5l0.3-3.1c0.8-0.3,1.5-0.7,2.2-1.3l2.9,1.3c0.3,0.1,0.6,0,0.8-0.2l2.5-4.3 c0.2-0.3,0.1-0.6-0.2-0.8L41.9,15.3z M33,19c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5C38,16.8,35.8,19,33,19z"}}]})(props);
};
function FcSettings (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#607D8B","d":"M39.6,27.2c0.1-0.7,0.2-1.4,0.2-2.2s-0.1-1.5-0.2-2.2l4.5-3.2c0.4-0.3,0.6-0.9,0.3-1.4L40,10.8 c-0.3-0.5-0.8-0.7-1.3-0.4l-5,2.3c-1.2-0.9-2.4-1.6-3.8-2.2l-0.5-5.5c-0.1-0.5-0.5-0.9-1-0.9h-8.6c-0.5,0-1,0.4-1,0.9l-0.5,5.5 c-1.4,0.6-2.7,1.3-3.8,2.2l-5-2.3c-0.5-0.2-1.1,0-1.3,0.4l-4.3,7.4c-0.3,0.5-0.1,1.1,0.3,1.4l4.5,3.2c-0.1,0.7-0.2,1.4-0.2,2.2 s0.1,1.5,0.2,2.2L4,30.4c-0.4,0.3-0.6,0.9-0.3,1.4L8,39.2c0.3,0.5,0.8,0.7,1.3,0.4l5-2.3c1.2,0.9,2.4,1.6,3.8,2.2l0.5,5.5 c0.1,0.5,0.5,0.9,1,0.9h8.6c0.5,0,1-0.4,1-0.9l0.5-5.5c1.4-0.6,2.7-1.3,3.8-2.2l5,2.3c0.5,0.2,1.1,0,1.3-0.4l4.3-7.4 c0.3-0.5,0.1-1.1-0.3-1.4L39.6,27.2z M24,35c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10C34,30.5,29.5,35,24,35z"}},{"tag":"path","attr":{"fill":"#455A64","d":"M24,13c-6.6,0-12,5.4-12,12c0,6.6,5.4,12,12,12s12-5.4,12-12C36,18.4,30.6,13,24,13z M24,30 c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5s5,2.2,5,5C29,27.8,26.8,30,24,30z"}}]})(props);
};
function FcShare (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#1976D2","d":"M38.1,31.2L19.4,24l18.7-7.2c1.5-0.6,2.3-2.3,1.7-3.9c-0.6-1.5-2.3-2.3-3.9-1.7l-26,10C8.8,21.6,8,22.8,8,24 s0.8,2.4,1.9,2.8l26,10c0.4,0.1,0.7,0.2,1.1,0.2c1.2,0,2.3-0.7,2.8-1.9C40.4,33.5,39.6,31.8,38.1,31.2z"}},{"tag":"g","attr":{"fill":"#1E88E5"},"child":[{"tag":"circle","attr":{"cx":"11","cy":"24","r":"7"}},{"tag":"circle","attr":{"cx":"37","cy":"14","r":"7"}},{"tag":"circle","attr":{"cx":"37","cy":"34","r":"7"}}]}]})(props);
};
function FcShipped (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#8BC34A","d":"M43,36H29V14h10.6c0.9,0,1.6,0.6,1.9,1.4L45,26v8C45,35.1,44.1,36,43,36z"}},{"tag":"path","attr":{"fill":"#388E3C","d":"M29,36H5c-1.1,0-2-0.9-2-2V9c0-1.1,0.9-2,2-2h22c1.1,0,2,0.9,2,2V36z"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"circle","attr":{"cx":"37","cy":"36","r":"5"}},{"tag":"circle","attr":{"cx":"13","cy":"36","r":"5"}}]},{"tag":"g","attr":{"fill":"#78909C"},"child":[{"tag":"circle","attr":{"cx":"37","cy":"36","r":"2"}},{"tag":"circle","attr":{"cx":"13","cy":"36","r":"2"}}]},{"tag":"path","attr":{"fill":"#37474F","d":"M41,25h-7c-0.6,0-1-0.4-1-1v-7c0-0.6,0.4-1,1-1h5.3c0.4,0,0.8,0.3,0.9,0.7l1.7,5.2c0,0.1,0.1,0.2,0.1,0.3V24 C42,24.6,41.6,25,41,25z"}},{"tag":"polygon","attr":{"fill":"#DCEDC8","points":"21.8,13.8 13.9,21.7 10.2,17.9 8,20.1 13.9,26 24,15.9"}}]})(props);
};
function FcShop (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"5","y":"19","fill":"#CFD8DC","width":"38","height":"19"}},{"tag":"rect","attr":{"x":"5","y":"38","fill":"#B0BEC5","width":"38","height":"4"}},{"tag":"rect","attr":{"x":"27","y":"24","fill":"#455A64","width":"12","height":"18"}},{"tag":"rect","attr":{"x":"9","y":"24","fill":"#E3F2FD","width":"14","height":"11"}},{"tag":"rect","attr":{"x":"10","y":"25","fill":"#1E88E5","width":"12","height":"9"}},{"tag":"path","attr":{"fill":"#90A4AE","d":"M36.5,33.5c-0.3,0-0.5,0.2-0.5,0.5v2c0,0.3,0.2,0.5,0.5,0.5S37,36.3,37,36v-2C37,33.7,36.8,33.5,36.5,33.5z"}},{"tag":"g","attr":{"fill":"#558B2F"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"19","r":"3"}},{"tag":"circle","attr":{"cx":"36","cy":"19","r":"3"}},{"tag":"circle","attr":{"cx":"12","cy":"19","r":"3"}}]},{"tag":"path","attr":{"fill":"#7CB342","d":"M40,6H8C6.9,6,6,6.9,6,8v3h36V8C42,6.9,41.1,6,40,6z"}},{"tag":"rect","attr":{"x":"21","y":"11","fill":"#7CB342","width":"6","height":"8"}},{"tag":"polygon","attr":{"fill":"#7CB342","points":"37,11 32,11 33,19 39,19"}},{"tag":"polygon","attr":{"fill":"#7CB342","points":"11,11 16,11 15,19 9,19"}},{"tag":"g","attr":{"fill":"#FFA000"},"child":[{"tag":"circle","attr":{"cx":"30","cy":"19","r":"3"}},{"tag":"path","attr":{"d":"M45,19c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3L45,19z"}},{"tag":"circle","attr":{"cx":"18","cy":"19","r":"3"}},{"tag":"path","attr":{"d":"M3,19c0,1.7,1.3,3,3,3s3-1.3,3-3s-1.3-3-3-3L3,19z"}}]},{"tag":"g","attr":{"fill":"#FFC107"},"child":[{"tag":"polygon","attr":{"points":"32,11 27,11 27,19 33,19"}},{"tag":"polygon","attr":{"points":"42,11 37,11 39,19 45,19"}},{"tag":"polygon","attr":{"points":"16,11 21,11 21,19 15,19"}},{"tag":"polygon","attr":{"points":"6,11 11,11 9,19 3,19"}}]}]})(props);
};
function FcSignature (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#1565C0","d":"M38.8,28.2C41.5,24.8,45,20.1,45,12c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,6.7-2.5,10.7-5,13.9c-0.6-1.9-1-4.2-1-6.9 c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1c-0.1,1.7-0.6,3.6-1,3.8c-0.4,0-0.9-1.4-1-2.8c0-0.5-0.5-0.9-1-0.9c-0.5,0-1,0.3-1,0.9 c-0.3,1.7-1.1,4.1-2,4.1c-0.4,0-0.6-0.1-0.7-0.3c-0.3-0.3-0.4-1-0.4-1.6c0-0.4,0.1-0.8,0.1-1.2c0-0.5-0.4-1-0.9-1 c-0.5,0-1,0.3-1.1,0.8c0,0.1-0.1,0.5-0.1,1.1C25.7,23.6,25.1,27,23,27c-0.7,0-1.1-0.2-1.4-0.7c-0.5-0.8-0.5-2.1,0-3.3c0,0,0,0,0-0.1 c0.1-0.1,0.1-0.3,0.2-0.4c0,0,0,0,0,0c0.8-1.6,1.7-2.5,3.2-2.5c0.6,0,1-0.4,1-1s-0.4-1-1-1c-4.2,0-5.4,4.1-6.6,8 c-1.4,4.8-2.7,8-6.4,8c-5.1,0-7-6.6-7-11c0-8.6,4.7-14,9-14c2.9,0,4,2.3,4.1,2.4c0.2,0.5,0.8,0.7,1.3,0.5c0.5-0.2,0.7-0.8,0.5-1.3 C19.8,10.4,18.2,7,14,7C8.6,7,3,13,3,23c0,10.3,5.9,13,9,13c5.1,0,6.8-4.5,8.1-8.5c0.7,0.9,1.7,1.5,2.9,1.5c2.2,0,3.5-1.6,4.2-3.6 c0.5,0.4,1.1,0.6,1.8,0.6c1.4,0,2.4-1.2,3-2.4c0.4,0.7,1.1,1.2,2,1.2c0.6,0,1.1-0.3,1.5-0.7c0.3,1.4,0.7,2.7,1,3.8 C35.1,29.7,34,31.2,34,33c0,1.7,1.3,3,3,3c1.8,0,3-1.6,3-3c0-1.3-0.5-2.7-1.1-4.3C38.9,28.5,38.8,28.4,38.8,28.2z M37,34 c-0.7,0-1-0.5-1-1c0-0.9,0.5-1.8,1.3-2.9c0.4,1.2,0.7,2.1,0.7,2.9C38,33.3,37.7,34,37,34z"}},{"tag":"rect","attr":{"x":"3","y":"40","fill":"#90A4AE","width":"42","height":"2"}}]})(props);
};
function FcSimCardChip (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF9800","d":"M5,35V13c0-2.2,1.8-4,4-4h30c2.2,0,4,1.8,4,4v22c0,2.2-1.8,4-4,4H9C6.8,39,5,37.2,5,35z"}},{"tag":"g","attr":{"fill":"#FFD54F"},"child":[{"tag":"path","attr":{"d":"M43,21v-2H31c-1.1,0-2-0.9-2-2s0.9-2,2-2h1v-2h-1c-2.2,0-4,1.8-4,4s1.8,4,4,4h3v6h-3c-2.8,0-5,2.2-5,5 s2.2,5,5,5h2v-2h-2c-1.7,0-3-1.3-3-3s1.3-3,3-3h12v-2h-7v-6H43z"}},{"tag":"path","attr":{"d":"M17,27h-3v-6h3c2.2,0,4-1.8,4-4s-1.8-4-4-4h-3v2h3c1.1,0,2,0.9,2,2s-0.9,2-2,2H5v2h7v6H5v2h12 c1.7,0,3,1.3,3,3s-1.3,3-3,3h-2v2h2c2.8,0,5-2.2,5-5S19.8,27,17,27z"}}]}]})(props);
};
function FcSimCard (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#009688","d":"M36,45H12c-2.2,0-4-1.8-4-4V7c0-2.2,1.8-4,4-4h16.3c1.1,0,2.1,0.4,2.8,1.2l7.7,7.7c0.8,0.8,1.2,1.8,1.2,2.8 V41C40,43.2,38.2,45,36,45z"}},{"tag":"path","attr":{"fill":"#FF9800","d":"M32,38H16c-1.1,0-2-0.9-2-2V24c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2v12C34,37.1,33.1,38,32,38z"}},{"tag":"path","attr":{"fill":"#FFD54F","d":"M29,30v3h5v2h-5v3h-2V22h2v6h5v2H29z M14,29v2h5v2h-5v2h5v3h2v-9H14z"}}]})(props);
};
function FcSlrBackSide (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#5E35B1","d":"M40,10h-7.6l-2-3c-0.4-0.6-1-0.9-1.7-0.9h-9.6c-0.7,0-1.3,0.3-1.7,0.9l-2,3H8c-2.2,0-4,1.8-4,4v24 c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V14C44,11.8,42.2,10,40,10z"}},{"tag":"path","attr":{"fill":"#F57C00","d":"M11,16h20c0.6,0,1,0.4,1,1v16c0,0.6-0.4,1-1,1H11c-0.6,0-1-0.4-1-1V17C10,16.4,10.4,16,11,16z"}},{"tag":"polygon","attr":{"fill":"#942A09","points":"18.9,22 12,32 25.8,32"}},{"tag":"circle","attr":{"fill":"#FFF9C4","cx":"27","cy":"21","r":"2"}},{"tag":"polygon","attr":{"fill":"#BF360C","points":"25.2,26 20.4,32 30,32"}},{"tag":"g","attr":{"fill":"#8667C4"},"child":[{"tag":"path","attr":{"d":"M34,10h6V9.2C40,8.5,39.5,8,38.8,8h-3.6C34.5,8,34,8.5,34,9.2V10z"}},{"tag":"circle","attr":{"cx":"38","cy":"18","r":"2"}},{"tag":"circle","attr":{"cx":"38","cy":"24","r":"2"}},{"tag":"circle","attr":{"cx":"38","cy":"30","r":"2"}}]}]})(props);
};
function FcSmartphoneTablet (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M4,39V7c0-2.2,1.8-4,4-4h22c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H8C5.8,43,4,41.2,4,39z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M30,6H8C7.4,6,7,6.4,7,7v29c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V7C31,6.4,30.6,6,30,6z"}},{"tag":"rect","attr":{"x":"15","y":"39","fill":"#78909C","width":"6","height":"2"}},{"tag":"path","attr":{"fill":"#E38939","d":"M24,41V17c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4H28C25.8,45,24,43.2,24,41z"}},{"tag":"path","attr":{"fill":"#FFF3E0","d":"M40,16H28c-0.6,0-1,0.4-1,1v22c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V17C41,16.4,40.6,16,40,16z"}},{"tag":"circle","attr":{"fill":"#A6642A","cx":"34","cy":"42.5","r":"1.5"}}]})(props);
};
function FcSms (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#009688","d":"M37,39H11l-6,6V11c0-3.3,2.7-6,6-6h26c3.3,0,6,2.7,6,6v22C43,36.3,40.3,39,37,39z"}},{"tag":"g","attr":{"fill":"#fff"},"child":[{"tag":"circle","attr":{"cx":"24","cy":"22","r":"3"}},{"tag":"circle","attr":{"cx":"34","cy":"22","r":"3"}},{"tag":"circle","attr":{"cx":"14","cy":"22","r":"3"}}]}]})(props);
};
function FcSoundRecordingCopyright (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#9C27B0","cx":"24","cy":"24","r":"21"}},{"tag":"path","attr":{"fill":"#E1BEE7","d":"M20.7,27.2v8.4h-3.9V12.9h8.7c1.3,0,2.5,0.2,3.5,0.5c1,0.4,1.9,0.9,2.6,1.5c0.7,0.6,1.2,1.4,1.6,2.3 c0.4,0.9,0.6,1.8,0.6,2.9c0,1.1-0.2,2.1-0.6,3c-0.4,0.9-0.9,1.6-1.6,2.2c-0.7,0.6-1.6,1.1-2.6,1.4c-1,0.3-2.2,0.5-3.5,0.5H20.7z M20.7,24h4.7c0.8,0,1.4-0.1,2-0.3c0.5-0.2,1-0.5,1.4-0.8c0.4-0.3,0.6-0.8,0.8-1.2c0.2-0.5,0.2-1,0.2-1.6c0-0.5-0.1-1-0.2-1.5 c-0.2-0.5-0.4-0.9-0.8-1.3c-0.4-0.4-0.8-0.7-1.4-0.9c-0.5-0.2-1.2-0.3-2-0.3h-4.7V24z"}}]})(props);
};
function FcSpeaker (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#81D4FA","d":"M28,7.1v2c7.3,1,13,7.3,13,14.9s-5.7,13.9-13,14.9v2c8.4-1,15-8.2,15-16.9S36.4,8.1,28,7.1z"}},{"tag":"path","attr":{"fill":"#546E7A","d":"M14,32H7c-1.1,0-2-0.9-2-2V18c0-1.1,0.9-2,2-2h7V32z"}},{"tag":"polygon","attr":{"fill":"#78909C","points":"26,42 14,32 14,16 26,6"}},{"tag":"path","attr":{"fill":"#03A9F4","d":"M28,17.3v2.1c1.8,0.8,3,2.5,3,4.6s-1.2,3.8-3,4.6v2.1c2.9-0.9,5-3.5,5-6.7S30.9,18.2,28,17.3z"}},{"tag":"path","attr":{"fill":"#4FC3F7","d":"M28,12.2v2c4.6,0.9,8,5,8,9.8s-3.4,8.9-8,9.8v2c5.7-1,10-5.9,10-11.8S33.7,13.1,28,12.2z"}}]})(props);
};
function FcSportsMode (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#FF9800","cx":"28","cy":"9","r":"5"}},{"tag":"path","attr":{"fill":"#00796B","d":"M29,27.3l-9.2-4.1c-1-0.5-1.5,1-2,2c-0.5,1-4.1,7.2-3.8,8.3c0.3,0.9,1.1,1.4,1.9,1.4c0.2,0,0.4,0,0.6-0.1 L28.8,31c0.8-0.2,1.4-1,1.4-1.8C30.2,28.4,29.7,27.6,29,27.3z"}},{"tag":"path","attr":{"fill":"#009688","d":"M26.8,15.2l-2.2-1c-1.3-0.6-2.9,0-3.5,1.3L9.2,41.1c-0.5,1,0,2.2,1,2.7c0.3,0.1,0.6,0.2,0.9,0.2 c0.8,0,1.5-0.4,1.8-1.1c0,0,9.6-13.3,10.4-14.9s4.9-9.3,4.9-9.3C28.7,17.4,28.2,15.8,26.8,15.2z"}},{"tag":"path","attr":{"fill":"#FF9800","d":"M40.5,15.7c-0.7-0.8-2-1-2.8-0.3l-5,4.2l-6.4-3.5c-1.1-0.6-2.6-0.4-3.3,0.9c-0.8,1.3-0.4,2.9,0.8,3.4 l8.3,3.4c0.3,0.1,0.6,0.2,0.9,0.2c0.5,0,0.9-0.2,1.3-0.5l6-5C41.1,17.8,41.2,16.6,40.5,15.7z"}},{"tag":"path","attr":{"fill":"#FF9800","d":"M11.7,23.1l3.4-5.1l4.6,0.6l1.5-3.1c0.4-0.9,1.2-1.4,2.1-1.5c-0.1,0-0.2,0-0.2,0h-9c-0.7,0-1.3,0.3-1.7,0.9 l-4,6c-0.6,0.9-0.4,2.2,0.6,2.8C9.2,23.9,9.6,24,10,24C10.6,24,11.3,23.7,11.7,23.1z"}}]})(props);
};
function FcStackOfPhotos (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"12.3","y":"12.3","transform":"matrix(.948 .318 -.318 .948 9.725 -6.994)","fill":"#64B5F6","width":"28","height":"28"}},{"tag":"rect","attr":{"x":"15.6","y":"15.4","transform":"matrix(.951 .31 -.31 .951 9.176 -6.977)","fill":"#1E88E5","width":"22","height":"20"}},{"tag":"rect","attr":{"x":"8.1","y":"8.1","transform":"matrix(.983 .181 -.181 .983 4.385 -3.65)","fill":"#90CAF9","width":"28","height":"28"}},{"tag":"rect","attr":{"x":"11.3","y":"11.2","transform":"matrix(.985 .175 -.175 .985 4.048 -3.566)","fill":"#42A5F5","width":"22","height":"20"}},{"tag":"rect","attr":{"x":"4","y":"4","fill":"#BBDEFB","width":"28","height":"28"}},{"tag":"rect","attr":{"x":"7","y":"7","fill":"#4CAF50","width":"22","height":"20"}},{"tag":"path","attr":{"fill":"#fff","d":"M16,13c0-1.1,0.9-2,2-2s2,0.9,2,2s-2,4-2,4S16,14.1,16,13z"}},{"tag":"path","attr":{"fill":"#fff","d":"M20,21c0,1.1-0.9,2-2,2s-2-0.9-2-2s2-4,2-4S20,19.9,20,21z"}},{"tag":"path","attr":{"fill":"#fff","d":"M13.5,16.7c-1-0.6-1.3-1.8-0.7-2.7c0.6-1,1.8-1.3,2.7-0.7c1,0.6,2.5,3.7,2.5,3.7S14.5,17.3,13.5,16.7z"}},{"tag":"path","attr":{"fill":"#fff","d":"M22.5,17.3c1,0.6,1.3,1.8,0.7,2.7c-0.6,1-1.8,1.3-2.7,0.7C19.5,20.2,18,17,18,17S21.5,16.7,22.5,17.3z"}},{"tag":"path","attr":{"fill":"#fff","d":"M22.5,16.7c1-0.6,1.3-1.8,0.7-2.7c-0.6-1-1.8-1.3-2.7-0.7C19.5,13.8,18,17,18,17S21.5,17.3,22.5,16.7z"}},{"tag":"path","attr":{"fill":"#fff","d":"M13.5,17.3c-1,0.6-1.3,1.8-0.7,2.7c0.6,1,1.8,1.3,2.7,0.7c1-0.6,2.5-3.7,2.5-3.7S14.5,16.7,13.5,17.3z"}},{"tag":"circle","attr":{"fill":"#FFC107","cx":"18","cy":"17","r":"2"}}]})(props);
};
function FcStart (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F44336","d":"M38,42H10c-2.2,0-4-1.8-4-4V10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v28C42,40.2,40.2,42,38,42z"}},{"tag":"polygon","attr":{"fill":"#fff","points":"31,24 20,16 20,32"}}]})(props);
};
function FcStatistics (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"rect","attr":{"x":"23","y":"5","width":"2","height":"36"}},{"tag":"rect","attr":{"x":"20.5","y":"31.4","transform":"matrix(.707 .707 -.707 .707 33.523 -3.921)","width":"2","height":"14.2"}},{"tag":"rect","attr":{"x":"25.5","y":"31.4","transform":"matrix(-.707 .707 -.707 -.707 72.487 46.995)","width":"2","height":"14.2"}}]},{"tag":"rect","attr":{"x":"4","y":"8","fill":"#CFD8DC","width":"40","height":"28"}},{"tag":"g","attr":{"fill":"#607D8B"},"child":[{"tag":"rect","attr":{"x":"3","y":"7","width":"42","height":"4"}},{"tag":"rect","attr":{"x":"3","y":"35","width":"42","height":"2"}},{"tag":"circle","attr":{"cx":"31.5","cy":"43.5","r":"1.5"}},{"tag":"circle","attr":{"cx":"16.5","cy":"43.5","r":"1.5"}}]},{"tag":"g","attr":{"fill":"#C51162"},"child":[{"tag":"polygon","attr":{"points":"31.9,18.9 26,24.9 20,18.9 11.9,26.9 14.1,29.1 20,23.1 26,29.1 34.1,21.1"}},{"tag":"polygon","attr":{"points":"36,24 29,17 36,17"}}]}]})(props);
};
function FcSteam (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FFFFFF","d":"M42,38c0,2.209-1.791,4-4,4H10c-2.209,0-4-1.791-4-4V10c0-2.209,1.791-4,4-4h28c2.209,0,4,1.791,4,4V38z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#455A64","d":"M18.459,33.645c-0.288,0-0.56-0.057-0.822-0.141l-0.005,0.02l-3.67-1.062\r\n\t\tc0.644,1.878,2.406,3.237,4.5,3.237c2.641,0,4.776-2.136,4.776-4.776s-2.135-4.777-4.776-4.777c-1.141,0-2.175,0.418-2.998,1.087\r\n\t\tL19,28.255c0.029,0.007,0.055,0.018,0.084,0.024l0.049,0.016v0.002c1.177,0.301,2.049,1.359,2.049,2.626\r\n\t\tC21.184,32.424,19.964,33.645,18.459,33.645z"}},{"tag":"path","attr":{"fill":"#455A64","d":"M30.923,24.299c3.222,0,5.837-2.615,5.837-5.838c0-3.222-2.615-5.837-5.837-5.837\r\n\t\tc-3.221,0-5.837,2.615-5.837,5.837C25.086,21.684,27.702,24.299,30.923,24.299z M30.92,14.409c2.24,0,4.056,1.813,4.056,4.052\r\n\t\tc0,2.241-1.815,4.053-4.056,4.053c-2.236,0-4.049-1.812-4.049-4.053C26.871,16.223,28.684,14.409,30.92,14.409z"}},{"tag":"path","attr":{"fill":"#455A64","d":"M38,6h-2.75h-22.5H10c-2.209,0-4,1.791-4,4v2.75v4.236v7.509l7.027,2.033\r\n\t\tc1.287-1.59,3.229-2.626,5.434-2.626c0.07,0,0.135,0.02,0.204,0.021l3.876-5.355c0-0.035-0.005-0.072-0.005-0.105\r\n\t\tc0-4.63,3.755-8.388,8.387-8.388c4.633,0,8.386,3.757,8.386,8.386c0,4.633-3.753,8.387-8.386,8.387\r\n\t\tc-0.044,0-0.087-0.006-0.132-0.007l-5.33,3.871c0.002,0.07,0.021,0.14,0.021,0.211c0,3.878-3.142,7.021-7.021,7.021\r\n\t\tc-3.593,0-6.52-2.707-6.937-6.188L6,30.158v2.583v2.509V38c0,2.209,1.791,4,4,4h2.75h22.5H38c2.209,0,4-1.791,4-4v-2.75v-22.5V10\r\n\t\tC42,7.791,40.209,6,38,6z"}}]}]})(props);
};
function FcStumbleupon (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E64A19","d":"M24.001,5c-10.494,0-19,8.506-19,19c0,10.493,8.506,19,19,19c10.493,0,19-8.507,19-19\r\n\tC43.001,13.506,34.494,5,24.001,5z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#FFFFFF","d":"M24.001,19C23.998,19,24.004,19,24.001,19c-0.062-0.004-1,0-1,1v7.876C22.916,29.888,21.504,33,17.959,33\r\n\t\tc-3.607,0-4.958-3.065-4.958-4.958V24h4v4c0.038,0.709,0.629,1,1,1c0.665,0,0.972-0.361,1-1v-8.124c0-2.01,1.332-5,5-5\r\n\t\tc0.045,0,0.086,0.006,0.131,0.007c0,0,4.869-0.009,4.869,5.117c0,1.104-0.896,1.876-2,1.876s-2-0.771-2-1.876\r\n\t\tC25.001,19.124,24.041,19.003,24.001,19z M35.001,27.876c0,2.01-1.331,5.124-5,5.124s-5-3.114-5-5.124v-3.439\r\n\t\tc0.614,0.272,1.285,0.439,2,0.439c0.712,0,1.386-0.154,2-0.424V28c0.038,1,0.663,1,1,1c0.247,0,1,0,1-1v-4h4V27.876z"}}]}]})(props);
};
function FcSupport (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#607D8B","d":"M44.7,11L36,19.6c0,0-2.6,0-5.2-2.6s-2.6-5.2-2.6-5.2l8.7-8.7c-4.9-1.2-10.8,0.4-14.4,4 c-5.4,5.4-0.6,12.3-2,13.7C12.9,28.7,5.1,34.7,4.9,35c-2.3,2.3-2.4,6-0.2,8.2c2.2,2.2,5.9,2.1,8.2-0.2c0.3-0.3,6.7-8.4,14.2-15.9 c1.4-1.4,8,3.7,13.6-1.8C44.2,21.7,45.9,15.9,44.7,11z M9.4,41.1c-1.4,0-2.5-1.1-2.5-2.5C6.9,37.1,8,36,9.4,36 c1.4,0,2.5,1.1,2.5,2.5C11.9,39.9,10.8,41.1,9.4,41.1z"}}]})(props);
};
function FcSurvey (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#455A64","d":"M36,4H26c0,1.1-0.9,2-2,2s-2-0.9-2-2H12C9.8,4,8,5.8,8,8v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V8 C40,5.8,38.2,4,36,4z"}},{"tag":"path","attr":{"fill":"#fff","d":"M36,41H12c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h24c0.6,0,1,0.4,1,1v32C37,40.6,36.6,41,36,41z"}},{"tag":"g","attr":{"fill":"#90A4AE"},"child":[{"tag":"path","attr":{"d":"M26,4c0,1.1-0.9,2-2,2s-2-0.9-2-2h-7v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V4H26z"}},{"tag":"path","attr":{"d":"M24,0c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S26.2,0,24,0z M24,6c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2 S25.1,6,24,6z"}}]},{"tag":"g","attr":{"fill":"#CFD8DC"},"child":[{"tag":"rect","attr":{"x":"21","y":"20","width":"12","height":"2"}},{"tag":"rect","attr":{"x":"15","y":"19","width":"4","height":"4"}}]},{"tag":"g","attr":{"fill":"#03A9F4"},"child":[{"tag":"rect","attr":{"x":"21","y":"29","width":"12","height":"2"}},{"tag":"rect","attr":{"x":"15","y":"28","width":"4","height":"4"}}]}]})(props);
};
function FcSwitchCamera (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#5E35B1"},"child":[{"tag":"path","attr":{"d":"M33.9,12.1H14.2L17.6,7c0.4-0.6,1-0.9,1.7-0.9h9.6c0.7,0,1.3,0.3,1.7,0.9L33.9,12.1z"}},{"tag":"path","attr":{"d":"M14,11H8V9.2C8,8.5,8.5,8,9.2,8h3.6C13.5,8,14,8.5,14,9.2V11z"}},{"tag":"path","attr":{"d":"M40,42H8c-2.2,0-4-1.8-4-4V14c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,40.2,42.2,42,40,42z"}}]},{"tag":"path","attr":{"fill":"#E8EAF6","d":"M34,25c0-5.5-4.5-10-10-10c-2.4,0-4.6,0.8-6.3,2.2l1.2,1.6c1.4-1.1,3.1-1.8,5.1-1.8c4.4,0,8,3.6,8,8h-3.5 l4.5,5.6l4.5-5.6H34z"}},{"tag":"path","attr":{"fill":"#E8EAF6","d":"M29.1,31.2C27.7,32.3,25.9,33,24,33c-4.4,0-8-3.6-8-8h3.5L15,19.4L10.5,25H14c0,5.5,4.5,10,10,10 c2.4,0,4.6-0.8,6.3-2.2L29.1,31.2z"}}]})(props);
};
function FcSynchronize (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#FF6F00","d":"M38.7,11.9l-3.1,2.5c2.2,2.7,3.4,6.1,3.4,9.5c0,8.3-6.7,15-15,15c-0.9,0-1.9-0.1-2.8-0.3l-0.7,3.9 c1.2,0.2,2.4,0.3,3.5,0.3c10.5,0,19-8.5,19-19C43,19.6,41.5,15.3,38.7,11.9z"}},{"tag":"polygon","attr":{"fill":"#FF6F02","points":"31,8 42.9,9.6 33.1,19.4"}},{"tag":"path","attr":{"fill":"#FF6F00","d":"M24,5C13.5,5,5,13.5,5,24c0,4.6,1.6,9,4.6,12.4l3-2.6C10.3,31.1,9,27.6,9,24c0-8.3,6.7-15,15-15 c0.9,0,1.9,0.1,2.8,0.3l0.7-3.9C26.4,5.1,25.2,5,24,5z"}},{"tag":"polygon","attr":{"fill":"#FF6F02","points":"17,40 5.1,38.4 14.9,28.6"}}]})(props);
};
function FcTabletAndroid (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M8,41V7c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v34c0,2.2-1.8,4-4,4H12C9.8,45,8,43.2,8,41z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M36,6H12c-0.6,0-1,0.4-1,1v31c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1V7C37,6.4,36.6,6,36,6z"}},{"tag":"rect","attr":{"x":"21","y":"41","fill":"#78909C","width":"6","height":"2"}}]})(props);
};
function FcTemplate (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"4","y":"7","fill":"#BBDEFB","width":"40","height":"34"}},{"tag":"rect","attr":{"x":"9","y":"12","fill":"#3F51B5","width":"30","height":"5"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"rect","attr":{"x":"9","y":"21","width":"13","height":"16"}},{"tag":"rect","attr":{"x":"26","y":"21","width":"13","height":"16"}}]}]})(props);
};
function FcTimeline (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#3F51B5","d":"M42,29H20.8c-0.5,0-1-0.2-1.4-0.6l-3.7-3.7c-0.4-0.4-0.4-1,0-1.4l3.7-3.7c0.4-0.4,0.9-0.6,1.4-0.6H42 c0.6,0,1,0.4,1,1v8C43,28.6,42.6,29,42,29z"}},{"tag":"rect","attr":{"x":"9","y":"6","fill":"#CFD8DC","width":"2","height":"36"}},{"tag":"g","attr":{"fill":"#90A4AE"},"child":[{"tag":"circle","attr":{"cx":"10","cy":"10","r":"3"}},{"tag":"circle","attr":{"cx":"10","cy":"24","r":"3"}},{"tag":"circle","attr":{"cx":"10","cy":"38","r":"3"}}]},{"tag":"path","attr":{"fill":"#448AFF","d":"M34,43H20.8c-0.5,0-1-0.2-1.4-0.6l-3.7-3.7c-0.4-0.4-0.4-1,0-1.4l3.7-3.7c0.4-0.4,0.9-0.6,1.4-0.6H34 c0.6,0,1,0.4,1,1v8C35,42.6,34.6,43,34,43z"}},{"tag":"path","attr":{"fill":"#00BCD4","d":"M35,15H20.8c-0.5,0-1-0.2-1.4-0.6l-3.7-3.7c-0.4-0.4-0.4-1,0-1.4l3.7-3.7C19.8,5.2,20.3,5,20.8,5H35 c0.6,0,1,0.4,1,1v8C36,14.6,35.6,15,35,15z"}}]})(props);
};
function FcTodoList (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"17.8,18.1 10.4,25.4 6.2,21.3 4,23.5 10.4,29.9 20,20.3"}},{"tag":"polygon","attr":{"points":"17.8,5.1 10.4,12.4 6.2,8.3 4,10.5 10.4,16.9 20,7.3"}},{"tag":"polygon","attr":{"points":"17.8,31.1 10.4,38.4 6.2,34.3 4,36.5 10.4,42.9 20,33.3"}}]},{"tag":"g","attr":{"fill":"#90CAF9"},"child":[{"tag":"rect","attr":{"x":"24","y":"22","width":"20","height":"4"}},{"tag":"rect","attr":{"x":"24","y":"9","width":"20","height":"4"}},{"tag":"rect","attr":{"x":"24","y":"35","width":"20","height":"4"}}]}]})(props);
};
function FcTouchscreenSmartphone (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#E38939","d":"M12,40V8c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H16C13.8,44,12,42.2,12,40z"}},{"tag":"path","attr":{"fill":"#FFF3E0","d":"M32,7H16c-0.6,0-1,0.4-1,1v29c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8C33,7.4,32.6,7,32,7z"}},{"tag":"circle","attr":{"fill":"#A6642A","cx":"24","cy":"41","r":"1.5"}},{"tag":"circle","attr":{"fill":"#E91E63","cx":"24","cy":"23","r":"2"}},{"tag":"circle","attr":{"fill":"none","stroke":"#F48FB1","strokeWidth":"2","strokeMiterlimit":"10","cx":"24","cy":"23","r":"4"}},{"tag":"circle","attr":{"fill":"none","stroke":"#F8BBD0","strokeMiterlimit":"10","cx":"24","cy":"23","r":"6.5"}}]})(props);
};
function FcTrademark (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"circle","attr":{"fill":"#9C27B0","cx":"24","cy":"24","r":"21"}},{"tag":"g","attr":{"fill":"#E1BEE7"},"child":[{"tag":"path","attr":{"d":"M20.6,18.5h-4.2v14.2h-3.5V18.5H8.7v-2.9h11.9V18.5z"}},{"tag":"path","attr":{"d":"M27.1,15.6L30.3,28l3.2-12.4h4.5v17.1h-3.5v-4.6l0.3-7.1l-3.4,11.8h-2.4L25.7,21l0.3,7.1v4.6h-3.5V15.6 H27.1z"}}]}]})(props);
};
function FcTreeStructure (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#90CAF9","points":"36.9,13.8 35.1,10.2 7.5,24 35.1,37.8 36.9,34.2 16.5,24"}},{"tag":"rect","attr":{"x":"6","y":"18","fill":"#D81B60","width":"12","height":"12"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"rect","attr":{"x":"30","y":"6","width":"12","height":"12"}},{"tag":"rect","attr":{"x":"30","y":"30","width":"12","height":"12"}}]}]})(props);
};
function FcTwoSmartphones (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#37474F","d":"M6,36V8c0-2.2,1.8-4,4-4h14c2.2,0,4,1.8,4,4v28c0,2.2-1.8,4-4,4H10C7.8,40,6,38.2,6,36z"}},{"tag":"path","attr":{"fill":"#BBDEFB","d":"M24,7H10C9.4,7,9,7.4,9,8v25c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V8C25,7.4,24.6,7,24,7z"}},{"tag":"rect","attr":{"x":"14","y":"36","fill":"#78909C","width":"6","height":"2"}},{"tag":"path","attr":{"fill":"#E38939","d":"M20,40V12c0-2.2,1.8-4,4-4h14c2.2,0,4,1.8,4,4v28c0,2.2-1.8,4-4,4H24C21.8,44,20,42.2,20,40z"}},{"tag":"path","attr":{"fill":"#FFF3E0","d":"M38,11H24c-0.6,0-1,0.4-1,1v25c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V12C39,11.4,38.6,11,38,11z"}},{"tag":"circle","attr":{"fill":"#A6642A","cx":"31","cy":"41","r":"1.5"}}]})(props);
};
function FcUndo (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#00BCD4"},"child":[{"tag":"polygon","attr":{"points":"5,18 19,6.3 19,29.7"}},{"tag":"path","attr":{"d":"M28,14H16v8h12c2.8,0,5,2.2,5,5s-2.2,5-5,5h-3v8h3c7.2,0,13-5.8,13-13S35.2,14,28,14z"}}]}]})(props);
};
function FcUnlock (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#424242","d":"M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6h4C34,8.5,29.5,4,24,4z"}},{"tag":"path","attr":{"fill":"#FB8C00","d":"M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"}},{"tag":"circle","attr":{"fill":"#C76E00","cx":"24","cy":"31","r":"3"}}]})(props);
};
function FcUpLeft (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"4,19 18,30.7 18,7.3"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M42,27v13h-8V27c0-2.2-1.8-4-4-4H13v-8h17C36.6,15,42,20.4,42,27z"}}]})(props);
};
function FcUpRight (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#3F51B5","points":"44,19 30,30.7 30,7.3"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M6,27v13h8V27c0-2.2,1.8-4,4-4h17v-8H18C11.4,15,6,20.4,6,27z"}},{"tag":"polygon","attr":{"fill":"#3F51B5","points":"44,19 30,30.7 30,7.3"}},{"tag":"path","attr":{"fill":"#3F51B5","d":"M6,27v13h8V27c0-2.2,1.8-4,4-4h17v-8H18C11.4,15,6,20.4,6,27z"}}]})(props);
};
function FcUp (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#3F51B5"},"child":[{"tag":"polygon","attr":{"points":"24,4 35.7,18 12.3,18"}},{"tag":"rect","attr":{"x":"20","y":"15","width":"8","height":"27"}}]}]})(props);
};
function FcUpload (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#009688"},"child":[{"tag":"polygon","attr":{"points":"24,10.9 35,24 13,24"}},{"tag":"rect","attr":{"x":"20","y":"40","width":"8","height":"4"}},{"tag":"rect","attr":{"x":"20","y":"34","width":"8","height":"4"}},{"tag":"rect","attr":{"x":"20","y":"21","width":"8","height":"11"}},{"tag":"rect","attr":{"x":"6","y":"4","width":"36","height":"4"}}]}]})(props);
};
function FcUsb (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#1565C0","d":"M38.701,24.355h-2.189l-0.467,2.265c0,0,2.277,0,2.51,0c0.233,0,1.545-0.167,1.545-1.267\r\n\tC40.1,24.266,38.701,24.355,38.701,24.355z M39.521,20.339h-2.15l-0.374,1.796c0,0,2.161,0,2.337,0c0.188,0,1.113-0.146,1.113-1.006\r\n\tC40.447,20.271,39.521,20.339,39.521,20.339z M44.064,23.109c0,0,1.436-0.743,1.436-3.093c0-3.715-4.377-3.516-4.377-3.516h-2.865\r\n\tl0.674-3c0,0-12.4,0-20.971,0c-9.344,0-12.158,6.774-12.158,6.774L5.736,20.5H2.547l-1.047,6h3.37l0.001,0.143\r\n\tc0,0-0.285,6.857,10.463,6.857c10.747,0,19.042,0,19.042,0l0.679-3c0.84,0,2.2,0,4.389,0c4.729,0,5.591-3.354,5.591-4.9\r\n\tC45.032,23.838,44.064,23.109,44.064,23.109z"}},{"tag":"path","attr":{"fill":"#FFFFFF","d":"M38.701,24.355h-2.189l-0.467,2.265c0,0,2.277,0,2.51,0c0.233,0,1.545-0.167,1.545-1.267\r\n\tC40.1,24.266,38.701,24.355,38.701,24.355z M39.521,20.339h-2.15l-0.374,1.796c0,0,2.161,0,2.337,0c0.188,0,1.113-0.146,1.113-1.006\r\n\tC40.447,20.271,39.521,20.339,39.521,20.339z M14.022,29.5c-5.306,0-5.306-3.624-5.238-3.986c0.069-0.363,1.789-8.014,1.789-8.014\r\n\th3.84l-1.358,6.354c0,0-0.971,2.728,1.251,2.728c2.081,0,2.336-2.535,2.336-2.535l1.465-6.543h3.839l-1.582,6.979\r\n\tC20.365,24.48,20.258,29.5,14.022,29.5z M26.098,29.521c-2.674,0-4.958-1.262-4.856-4.14h3.438c0,0.576,0.086,1.627,1.633,1.627\r\n\tc0.627,0,1.688-0.266,1.688-1.133c0-1.631-5.597-0.785-5.597-4.57c0-2.063,1.899-3.785,4.989-3.785c4.976,0,4.613,3.749,4.613,3.749\r\n\th-3.369c0-1.044-0.664-1.204-1.463-1.204c-0.8,0-1.372,0.343-1.372,0.944c0,1.471,5.634,0.456,5.634,4.531\r\n\tC31.436,27.305,30.012,29.521,26.098,29.521z M39.366,29.5c-0.419,0-7.515,0-7.515,0l2.601-12c0,0,5.444,0,6.556,0\r\n\tc1.113,0,3.43,0.234,3.43,2.542c0,2.602-2.227,3.013-2.227,3.013s1.764,0.407,1.764,2.473C43.975,29.457,39.775,29.5,39.366,29.5z"}}]})(props);
};
function FcVideoCall (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#4CAF50","d":"M8,12h22c2.2,0,4,1.8,4,4v16c0,2.2-1.8,4-4,4H8c-2.2,0-4-1.8-4-4V16C4,13.8,5.8,12,8,12z"}},{"tag":"polygon","attr":{"fill":"#388E3C","points":"44,35 34,29 34,19 44,13"}}]})(props);
};
function FcVideoFile (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"polygon","attr":{"fill":"#90CAF9","points":"40,45 8,45 8,3 30,3 40,13"}},{"tag":"polygon","attr":{"fill":"#E1F5FE","points":"38.5,14 29,14 29,4.5"}},{"tag":"polygon","attr":{"fill":"#1976D2","points":"30,28 20,22 20,34"}}]})(props);
};
function FcVideoProjector (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{"fill":"#546E7A"},"child":[{"tag":"rect","attr":{"x":"5","y":"34","width":"6","height":"3"}},{"tag":"rect","attr":{"x":"37","y":"34","width":"6","height":"3"}}]},{"tag":"path","attr":{"fill":"#78909C","d":"M44,35H4c-2.2,0-4-1.8-4-4V17c0-2.2,1.8-4,4-4h40c2.2,0,4,1.8,4,4v14C48,33.2,46.2,35,44,35z"}},{"tag":"g","attr":{"fill":"#37474F"},"child":[{"tag":"rect","attr":{"x":"5","y":"19","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"5","y":"23","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"5","y":"27","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"9","y":"19","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"9","y":"23","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"9","y":"27","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"13","y":"19","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"13","y":"23","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"13","y":"27","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"17","y":"19","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"17","y":"23","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"17","y":"27","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"21","y":"19","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"21","y":"23","width":"2","height":"2"}},{"tag":"rect","attr":{"x":"21","y":"27","width":"2","height":"2"}}]},{"tag":"circle","attr":{"fill":"#37474F","cx":"37","cy":"24","r":"8"}},{"tag":"circle","attr":{"fill":"#a0f","cx":"37","cy":"24","r":"6"}},{"tag":"path","attr":{"fill":"#EA80FC","d":"M40.7,21.7c-1-1.1-2.3-1.7-3.7-1.7s-2.8,0.6-3.7,1.7c-0.4,0.4-0.3,1,0.1,1.4c0.4,0.4,1,0.3,1.4-0.1 c1.2-1.3,3.3-1.3,4.5,0c0.2,0.2,0.5,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3C41.1,22.7,41.1,22.1,40.7,21.7z"}}]})(props);
};
function FcViewDetails (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"7","y":"4","fill":"#BBDEFB","width":"34","height":"40"}},{"tag":"g","attr":{"fill":"#2196F3"},"child":[{"tag":"rect","attr":{"x":"13","y":"26","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"13","y":"18","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"13","y":"34","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"13","y":"10","width":"4","height":"4"}},{"tag":"rect","attr":{"x":"21","y":"26","width":"14","height":"4"}},{"tag":"rect","attr":{"x":"21","y":"18","width":"14","height":"4"}},{"tag":"rect","attr":{"x":"21","y":"34","width":"14","height":"4"}},{"tag":"rect","attr":{"x":"21","y":"10","width":"14","height":"4"}}]}]})(props);
};
function FcVip (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#880E4F","d":"M38,43H10c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v28C42,41.2,40.2,43,38,43z"}},{"tag":"g","attr":{"fill":"#FFD54F"},"child":[{"tag":"path","attr":{"d":"M15.9,28l2.1-9.1h2.8l-3.6,12.6h-2.6L11,18.9h2.8L15.9,28z"}},{"tag":"path","attr":{"d":"M25.6,31.5h-2.5V18.9h2.5V31.5z"}},{"tag":"path","attr":{"d":"M31.2,27.1v4.4h-2.5V18.9h4.3c3.7,0,4.1,3.4,4.1,4.2c0,1.2-0.5,4-4.1,4H31.2z M31.2,24.9h1.7 c1.3,0,1.5-1.1,1.5-1.9c0-1.6-0.9-2.1-1.5-2.1h-1.7V24.9z"}}]}]})(props);
};
function FcVlc (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#F57C00","d":"M36.258,28.837c0,0-0.11-0.837-1.257-0.837c-0.216,0-2.392,0-3.719,0c0.798,2.671,1.497,5.135,1.497,5.279\r\n\tc0,2.387-3.401,3.393-8.917,3.393c-5.515,0-8.651-0.94-8.651-3.326c0-0.167,0.998-2.692,1.791-5.346c-1.591,0-3.863,0-4.063,0\r\n\tc-0.806,0-0.937,0.749-0.937,0.749L8.159,40.986L8.815,42h30.652l0.376-1.014L36.258,28.837z"}},{"tag":"path","attr":{"fill":"#E0E0E0","d":"M24.001,6c-1.029,0-1.864,0.179-1.864,0.398c-0.492,1.483-8.122,26.143-8.122,26.774\r\n\tc0,2.388,4.471,3.827,9.985,3.827s9.986-1.439,9.986-3.827c0-0.549-7.614-25.268-8.122-26.774C25.865,6.179,25.031,6,24.001,6\r\n\tL24.001,6z"}},{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#FF9800","d":"M33.196,30.447C32.032,32.232,28.341,34,24.046,34c-4.34,0-8.156-1.696-9.281-3.51\r\n\t\tc-0.499,1.483-0.892,2.647-0.892,3.28c0,2.386,4.533,4.229,10.128,4.229c5.595,0,10.131-1.844,10.131-4.229\r\n\t\tC34.132,33.222,33.713,31.955,33.196,30.447z"}},{"tag":"path","attr":{"fill":"#FF9800","d":"M31.387,24.314l-2.074-6.794c0,0-1.857,1.479-5.311,1.479c-3.453,0-5.316-1.479-5.316-1.479l-2.081,6.806\r\n\t\tc0,0,2.068,2.674,7.397,2.674C29.375,27,31.387,24.314,31.387,24.314z"}},{"tag":"path","attr":{"fill":"#FF9800","d":"M27.241,10.809l-1.376-4.41c0,0-0.083-0.398-1.864-0.398c-1.844,0-1.864,0.398-1.864,0.398l-1.376,4.407\r\n\t\tc0,0,0.885,1.194,3.239,1.194C26.355,12,27.241,10.809,27.241,10.809z"}}]}]})(props);
};
function FcVoicePresentation (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#2196F3","d":"M40,22h-8l-4,4V12c0-2.2,1.8-4,4-4h8c2.2,0,4,1.8,4,4v6C44,20.2,42.2,22,40,22z"}},{"tag":"circle","attr":{"fill":"#FFA726","cx":"17","cy":"19","r":"8"}},{"tag":"path","attr":{"fill":"#607D8B","d":"M30,36.7c0,0-3.6-6.7-13-6.7S4,36.7,4,36.7V40h26V36.7z"}}]})(props);
};
function FcVoicemail (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#4CAF50","d":"M48,24c0-6.1-4.9-11-11-11s-11,4.9-11,11c0,2.7,0.9,5.1,2.5,7h-9c1.6-1.9,2.5-4.3,2.5-7c0-6.1-4.9-11-11-11 S0,17.9,0,24s4.9,11,11,11h27v-0.1C43.6,34.4,48,29.7,48,24z M4,24c0-3.9,3.1-7,7-7s7,3.1,7,7s-3.1,7-7,7S4,27.9,4,24z M37,31 c-3.9,0-7-3.1-7-7s3.1-7,7-7c3.9,0,7,3.1,7,7S40.9,31,37,31z"}}]})(props);
};
function FcWebcam (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#455A64","d":"M36.5,44H11.5c-1.1,0-1.8-1.2-1.3-2.2L13,37h22l2.7,4.8C38.3,42.8,37.6,44,36.5,44z"}},{"tag":"circle","attr":{"fill":"#78909C","cx":"24","cy":"23","r":"18"}},{"tag":"path","attr":{"fill":"#455A64","d":"M24,35c-6.6,0-12-5.4-12-12c0-6.6,5.4-12,12-12s12,5.4,12,12C36,29.6,30.6,35,24,35z"}},{"tag":"circle","attr":{"fill":"#42A5F5","cx":"24","cy":"23","r":"9"}},{"tag":"path","attr":{"fill":"#90CAF9","d":"M28.8,20c-1.2-1.4-3-2.2-4.8-2.2s-3.6,0.8-4.8,2.2c-0.5,0.5-0.4,1.3,0.1,1.8c0.5,0.5,1.3,0.4,1.8-0.1 c1.5-1.7,4.3-1.7,5.8,0c0.3,0.3,0.6,0.4,1,0.4c0.3,0,0.6-0.1,0.9-0.3C29.2,21.4,29.3,20.5,28.8,20z"}}]})(props);
};
function FcWiFiLogo (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"fill":"#3F51B5","d":"M46,26.48c0,4.527-3.268,7.52-7.3,7.52H9.299C5.269,34,2,30.634,2,26.48V21.52C2,17.366,5.269,14,9.299,14\r\n\t\tH38.7c4.032,0,7.3,3.366,7.3,7.52V26.48z"}},{"tag":"ellipse","attr":{"fill":"#3F51B5","cx":"24","cy":"24","rx":"14.902","ry":"15"}}]},{"tag":"g","attr":{},"child":[{"tag":"polygon","attr":{"fill":"#FFFFFF","points":"17,19 14.264,19 13.427,24.859 12.388,19.028 9.93,19.028 8.864,24.859 8.054,19.028 5.266,19.028 \r\n\t\t7.597,29 10.056,29 11.12,22.854 12.209,29 14.693,29 \t"}},{"tag":"rect","attr":{"x":"19","y":"22","fill":"#FFFFFF","width":"2.508","height":"7"}},{"tag":"path","attr":{"fill":"#FFFFFF","d":"M21.5,19.747C21.5,20.44,20.94,21,20.25,21S19,20.44,19,19.747c0-0.696,0.56-1.258,1.25-1.258\r\n\t\tS21.5,19.051,21.5,19.747z"}},{"tag":"path","attr":{"fill":"#FFFFFF","d":"M38.561,16c-4.818,0-7.979,0-7.979,0S25,16.193,25,21.914v4.336c0,0,0.101,2.941-3,5.75h16.785\r\n\t\tc0,0,5.215,0,5.215-5.553c0-4.879,0-4.879,0-4.879S43.772,16,38.561,16z M37.339,21.369h-5.651v2.236h5.094v2.344h-5.094V29H29V19\r\n\t\th8.339V21.369z M40.25,18.489c0.689,0,1.25,0.562,1.25,1.258C41.5,20.44,40.939,21,40.25,21S39,20.44,39,19.747\r\n\t\tC39,19.051,39.561,18.489,40.25,18.489z M41.508,29H39v-7h2.508V29z"}}]}]})(props);
};
function FcWikipedia (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#CFD8DC","d":"M6,10c0-2.209,1.791-4,4-4h28c2.209,0,4,1.791,4,4v28c0,2.209-1.791,4-4,4H10c-2.209,0-4-1.791-4-4V10z"}},{"tag":"path","attr":{"fill":"#37474F","d":"M39,17.271c0,0.191-0.148,0.349-0.334,0.349h-1.799l-8.164,18.179c-0.052,0.12-0.17,0.2-0.297,0.202h-0.004\r\n\tc-0.127,0-0.242-0.074-0.298-0.193l-3.874-8.039l-4.18,8.049c-0.06,0.116-0.167,0.181-0.303,0.184\r\n\tc-0.125-0.004-0.239-0.082-0.292-0.199l-8.252-18.182h-1.87C9.149,17.619,9,17.462,9,17.271V16.35C9,16.155,9.149,16,9.333,16h6.657\r\n\tc0.184,0,0.333,0.155,0.333,0.35v0.921c0,0.191-0.149,0.349-0.333,0.349h-1.433l5.696,13.748l2.964-5.793l-3.757-7.953h-0.904\r\n\tc-0.184,0-0.333-0.157-0.333-0.35V16.35c0-0.191,0.149-0.348,0.333-0.348h4.924c0.184,0,0.333,0.156,0.333,0.348v0.922\r\n\tc0,0.192-0.149,0.35-0.333,0.35h-0.867l2.162,4.948l2.572-4.948H25.77c-0.187,0-0.334-0.157-0.334-0.35V16.35\r\n\tc0-0.191,0.147-0.348,0.334-0.348h4.784c0.187,0,0.333,0.156,0.333,0.348v0.922c0,0.192-0.146,0.35-0.333,0.35h-1.05l-3.757,7.141\r\n\tl3.063,6.584l5.905-13.725h-1.872c-0.184,0-0.334-0.157-0.334-0.35V16.35c0-0.191,0.15-0.348,0.334-0.348h5.822\r\n\tc0.186,0,0.334,0.156,0.334,0.348V17.271z"}}]})(props);
};
function FcWorkflow (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["GenIcon"])({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"rect","attr":{"x":"7","y":"31","fill":"#00BCD4","width":"10","height":"10"}},{"tag":"path","attr":{"fill":"#00BCD4","d":"M35.3,19.3l-5.6-5.6c-0.4-0.4-0.4-1,0-1.4l5.6-5.6c0.4-0.4,1-0.4,1.4,0l5.6,5.6c0.4,0.4,0.4,1,0,1.4 l-5.6,5.6C36.3,19.7,35.7,19.7,35.3,19.3z"}},{"tag":"circle","attr":{"fill":"#3F51B5","cx":"12","cy":"13","r":"6"}},{"tag":"circle","attr":{"fill":"#448AFF","cx":"36","cy":"36","r":"6"}},{"tag":"g","attr":{"fill":"#90A4AE"},"child":[{"tag":"rect","attr":{"x":"11","y":"24","width":"2","height":"5"}},{"tag":"polygon","attr":{"points":"12,21 9,25 15,25"}}]},{"tag":"g","attr":{"fill":"#90A4AE"},"child":[{"tag":"rect","attr":{"x":"20","y":"12","width":"5","height":"2"}},{"tag":"polygon","attr":{"points":"28,13 24,10 24,16"}}]},{"tag":"g","attr":{"fill":"#90A4AE"},"child":[{"tag":"rect","attr":{"x":"35","y":"21","width":"2","height":"5"}},{"tag":"polygon","attr":{"points":"36,29 39,25 33,25"}}]}]})(props);
};


/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactChartjs = __webpack_require__(559);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _CHART_SIZE = 175;

var Balance = function (_Component) {
    _inherits(Balance, _Component);

    function Balance(props) {
        _classCallCheck(this, Balance);

        var _this = _possibleConstructorReturn(this, (Balance.__proto__ || Object.getPrototypeOf(Balance)).call(this, props));

        _this.state = {
            selectedCartTotal: 0,
            hasOverspentForSelected: false
        };
        return _this;
    }

    _createClass(Balance, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.editCart) {
                if (this.state.selectedCartTotal !== this.props.cartTotal || this.state.hasOverspentForSelected !== this.props.hasOverspent) {
                    this.setState({ selectedCartTotal: this.props.cartTotal, hasOverspentForSelected: this.props.hasOverspent });
                }
            } else {
                if (this.state.selectedCartTotal !== this.props.tempCartTotal || this.state.hasOverspentForSelected !== this.props.hasTempCartOverspent) {
                    this.setState({ selectedCartTotal: this.props.tempCartTotal, hasOverspentForSelected: this.props.hasTempCartOverspent });
                }
            }
        }
    }, {
        key: '_getRemainingBalance',
        value: function _getRemainingBalance() {
            return this.props.offerBalance - this.state.selectedCartTotal - (this.props.editCart ? 0 : this.props.cartTotal);
        }
    }, {
        key: '_getErrorChartData',
        value: function _getErrorChartData() {
            return {
                datasets: [{
                    data: [this.props.offerBalance],
                    backgroundColor: ['#c00'],
                    hoverBackgroundColor: ['#c00']
                }]
            };
        }
    }, {
        key: '_getValidCartData',
        value: function _getValidCartData() {
            return {
                datasets: [{
                    data: [this.state.selectedCartTotal, this._getRemainingBalance()],
                    backgroundColor: ['#4b8edb', '#e1eef5'],
                    hoverBackgroundColor: ['#5cb85c', '#3d434b']
                }],
                labels: [_strings2.default.creditsUtilized, _strings2.default.availableCredits]
            };
        }
    }, {
        key: '_getChartData',
        value: function _getChartData() {
            if (this.state.hasOverspentForSelected) {
                return this._getErrorChartData();
            }
            return this._getValidCartData();
        }
    }, {
        key: '_getTotalClasses',
        value: function _getTotalClasses() {
            if (this.state.hasOverspentForSelected) {
                return 'text-danger';
            }
            return 'text-info';
        }
    }, {
        key: '_getBalanceClasses',
        value: function _getBalanceClasses() {
            var base = 'text-muted text-sm text-uppercase text-dark';
            if (this.state.hasOverspentForSelected) {
                return base + ' text-danger';
            }
            return base;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'p-a-md balance-indicator' },
                _react2.default.createElement(
                    'h2',
                    { className: 'text-md text-uppercase text-dark' },
                    _strings2.default.credits
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'chart-doughnut-container m-b' },
                    _react2.default.createElement(
                        'div',
                        { className: 'chart-doughnut-middle text-sm is-fadedin' },
                        _react2.default.createElement(
                            'div',
                            { className: 'display-2', style: { marginBottom: -5 } },
                            _react2.default.createElement(
                                'b',
                                { className: this._getTotalClasses() },
                                _utils2.default.formatPrice(this.state.selectedCartTotal)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: this._getBalanceClasses() },
                            _utils2.default.formatPrice(this._getRemainingBalance()),
                            ' ',
                            _strings2.default.available
                        )
                    ),
                    _react2.default.createElement(_reactChartjs.Doughnut, {
                        id: 'chart-doughnut',
                        className: 'chart-doughnut',
                        width: _CHART_SIZE,
                        height: _CHART_SIZE,
                        options: {
                            responsive: false,
                            cutoutPercentage: 85,
                            legend: {
                                display: false
                            },
                            animationSteps: 60,
                            animateScale: false,
                            showTooltips: false
                        },
                        data: this._getChartData()
                    })
                )
            );
        }
    }]);

    return Balance;
}(_react.Component);

Balance.propTypes = {
    offerBalance: _propTypes2.default.number.isRequired,
    cartTotal: _propTypes2.default.number.isRequired,
    hasOverspent: _propTypes2.default.bool.isRequired,
    tempCartTotal: _propTypes2.default.number.isRequired,
    hasTempCartOverspent: _propTypes2.default.bool.isRequired,
    editCart: _propTypes2.default.bool.isRequired
};

Balance.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        offerBalance: _selectors2.default.offer.getSelectedBalance,
        cartTotal: _selectors2.default.cart.getTotal,
        hasOverspent: _selectors2.default.cart.hasOverspent,
        tempCartTotal: _selectors2.default.cart.getTempCartTotal,
        hasTempCartOverspent: _selectors2.default.cart.hasTempCartOverspent
    });
};

exports.default = (0, _ReduxStore.attach)(Balance);

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ReduxTools = __webpack_require__(11);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

var _offer = __webpack_require__(113);

var _offer2 = _interopRequireDefault(_offer);

var _sites = __webpack_require__(114);

var _sites2 = _interopRequireDefault(_sites);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserActions = function UserActions() {
    _classCallCheck(this, UserActions);
};

UserActions.types = (0, _ReduxTools.actionsFromList)(['RECEIVED_USER_SUMMARIES', 'REQUESTING_USER_SUMMARIES', 'RECEIVED_USER', 'REQUESTED_SPOOF', 'REQUESTING_SPOOF', 'REQUESTING_USER', 'UPDATED_PREFERENCES', 'UPDATE_MAP_USERNAME', 'UPDATING_PREFERENCES', 'USERNAME_LOOKUP_FINISHED', 'USERNAME_LOOKUP_RESET', 'USERNAME_LOOKUP_STARTED']);

UserActions.requestingUser = function () {
    return {
        type: UserActions.types.REQUESTING_USER
    };
};

UserActions.receivedUser = function (response) {
    return {
        type: UserActions.types.RECEIVED_USER,
        payload: { response: response.data }
    };
};

UserActions.updatingPreferences = function () {
    return {
        type: UserActions.types.UPDATING_PREFERENCES
    };
};

UserActions.updatedPreferences = function (response) {
    return {
        type: UserActions.types.UPDATED_PREFERENCES,
        payload: { response: response.data }
    };
};

UserActions.updateMapUsername = function (value) {
    return {
        type: UserActions.types.UPDATE_MAP_USERNAME,
        payload: { value: value }
    };
};

UserActions.usernameLookupStarted = function () {
    return {
        type: UserActions.types.USERNAME_LOOKUP_STARTED
    };
};

UserActions.usernameLookupFinished = function () {
    return {
        type: UserActions.types.USERNAME_LOOKUP_FINISHED
    };
};

UserActions.usernameLookupReset = function () {
    return {
        type: UserActions.types.USERNAME_LOOKUP_RESET
    };
};

UserActions.requestingSummaries = function () {
    return {
        type: UserActions.types.REQUESTING_USER_SUMMARIES
    };
};

UserActions.receivedSummaries = function (summaries) {
    return {
        type: UserActions.types.RECEIVED_USER_SUMMARIES,
        payload: { summaries: summaries }
    };
};

UserActions.requestingSpoof = function (userId) {
    return {
        type: UserActions.types.REQUESTING_SPOOF,
        payload: { userId: userId }
    };
};

UserActions.requestedSpoof = function () {
    return { type: UserActions.types.REQUESTED_SPOOF };
};

UserActions.requestUser = function () {
    return function (dispatch, getState) {
        dispatch(UserActions.requestingUser());

        getState().api.getMyUser().then(function (response) {
            return dispatch(UserActions.receivedUser(response));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

UserActions.updatePreferences = function (preferences) {
    return function (dispatch, getState) {
        dispatch(UserActions.updatingPreferences());

        getState().api.updateMyPreferences(preferences).then(function (response) {
            return dispatch(UserActions.updatedPreferences(response));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

UserActions.updateFavorites = function (offer, site, server) {
    return function (dispatch) {
        dispatch(UserActions.updatePreferences(_defineProperty({}, 'favorites' + offer.mentorId, {
            site: site.id,
            server: server.id
        })));
    };
};

UserActions.updateServerAlias = function (server, alias) {
    return function (dispatch) {
        dispatch(UserActions.updatePreferences({
            serverAliases: _defineProperty({}, server.id, alias)
        }));
    };
};

UserActions.lookupMapUsername = function (username) {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(UserActions.usernameLookupStarted());

        state.api.usernameLookup(username).then(function () {
            return dispatch(UserActions.usernameLookupFinished());
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

UserActions.fetchSummaries = function () {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(UserActions.requestingSummaries());

        state.api.getUserSummaries().then(function (response) {
            return dispatch(UserActions.receivedSummaries(response.data.users));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

UserActions.spoofUser = function (userId) {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(UserActions.requestingSpoof(userId));

        state.api.spoofUser(userId).then(function () {
            return Promise.all([state.api.getMyUser(), state.api.getMyOffers()]);
        }).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                user = _ref2[0],
                offers = _ref2[1];

            dispatch(UserActions.receivedUser(user));
            dispatch(_offer2.default.receivedOffers(offers));
            // when spoofed trying to fetch the user sites of the spoofed user for adding host / server.              
            dispatch(_sites2.default.fetchSitesForUserAccount());
            dispatch(_cart2.default.setItems());
        }).then(function () {
            return dispatch(UserActions.requestedSpoof());
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

UserActions.endSpoof = function () {
    return UserActions.spoofUser(null);
};

exports.default = UserActions;

/***/ }),

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelectPlus = __webpack_require__(92);

var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);

var _reactComponents = __webpack_require__(35);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductSelector = function (_Component) {
    _inherits(ProductSelector, _Component);

    function ProductSelector() {
        _classCallCheck(this, ProductSelector);

        return _possibleConstructorReturn(this, (ProductSelector.__proto__ || Object.getPrototypeOf(ProductSelector)).call(this));
    }

    _createClass(ProductSelector, [{
        key: '_handleButtonClick',
        value: function _handleButtonClick() {
            this.props.addProductToCart(this.props.selectedProductIndex);
            this.props.selectProduct(-1);
        }
    }, {
        key: '_handleProductSelect',
        value: function _handleProductSelect(option) {
            if (!option) {
                this.props.selectProduct(-1);
            } else {
                this.props.selectProduct(option.value);
            }
        }
    }, {
        key: '_renderOption',
        value: function _renderOption(option) {
            return _react2.default.createElement(
                'span',
                null,
                option.product.name,
                _react2.default.createElement(
                    'small',
                    { className: 'text-mute' },
                    ' #',
                    option.product.mentorId
                )
            );
        }
    }, {
        key: '_getOptions',
        value: function _getOptions() {
            if (!this.props.offer || !this.props.offer.pricing) {
                return [];
            }

            return this.props.offer.pricing.map(function (item, index) {
                return {
                    label: item.product.name + ' #' + item.product.mentorId,
                    product: item.product,
                    value: index
                };
            });
        }
    }, {
        key: '_getSelectedOption',
        value: function _getSelectedOption() {
            if (this._isButtonDisabled()) {
                return -1;
            }

            return this.props.selectedProductIndex;
        }
    }, {
        key: '_isButtonDisabled',
        value: function _isButtonDisabled() {
            return !this.props.offer || this.props.selectedProductIndex === -1;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'card raised-sm border-none product-selector' },
                _react2.default.createElement(
                    'div',
                    { className: 'card-header card-header-success text-inverse' },
                    _react2.default.createElement(
                        'b',
                        null,
                        _strings2.default.chooseAProduct
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card-block' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group' },
                        _react2.default.createElement(
                            'div',
                            { id: 'product-select', className: '' },
                            _react2.default.createElement(_reactSelectPlus2.default, {
                                multi: false,
                                placeholder: _strings2.default.selectAProduct + '...',
                                clearable: !this._isButtonDisabled(),
                                value: this._getSelectedOption(),
                                options: this._getOptions(),
                                onChange: function onChange(s) {
                                    return _this2._handleProductSelect(s);
                                },
                                valueRenderer: function valueRenderer(o) {
                                    return _this2._renderOption(o);
                                },
                                optionRenderer: function optionRenderer(o) {
                                    return _this2._renderOption(o);
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'input-group-btn' },
                            _react2.default.createElement(
                                'button',
                                {
                                    onClick: function onClick() {
                                        return _this2._handleButtonClick();
                                    },
                                    disabled: this._isButtonDisabled(),
                                    className: 'btn btn-success btn-lg btn-block configure-button'
                                },
                                _react2.default.createElement(_reactComponents.Icon, { name: 'icon-cog3' }),
                                ' ',
                                _strings2.default.configureThisProduct
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ProductSelector;
}(_react.Component);

ProductSelector.propTypes = {
    offer: _MapPropTypes2.default.OfferProps,
    selectedProductIndex: _propTypes2.default.number.isRequired,

    selectProduct: _propTypes2.default.func.isRequired,
    addProductToCart: _propTypes2.default.func.isRequired
};
exports.default = ProductSelector;

/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _reactSelectPlus = __webpack_require__(92);

var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);

var _reactComponents = __webpack_require__(35);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__(262);

var _format = __webpack_require__(224);

var format = _interopRequireWildcard(_format);

var _AlertToggle = __webpack_require__(1127);

var _AlertToggle2 = _interopRequireDefault(_AlertToggle);

var _sites = __webpack_require__(114);

var _sites2 = _interopRequireDefault(_sites);

var _reactBootstrap = __webpack_require__(64);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddHostServer = function (_Component) {
    _inherits(AddHostServer, _Component);

    function AddHostServer(props) {
        _classCallCheck(this, AddHostServer);

        var _this = _possibleConstructorReturn(this, (AddHostServer.__proto__ || Object.getPrototypeOf(AddHostServer)).call(this, props));

        _this.state = {
            disabled: true,
            serverInput: '',
            hostInput: '',
            cleared: false
        };
        return _this;
    }

    // constructor() {
    //     super();
    //     this._closeAlert = this._closeAlert.bind(this);
    // }

    _createClass(AddHostServer, [{
        key: '_handleSiteSelection',
        value: function _handleSiteSelection(option) {
            if (!option) {
                this.props.selectSite(-1);
            } else {
                this.props.selectSite(option.value);
                this.setState({ disabled: false });
            }
        }
    }, {
        key: '_handleOnServerIdChanged',
        value: function _handleOnServerIdChanged(value) {
            this.props.setServerId(value);
            this.setState({ disabled: this._isButtonDisabled(), serverInput: value });
        }
    }, {
        key: '_handleOnHostIdChange',
        value: function _handleOnHostIdChange(value) {
            this.props.setHostId(value);
            this.setState({ disabled: this._isButtonDisabled(), hostInput: value });
        }
    }, {
        key: '_renderOption',
        value: function _renderOption(option) {
            return _react2.default.createElement(
                'span',
                null,
                option.value,
                _react2.default.createElement(
                    'small',
                    { className: 'text-mute' },
                    ' #',
                    option.label
                )
            );
        }
    }, {
        key: '_getSiteOptions',
        value: function _getSiteOptions() {
            if (!this.props.sites) {
                return [];
            }

            return this.props.sites.map(function (site, i) {
                return {
                    label: format.siteLabel(site),
                    value: site.mentorId
                };
            });
        }
    }, {
        key: '_getSelectedOption',
        value: function _getSelectedOption() {
            if (this._isButtonDisabled()) {
                return -1;
            }

            return this.props.selectedSiteId;
        }
    }, {
        key: '_isButtonDisabled',
        value: function _isButtonDisabled() {
            var disabled = false;
            if (this.props.selectedSiteId == -1 || this.props.selectedSiteId == '') {
                disabled = true;
            }
            return disabled;
        }
    }, {
        key: '_getInputClasses',
        value: function _getInputClasses(field_type) {
            var classes = [];

            if (field_type !== 'select' && field_type !== 'checkbox') {
                classes.push('form-control');
            }

            if (field_type === 'date') {
                classes.push('datepicker');
                classes.push('flatpickr-input');
            }

            if (this.props.hasError) {
                classes.push('form-control-error');
            } else if (this.props.isChanged) {
                classes.push('form-control-success');
            }

            return classes.join(' ');
        }
    }, {
        key: '_handleAddServerHostButtonClick',
        value: function _handleAddServerHostButtonClick() {
            if (this.props.showAlert == true) {
                this.props.showAlertToggle(false);
            }

            if (
            /*If site is selected*/
            this.props.selectedSiteId != -1 && this.props.selectedSiteId != '' && this.props.hostId != '' && this.props.serverId != '') {
                this.setState({ disabled: true, cleared: false });
                this.props.handleAddServerHostButtonClick(this.props.selectedSiteId, this.props.hostId, this.props.serverId, this.props.offer.id);
            } else if (
            /*If site is selected*/
            this.props.selectedSiteId != -1 && this.props.selectedSiteId != '') {
                /*If both host and server are not selected/empty */
                if (this.props.hostId == '' && this.props.serverId == '') {
                    this.props.setErrorMessage(_strings2.default.serverOrHostRequired, _strings2.default.danger);
                    this.props.showAlertToggle(true);
                } else if (this.props.hostId != '' || this.props.serverId != '') {
                    this.setState({ disabled: true, cleared: false });
                    this.props.handleAddServerHostButtonClick(this.props.selectedSiteId, this.props.hostId, this.props.serverId, this.props.offer.id);
                }
            } else if (
            /* If site is not selected*/
            this.props.selectedSiteId == -1 || this.props.selectedSiteId == '') {
                this.props.setErrorMessage(_strings2.default.siteIdRequired, _strings2.default.danger);
                this.props.showAlertToggle(true);
            }
        }
    }, {
        key: '_closeAlert',
        value: function _closeAlert() {
            if (this.props.showAlert == true) {
                this.props.showAlertToggle(false);
            }
        }
    }, {
        key: '_renderTab',
        value: function _renderTab(tab) {
            var _this2 = this;

            return _react2.default.createElement(
                'li',
                { className: 'nav-item text-sm', key: String(Math.random()) },
                _react2.default.createElement(
                    'a',
                    { role: 'tab', onClick: function onClick() {
                            return _this2._handleClick(true);
                        } },
                    'Super'
                )
            );
        }
    }, {
        key: '_checkAlert',
        value: function _checkAlert() {
            if (this.props.showAlert && !this.state.cleared && this.props.toggleMessage.message === '["Server / Host successfully added to the site"]') {
                this.setState({ serverInput: '', hostInput: '', cleared: true });
                this.props.setServerId('');
                this.props.setHostId('');
            }
            return this.props.toggleMessage;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'card raised-sm border-none product-selector' },
                _react2.default.createElement(
                    'div',
                    { className: 'card-header card-header-info text-inverse' },
                    _react2.default.createElement(
                        'b',
                        null,
                        _strings2.default.addHostServer
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card-block' },
                    _react2.default.createElement(
                        _reactBootstrap.Grid,
                        null,
                        _react2.default.createElement(
                            _reactBootstrap.Row,
                            null,
                            _react2.default.createElement(_AlertToggle2.default, {
                                showAlert: this.props.showAlert,
                                bStyleClass: this.props.bStyleClass,
                                message: this._checkAlert(),
                                closeAlert: this.props.showAlertToggle
                            })
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.Row,
                            { className: 'show-grid' },
                            _react2.default.createElement(
                                _reactBootstrap.Col,
                                { xs: 7, md: 5 },
                                _react2.default.createElement(
                                    'div',
                                    { className: '' },
                                    _react2.default.createElement(_reactSelectPlus2.default, {
                                        multi: false,
                                        placeholder: _strings2.default.selectSiteForNewServer + '...',
                                        clearable: !this._isButtonDisabled(),
                                        value: this._getSelectedOption(),
                                        options: this._getSiteOptions(),
                                        onChange: function onChange(s) {
                                            return _this3._handleSiteSelection(s);
                                        },
                                        valueRenderer: function valueRenderer(o) {
                                            return _this3._renderOption(o);
                                        },
                                        optionRenderer: function optionRenderer(o) {
                                            return _this3._renderOption(o);
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                _reactBootstrap.Col,
                                { xs: 6, md: 4 },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement('input', {
                                        id: 'host_id',
                                        type: 'text',
                                        placeholder: 'Enter a Host Name',
                                        value: this.state.hostInput,
                                        className: this._getInputClasses('text'),
                                        onChange: function onChange(val) {
                                            return _this3._handleOnHostIdChange(val.target.value.trim());
                                        }
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                _reactBootstrap.Col,
                                { xs: 3, md: 3 },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement('input', {
                                        id: 'server_id',
                                        type: 'text',
                                        placeholder: 'Enter a Host ID',
                                        className: this._getInputClasses(),
                                        value: this.state.serverInput,
                                        onChange: function onChange(val) {
                                            return _this3._handleOnServerIdChanged(val.target.value.trim());
                                        }
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            '\xA0'
                        ),
                        _react2.default.createElement(
                            _reactBootstrap.Row,
                            { className: 'show-grid' },
                            _react2.default.createElement(
                                _reactBootstrap.Col,
                                { xs: 2, xsOffset: 10 },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-group-btn' },
                                    _react2.default.createElement(
                                        'button',
                                        {
                                            onClick: function onClick() {
                                                return _this3._handleAddServerHostButtonClick();
                                            }
                                            // onClick={() => this._handleClick(true)}
                                            , disabled: this.state.disabled,
                                            className: 'btn btn-primary btn-lg btn-block configure-button'
                                        },
                                        _strings2.default.submit
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AddHostServer;
}(_react.Component);

AddHostServer.propTypes = {
    sites: _propTypes2.default.arrayOf(_propTypes2.default.object),
    selectedSite: _propTypes2.default.object,
    selectedSiteId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    selectSite: _propTypes2.default.func.isRequired,
    showAlertToggle: _propTypes2.default.func
    // showAlert: PropTypes.bool,
    // serverId: PropTypes.string,
    // hostId: PropTypes.string,
};

AddHostServer.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        // site
        showAlert: _selectors2.default.sites.showAlert,
        serverId: _selectors2.default.sites.getServerId,
        hostId: _selectors2.default.sites.getHostId,
        toggleMessage: _selectors2.default.sites.getAlertMessage,
        offer: _selectors2.default.offer.getSelectedOffer
    });
};

AddHostServer.mapDispatch = function (dispatch) {
    return {
        showAlertToggle: function showAlertToggle(boolValue) {
            return dispatch(_sites2.default.showAlert(boolValue));
        },
        setServerId: function setServerId(serverId) {
            return dispatch(_sites2.default.setServerId(serverId));
        },
        setHostId: function setHostId(hostId) {
            return dispatch(_sites2.default.setHostId(hostId));
        },
        setErrorMessage: function setErrorMessage(message, errorType) {
            return dispatch(_sites2.default.setErrorMessage(message, errorType));
        },
        handleAddServerHostButtonClick: function handleAddServerHostButtonClick(siteId, hostId, serverId, offerId) {
            return dispatch(_sites2.default.validateThroughLightHouseAPI(siteId, hostId != '' ? hostId : null, serverId != '' ? serverId : null, offerId));
        }
    };
};

exports.default = (0, _ReduxStore.attach)(AddHostServer);

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(64);

var _reactSelectPlus = __webpack_require__(92);

var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);

var _reactComponents = __webpack_require__(35);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__(262);

var _format = __webpack_require__(224);

var format = _interopRequireWildcard(_format);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertToggle = function (_Component) {
    _inherits(AlertToggle, _Component);

    function AlertToggle() {
        _classCallCheck(this, AlertToggle);

        return _possibleConstructorReturn(this, (AlertToggle.__proto__ || Object.getPrototypeOf(AlertToggle)).call(this));
    }

    _createClass(AlertToggle, [{
        key: '_isJsonString',
        value: function _isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }
    }, {
        key: '_handleAlertToggleClose',
        value: function _handleAlertToggleClose(bool_val) {
            this.props.closeAlert(bool_val);
        }
    }, {
        key: '_buildErrorMessageBlock',
        value: function _buildErrorMessageBlock(message) {
            return _react2.default.createElement(
                'ul',
                null,
                message.map(function (item, index) {
                    return _react2.default.createElement(
                        'li',
                        { key: index },
                        item.errorMessage != undefined ? item.errorMessage : item
                    );
                })
            );
        }
    }, {
        key: '_renderMessage',
        value: function _renderMessage(messageObj) {
            if (this._isJsonString(messageObj.message)) {
                {
                    return this._buildErrorMessageBlock(JSON.parse(messageObj.message));
                }
            } else {
                return messageObj.message;
            }
        }
    }, {
        key: '_renderbStyleClass',
        value: function _renderbStyleClass(messageObj) {
            return messageObj.errorType;
        }
    }, {
        key: '_renderAlertToggle',
        value: function _renderAlertToggle() {
            var _this2 = this;

            if (this.props.showAlert == true) {
                return _react2.default.createElement(
                    _reactBootstrap.Alert,
                    {
                        bsStyle: this._renderbStyleClass(this.props.message),
                        onDismiss: function onDismiss() {
                            return _this2._handleAlertToggleClose(false);
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: '' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            this._renderMessage(this.props.message)
                        )
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                this._renderAlertToggle()
            );
        }
    }]);

    return AlertToggle;
}(_react.Component);

AlertToggle.propTypes = {
    show: _propTypes2.default.bool,
    bStyleClass: _propTypes2.default.string,
    message: _propTypes2.default.object,
    closeAlert: _propTypes2.default.func.isRequired
};
exports.default = AlertToggle;

/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactComponents = __webpack_require__(35);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _PriceTable = __webpack_require__(1129);

var _PriceTable2 = _interopRequireDefault(_PriceTable);

__webpack_require__(1130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PricingModal = function (_Component) {
    _inherits(PricingModal, _Component);

    function PricingModal() {
        _classCallCheck(this, PricingModal);

        return _possibleConstructorReturn(this, (PricingModal.__proto__ || Object.getPrototypeOf(PricingModal)).apply(this, arguments));
    }

    _createClass(PricingModal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                offer = _props.offer,
                visible = _props.visible,
                close = _props.close;


            if (!offer) {
                return _react2.default.createElement('div', null);
            }

            var title = _react2.default.createElement(
                'span',
                null,
                _strings2.default.pricingForOffer,
                ': ',
                offer.mentorId,
                ' -',
                ' ',
                offer.account.name,
                ' ',
                _react2.default.createElement(
                    'span',
                    { className: 'text-mute p-l text-normal' },
                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-calendar' }),
                    ' ',
                    _utils2.default.formatShortDate(offer.validFrom),
                    ' -',
                    ' ',
                    _utils2.default.formatShortDate(offer.validTo)
                )
            );

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'pricing-modal',
                    modalTitle: title,
                    visible: visible,
                    closeModal: close
                },
                _react2.default.createElement(_PriceTable2.default, { pricing: offer.pricing })
            );
        }
    }]);

    return PricingModal;
}(_react.Component);

PricingModal.propTypes = {
    offer: _MapPropTypes2.default.OfferProps,
    visible: _propTypes2.default.bool.isRequired,
    close: _propTypes2.default.func.isRequired
};

PricingModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        offer: _selectors2.default.offer.getSelectedOffer,
        visible: _selectors2.default.ui.getPricingModalVisible
    });
};

PricingModal.mapDispatch = function (dispatch) {
    return {
        close: function close() {
            return dispatch(_ui2.default.closeModal('pricing'));
        }
    };
};

exports.default = (0, _ReduxStore.attach)(PricingModal);

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PriceTable = function (_Component) {
    _inherits(PriceTable, _Component);

    function PriceTable() {
        _classCallCheck(this, PriceTable);

        return _possibleConstructorReturn(this, (PriceTable.__proto__ || Object.getPrototypeOf(PriceTable)).apply(this, arguments));
    }

    _createClass(PriceTable, [{
        key: '_renderRows',
        value: function _renderRows() {
            return this.props.pricing.map(function (item, i) {
                return _react2.default.createElement(
                    'tr',
                    { key: i },
                    _react2.default.createElement(
                        'th',
                        { scope: 'row' },
                        item.product.name
                    ),
                    item.weekly && item.weekly.length > 0 && _react2.default.createElement(
                        'td',
                        { key: 'weekly' },
                        _utils2.default.formatPrice(item.weekly[0].price)
                    ),
                    item.monthly.map(function (_ref, j) {
                        var price = _ref.price;
                        return _react2.default.createElement(
                            'td',
                            { key: j },
                            _utils2.default.formatPrice(price)
                        );
                    })
                );
            });
        }
    }, {
        key: '_renderLabels',
        value: function _renderLabels() {
            var first = this.props.pricing[0];
            var result = [];

            if (first.weekly && first.weekly.length > 0) {
                result.push(_react2.default.createElement(
                    'th',
                    { key: 'weekly' },
                    _strings2.default.weekly
                ));
            }

            first.monthly.forEach(function (_ref2) {
                var amount = _ref2.amount;

                result.push(_react2.default.createElement(
                    'th',
                    { key: amount },
                    amount,
                    ' ',
                    _strings2.default.monthAbbr
                ));
            });

            return result;
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.pricing || this.props.pricing.length <= 0) {
                return null;
            }

            return _react2.default.createElement(
                'table',
                { className: 'table table-sm table-hover m-b-0' },
                _react2.default.createElement(
                    'thead',
                    { className: 'thead-inverse' },
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.product
                        ),
                        this._renderLabels()
                    )
                ),
                _react2.default.createElement(
                    'tbody',
                    null,
                    this._renderRows()
                )
            );
        }
    }]);

    return PriceTable;
}(_react.Component);

PriceTable.propTypes = {
    pricing: _propTypes2.default.arrayOf(_MapPropTypes2.default.PricingProps).isRequired
};
exports.default = PriceTable;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferActions = function OfferActions() {
    _classCallCheck(this, OfferActions);
};

OfferActions.types = (0, _ReduxTools.actionsFromList)(['RECEIVED_OFFERS', 'REQUESTING_OFFERS', 'SELECT_OFFER', 'SELECT_PRODUCT']);

OfferActions.requestingOffers = function () {
    return {
        type: OfferActions.types.REQUESTING_OFFERS
    };
};

OfferActions.receivedOffers = function (response) {
    return {
        type: OfferActions.types.RECEIVED_OFFERS,
        payload: { response: response.data }
    };
};

OfferActions.selectOffer = function (offerIndex) {
    return {
        type: OfferActions.types.SELECT_OFFER,
        payload: { offerIndex: offerIndex }
    };
};

OfferActions.selectProduct = function (productIndex) {
    return {
        type: OfferActions.types.SELECT_PRODUCT,
        payload: { productIndex: productIndex }
    };
};

OfferActions.requestOffers = function () {
    return function (dispatch, getState) {
        dispatch(OfferActions.requestingOffers());

        getState().api.getMyOffers().then(function (response) {
            return dispatch(OfferActions.receivedOffers(response));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

exports.default = OfferActions;

/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(142);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _help = __webpack_require__(115);

var _help2 = _interopRequireDefault(_help);

var _order = __webpack_require__(78);

var _order2 = _interopRequireDefault(_order);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _Summary = __webpack_require__(576);

var _Summary2 = _interopRequireDefault(_Summary);

var _Progress = __webpack_require__(1133);

var _Progress2 = _interopRequireDefault(_Progress);

__webpack_require__(1134);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckoutModal = function (_Component) {
    _inherits(CheckoutModal, _Component);

    function CheckoutModal() {
        _classCallCheck(this, CheckoutModal);

        return _possibleConstructorReturn(this, (CheckoutModal.__proto__ || Object.getPrototypeOf(CheckoutModal)).apply(this, arguments));
    }

    _createClass(CheckoutModal, [{
        key: '_handleCloseClick',
        value: function _handleCloseClick() {
            // action order matter here, since this.props.close() will reset
            // this.props.orderIsSuccessful, making it so that this.props.finishOrder
            // is never called.
            if (this.props.orderIsSuccessful) {
                this.props.finishOrder(this.props.history);
            }
            this.props.close();
            this.props.onEditCartChange(false);
        }
    }, {
        key: '_handlePrintClick',
        value: function _handlePrintClick() {
            this.props.finishOrder(this.props.history);
            this.props.onEditCartChange(false);
            // if we print() right away, then we get a nice printout of the modal.
            // so we'll wait for the page to re-render before printing.
            // secret bonus: after an order, the user can print a receipt from the /order
            // or /checkout screens *at any time*. we store the last transaction made
            // in our redux store. it's used to fill out the receipt.
            setTimeout(function () {
                return window.print();
            }, 250);
        }
    }, {
        key: '_handleInstructionsUpdate',
        value: function _handleInstructionsUpdate(event) {
            this.props.updateInstructions(event.target.value);
        }
    }, {
        key: '_closeButtonClass',
        value: function _closeButtonClass() {
            if (this.props.orderFailed) {
                return 'btn-danger';
            }
            if (this.props.isSucessful) {
                return 'btn-success';
            }
            return 'btn-warning';
        }
    }, {
        key: '_renderContent',
        value: function _renderContent() {
            var _this2 = this;

            //console.log('sold to in checkout model=', this.props.soldTo)
            if (this.props.orderStarted) {
                return _react2.default.createElement(_Progress2.default, {
                    complete: this.props.orderComplete,
                    failed: this.props.orderFailed,
                    isSuccessful: this.props.orderIsSuccessful,
                    openHelp: function openHelp() {
                        return _this2.props.openHelpModal();
                    }
                });
            }

            return _react2.default.createElement(_Summary2.default, {
                cart: this.props.cart,
                cartTotal: this.props.cartTotal,
                offer: this.props.offer,
                onUpdateInstructions: function onUpdateInstructions(e) {
                    return _this2._handleInstructionsUpdate(e);
                },
                soldTo: this.props.soldTo
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.props.offer) {
                return _react2.default.createElement('span', null);
            }

            var actionButton = this.props.orderComplete ? _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-info',
                    onClick: function onClick() {
                        return _this3._handlePrintClick();
                    }
                },
                _strings2.default.printReceipt
            ) : _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-success',
                    onClick: function onClick() {
                        return _this3.props.submitOrder();
                    },
                    disabled: this.props.orderInProgress
                },
                _strings2.default.submitOrder
            );

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'checkout-modal',
                    modalTitle: this.props.orderComplete ? _strings2.default.orderSubmitted : _strings2.default.submitOrderQuestion,
                    visible: this.props.visible,
                    backdrop: 'static',
                    closeModal: function closeModal() {
                        return _this3._handleCloseClick();
                    }
                },
                this._renderContent(),
                _react2.default.createElement(
                    'div',
                    { className: 'text-right' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn ' + this._closeButtonClass(),
                            onClick: function onClick() {
                                return _this3._handleCloseClick();
                            },
                            disabled: this.props.orderInProgress
                        },
                        this.props.orderComplete ? _strings2.default.close : _strings2.default.cancel
                    ),
                    '\xA0',
                    actionButton
                )
            );
        }
    }]);

    return CheckoutModal;
}(_react.Component);

CheckoutModal.propTypes = {
    // functions
    close: _propTypes2.default.func.isRequired,
    submitOrder: _propTypes2.default.func.isRequired,
    finishOrder: _propTypes2.default.func.isRequired,
    openHelpModal: _propTypes2.default.func.isRequired,
    updateInstructions: _propTypes2.default.func.isRequired,
    onEditCartChange: _propTypes2.default.func,
    // data
    cart: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        item: _MapPropTypes2.default.CartItemProps,
        product: _MapPropTypes2.default.PricingProps
    })).isRequired,
    cartTotal: _propTypes2.default.number.isRequired,
    offer: _MapPropTypes2.default.OfferProps,
    orderStarted: _propTypes2.default.bool.isRequired,
    orderComplete: _propTypes2.default.bool.isRequired,
    orderIsSuccessful: _propTypes2.default.bool.isRequired,
    orderInProgress: _propTypes2.default.bool.isRequired,
    orderFailed: _propTypes2.default.bool.isRequired,
    visible: _propTypes2.default.bool.isRequired,
    history: _propTypes2.default.object,
    isSucessful: _propTypes2.default.bool,
    soldTo: _propTypes2.default.string
};

CheckoutModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        cart: _selectors2.default.cart.getCartContents,
        soldTo: _selectors2.default.cart.getSoldTo,
        cartTotal: _selectors2.default.cart.getTotal,
        offer: _selectors2.default.offer.getSelectedOffer,
        orderStarted: _selectors2.default.order.orderStarted,
        orderComplete: _selectors2.default.order.orderIsComplete,
        orderIsSuccessful: _selectors2.default.order.orderIsSuccessful,
        orderInProgress: _selectors2.default.order.orderInProgress,
        orderFailed: _selectors2.default.order.orderFailed,
        visible: _selectors2.default.ui.getCheckoutModalVisible
    });
};

CheckoutModal.mapDispatch = function (dispatch) {
    return {
        close: function close() {
            return dispatch(_ui2.default.closeCheckoutModal());
        },
        submitOrder: function submitOrder() {
            return dispatch(_order2.default.submitOrder());
        },
        finishOrder: function finishOrder(history) {
            return dispatch(_ui2.default.finishOrder(history));
        },
        openHelpModal: function openHelpModal() {
            dispatch(_help2.default.showContactTab());
            dispatch(_help2.default.updateContactSubjectIndex(_help2.default.contactSubjects.indexOf('Support Inquiry')));
            dispatch(_ui2.default.closeCheckoutModal());
            dispatch(_ui2.default.openHelpModal());
        },
        updateInstructions: function updateInstructions(instructions) {
            return dispatch(_cart2.default.updateCartInstructions(instructions));
        }
    };
};

exports.default = (0, _reactRouter.withRouter)((0, _ReduxStore.attach)(CheckoutModal));

/***/ }),

/***/ 1132:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Progress = __webpack_require__(544);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Progress = function (_Component) {
    _inherits(Progress, _Component);

    function Progress() {
        _classCallCheck(this, Progress);

        return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
    }

    _createClass(Progress, [{
        key: '_getLabel',
        value: function _getLabel() {
            if (this.props.failed) {
                return _strings2.default.orderFailed;
            }
            if (this.props.isSuccessful) {
                return _strings2.default.orderSubmitted;
            }
            return _strings2.default.submittingOrder;
        }
    }, {
        key: '_getHelpPrompt',
        value: function _getHelpPrompt() {
            var _this2 = this;

            if (this.props.failed) {
                return _react2.default.createElement(
                    'a',
                    {
                        className: 'cursor-pointer',
                        onClick: function onClick() {
                            return _this2.props.openHelp();
                        }
                    },
                    _strings2.default.orderHelp
                );
            }
            return '';
        }
    }, {
        key: '_getStatus',
        value: function _getStatus() {
            if (this.props.failed) {
                return 'danger';
            }
            if (this.props.isSuccessful) {
                return 'success';
            }
            return 'info';
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'strong',
                        null,
                        this._getLabel()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-b-sm' },
                    _react2.default.createElement(
                        'small',
                        null,
                        this._getHelpPrompt()
                    )
                ),
                _react2.default.createElement(_Progress.ProgressBar, {
                    progress: 100,
                    striped: true,
                    animated: !this.props.complete,
                    status: this._getStatus()
                })
            );
        }
    }]);

    return Progress;
}(_react.Component);

Progress.propTypes = {
    complete: _propTypes2.default.bool.isRequired,
    failed: _propTypes2.default.bool.isRequired,
    isSuccessful: _propTypes2.default.bool.isRequired,
    openHelp: _propTypes2.default.func.isRequired
};
exports.default = Progress;

/***/ }),

/***/ 1134:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropzone = __webpack_require__(577);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _reactComponents = __webpack_require__(35);

var _ReduxStore = __webpack_require__(25);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _uploadConfiguration = __webpack_require__(494);

var _uploadConfiguration2 = _interopRequireDefault(_uploadConfiguration);

var _ReduxTools = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(64);

__webpack_require__(1140);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ExcelValidationModal = __webpack_require__(1141);

var _ExcelValidationModal2 = _interopRequireDefault(_ExcelValidationModal);

var _ExcelValidationFailedModal = __webpack_require__(1143);

var _ExcelValidationFailedModal2 = _interopRequireDefault(_ExcelValidationFailedModal);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ACCEPT_EXTENSIONS = ['xlsm'];

var UploadConfiguration = function (_Component) {
    _inherits(UploadConfiguration, _Component);

    function UploadConfiguration() {
        _classCallCheck(this, UploadConfiguration);

        return _possibleConstructorReturn(this, (UploadConfiguration.__proto__ || Object.getPrototypeOf(UploadConfiguration)).apply(this, arguments));
    }

    _createClass(UploadConfiguration, [{
        key: '_onFileDrop',


        // constructor() {
        //     super();
        //     this.state = {
        //         dragOver: false,
        //         unknownFileType: false,
        //     };
        // }

        value: function _onFileDrop(accepted, rejected) {
            if (rejected.length > 0 && accepted.length === 0) {
                this.props.setDragOver(false);
                this.props.setUnknownFileType(true);
                // this.setState({ unknownFileType: true, dragOver: false });
                return;
            }

            this.props.uploadConfigurationSheet(accepted[0], this.props.offer.id);
            this.props.setDragOver(false);
            this.props.setUnknownFileType(false);
            // this.setState({ unknownFileType: false, dragOver: false });
        }
    }, {
        key: '_renderContent',
        value: function _renderContent() {
            var browseStyle = {
                fontSize: '16px'
            };
            var content = _react2.default.createElement(
                'div',
                { className: 'pricing-pane row' },
                _react2.default.createElement(
                    _reactBootstrap.Col,
                    { xs: 9, md: 6 },
                    _react2.default.createElement(
                        'button',
                        {
                            onClick: function onClick() {}
                            // onClick={() => this._handleClick(true)}
                            , className: 'btn  btn-lg btn-block configure-button btn-primary-outline'
                        },
                        _strings2.default.uploadNewConfiguration,
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'span',
                            { style: browseStyle },
                            'Drop file here or ',
                            _react2.default.createElement(
                                'u',
                                null,
                                'browse'
                            ),
                            ' to upload file'
                        )
                    )
                )
            );

            if (this.props.dragOver) {
                content = _react2.default.createElement(
                    'div',
                    { className: 'drag-area' },
                    _react2.default.createElement(
                        'div',
                        { className: 'drag-overlay text-inverse' },
                        _react2.default.createElement(
                            'div',
                            { className: 'drag-indicator' },
                            _react2.default.createElement(_reactComponents.Icon, { name: 'icon-file-upload2' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'drag-content' },
                        content
                    )
                );
            }

            return content;
        }
    }, {
        key: '_setDragOver',
        value: function _setDragOver(boolVal) {
            this.props.setDragOver(boolVal);
        }
    }, {
        key: '_renderDragHint',
        value: function _renderDragHint() {
            var message = '';
            var className = '';

            if (this.props.unknownFileType) {
                message = _strings2.default.dragOnlyExcelFiles;
                className = 'text-danger';
            } else if (this.props.getFileUploaded) {
                message = _strings2.default.pricingUploaded;
                className = 'text-success';
            }

            return _react2.default.createElement(
                'small',
                { className: className },
                message
            );
        }
    }, {
        key: '_renderProgressBar',
        value: function _renderProgressBar() {
            var percent = this.props.configurationUploadProgress;
            var message = percent + '% ' + _strings2.default.complete;

            if (percent === 100) {
                message = _strings2.default.uploadedConfiguration;
            }

            return _react2.default.createElement(
                'div',
                { className: 'text-left' },
                _react2.default.createElement(
                    'small',
                    null,
                    _strings2.default.uploading
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'progress progress-striped active m-b-0' },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'progress-bar',
                            role: 'progressbar',
                            style: { width: percent + '%' }
                        },
                        _react2.default.createElement(
                            'span',
                            null,
                            message
                        )
                    )
                )
            );
        }
    }, {
        key: '_isEmpty',
        value: function _isEmpty(obj) {
            return Object.keys(obj).length === 0;
        }
    }, {
        key: '_renderUploadError',
        value: function _renderUploadError(errorObj) {
            return _react2.default.createElement(
                'small',
                { className: 'text-danger' },
                _react2.default.createElement(_reactComponents.Icon, { name: 'icon-warning' }),
                '\xA0',
                errorObj.message
            );
        }
    }, {
        key: '_renderDragState',
        value: function _renderDragState() {
            // if (this._isEmpty(this.props.excelUploadErrorData) === false) {
            //     return this._renderUploadError(this.props.excelUploadErrorData);
            // }

            if (this.props.configurationUploadInTransit) {
                return this._renderProgressBar();
            }

            return this._renderDragHint();
        }
    }, {
        key: '_showFailedValidationModal',
        value: function _showFailedValidationModal(event) {}
    }, {
        key: '_showSuccessValidationModal',
        value: function _showSuccessValidationModal(event) {
            this.props.openModal('checkout');
        }
    }, {
        key: '_handleDownloadConfigurationButtonClick',
        value: function _handleDownloadConfigurationButtonClick() {
            this.props.downloadConfigurationProductList(this.props.offer.id);
        }
    }, {
        key: '_isButtonDisabled',
        value: function _isButtonDisabled() {
            return this.props.configurationDownloadSpinner;
        }
    }, {
        key: '_renderDownloadSpinner',
        value: function _renderDownloadSpinner() {
            if (this.props.configurationDownloadSpinner) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'spinner-container' },
                        _react2.default.createElement('div', { className: 'loading-spinner' })
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var fontSize = {
                fontSize: '12px'
            };
            var divRight = {
                position: 'fixed',
                right: '20px'
            };

            var floatCont = {
                border: '3px solid #fff',
                padding: '10px'
            };

            var floatChild = {
                width: '50%',
                float: 'left',
                padding: '10px'
                // border: '2px solid red',
            };

            return _react2.default.createElement(
                'div',
                { className: 'm-b' },
                _react2.default.createElement(
                    'div',
                    { className: 'text-right' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-12 text-center text-mute' },
                        this._renderDragState()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { style: floatCont },
                    this._renderDownloadSpinner(),
                    _react2.default.createElement(
                        'div',
                        { style: floatChild },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'button',
                                {
                                    onClick: function onClick() {
                                        return _this2._handleDownloadConfigurationButtonClick();
                                    },
                                    disabled: this._isButtonDisabled(),
                                    className: 'btn btn-lg btn-block configure-button btn-primary-outline'
                                },
                                _strings2.default.downloadConfigurationProductList,
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    '\xA0'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: floatChild },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                _reactDropzone2.default,
                                {
                                    disableClick: false,
                                    style: { position: 'absolute', width: '65%' },
                                    accept: ACCEPT_EXTENSIONS.map(function (e) {
                                        return '.' + e;
                                    }).join(','),
                                    onDrop: function onDrop(a, r) {
                                        return _this2._onFileDrop(a, r);
                                    },
                                    onDragEnter: function onDragEnter() {
                                        return _this2._setDragOver(true);
                                    },
                                    onDragLeave: function onDragLeave() {
                                        return _this2._setDragOver(false);
                                    }
                                },
                                this._renderContent()
                            )
                        )
                    )
                ),
                _react2.default.createElement(_ExcelValidationModal2.default, {
                    configurationSheetUploadResponse: this.props.configurationSheetUploadResponse
                }),
                _react2.default.createElement(_ExcelValidationFailedModal2.default, null)
            );
        }
    }]);

    return UploadConfiguration;
}(_react.Component);

UploadConfiguration.propTypes = {
    offer: _propTypes2.default.object,
    uploadInTransit: _propTypes2.default.bool,
    uploadProgress: _propTypes2.default.number,
    configurationUploadError: _propTypes2.default.object
};

UploadConfiguration.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        excelUploadErrorData: _selectors2.default.configurations.getExcelErrorMessageDataObj,
        clearExcelUploadErrorData: _selectors2.default.configurations.getExcelErrorMessageDataObj,
        excelUploadError: _selectors2.default.configurations.getUploadErrorResponseData,
        configurationUploadInTransit: _selectors2.default.configurations.getUploadInTransit,
        configurationDownloadSpinner: _selectors2.default.configurations.getDownloadSpinner,
        configurationUploadProgress: _selectors2.default.configurations.getUploadProgress,
        configurationUploadedFile: _selectors2.default.configurations.getFileUploaded,
        dragOver: _selectors2.default.configurations.dragOver,
        unknownFileType: _selectors2.default.configurations.unknownFileType,
        catchedErrorMessage: _selectors2.default.configurations.catchedErrorMessage,
        offer: _selectors2.default.offer.getSelectedOffer
    });
};

UploadConfiguration.mapDispatch = function (dispatch) {
    return {
        uploadConfigurationSheet: function uploadConfigurationSheet(file, offerid) {
            return dispatch(_uploadConfiguration2.default.uploadConfigurationExcel(file, offerid));
        },
        setDragOver: function setDragOver(boolVal) {
            return dispatch(_uploadConfiguration2.default.setDragOver(boolVal));
        },
        setUnknownFileType: function setUnknownFileType(boolVal) {
            return dispatch(_uploadConfiguration2.default.setUnknownFileType(boolVal));
        },
        clearExcelUploadError: function clearExcelUploadError() {
            return dispatch(_uploadConfiguration2.default.clearExcelSheetUploadError());
        },
        openModal: function openModal(modalName) {
            return dispatch(_ui2.default.openModal(modalName));
        }
    };
};

exports.default = (0, _ReduxStore.attach)(UploadConfiguration);

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _format = __webpack_require__(224);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

var _offer = __webpack_require__(113);

var _offer2 = _interopRequireDefault(_offer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SiteActions = function SiteActions() {
    _classCallCheck(this, SiteActions);
};

SiteActions.types = (0, _ReduxTools.actionsFromList)(['REQUESTING_SITES', 'RECEIVED_SITES',
// 'REQUESTING_SITE',
// 'RECEIVED_SITE',
'SELECT_SITE', 'SHOW_ALERT', 'SET_SERVER_ID', 'SET_HOST_ID', 'SET_MESSAGE', 'SET_ALERT_ERROR_TYPE', 'SET_ALERT_MESSAGE']);

SiteActions.validateThroughLightHouseAPI = function (siteId, hostId, serverId, offerId) {
    return function (dispatch, getState) {
        var params = {
            siteId: siteId,
            hostId: hostId,
            serverId: serverId,
            offerId: offerId
        };
        var validationUrl = '/site/host/server/validate';
        var state = getState();

        state.api.validateSiteHostServerInfo(validationUrl, params).then(function (response) {
            if (response.data.isValidationFailed == true) {
                dispatch(SiteActions.setErrorMessage(JSON.stringify(response.data.errorResponse), _strings2.default.danger));
                dispatch(SiteActions.showAlert(true));
            } else {
                dispatch(SiteActions.setErrorMessage(JSON.stringify(["Server / Host successfully added to the site"]), _strings2.default.success));
                dispatch(SiteActions.showAlert(true));
                //refreshing the offers to load the new server and host
                dispatch(_offer2.default.requestOffers());
            }
        }).catch(function (error) {
            return dispatch(_error2.default.catchError(error));
        });
    };
};

SiteActions.fetchSites = function () {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(SiteActions.requestingSites());

        state.api.getAllSites().then(function (response) {
            return dispatch(SiteActions.receivedSites(response.data));
        }).catch(function (error) {
            return dispatch(_error2.default.catchError(error));
        });
    };
};

SiteActions.fetchSitesForUserAccount = function () {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(SiteActions.requestingSites());

        state.api.getAllSitesForUser().then(function (response) {
            return dispatch(SiteActions.receivedSites(response.data));
        }).catch(function (error) {
            return dispatch(_error2.default.catchError(error));
        });
    };
};

SiteActions.requestingSites = function () {
    return {
        type: SiteActions.types.REQUESTING_SITES
    };
};

SiteActions.receivedSites = function (response) {
    return {
        type: SiteActions.types.RECEIVED_SITES,
        payload: { response: response }
    };
};

SiteActions.selectSite = function (siteId) {
    return {
        type: SiteActions.types.SELECT_SITE,
        payload: { siteId: siteId }
    };
};

SiteActions.showAlert = function (showAlert) {
    var action_obj = {
        type: SiteActions.types.SHOW_ALERT,
        payload: { showAlert: showAlert }
    };
    return action_obj;
};

SiteActions.setServerId = function (serverId) {
    return {
        type: SiteActions.types.SET_SERVER_ID,
        payload: { serverId: serverId }
    };
};

SiteActions.setHostId = function (hostId) {
    return {
        type: SiteActions.types.SET_HOST_ID,
        payload: { hostId: hostId }
    };
};

SiteActions.setErrorMessage = function (message, errorType) {
    var action_obj = {
        type: SiteActions.types.SET_ALERT_MESSAGE,
        payload: { message: message, errorType: errorType }
    };
    return action_obj;
};

SiteActions.downloadServersBySiteList = function (offerId) {
    return function (dispatch, getState) {
        var state = getState();
        var filename = _strings2.default.ServersBySite + '.xlsx';
        // dispatch(UploadConfigurationActions.setDownloadSpinner(true));
        // dispatch(OrderActions.downloadingConfigurationProductList());

        state.api.downloadServersBySiteList(offerId, filename).then(function () {
            // OrderActions.downloadedConfigurationProductList();
            // dispatch(UploadConfigurationActions.setDownloadSpinner(false));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

exports.default = SiteActions;

/***/ }),

/***/ 1140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactComponents = __webpack_require__(35);

var _reactRouter = __webpack_require__(142);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _order = __webpack_require__(78);

var _order2 = _interopRequireDefault(_order);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _Summary = __webpack_require__(576);

var _Summary2 = _interopRequireDefault(_Summary);

__webpack_require__(1142);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExcelValidationModal = function (_Component) {
    _inherits(ExcelValidationModal, _Component);

    function ExcelValidationModal() {
        _classCallCheck(this, ExcelValidationModal);

        return _possibleConstructorReturn(this, (ExcelValidationModal.__proto__ || Object.getPrototypeOf(ExcelValidationModal)).apply(this, arguments));
    }

    _createClass(ExcelValidationModal, [{
        key: '_handleCloseClick',
        value: function _handleCloseClick() {
            // action order matter here, since this.props.close() will reset
            // this.props.orderIsSuccessful, making it so that this.props.finishOrder
            // is never called.
            // if (this.props.orderIsSuccessful) {
            // this.props.finishOrder(this.props.history);
            // }
            this.props.finishOrder(this.props.history);
            this.props.close();
        }
    }, {
        key: '_checkBalanceExceeds',
        value: function _checkBalanceExceeds() {
            if (this.props.configurationSheetUploadResponse.cart != undefined) {
                var sumOfTotal = 0;
                this.props.configurationSheetUploadResponse.cart.map(function (item) {
                    sumOfTotal += item.subtotal;
                });
                if (sumOfTotal > this.props.offer.balance) return true;
            }
            return false;
        }
    }, {
        key: '_handlePrintClick',
        value: function _handlePrintClick() {
            this.props.finishOrder(this.props.history);
            // if we print() right away, then we get a nice printout of the modal.
            // so we'll wait for the page to re-render before printing.
            // secret bonus: after an order, the user can print a receipt from the /order
            // or /checkout screens *at any time*. we store the last transaction made
            // in our redux store. it's used to fill out the receipt.
            setTimeout(function () {
                return window.print();
            }, 250);
        }
    }, {
        key: '_handleInstructionsUpdate',
        value: function _handleInstructionsUpdate(event) {
            this.props.updateInstructions(event.target.value);
        }
    }, {
        key: '_closeButtonClass',
        value: function _closeButtonClass() {
            if (this.props.orderFailed) {
                return 'btn-danger';
            }
            if (this.props.isSucessful) {
                return 'btn-success';
            }
            return 'btn-warning';
        }
    }, {
        key: '_renderContent',
        value: function _renderContent() {
            var _this2 = this;

            return _react2.default.createElement(_Summary2.default, {
                sheetResponseData: this.props.configurationSheetUploadResponse,
                cart: this.props.configurationSheetUploadResponse.cart ? this.props.configurationSheetUploadResponse.cart : [],
                cartTotal: this.props.cartTotal,
                offer: this.props.offer,
                onUpdateInstructions: function onUpdateInstructions(e) {
                    return _this2._handleInstructionsUpdate(e);
                },
                excelUpload: true,
                soldTo: this.props.soldTo
            });
        }
    }, {
        key: '_getTitle',
        value: function _getTitle() {
            if (this.props.orderFailed) {
                return _strings2.default.orderFailedTitle;
            }
            if (this.props.orderComplete) {
                return _strings2.default.orderSubmitted;
            }
            return _strings2.default.confirmOrderQuestion;
        }
    }, {
        key: '_renderSpinner',
        value: function _renderSpinner() {
            if (this.props.orderInProgress) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'spinner-text' },
                        'Please wait while the order is being submitted...'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'spinner-container' },
                        _react2.default.createElement('div', { className: 'loading-spinner' })
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var actionButton = this.props.orderComplete ? _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-info',
                    onClick: function onClick() {
                        return _this3._handlePrintClick();
                    },
                    disabled: this.props.orderFailed
                },
                _strings2.default.printReceipt
            ) : _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-success',
                    onClick: function onClick() {
                        return _this3.props.submitOrder(_this3.props.configurationSheetUploadResponse.cart);
                    },
                    disabled: this.props.orderInProgress || this._checkBalanceExceeds()
                },
                _strings2.default.submitOrder
            );

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'checkout-modal',
                    modalTitle: this._getTitle(),
                    visible: this.props.visible,
                    backdrop: 'static',
                    closeModal: function closeModal() {
                        return _this3._handleCloseClick();
                    }
                },
                this._renderContent(),
                this.props.orderFailed ? _react2.default.createElement(
                    'div',
                    { className: 'bottomPadding' },
                    ' ',
                    _strings2.default.orderFailed,
                    ' '
                ) : '',
                this._checkBalanceExceeds() ? _react2.default.createElement(
                    'div',
                    { className: 'text-danger' },
                    _strings2.default.InsufficientFunds
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'text-right' },
                    this._renderSpinner(),
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn ' + this._closeButtonClass(),
                            onClick: function onClick() {
                                return _this3._handleCloseClick();
                            },
                            disabled: this.props.orderInProgress
                        },
                        this.props.orderComplete ? _strings2.default.close : _strings2.default.cancel
                    ),
                    '\xA0',
                    actionButton
                )
            );
        }
    }]);

    return ExcelValidationModal;
}(_react.Component);

ExcelValidationModal.propTypes = {
    // functions
    close: _propTypes2.default.func.isRequired,
    submitOrder: _propTypes2.default.func.isRequired,
    // data
    cart: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        item: _MapPropTypes2.default.CartItemProps,
        product: _MapPropTypes2.default.PricingProps
    })).isRequired,
    cartTotal: _propTypes2.default.number.isRequired,
    offer: _MapPropTypes2.default.OfferProps,
    orderStarted: _propTypes2.default.bool.isRequired,
    orderComplete: _propTypes2.default.bool.isRequired,
    orderIsSuccessful: _propTypes2.default.bool.isRequired,
    orderInProgress: _propTypes2.default.bool.isRequired,
    orderFailed: _propTypes2.default.bool.isRequired,
    isSucessful: _propTypes2.default.bool.isRequired,
    visible: _propTypes2.default.bool.isRequired,
    configurationSheetUploadResponse: _propTypes2.default.object
};

ExcelValidationModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        cart: _selectors2.default.cart.getCartContents,
        cartTotal: _selectors2.default.cart.getTotal,
        offer: _selectors2.default.offer.getSelectedOffer,
        orderStarted: _selectors2.default.order.excelOrderStarted,
        soldTo: _selectors2.default.cart.getSoldTo,
        orderComplete: _selectors2.default.order.excelOrderIsComplete,
        orderIsSuccessful: _selectors2.default.order.excelOrderIsSuccessful,
        orderInProgress: _selectors2.default.order.excelOrderInProgress,
        orderFailed: _selectors2.default.order.excelOrderFailed,
        isSucessful: _selectors2.default.order.excelOrderIsComplete,
        visible: _selectors2.default.ui.getValidationModalVisible,
        configurationSheetUploadResponse: _selectors2.default.configurations.getconfigurationSheetUploadResponse
    });
};

ExcelValidationModal.mapDispatch = function (dispatch, ownProps) {
    return {
        close: function close() {
            return dispatch(_ui2.default.closeValidationModal());
        },
        submitOrder: function submitOrder(cart) {
            return dispatch(_order2.default.submitExcelOrder(cart));
        },
        finishOrder: function finishOrder(history) {
            return dispatch(_ui2.default.finishExcelOrder(history));
        },
        updateInstructions: function updateInstructions(instructions) {
            return dispatch(_cart2.default.updateCartInstructions(instructions));
        }
    };
};

exports.default = (0, _reactRouter.withRouter)((0, _ReduxStore.attach)(ExcelValidationModal));

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(142);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _order = __webpack_require__(78);

var _order2 = _interopRequireDefault(_order);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _reactComponents = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExcelValidationFailedModal = function (_Component) {
    _inherits(ExcelValidationFailedModal, _Component);

    function ExcelValidationFailedModal() {
        _classCallCheck(this, ExcelValidationFailedModal);

        return _possibleConstructorReturn(this, (ExcelValidationFailedModal.__proto__ || Object.getPrototypeOf(ExcelValidationFailedModal)).apply(this, arguments));
    }

    _createClass(ExcelValidationFailedModal, [{
        key: '_handleCancelClick',
        value: function _handleCancelClick() {
            this.props.cancel();
        }
    }, {
        key: '_closeButtonClass',
        value: function _closeButtonClass() {
            return 'btn';
        }
    }, {
        key: '_renderContent',
        value: function _renderContent() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'small',
                        { className: 'text-danger' },
                        _react2.default.createElement(_reactComponents.Icon, { name: 'icon-warning' })
                    ),
                    _react2.default.createElement('br', null),
                    'The file you uploaded failed validation. ',
                    _react2.default.createElement('br', null),
                    ' To fix the problems: ',
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'span',
                        null,
                        '- Download the validation errors'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'span',
                        null,
                        '- Correct the errors in the downloaded file'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'span',
                        null,
                        '- Upload the corrected file to try again'
                    ),
                    _react2.default.createElement('br', null)
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'checkout-modal',
                    modalTitle: 'Error Validation Failed',
                    visible: this.props.modalVisible,
                    closeModal: function closeModal() {
                        return _this2._handleCancelClick();
                    }
                },
                this._renderContent(),
                _react2.default.createElement(
                    'span',
                    null,
                    '\xA0'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'text-left' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-primary',
                            onClick: function onClick() {
                                return _this2.props.downloadFailedExcel(_this2.props.failedError);
                            },
                            disabled: false
                        },
                        _strings2.default.downloadValidationErros
                    ),
                    _react2.default.createElement(
                        'span',
                        null,
                        '\xA0\xA0\xA0'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn ' + this._closeButtonClass(),
                            onClick: function onClick() {
                                return _this2._handleCancelClick();
                            },
                            disabled: false
                        },
                        _strings2.default.cancel
                    )
                )
            );
        }
    }]);

    return ExcelValidationFailedModal;
}(_react.Component);

ExcelValidationFailedModal.propTypes = {
    // functions
    cancel: _propTypes2.default.func.isRequired,
    downloadFailedExcel: _propTypes2.default.func.isRequired,
    modalVisible: _propTypes2.default.bool.isRequired,
    failedError: _propTypes2.default.object
};

ExcelValidationFailedModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        modalVisible: _selectors2.default.ui.getFailedValidationModalVisible,
        failedError: _selectors2.default.configurations.getExcelErrorMessageDataObj
    });
};

ExcelValidationFailedModal.mapDispatch = function (dispatch, ownProps) {
    return {
        cancel: function cancel() {
            return dispatch(_ui2.default.closeFailedValidationModal());
        },
        // downloadFailedExcel: () => dispatch(OrderActions.submitExcelOrder()),
        downloadFailedExcel: function downloadFailedExcel(fileData) {
            return dispatch(_order2.default.downloadConfigurationProductListWithErrors(fileData));
        }
    };
};

exports.default = (0, _reactRouter.withRouter)((0, _ReduxStore.attach)(ExcelValidationFailedModal));

/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _reactRouterDom = __webpack_require__(132);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _Loading = __webpack_require__(551);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RootView = function (_Component) {
    _inherits(RootView, _Component);

    function RootView() {
        _classCallCheck(this, RootView);

        return _possibleConstructorReturn(this, (RootView.__proto__ || Object.getPrototypeOf(RootView)).apply(this, arguments));
    }

    _createClass(RootView, [{
        key: 'render',
        value: function render() {
            if (this.props.wantLogin) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
            }
            if (!this.props.isLoggedIn) {
                return _react2.default.createElement(_Loading2.default, null);
            }
            return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/order' });
        }
    }]);

    return RootView;
}(_react.Component);

RootView.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        isLoggedIn: _selectors2.default.login.getIsLoggedIn,
        wantLogin: _selectors2.default.login.getWantLogin
    });
};

exports.default = (0, _ReduxStore.attach)(RootView);

/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactComponents = __webpack_require__(35);

var _BaseLayout = __webpack_require__(160);

var _BaseLayout2 = _interopRequireDefault(_BaseLayout);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnknownUser = function (_Component) {
    _inherits(UnknownUser, _Component);

    function UnknownUser() {
        _classCallCheck(this, UnknownUser);

        return _possibleConstructorReturn(this, (UnknownUser.__proto__ || Object.getPrototypeOf(UnknownUser)).apply(this, arguments));
    }

    _createClass(UnknownUser, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _BaseLayout2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'card m-t' },
                    _react2.default.createElement(
                        'div',
                        { className: 'card-block' },
                        _react2.default.createElement(
                            'h2',
                            { className: 'card-title' },
                            _react2.default.createElement(
                                'span',
                                { className: 'text-warning' },
                                _react2.default.createElement(_reactComponents.Icon, { name: 'icon-warning' })
                            ),
                            ' ',
                            _strings2.default.noUserRecord
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'text-description m-b-sm' },
                            _strings2.default.noUserRecordExplanation
                        )
                    )
                )
            );
        }
    }]);

    return UnknownUser;
}(_react.Component);

exports.default = UnknownUser;

/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLoadable = __webpack_require__(578);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _ReduxStore = __webpack_require__(25);

var _ReduxStore2 = _interopRequireDefault(_ReduxStore);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _joyride = __webpack_require__(134);

var _joyride2 = _interopRequireDefault(_joyride);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AsyncLoadable = (0, _reactLoadable2.default)({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1362));
    },
    loading: function loading() {
        return null;
    }
});

var MapJoyride = function (_Component) {
    _inherits(MapJoyride, _Component);

    function MapJoyride() {
        _classCallCheck(this, MapJoyride);

        var _this = _possibleConstructorReturn(this, (MapJoyride.__proto__ || Object.getPrototypeOf(MapJoyride)).call(this));

        _this.state = { startPage: 1 };
        return _this;
    }

    _createClass(MapJoyride, [{
        key: '_restartTourAt',
        value: function _restartTourAt(startPage) {
            this.setState({ startPage: startPage });
            this._joyride.reset(true);
        }
    }, {
        key: '_progressHandler',
        value: function _progressHandler(event) {
            var _this2 = this;

            switch (event.type) {
                case 'step:after':
                    if (event.action === 'next' && event.step.forwardSetup) {
                        event.step.forwardSetup(this.props.dispatch, this.props.router);
                    } else if (event.action === 'back' && event.step.backwardSetup) {
                        event.step.backwardSetup(this.props.dispatch, this.props.router);
                    }

                    break;

                case 'finished':
                    if (event.isTourSkipped) {
                        this.props.cancelJoyride();
                    } else {
                        this.props.finishJoyride();
                    }
                    break;

                case 'error:target_not_found':
                    if (event.index == 6) {
                        var index = event.index + 1;
                        if (event.action == 'back') index = index - 2;
                        this._restartTourAt(index);
                    } else {
                        setTimeout(function () {
                            return _this2._restartTourAt(event.index);
                        }, 50);
                    }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.startJoyride) {
                return _react2.default.createElement(AsyncLoadable, {
                    setJoyrideRef: function setJoyrideRef(r) {
                        return _this3._joyride = r;
                    },
                    startJoyride: this.props.startJoyride,
                    startPage: this.state.startPage,
                    progressHandler: function progressHandler(event) {
                        return _this3._progressHandler(event);
                    }
                });
            }

            return null;
        }
    }]);

    return MapJoyride;
}(_react.Component);

MapJoyride.propTypes = {
    router: _propTypes2.default.object,
    startJoyride: _propTypes2.default.bool.isRequired,
    dispatch: _propTypes2.default.func.isRequired
};

MapJoyride.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        startJoyride: _selectors2.default.joyride.shouldStartJoyride
    });
};

MapJoyride.mapDispatch = function (dispatch) {
    return {
        dispatch: dispatch,
        finishJoyride: function finishJoyride() {
            return dispatch(_joyride2.default.finishJoyride());
        },
        cancelJoyride: function cancelJoyride() {
            return dispatch(_joyride2.default.cancelJoyride());
        }
    };
};

exports.default = _ReduxStore2.default.attach(MapJoyride);

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReduxStore = __webpack_require__(25);

var _ReduxStore2 = _interopRequireDefault(_ReduxStore);

var _ReduxTools = __webpack_require__(11);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _joyride = __webpack_require__(134);

var _joyride2 = _interopRequireDefault(_joyride);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewUserModal = function (_Component) {
    _inherits(NewUserModal, _Component);

    function NewUserModal() {
        _classCallCheck(this, NewUserModal);

        return _possibleConstructorReturn(this, (NewUserModal.__proto__ || Object.getPrototypeOf(NewUserModal)).apply(this, arguments));
    }

    _createClass(NewUserModal, [{
        key: '_getContent',
        value: function _getContent() {
            // TODO if tour was started but no finished, return a diff msg
            return _strings2.default.startTheTour;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'new-user-modal',
                    modalTitle: _strings2.default.welcome,
                    visible: this.props.visible,
                    closeModal: this.props.close
                },
                _react2.default.createElement(
                    'p',
                    null,
                    this._getContent()
                ),
                _react2.default.createElement(
                    'fieldset',
                    { className: 'form-group text-right m-b-0' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-info m-r-sm p-l-lg p-r-lg',
                            onClick: function onClick() {
                                return _this2.props.close();
                            }
                        },
                        _strings2.default.no
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-success p-l-lg p-r-lg',
                            onClick: function onClick() {
                                return _this2.props.startJoyride();
                            }
                        },
                        _strings2.default.yes
                    )
                )
            );
        }
    }]);

    return NewUserModal;
}(_react.Component);

NewUserModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        visible: _selectors2.default.ui.getNewUserModalVisible
    });
};

NewUserModal.mapDispatch = function (dispatch) {
    return {
        close: function close() {
            dispatch(_ui2.default.closeModal('newUser'));
            dispatch(_joyride2.default.cancelJoyride());
        },
        startJoyride: function startJoyride() {
            dispatch(_ui2.default.closeModal('newUser'));
            dispatch(_joyride2.default.startJoyride());
        }
    };
};

exports.default = _ReduxStore2.default.attach(NewUserModal);

/***/ }),

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReduxStore = __webpack_require__(25);

var _ReduxStore2 = _interopRequireDefault(_ReduxStore);

var _ReduxTools = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrintableTransactions = function (_Component) {
    _inherits(PrintableTransactions, _Component);

    function PrintableTransactions() {
        _classCallCheck(this, PrintableTransactions);

        return _possibleConstructorReturn(this, (PrintableTransactions.__proto__ || Object.getPrototypeOf(PrintableTransactions)).apply(this, arguments));
    }

    _createClass(PrintableTransactions, [{
        key: '_getLicenseDuration',
        value: function _getLicenseDuration(license) {
            if (this.props.offer && this.props.offer.dailyPricingEnabled) {
                return Math.max(0, (0, _moment2.default)(license.validTo).startOf('day').diff((0, _moment2.default)(license.validFrom).startOf('day'), 'days'));
            }

            return license.duration;
        }
    }, {
        key: '_renderBody',
        value: function _renderBody() {
            var _this2 = this;

            if (this.props.transaction.licenses) {
                return _react2.default.createElement(
                    'tbody',
                    null,
                    this.props.transaction.licenses.map(function (license, i) {
                        var serverAlias = _this2.props.serverAliases[license.server.id] ? _react2.default.createElement(
                            'span',
                            { className: 'text-muted' },
                            '(',
                            _strings2.default.alias,
                            ':',
                            ' ',
                            _this2.props.serverAliases[license.server.id],
                            ')'
                        ) : null;

                        return _react2.default.createElement(
                            'tr',
                            { key: i },
                            _react2.default.createElement(
                                'td',
                                null,
                                license.product.mentorId
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                license.product.name
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                license.site.mentorId
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                license.server.mentorId,
                                ' ',
                                serverAlias
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                license.seats
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _this2._getLicenseDuration(license)
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _utils2.default.formatShortDate(license.validTo)
                            ),
                            _this2.props.offer.weeklyPricingEnabled && _react2.default.createElement(
                                'td',
                                null,
                                license.weeks
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                _utils2.default.formatPrice(license.amount)
                            )
                        );
                    })
                );
            }
        }
    }, {
        key: '_renderLicenseTable',
        value: function _renderLicenseTable() {
            return _react2.default.createElement(
                'table',
                { className: 'table table-sm table-bordered table-striped' },
                _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.partNumber
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.product
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.site
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.server
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.seats
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            this.props.offer && this.props.offer.dailyPricingEnabled ? _strings2.default.days : _strings2.default.months
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.endDate
                        ),
                        this.props.offer.weeklyPricingEnabled && _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.weeks
                        ),
                        _react2.default.createElement(
                            'th',
                            null,
                            _strings2.default.subtotal
                        )
                    )
                ),
                this._renderBody()
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.transaction) {
                return null;
            }

            var dt = function dt(s) {
                return _react2.default.createElement(
                    'dt',
                    { className: 'col-xs-3 m-a-0' },
                    s
                );
            };
            var dd = function dd(s) {
                return _react2.default.createElement(
                    'dd',
                    { className: 'col-xs-9 m-a-0' },
                    s
                );
            };

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h1',
                    { className: 'm-b-md' },
                    _strings2.default.printHeader
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'm-b-md' },
                    _react2.default.createElement(
                        'dl',
                        { className: 'dl-horizontal' },
                        dt(_strings2.default.orderDate),
                        dd(_utils2.default.formatDate((0, _moment2.default)(this.props.transaction.lastModified))),
                        dt(_strings2.default.username),
                        dd(this.props.transaction.user.email),
                        dt(_strings2.default.confirmation),
                        dd(this.props.transaction.confirmation)
                    )
                ),
                this._renderLicenseTable(),
                _react2.default.createElement(
                    'div',
                    { className: 'pull-right text-xxl' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _strings2.default.total
                    ),
                    ':',
                    ' ',
                    this.props.transaction.amount,
                    '\xA0',
                    this.props.transaction.currency || ''
                )
            );
        }
    }]);

    return PrintableTransactions;
}(_react.Component);

PrintableTransactions.propTypes = {
    offer: _MapPropTypes2.default.OfferProps,
    transaction: _MapPropTypes2.default.TransactionProps,
    serverAliases: _propTypes2.default.object
};

PrintableTransactions.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        offer: _selectors2.default.offer.getSelectedOffer,
        transaction: _selectors2.default.order.getLastTransaction,
        serverAliases: _selectors2.default.user.getServerAliases
    });
};

exports.default = _ReduxStore2.default.attach(PrintableTransactions);

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HelpActions = function HelpActions() {
    _classCallCheck(this, HelpActions);
};

HelpActions.types = (0, _ReduxTools.actionsFromList)(['CONTACT_MESSAGE_SENT', 'HELP_SHOW_CONTACT', 'HELP_SHOW_FAQ', 'HELP_SHOW_TOUR', 'HELP_SHOW_ABOUT', 'RECEIVED_CONTACTS', 'RECEIVED_FAQS', 'REQUESTING_CONTACTS', 'REQUESTING_FAQS', 'SENDING_CONTACT_MESSAGE', 'UPDATE_CONTACT_MESSAGE', 'UPDATE_CONTACT_SUBJECT_INDEX']);
HelpActions.contactSubjects = ['Change Request', 'Site Inquiry', 'Sales Inquiry', 'Support Inquiry', 'General Inquiry'];

HelpActions.requestingFaqs = function () {
    return {
        type: HelpActions.types.REQUESTING_FAQS
    };
};

HelpActions.receivedFaqs = function (response) {
    return {
        type: HelpActions.types.RECEIVED_FAQS,
        payload: { response: response.data }
    };
};

HelpActions.requestingContacts = function () {
    return {
        type: HelpActions.types.REQUESTING_CONTACTS
    };
};

HelpActions.receivedContacts = function (response) {
    return {
        type: HelpActions.types.RECEIVED_CONTACTS,
        payload: { response: response.data }
    };
};

HelpActions.updateContactSubjectIndex = function (index) {
    return {
        type: HelpActions.types.UPDATE_CONTACT_SUBJECT_INDEX,
        payload: { index: index }
    };
};

HelpActions.updateContactMessage = function (message) {
    return {
        type: HelpActions.types.UPDATE_CONTACT_MESSAGE,
        payload: { message: message }
    };
};

HelpActions.sendingContactMessage = function () {
    return {
        type: HelpActions.types.SENDING_CONTACT_MESSAGE
    };
};

HelpActions.contactMessageSent = function () {
    return {
        type: HelpActions.types.CONTACT_MESSAGE_SENT
    };
};

HelpActions.showFaqTab = function () {
    return {
        type: HelpActions.types.HELP_SHOW_FAQ
    };
};

HelpActions.showContactTab = function () {
    return {
        type: HelpActions.types.HELP_SHOW_CONTACT
    };
};

HelpActions.showTourTab = function () {
    return {
        type: HelpActions.types.HELP_SHOW_TOUR
    };
};

HelpActions.showAboutTab = function () {
    return {
        type: HelpActions.types.HELP_SHOW_ABOUT
    };
};

HelpActions.requestFaqs = function () {
    return function (dispatch, getState) {
        dispatch(HelpActions.requestingFaqs());

        getState().api.getFaqs().then(function (response) {
            return dispatch(HelpActions.receivedFaqs(response));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

HelpActions.requestContacts = function () {
    return function (dispatch, getState) {
        dispatch(HelpActions.requestingContacts());

        getState().api.getContacts().then(function (response) {
            return dispatch(HelpActions.receivedContacts(response));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

HelpActions.sendContactMessage = function () {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(HelpActions.sendingContactMessage());

        state.api.postContactMessage(_selectors2.default.help.getContactSubject(state), _selectors2.default.help.getContactMessage(state)).then(function () {
            return dispatch(HelpActions.contactMessageSent());
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

exports.default = HelpActions;

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseLayout = __webpack_require__(160);

var _BaseLayout2 = _interopRequireDefault(_BaseLayout);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Downtime = function (_Component) {
    _inherits(Downtime, _Component);

    function Downtime() {
        _classCallCheck(this, Downtime);

        return _possibleConstructorReturn(this, (Downtime.__proto__ || Object.getPrototypeOf(Downtime)).apply(this, arguments));
    }

    _createClass(Downtime, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _BaseLayout2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'card m-t' },
                    _react2.default.createElement(
                        'div',
                        { className: 'card-block' },
                        _react2.default.createElement(
                            'h2',
                            { className: 'card-title' },
                            _strings2.default.mapDowntime
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'text-description m-b-sm' },
                            "Please Note our Siemens Advantage Portal will be down for system maintenance beginning Saturday, February 7th at 5 AM PST though 10 AM PST. \n During this time, you will be unable to draw down from the system until it comes back online. \n \n We apologize for any inconvenience this causes."
                        )
                    )
                )
            );
        }
    }]);

    return Downtime;
}(_react.Component);

exports.default = Downtime;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactLocalization = __webpack_require__(354);

var _reactLocalization2 = _interopRequireDefault(_reactLocalization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var strings = new _reactLocalization2.default({
    en: {
        about: 'About',
        alias: 'Alias',
        amount: 'Amount',
        available: 'available',
        availableCredits: 'Available Credits',
        addHostServer: 'Add a Host / Server',
        addToCart: 'Add To Cart',
        back: 'Back',
        browseConfigurationFile: 'Drop file here, or <u>browse</u> to upload file',
        cancel: 'Cancel',
        changeItAt: 'Change it at',
        checkout: 'Checkout',
        chooseAProduct: 'Choose a product to configure',
        chooseDate: 'Choose date',
        close: 'Close',
        remove: 'Remove',
        configureThisProduct: 'Configure this product',
        confirmation: 'Confirmation',
        contact: 'Contact',
        contactForHelp: 'Please contact Siemens for help.',
        continueShopping: 'Continue Shopping',
        contractDuration: 'Contract duration',
        creditsSeat: 'Credits/seat',
        creditsUsed: 'Credits Used',
        credits: 'Credits',
        creditsUtilized: 'Credits Utilized',
        currency: 'Currency',
        currentFavorite: 'Current favorite',
        configurationUploaded: 'Configuration file uploaded successfully. Please click show validation success message link below',
        complete: "complete",
        configureAProductWithTemplate: 'Configure products with a template',
        configurationTemplate: 'Consumption Template',
        date: 'Date',
        dealId: 'Deal ID',
        description: 'Description',
        downloadTransactions: 'Download all as Excel',
        downloadValidationErros: 'Download Validation Errors',
        duration: 'Duration',
        durationOverflow: 'Your deal will end before this date.',
        danger: 'danger',
        days: 'Days',
        dragOnlyExcelFiles: 'Configuration data must be in Excel format. Please use a file with extension .xlsm',
        downloadConfigurationProductList: 'Download current configuration & product list',
        enableUserSpoofing: 'Enable user spoofing',
        enterSpecialInstructions: 'Please enter any notes for this order here. (Note: they are for your own internal usage and will not be reviewed on fulfillment).',
        faq: 'FAQ',
        favorite: 'Favorite',
        favoriteThisServer: 'Favorite this server',
        forgotPassword: 'Forgot your password?',
        fulfilledOn: 'Fulfilled on',
        failedValidation: 'Show Validation Failed message',
        help: 'Help',
        history: 'History',
        info: 'info',
        InsufficientFunds: ' Insufficient Funds',
        lastLogin: 'Last login',
        lastTransaction: 'Last Transaction',
        licenses: 'Licenses',
        loggedInAs: 'Logged in as',
        login: 'Login to Siemens Advantage',
        loginHelp0: 'Siemens Advantage now uses your Support Center password for authentication. This allows you to manage your own password, as well as gives you a single password to remember for every Siemens web property.',
        loginHelp1: "If you are a new Siemens Advantage user, you'll start by using your Support Center password. If you've used Siemens Advantage before and were logging in with a non-email username and password that was assigned to you, you can use the following form to map your old username to a Support Center account.",
        loginHelp2: "Enter your old Siemens Advantage username below, then click 'Submit.' We'll email you your Support Center username, as well as instructions for using it.",
        lookup: 'Look up username',
        mentorAdvantage: 'Advantage',
        mentorId: 'Siemens ID',
        message: 'Message',
        messageSent: 'Message sent.',
        monthAbbr: 'mo',
        months: 'Months',
        myAccount: 'My Account',
        myBalance: 'My balance',
        myMentorContact: 'My Siemens Contact',
        myProfile: 'My Profile',
        mapDowntime: "MAP PORTAL SCHEDULED DOWNTIME",
        needHelpQuestion: 'Need help?',
        needLoginHelp: 'Need help logging in?',
        nickname: 'Nickname',
        no: 'No',
        noOffersAvailable: 'You have no deals available.',
        notes: 'Notes',
        noUserRecord: "You don't have a Siemens Advantage user record.",
        noUserRecordExplanation: "While you entered your Support Center username and password correctly, you can't be logged in to the Siemens Advantage portal. You don't have a user record in the Siemens Advantage system. Please contact your Siemens representative to have them create a user record for you. After your user record has been created, close this window and log in again.",
        none: 'None',
        notFulfilled: 'Not fulfilled yet.',

        order: 'Order',
        yourCart: 'Your Cart',
        orderDate: 'Order date',
        orderFailed: 'Your order could not be submitted. Please try again in a few minutes.',
        orderFailedTitle: 'Order Submit failed.',
        orderHelp: 'If you continue to have problems, please contact Siemens.',
        orderSubmitted: 'Order submitted.',
        orderedOn: 'Ordered on',
        placeOrder: 'Place order',
        pricing: 'Pricing',
        pricingForOffer: 'Pricing for deal',
        printHeader: 'Siemens Advantage - Receipt',
        printReceipt: 'Print Receipt',
        product: 'Product',
        partNumber: 'PN',
        profile: 'Profile',
        reallyCancel: 'Do you really want to cancel this order?',
        regardingOrder: 'Regarding Siemens Advantage order from',
        remaining: 'Remaining',
        requestSent: 'Request sent. Check your email for further details.',
        retain: 'Retain',
        reviewCart: 'Shopping Cart',
        reviewYourOrder: 'Please review your order and make any necessary changes.',
        seat: 'Seat',
        seats: 'Seats',
        selectAProduct: 'Please select a product to configure',
        selectSiteForNewServer: 'Select the Site for new server',
        sendMessage: 'Send message',
        sendingRequest: 'Sending request...',
        server: 'Server',
        serverId: 'Server ID',
        serversFor: 'Servers for',
        signOut: 'Sign out',
        site: 'Site',
        siteId: 'Site ID',
        sites: 'Sites',
        specialInstructions: 'Special Instructions',
        spoof: 'Spoof',
        spoofing: 'Spoofing...',
        startDate: 'Start date',
        endDate: 'End date',
        startTheTour: 'This looks like your first time using the new and improved Siemens Advantage. Would you like to take a tour?',
        startTour: 'Start Tour',
        subject: 'Subject',
        submitOrder: 'Submit order',
        submitOrderQuestion: 'Submit this order?',

        confirmOrderQuestion: 'Confirm Order Submission',
        submittingOrder: 'Submitting order.',
        submit: 'Submit',
        siteIdRequired: 'Please select Site and provide a Host and/or Server ID',
        serverOrHostRequired: 'Please provide a Host and/or Server ID',
        subtotal: 'Subtotal',
        success: 'success',
        successValidation: 'Show Validation Success message',
        ServersBySite: 'ServersBySite',
        ServersBySiteList: 'Download all Servers as Excel',
        saveAndContinueShopping: 'Save & Continue Shopping',
        saveForLater: 'Save For Later',
        takeTour: 'Click the button below to restart the Siemens Advantage tour.',
        total: 'Total',
        totalCredits: 'Total credits',
        tour: 'Tour',
        transactionReportFilename: 'Siemens Advantage Transactions For Deal',
        transactions: 'Transactions',
        unknownPlatform: 'Unknown platform',
        user: 'User',
        username: 'Username',
        uploadNewConfiguration: 'Upload new configuration',
        uploadedConfiguration: 'Uploading configuration file. Please wait .....',
        uploading: 'Uploading...',
        uploadError: 'There was a problem during upload. Please try again',
        uploadConfigurationProductList: 'Upload New Configuration',
        version: 'Version',
        weekAbbr: 'wk',
        weekly: 'Weekly',
        weeks: 'Weeks',
        welcome: 'Welcome to Siemens Advantage',
        warning: 'warning',
        yes: 'Yes'
    }
});

exports.default = strings;

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JoyrideActions = function JoyrideActions() {
    _classCallCheck(this, JoyrideActions);
};

JoyrideActions.STATUS = {
    UNFINISHED: 'unfinished',
    FINISHED: 'finished',
    CANCELED: 'canceled'
};
JoyrideActions.types = (0, _ReduxTools.actionsFromList)(['START_JOYRIDE', 'FINISH_JOYRIDE', 'CANCEL_JOYRIDE', 'SAVING_JOYRIDE_STATUS', 'SAVED_JOYRIDE_STATUS']);

JoyrideActions.savingJoyrideStatus = function (status) {
    return {
        type: JoyrideActions.types.SAVING_JOYRIDE_STATUS,
        payload: { status: status }
    };
};

JoyrideActions.savedJoyrideStatus = function () {
    return {
        type: JoyrideActions.types.SAVED_JOYRIDE_STATUS
    };
};

JoyrideActions.startJoyride = function () {
    return function (dispatch) {
        dispatch({ type: JoyrideActions.types.START_JOYRIDE });
        dispatch(JoyrideActions.updateJoyrideStatus(JoyrideActions.STATUS.UNFINISHED));
    };
};

JoyrideActions.cancelJoyride = function () {
    return function (dispatch) {
        dispatch({ type: JoyrideActions.types.CANCEL_JOYRIDE });
        dispatch(JoyrideActions.updateJoyrideStatus(JoyrideActions.STATUS.CANCELED));
        dispatch(_cart2.default.setItems());
    };
};

JoyrideActions.finishJoyride = function () {
    return function (dispatch) {
        dispatch({ type: JoyrideActions.types.FINISH_JOYRIDE });
        dispatch(JoyrideActions.updateJoyrideStatus(JoyrideActions.STATUS.FINISHED));
        dispatch(_cart2.default.setItems());
    };
};

JoyrideActions.updateJoyrideStatus = function (status) {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(JoyrideActions.savingJoyrideStatus(status));

        state.api.updateMyPreferences({ joyrideStatus: status }).then(function (response) {
            return dispatch(JoyrideActions.savedJoyrideStatus(response));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

exports.default = JoyrideActions;

/***/ }),

/***/ 1360:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(974);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bootstrap = __webpack_require__(348);

var _bootstrap2 = _interopRequireDefault(_bootstrap);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

var _help = __webpack_require__(115);

var _help2 = _interopRequireDefault(_help);

var _joyride = __webpack_require__(134);

var _joyride2 = _interopRequireDefault(_joyride);

var _login = __webpack_require__(350);

var _login2 = _interopRequireDefault(_login);

var _offer = __webpack_require__(113);

var _offer2 = _interopRequireDefault(_offer);

var _order = __webpack_require__(78);

var _order2 = _interopRequireDefault(_order);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _user = __webpack_require__(112);

var _user2 = _interopRequireDefault(_user);

var _sites = __webpack_require__(114);

var _sites2 = _interopRequireDefault(_sites);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, _bootstrap2.default.types, _cart2.default.types, _error2.default.types, _help2.default.types, _joyride2.default.types, _login2.default.types, _offer2.default.types, _order2.default.types, _ui2.default.types, _user2.default.types, _sites2.default.types);

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Header = __webpack_require__(815);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(1011);

var _Footer2 = _interopRequireDefault(_Footer);

__webpack_require__(1012);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseLayout = function (_Component) {
    _inherits(BaseLayout, _Component);

    function BaseLayout() {
        _classCallCheck(this, BaseLayout);

        return _possibleConstructorReturn(this, (BaseLayout.__proto__ || Object.getPrototypeOf(BaseLayout)).apply(this, arguments));
    }

    _createClass(BaseLayout, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_Header2.default, null),
                ' ',
                _react2.default.createElement(
                    'div',
                    { className: 'container-full p-y-lg bg-info-lighter' },
                     true ? _react2.default.createElement(
                        'div',
                        { className: 'container-full p-t-0' },
                        _react2.default.createElement(
                            'p',
                            null,
                            "Please Note our Siemens Advantage Portal will be down for system maintenance beginning Friday, 13 November 2026 7:00 PM PST through Saturday, 14 November 2026 8:00 PM PST. \n During this time, you will be unable to draw down from the system until it comes back online. \n \n We apologize for any inconvenience this causes.",
                            ' ',
                            _react2.default.createElement('br', null)
                        )
                    ) : _react2.default.createElement('div', null),
                    this.props.children
                ),
                ' '
            );
        }
    }]);

    return BaseLayout;
}(_react.Component);

exports.default = BaseLayout;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapObject = {
    id: _propTypes2.default.string.isRequired,
    lastModified: _propTypes2.default.string
};

var MapPropTypes = function MapPropTypes() {
    _classCallCheck(this, MapPropTypes);
};

MapPropTypes.AccountProps = _propTypes2.default.shape(_extends({}, MapObject, {
    active: _propTypes2.default.bool.isRequired,
    billTo: _propTypes2.default.string,
    bsdFlow: _propTypes2.default.string,
    businessModel: _propTypes2.default.string.isRequired,
    contact: _propTypes2.default.string.isRequired,
    mentorId: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    payer: _propTypes2.default.string,
    shipTo: _propTypes2.default.string,
    soldTo: _propTypes2.default.string
}));
MapPropTypes.AccountRepProps = _propTypes2.default.shape(_extends({}, MapObject, {
    active: _propTypes2.default.bool.isRequired,
    email: _propTypes2.default.string.isRequired,
    firstName: _propTypes2.default.string.isRequired,
    lastName: _propTypes2.default.string.isRequired,
    mentorId: _propTypes2.default.string.isRequired,
    phone: _propTypes2.default.string.isRequired
}));
MapPropTypes.ProductProps = _propTypes2.default.shape(_extends({}, MapObject, {
    active: _propTypes2.default.bool.isRequired,
    factoryReferencePrice: _propTypes2.default.number,
    factoryReferencePriceLocal: _propTypes2.default.number,
    mentorId: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    productFamilyId: _propTypes2.default.string.isRequired,
    productFamilyName: _propTypes2.default.string.isRequired
}));
MapPropTypes.ServerProps = _propTypes2.default.shape(_extends({}, MapObject, {
    active: _propTypes2.default.bool.isRequired,
    comment: _propTypes2.default.string,
    licenseType: _propTypes2.default.string,
    mentorId: _propTypes2.default.string.isRequired,
    platform: MapPropTypes.PlatformProps,
    productFlowCode: _propTypes2.default.string,
    siteServerConfigId: _propTypes2.default.string
}));
MapPropTypes.SiteProps = _propTypes2.default.shape(_extends({}, MapObject, {
    account: _propTypes2.default.oneOfType([_propTypes2.default.string, MapPropTypes.AccountProps]).isRequired,
    active: _propTypes2.default.bool.isRequired,
    address1: _propTypes2.default.string,
    address2: _propTypes2.default.string,
    city: _propTypes2.default.string,
    contact1: _propTypes2.default.string,
    contact2: _propTypes2.default.string,
    country: _propTypes2.default.string,
    mentorId: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string,
    phone: _propTypes2.default.string,
    postalCode: _propTypes2.default.string,
    servers: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, MapPropTypes.ServerProps])).isRequired,
    state: _propTypes2.default.string
}));
MapPropTypes.PlatformProps = _propTypes2.default.shape(_extends({}, MapObject, {
    active: _propTypes2.default.bool.isRequired,
    mentorId: _propTypes2.default.string.isRequired,
    variant: _propTypes2.default.string.isRequired,
    vendor: _propTypes2.default.string.isRequired
}));
MapPropTypes.LicenseProps = _propTypes2.default.shape(_extends({}, MapObject, {
    amount: _propTypes2.default.number.isRequired,
    duration: _propTypes2.default.number.isRequired,
    seats: _propTypes2.default.number.isRequired,
    validFrom: _propTypes2.default.string.isRequired,
    validTo: _propTypes2.default.string.isRequired,
    product: MapPropTypes.ProductProps,
    site: MapPropTypes.SiteProps.isRequired,
    server: MapPropTypes.ServerProps,
    timezoneOffset: _propTypes2.default.number.isRequired
}));
MapPropTypes.PriceQuoteProps = _propTypes2.default.shape({
    amount: _propTypes2.default.number.isRequired,
    price: _propTypes2.default.number.isRequired
});
MapPropTypes.PricingProps = _propTypes2.default.shape({
    product: MapPropTypes.ProductProps.isRequired,
    weekly: _propTypes2.default.arrayOf(MapPropTypes.PriceQuoteProps).isRequired,
    monthly: _propTypes2.default.arrayOf(MapPropTypes.PriceQuoteProps).isRequired
});
MapPropTypes.RoleProps = _propTypes2.default.shape({
    active: _propTypes2.default.bool.isRequired,
    name: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string
});
MapPropTypes.UserProps = _propTypes2.default.shape(_extends({}, MapObject, {
    account: MapPropTypes.AccountProps,
    active: _propTypes2.default.bool.isRequired,
    address1: _propTypes2.default.string,
    address2: _propTypes2.default.string,
    city: _propTypes2.default.string,
    comment: _propTypes2.default.string,
    country: _propTypes2.default.string,
    email: _propTypes2.default.string,
    firstName: _propTypes2.default.string.isRequired,
    lastName: _propTypes2.default.string.isRequired,
    phone: _propTypes2.default.string,
    postalCode: _propTypes2.default.string,
    roles: _propTypes2.default.arrayOf(MapPropTypes.RoleProps).isRequired,
    signinOnly: _propTypes2.default.bool.isRequired,
    signinTransition: _propTypes2.default.string,
    state: _propTypes2.default.string,
    username: _propTypes2.default.string.isRequired,
    checkProductConfig: _propTypes2.default.bool,
    checkHostServerConfig: _propTypes2.default.bool
}));
MapPropTypes.TransactionProps = _propTypes2.default.shape(_extends({}, MapObject, {
    amount: _propTypes2.default.number.isRequired,
    batchTimestamp: _propTypes2.default.string,
    confirmation: _propTypes2.default.string.isRequired,
    currency: _propTypes2.default.string,
    dealConsumptionId: _propTypes2.default.number,
    description: _propTypes2.default.string,
    instructions: _propTypes2.default.string,
    licenses: _propTypes2.default.arrayOf(MapPropTypes.LicenseProps),
    offer: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string,
    user: _propTypes2.default.oneOfType([_propTypes2.default.string, MapPropTypes.UserProps, _propTypes2.default.instanceOf(null)])
}));
MapPropTypes.OfferProps = _propTypes2.default.shape(_extends({}, MapObject, {
    account: MapPropTypes.AccountProps.isRequired,
    accountReps: _propTypes2.default.arrayOf(MapPropTypes.AccountRepProps).isRequired,
    active: _propTypes2.default.bool.isRequired,
    amount: _propTypes2.default.number.isRequired,
    approved: _propTypes2.default.string,
    balance: _propTypes2.default.number.isRequired,
    currency: _propTypes2.default.string,
    discount: _propTypes2.default.number.isRequired,
    exportFormat: _propTypes2.default.string.isRequired,
    fulfillmentContactId: _propTypes2.default.string.isRequired,
    fulfillmentContactName: _propTypes2.default.string.isRequired,
    idealDealId: _propTypes2.default.string,
    isEld: _propTypes2.default.bool.isRequired,
    mentorId: _propTypes2.default.string.isRequired,
    po: _propTypes2.default.string.isRequired,
    poDate: _propTypes2.default.string.isRequired,
    poolId: _propTypes2.default.string,
    pricing: _propTypes2.default.arrayOf(MapPropTypes.PricingProps).isRequired,
    quote: _propTypes2.default.string,
    sites: _propTypes2.default.arrayOf(MapPropTypes.SiteProps).isRequired,
    transactions: _propTypes2.default.arrayOf(MapPropTypes.TransactionProps).isRequired,
    // users: PropTypes.arrayOf(MapPropTypes.UserProps).isRequired,
    validFrom: _propTypes2.default.string.isRequired,
    validTo: _propTypes2.default.string.isRequired
}));
MapPropTypes.FaqProps = _propTypes2.default.shape({
    answer: _propTypes2.default.string.isRequired,
    question: _propTypes2.default.string.isRequired
});
MapPropTypes.ContactProps = _propTypes2.default.shape({
    kind: _propTypes2.default.string.isRequired,
    recipients: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
});
MapPropTypes.BsdFlowProps = _propTypes2.default.arrayOf(_propTypes2.default.string);
MapPropTypes.BusinessModelProps = _propTypes2.default.arrayOf(_propTypes2.default.string);
MapPropTypes.CountryProps = _propTypes2.default.shape({
    abbr: _propTypes2.default.string.isRequired,
    full: _propTypes2.default.string.isRequired
});
MapPropTypes.CartItemProps = _propTypes2.default.shape({
    monthCount: _propTypes2.default.number.isRequired,
    productIndex: _propTypes2.default.number.isRequired,
    seats: _propTypes2.default.oneOfType([_propTypes2.default.number.isRequired, _propTypes2.default.string.isRequired]),
    serverIndex: _propTypes2.default.number,
    siteIndex: _propTypes2.default.number,
    weekCount: _propTypes2.default.number.isRequired,
    saveForLater: _propTypes2.default.bool.isRequired,
    itemDataChanged: _propTypes2.default.bool.isRequired
});
MapPropTypes.CartProps = _propTypes2.default.arrayOf(MapPropTypes.CartItemProps);
exports.default = MapPropTypes;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cart = __webpack_require__(794);

var _cart2 = _interopRequireDefault(_cart);

var _help = __webpack_require__(795);

var _help2 = _interopRequireDefault(_help);

var _joyride = __webpack_require__(796);

var _joyride2 = _interopRequireDefault(_joyride);

var _login = __webpack_require__(797);

var _login2 = _interopRequireDefault(_login);

var _offer = __webpack_require__(227);

var _offer2 = _interopRequireDefault(_offer);

var _order = __webpack_require__(798);

var _order2 = _interopRequireDefault(_order);

var _ui = __webpack_require__(799);

var _ui2 = _interopRequireDefault(_ui);

var _user = __webpack_require__(800);

var _user2 = _interopRequireDefault(_user);

var _sites = __webpack_require__(801);

var _sites2 = _interopRequireDefault(_sites);

var _configurations = __webpack_require__(802);

var _configurations2 = _interopRequireDefault(_configurations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    cart: _cart2.default,
    help: _help2.default,
    joyride: _joyride2.default,
    login: _login2.default,
    offer: _offer2.default,
    order: _order2.default,
    ui: _ui2.default,
    user: _user2.default,
    sites: _sites2.default,
    configurations: _configurations2.default
};

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatPrice = formatPrice;
exports.formatDate = formatDate;
exports.formatDateTime = formatDateTime;
exports.phoneLink = phoneLink;
exports.accountLabel = accountLabel;
exports.userLabel = userLabel;
exports.siteLabel = siteLabel;
exports.serverLabel = serverLabel;
exports.formatString = formatString;

var _numeral = __webpack_require__(225);

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatPrice(p) {
    return (0, _numeral2.default)(p).format('0,0');
}

function formatDate(d) {
    return (0, _moment2.default)(d).format('L');
}

function formatDateTime(d) {
    if (!_moment2.default.isMoment(d)) {
        d = (0, _moment2.default)(d);
    }
    return d.format('L hh:mm:ss A');
}

function phoneLink(p) {
    var result = p.replace(/[^0-9]/g, '');

    // assume us
    if (result.charAt(0) !== '+') {
        result = '+1' + result;
    }

    return 'tel:' + result;
}

function accountLabel(a) {
    return (a.mentorId ? a.mentorId + ' - ' : '') + a.name + (!a.active ? ' (' + _strings2.default.inactive + ')' : '');
}

function userLabel(u) {
    var label = '';

    if (u.firstName && u.lastName) {
        label = u.lastName + ', ' + u.firstName;
        if (u.email) {
            label += ' - ' + u.email;
        }
    } else if (u.email) {
        label = u.email;
    } else {
        label = _strings2.default.newUser;
    }

    if (!u.active) {
        label += ' (' + _strings2.default.inactive + ')';
    }

    return label;
}

function siteLabel(s) {
    return s.mentorId + ' - ' + s.name;
}

function serverLabel(s) {
    var label = s.mentorId;

    if (s.platform && s.platform.mentorId) {
        label += ' - ' + s.platform.mentorId;
    }

    return label;
}

function formatString() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    // The string containing the format items (e.g. "{0}")
    // will and always has to be the first argument.
    var theString = args[0];

    // start with the second argument (i = 1)
    for (var i = 1; i < args.length; i++) {
        // "gm" = RegEx options for Global search (more than one instance)
        // and for Multiline search
        var regEx = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
        theString = theString.replace(regEx, args[i]);
    }

    return theString;
}

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = __webpack_require__(88);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferSelectors = function OfferSelectors() {
    _classCallCheck(this, OfferSelectors);
};

OfferSelectors.getOffers = function (state) {
    return state.offer.offers;
};

OfferSelectors.getSelectedOfferIndex = function (state) {
    return state.offer.selectedOfferIndex;
};

OfferSelectors.getOffersRetrieved = function (state) {
    return state.offer.offersRetrieved;
};

OfferSelectors.getSelectedProductIndex = function (state) {
    return state.offer.selectedProductIndex;
};

OfferSelectors.showOfferSelect = (0, _reselect.createSelector)(OfferSelectors.getOffers, OfferSelectors.getSelectedOfferIndex, function (offers, index) {
    return index > -1 && offers.length > 1;
});
OfferSelectors.getSelectedOffer = (0, _reselect.createSelector)(OfferSelectors.getOffers, OfferSelectors.getSelectedOfferIndex, function (offers, index) {
    return index >= 0 ? offers[index] : null;
});
OfferSelectors.getSelectedCurrency = (0, _reselect.createSelector)(OfferSelectors.getSelectedOffer, function (offer) {
    return offer ? offer.currency : 'USD';
});
OfferSelectors.getSelectedOfferId = (0, _reselect.createSelector)(OfferSelectors.getSelectedOffer, function (offer) {
    return offer ? offer.id : '';
});
OfferSelectors.getSelectedTransactions = (0, _reselect.createSelector)(OfferSelectors.getSelectedOffer, function (offer) {
    return offer ? offer.transactions : [];
});
OfferSelectors.getSelectedBalance = (0, _reselect.createSelector)(OfferSelectors.getSelectedOffer, function (offer) {
    return offer ? offer.balance : 0;
});
OfferSelectors.getLastTransaction = (0, _reselect.createSelector)(OfferSelectors.getSelectedTransactions, function (transactions) {
    return transactions.reduce(function (result, t) {
        return (0, _moment2.default)(t.lastModified) > (0, _moment2.default)(result.lastModified) ? t : result;
    }, transactions[0]);
});
OfferSelectors.getSortedTransactions = (0, _reselect.createSelector)(OfferSelectors.getSelectedTransactions, function (transactions) {
    return transactions.slice().sort(function (a, b) {
        if (a.lastModified < b.lastModified) {
            return 1;
        }
        if (a.lastModified > b.lastModified) {
            return -1;
        }
        return 0;
    });
});
OfferSelectors.getOfferIsUsable = (0, _reselect.createSelector)(OfferSelectors.getSelectedOffer, function (offer) {
    return Boolean(offer && offer.active && offer.account &&
    // offer.balance > 0 &&
    offer.pricing.length > 0 && offer.sites.length > 0);
});
OfferSelectors.getServersGroupedBySite = (0, _reselect.createSelector)(OfferSelectors.getSelectedOffer, function (offer) {
    var configured = {};
    var siteStash = {};

    if (!offer) {
        return [];
    }

    offer.servers.forEach(function (s) {
        return configured[s.id] = s;
    });

    offer.sites.forEach(function (site) {
        site.servers.forEach(function (server) {
            if (configured[server.id]) {
                if (!siteStash[site.id]) {
                    siteStash[site.id] = Object.assign({}, site);
                    siteStash[site.id].servers = [];
                }
                siteStash[site.id].servers.push(server);
            }
        });
    });

    return Object.values(siteStash);
});
OfferSelectors.getIsPricingContinuous = (0, _reselect.createSelector)(OfferSelectors.getSelectedOffer, function (offer) {
    if (!offer || offer.pricing.length === 0) {
        return false;
    }

    var monthly = offer.pricing[0].monthly;
    var amounts = monthly.map(function (m) {
        return m.amount;
    });
    var min = Math.min.apply(Math, _toConsumableArray(amounts));
    var max = Math.max.apply(Math, _toConsumableArray(amounts));
    var amountSet = new Set(amounts);

    for (var i = min; i <= max; i++) {
        if (!amountSet.has(i)) {
            return false;
        }
    }

    return true;
});
OfferSelectors.getHasOnlyWeeklyPricing = (0, _reselect.createSelector)(OfferSelectors.getSelectedOffer, function (offer) {
    if (offer.weeklyPricingEnabled && offer.pricing[0]) {
        return offer.pricing[0].weekly.length > 0 && offer.pricing[0].monthly.length === 0;
    }
    return false;
});
exports.default = OfferSelectors;

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_Component) {
    _inherits(Label, _Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'text-xs text-uppercase text-mute m-t-xs' },
                _strings2.default[this.props.s]
            );
        }
    }]);

    return Label;
}(_react.Component);

Label.propTypes = { s: _propTypes2.default.string.isRequired };
exports.default = Label;

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FLATPICKR_FORMAT = undefined;

var _numeral = __webpack_require__(225);

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FLATPICKR_FORMAT = exports.FLATPICKR_FORMAT = 'm/j/y';

exports.default = {
    formatPrice: function formatPrice(n) {
        return (0, _numeral2.default)(n).format('0,0.00');
    },

    formatDate: function formatDate(d) {
        return (0, _moment2.default)(d).format('dddd LL');
    },

    formatShortDate: function formatShortDate(d) {
        return (0, _moment2.default)(d).format('L');
    },

    amountClass: function amountClass(t) {
        return ['credit', 'adjustment'].indexOf(t.type) > -1 ? 'text-success' : 'text-danger';
    },

    truncateString: function truncateString(s) {
        var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
        return s.length > l ? s.substring(0, l) + '\u2026' : s;
    },

    formatString: function formatString(source, params) {
        $.each(params, function (i, n) {
            source = source.replace(new RegExp('\\{' + i + '\\}', 'g'), n);
        });
        return source;
    },
    isDateRangeSoldTO: function isDateRangeSoldTO(soldTo) {
        return "201876".includes(soldTo) ? true : false;
    }

};

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ReduxTools = __webpack_require__(11);

var _IdleMonitor = __webpack_require__(221);

var _cookie = __webpack_require__(349);

var _cookie2 = _interopRequireDefault(_cookie);

var _login = __webpack_require__(350);

var _login2 = _interopRequireDefault(_login);

var _user = __webpack_require__(112);

var _user2 = _interopRequireDefault(_user);

var _offer = __webpack_require__(113);

var _offer2 = _interopRequireDefault(_offer);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BootstrapActions = function BootstrapActions() {
    _classCallCheck(this, BootstrapActions);
};

BootstrapActions.types = (0, _ReduxTools.actionsFromList)(['APP_MOUNTED']);

BootstrapActions.appMounted = function () {
    return { type: BootstrapActions.types.APP_MOUNTED };
};

BootstrapActions.bootstrapApp = function () {
    return function (dispatch, getState) {
        var cookies = _cookie2.default.parse(document.cookie);

        if (!cookies.xsrf_token) {
            dispatch(_login2.default.wantLogin(true));
            return;
        }

        dispatch(_login2.default.storeXsrfToken(cookies.xsrf_token));
        dispatch((0, _IdleMonitor.startIdleMonitor)());

        Promise.all([getState().api.getMyUser(), getState().api.getMyOffers()]).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                user = _ref2[0],
                offers = _ref2[1];

            dispatch(_user2.default.receivedUser(user));
            dispatch(_offer2.default.receivedOffers(offers));
        }).then(function () {
            dispatch(BootstrapActions.appMounted()); // Ensure this dispatch happens first
            dispatch(_cart2.default.setItems()); // Dispatch with user and selectedOffer
            if (!getState().myself.preferences.joyrideStatus) {
                dispatch(_ui2.default.openModal('newUser'));
            }
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

exports.default = BootstrapActions;

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginActions = function LoginActions() {
    _classCallCheck(this, LoginActions);
};

LoginActions.types = (0, _ReduxTools.actionsFromList)(['WANT_LOGIN', 'STORE_XSRF_TOKEN']);

LoginActions.wantLogin = function (want) {
    return {
        type: LoginActions.types.WANT_LOGIN,
        payload: { wantLogin: want }
    };
};

LoginActions.storeXsrfToken = function (token) {
    return {
        type: LoginActions.types.STORE_XSRF_TOKEN,
        payload: { xsrfToken: token }
    };
};

exports.default = LoginActions;

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logException = logException;
var Raven = __webpack_require__(352);
var clientConfig = Raven.config("https://7699431fa3564ca5b4ba576b0c7fb9ba@sentry.io/306596", {
    logger: 'client',
    node_end: "production",
    mgc_env: "prod",
    api_url: "https://advantage.sw.siemens.com/api/v1"
});
var client = null;
var SENTRY_ENABLED = "false" && "false" !== 'false';

if (SENTRY_ENABLED) {
    client = clientConfig.install();
}

function logException(e) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (SENTRY_ENABLED) {
        client.captureException(e, {
            extra: Object.assign({}, context, { _env: Object({"NODE_ENV":"production"}) })
        });
    }
    /* eslint no-console:0*/
    console && console.error && console.error(e);
}

exports.default = { logException: logException };

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

var _help = __webpack_require__(115);

var _help2 = _interopRequireDefault(_help);

var _offer = __webpack_require__(113);

var _offer2 = _interopRequireDefault(_offer);

var _order = __webpack_require__(78);

var _order2 = _interopRequireDefault(_order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UiActions = function UiActions() {
    _classCallCheck(this, UiActions);
};

UiActions.types = (0, _ReduxTools.actionsFromList)(['CLOSE_MODAL', 'OPEN_MODAL', 'SWITCH_ACCOUNT_MODAL_VIEW']);

UiActions.openModal = function (modalName) {
    return {
        type: UiActions.types.OPEN_MODAL,
        payload: { modalName: modalName }
    };
};

UiActions.closeModal = function (modalName) {
    return {
        type: UiActions.types.CLOSE_MODAL,
        payload: { modalName: modalName }
    };
};

UiActions.switchAccountModalPane = function (pane) {
    return {
        type: UiActions.types.SWITCH_ACCOUNT_MODAL_VIEW,
        payload: { pane: pane }
    };
};

UiActions.openHelpModal = function () {
    return function (dispatch, getState) {
        var state = getState();

        if (_selectors2.default.help.getFaqs(state).length === 0) {
            dispatch(_help2.default.requestFaqs());
        }
        if (_selectors2.default.help.getContacts(state).length === 0) {
            dispatch(_help2.default.requestContacts());
        }
        dispatch(UiActions.openModal('help'));
    };
};

UiActions.finishOrder = function (history) {
    return function (dispatch) {
        dispatch(_cart2.default.setItems());
        dispatch(_offer2.default.requestOffers());
        dispatch(_offer2.default.selectProduct(-1));
        dispatch(_order2.default.resetProgress());
        dispatch(UiActions.closeModal('checkout'));

        history.push('/order');
    };
};

UiActions.finishExcelOrder = function (history) {
    return function (dispatch) {
        dispatch(_cart2.default.setItems());
        dispatch(_offer2.default.requestOffers());
        dispatch(_order2.default.resetExcelProgress());
        dispatch(UiActions.closeModal('validation'));

        history.push('/order');
    };
};

UiActions.closeCheckoutModal = function () {
    return function (dispatch) {
        dispatch(UiActions.closeModal('checkout'));
        dispatch(_order2.default.resetProgress());
    };
};

UiActions.closeShoppingCartModal = function () {
    return function (dispatch) {
        dispatch(UiActions.closeModal('shoppingcart'));
        dispatch(_order2.default.resetProgress());
    };
};

UiActions.closeValidationModal = function () {
    return function (dispatch) {
        dispatch(UiActions.closeModal('validation'));
    };
};

UiActions.closeFailedValidationModal = function () {
    return function (dispatch) {
        dispatch(UiActions.closeModal('failedValidation'));
    };
};

UiActions.closeHelpModal = function () {
    return function (dispatch) {
        dispatch(UiActions.closeModal('help'));
        dispatch(_help2.default.updateContactMessage(''));
        dispatch(_help2.default.updateContactSubjectIndex(0));
    };
};

exports.default = UiActions;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

var _order = __webpack_require__(78);

var _order2 = _interopRequireDefault(_order);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UploadConfigurationActions = function UploadConfigurationActions() {
    _classCallCheck(this, UploadConfigurationActions);
};

UploadConfigurationActions.types = (0, _ReduxTools.actionsFromList)([
// Uploading
'PRICE_SHEET_UPLOADING', 'CONFIGURATION_SHEET_UPLOAD_ERROR', 'CONFIGURATION_SHEET_UPLOAD_PROGRESS', 'PRICE_SHEET_UPLOAD_SUCCESS', 'RECEIVED_PRICE_SHEET', 'REQUESTING_CONFIGURATION_SHEET', 'CONFIGURATION_SHEET_UPLOADING', 'SET_DRAG_OVER', 'SET_UNKOWN_FILETYE', 'RECEIVED_CONFIGURATION_SHEET_RESPONSE', 'CONFIGURATION_SHEET_UPLOAD_SUCCESS', 'SET_ERROR_MESSAGE', 'CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE', 'CLEAR_EXCEL_SHEET_UPLOAD_ERROR_RESPONSE', 'SUPERMAN', 'SET_DOWNLOAD_SPINNER']);

UploadConfigurationActions.setErrorMessage = function (message) {
    return {
        type: UploadConfigurationActions.types.SET_ERROR_MESSAGE,
        payload: { message: message }
    };
};

UploadConfigurationActions.setExcelUploadErrorResponseData = function (message) {
    return {
        type: UploadConfigurationActions.types.CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE,
        payload: { message: message }
    };
};

UploadConfigurationActions.clearExcelSheetUploadError = function () {
    return {
        type: UploadConfigurationActions.types.CLEAR_EXCEL_SHEET_UPLOAD_ERROR_RESPONSE
    };
};

UploadConfigurationActions.setDragOver = function (boolVal) {
    return {
        type: UploadConfigurationActions.types.SET_DRAG_OVER,
        payload: { boolVal: boolVal }
    };
};

UploadConfigurationActions.setUnknownFileType = function (boolVal) {
    return {
        type: UploadConfigurationActions.types.SET_UNKOWN_FILETYE,
        payload: { boolVal: boolVal }
    };
};

UploadConfigurationActions.uploadingConfigurationExcelSheet = function (file) {
    return {
        type: UploadConfigurationActions.types.CONFIGURATION_SHEET_UPLOADING,
        payload: { file: file }
    };
};

UploadConfigurationActions.configurationSheetUploadProgress = function (total, complete) {
    return {
        type: UploadConfigurationActions.types.CONFIGURATION_SHEET_UPLOAD_PROGRESS,
        payload: { total: total, complete: complete }
    };
};

UploadConfigurationActions.excelSheetUploadError = function (error) {
    var data = {
        type: UploadConfigurationActions.types.CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE,
        payload: { error: error }
    };
    return data;
};

UploadConfigurationActions.receivedConfigurationSheetResponse = function (response) {
    return {
        type: UploadConfigurationActions.types.RECEIVED_CONFIGURATION_SHEET_RESPONSE,
        payload: { response: response }
    };
};

UploadConfigurationActions.requestingConfigurationSheet = function (sheetName) {
    return {
        type: PricingActions.types.REQUESTING_CONFIGURATION_SHEET,
        payload: { sheetName: sheetName }
    };
};

UploadConfigurationActions.configurationSheetUploadSuccess = function () {
    return {
        type: UploadConfigurationActions.types.CONFIGURATION_SHEET_UPLOAD_SUCCESS
    };
};

UploadConfigurationActions.setDownloadSpinner = function (boolVal) {
    return {
        type: UploadConfigurationActions.types.SET_DOWNLOAD_SPINNER,
        payload: boolVal
    };
};

UploadConfigurationActions.uploadConfigurationExcel = function (file, offerid) {
    return function (dispatch, getState) {
        var state = getState();
        dispatch(_order2.default.resetExcelProgress());
        dispatch(UploadConfigurationActions.clearExcelSheetUploadError(file));
        dispatch(UploadConfigurationActions.uploadingConfigurationExcelSheet(file));
        var timezoneOffset = (0, _moment2.default)().utcOffset() / 60;
        state.api.uploadConfigurationSheet(file, offerid, timezoneOffset, function (total, progress) {
            return dispatch(UploadConfigurationActions.configurationSheetUploadProgress(total, progress));
        }).then(function (result) {
            // Now convert blob to json data (We are receving the blob instead of
            // json because we are requesting responseType as 'blob' instead of 'application/json'
            // in MapApi.uploadConfigurationSheet, and this because from backend based on the
            // response type(400 or 200) we are sending different data type.
            // For 400 - it is excel blob obj, for 200 it is json. So from UI we stick to only
            // responseType as 'blob' as we cannot request a url with both blob and json)
            if (result.data.type == 'application/vnd.ms-excel') {
                dispatch(UploadConfigurationActions.excelSheetUploadError(result));
                dispatch(UploadConfigurationActions.setErrorMessage(_strings2.default.uploadError));
                dispatch(_ui2.default.openModal('failedValidation'));
                dispatch(UploadConfigurationActions.configurationSheetUploadSuccess());
            } else {
                var blobObj = result.data;
                var fileReader = new FileReader();
                var excelWorkbookData = {};
                fileReader.onload = function (e) {
                    excelWorkbookData = JSON.parse(e.target.result);
                    dispatch(UploadConfigurationActions.receivedConfigurationSheetResponse(excelWorkbookData));
                    dispatch(UploadConfigurationActions.configurationSheetUploadSuccess());
                    dispatch(_ui2.default.openModal('validation'));
                };
                // We need to send blob as input to fileReader
                fileReader.readAsText(blobObj);
                return excelWorkbookData;

                // dispatch(
                //     UploadConfigurationActions.receivedConfigurationSheetResponse(
                //         excelWorkbookData
                //     )
                // );
                // dispatch(
                //     UploadConfigurationActions.configurationSheetUploadSuccess()
                // );
                // dispatch(UiActions.openModal('validation'));
            }
        }).catch(function (error) {
            dispatch(UploadConfigurationActions.excelSheetUploadError(error));
            dispatch(_error2.default.catchError(error));
            dispatch(UploadConfigurationActions.setErrorMessage(_strings2.default.uploadError));
            dispatch(_ui2.default.openModal('failedValidation'));
            dispatch(UploadConfigurationActions.configurationSheetUploadSuccess());
        });
    };
};

exports.default = UploadConfigurationActions;

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavLines = function (_Component) {
    _inherits(NavLines, _Component);

    function NavLines() {
        _classCallCheck(this, NavLines);

        var _this = _possibleConstructorReturn(this, (NavLines.__proto__ || Object.getPrototypeOf(NavLines)).call(this));

        _this.state = { activeTab: '' };
        return _this;
    }

    _createClass(NavLines, [{
        key: '_handleClick',
        value: function _handleClick(name) {
            this.setState({ activeTab: name });
            this.props.onChange(name);
        }
    }, {
        key: '_getActiveTab',
        value: function _getActiveTab() {
            if (this.state.activeTab) {
                return this.state.activeTab;
            }
            if (this.props.activeTab) {
                return this.props.activeTab;
            }
            if (this.props.tabs.length > 0) {
                return this.props.tabs[0].name;
            }
            return '';
        }
    }, {
        key: '_renderTab',
        value: function _renderTab(tab) {
            var _this2 = this;

            return _react2.default.createElement(
                'li',
                { className: 'nav-item text-sm', key: String(Math.random()) },
                _react2.default.createElement(
                    'a',
                    {
                        className: 'cursor-pointer' + (this._getActiveTab() === tab.name ? ' active' : ''),
                        role: 'tab',
                        onClick: function onClick() {
                            return _this2._handleClick(tab.name);
                        }
                    },
                    tab.label
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'ul',
                { className: 'nav nav-lines' },
                this.props.tabs.map(function (tab, i) {
                    return _this3._renderTab(tab);
                })
            );
        }
    }]);

    return NavLines;
}(_react.Component);

NavLines.propTypes = {
    tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
    })).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    activeTab: _propTypes2.default.string
};
exports.default = NavLines;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = __webpack_require__(142);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _cart = __webpack_require__(60);

var _cart2 = _interopRequireDefault(_cart);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _help = __webpack_require__(115);

var _help2 = _interopRequireDefault(_help);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _ShoppingCartBase = __webpack_require__(983);

var _ShoppingCartBase2 = _interopRequireDefault(_ShoppingCartBase);

var _Summary = __webpack_require__(984);

var _Summary2 = _interopRequireDefault(_Summary);

var _Progress = __webpack_require__(1001);

var _Progress2 = _interopRequireDefault(_Progress);

__webpack_require__(1002);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShoppingCartModal = function (_Component) {
    _inherits(ShoppingCartModal, _Component);

    function ShoppingCartModal() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ShoppingCartModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShoppingCartModal.__proto__ || Object.getPrototypeOf(ShoppingCartModal)).call.apply(_ref, [this].concat(args))), _this), _this.removeItemFromCartAfterSaveCart = function () {
            var itemIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
            var cartId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var saveForLater = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            _this.props.saveShoppingCart(_this.props.user.id);
            if (itemIndex == -1 && cartId == '') {
                var cartIds = _this.props.cart.filter(function (item) {
                    return item.addedToCart && item.saveForLater == saveForLater;
                }).map(function (item) {
                    return item.cartId;
                });
                _this.props.removeItemFromCart(itemIndex, cartIds);
            } else _this.props.removeItemFromCart(itemIndex, cartId);
            // Place holder to close the pop if cart items are all empty in both sections - To be written if business asks for it.
        }, _this.onEditOrder = function () {
            _this.props.saveShoppingCart(_this.props.user.id); // Save the shopping cart        
            _this.props.onEditCartChange(true);
            _this.props.close(); // Close the modal
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ShoppingCartModal, [{
        key: '_handleContinueShoppingOrCloseClick',
        value: function _handleContinueShoppingOrCloseClick() {
            this.props.saveShoppingCart(this.props.user.id);
            this.props.close();
        }
    }, {
        key: '_handlePrintClick',
        value: function _handlePrintClick() {
            this.props.finishOrder(this.props.history);
            // if we print() right away, then we get a nice printout of the modal.
            // so we'll wait for the page to re-render before printing.
            // secret bonus: after an order, the user can print a receipt from the /order
            // or /checkout screens *at any time*. we store the last transaction made
            // in our redux store. it's used to fill out the receipt.
            setTimeout(function () {
                return window.print();
            }, 250);
        }
    }, {
        key: '_handleInstructionsUpdate',
        value: function _handleInstructionsUpdate(event) {
            this.props.updateInstructions(event.target.value);
        }
    }, {
        key: '_closeButtonClass',
        value: function _closeButtonClass() {
            if (this.props.orderFailed) {
                return 'btn-danger';
            }
            if (this.props.isSucessful) {
                return 'btn-success';
            }
            return 'btn-warning';
        }
    }, {
        key: '_renderContent',
        value: function _renderContent() {
            var _this2 = this;

            //console.log('sold to in checkout model=', this.props.soldTo)

            if (this.props.orderStarted) {
                return _react2.default.createElement(_Progress2.default, {
                    complete: this.props.orderComplete,
                    failed: this.props.orderFailed,
                    isSuccessful: this.props.orderIsSuccessful,
                    openHelp: function openHelp() {
                        return _this2.props.openHelpModal();
                    }
                });
            }

            return _react2.default.createElement(_Summary2.default, {
                cart: this.props.cart,
                cartTotal: this.props.cartTotal,
                offer: this.props.offer,
                onUpdateInstructions: function onUpdateInstructions(e) {
                    return _this2._handleInstructionsUpdate(e);
                },
                updateSaveForLater: this.props.updateSaveForLaterList // Pass the function
                , soldTo: this.props.soldTo,
                onEditOrder: this.onEditOrder,
                removeItemFromCart: function removeItemFromCart() {
                    return _this2.removeItemFromCartAfterSaveCart.apply(_this2, arguments);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.props.offer) {
                return _react2.default.createElement('span', null);
            }

            var itemsToPurchase = this.props.cart.filter(function (item) {
                return !item.saveForLater && item.addedToCart;
            });
            // Disable checkout if there are no items to purchase, or if any item has an
            // end date that is less than or equal to its start date (invalid date range).
            var hasInvalidDateRange = itemsToPurchase.some(function (item) {
                return !item.startDate || !item.endDate || (0, _moment2.default)(item.endDate).isSameOrBefore((0, _moment2.default)(item.startDate));
            });
            var areCartActionsDisabled = itemsToPurchase.length === 0 || hasInvalidDateRange;

            var actionButton = _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-success',
                    onClick: function onClick() {
                        return _this3.props.openCheckModal(_this3.props.user.id);
                    },
                    disabled: areCartActionsDisabled || this.props.orderInProgress
                },
                _strings2.default.checkout
            );

            return _react2.default.createElement(
                _ShoppingCartBase2.default,
                {
                    modalClassName: 'shoppingcart-modal',
                    modalTitle: _strings2.default.reviewCart,
                    visible: this.props.visible,
                    backdrop: 'static',
                    closeModal: function closeModal() {
                        return _this3._handleContinueShoppingOrCloseClick();
                    }
                },
                this._renderContent(),
                _react2.default.createElement(
                    'div',
                    { className: 'cart-footer' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn ' + this._closeButtonClass(),
                            onClick: function onClick() {
                                return _this3._handleContinueShoppingOrCloseClick();
                            },
                            disabled: areCartActionsDisabled || this.props.orderInProgress
                        },
                        _strings2.default.continueShopping
                    ),
                    '\xA0',
                    actionButton
                )
            );
        }
    }]);

    return ShoppingCartModal;
}(_react.Component);

ShoppingCartModal.propTypes = {
    // functions
    close: _propTypes2.default.func.isRequired,
    saveShoppingCart: _propTypes2.default.func.isRequired,
    onEditCartChange: _propTypes2.default.func,
    updateInstructions: _propTypes2.default.func.isRequired,
    updateSaveForLaterList: _propTypes2.default.func.isRequired,
    removeItemFromCart: _propTypes2.default.func.isRequired,
    finishOrder: _propTypes2.default.func.isRequired,
    openHelpModal: _propTypes2.default.func.isRequired,
    openCheckModal: _propTypes2.default.func.isRequired,
    // data
    cart: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        item: _MapPropTypes2.default.CartItemProps,
        product: _MapPropTypes2.default.PricingProps
    })).isRequired,
    cartTotal: _propTypes2.default.number.isRequired,
    offer: _MapPropTypes2.default.OfferProps,
    orderStarted: _propTypes2.default.bool.isRequired,
    orderComplete: _propTypes2.default.bool.isRequired,
    orderIsSuccessful: _propTypes2.default.bool.isRequired,
    orderInProgress: _propTypes2.default.bool.isRequired,
    orderFailed: _propTypes2.default.bool.isRequired,
    visible: _propTypes2.default.bool.isRequired,
    user: _MapPropTypes2.default.UserProps,
    history: _propTypes2.default.object,
    isSucessful: _propTypes2.default.bool,
    soldTo: _propTypes2.default.string
};

ShoppingCartModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        cart: _selectors2.default.cart.getCartContents,
        soldTo: _selectors2.default.cart.getSoldTo,
        cartTotal: _selectors2.default.cart.getTotal,
        offer: _selectors2.default.offer.getSelectedOffer,
        orderStarted: _selectors2.default.order.orderStarted,
        orderComplete: _selectors2.default.order.orderIsComplete,
        orderIsSuccessful: _selectors2.default.order.orderIsSuccessful,
        orderInProgress: _selectors2.default.order.orderInProgress,
        orderFailed: _selectors2.default.order.orderFailed,
        visible: _selectors2.default.ui.getShoppingCartModalVisible,
        user: _selectors2.default.user.getMyself
    });
};

ShoppingCartModal.mapDispatch = function (dispatch) {
    return {
        close: function close() {
            return dispatch(_ui2.default.closeShoppingCartModal());
        },
        saveShoppingCart: function saveShoppingCart(userId) {
            return dispatch(_cart2.default.saveShoppingCart(userId));
        },
        finishOrder: function finishOrder(history) {
            return dispatch(_ui2.default.finishOrder(history));
        },
        openCheckModal: function openCheckModal(userId) {
            dispatch(_cart2.default.saveShoppingCart(userId));
            dispatch(_ui2.default.closeModal('shoppingcart'));
            dispatch(_ui2.default.openModal('checkout'));
        },
        openHelpModal: function openHelpModal() {
            dispatch(_help2.default.showContactTab());
            dispatch(_help2.default.updateContactSubjectIndex(_help2.default.contactSubjects.indexOf('Support Inquiry')));
            dispatch(_ui2.default.closeCheckoutModal());
            dispatch(_ui2.default.openHelpModal());
        },
        updateInstructions: function updateInstructions(instructions) {
            return dispatch(_cart2.default.updateCartInstructions(instructions));
        },
        updateSaveForLaterList: function updateSaveForLaterList(itemId, flag) {
            return dispatch(_cart2.default.updateSaveForLaterList(itemId, flag));
        },
        removeItemFromCart: function removeItemFromCart(itemIndex, cartId) {
            return dispatch(_cart2.default.removeItemFromCart(itemIndex, cartId));
        }
    };
};

exports.default = (0, _reactRouter.withRouter)((0, _ReduxStore.attach)(ShoppingCartModal));

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint new-cap: 0 */


exports.ProgressPill = ProgressPill;
exports.ProgressBar = ProgressBar;
exports.ProgressStub = ProgressStub;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// helper to render the internal child progress bar.
function renderChild(childProps, key) {
  var status = childProps.status ? childProps.status.toLowerCase() : '';
  var min = childProps.min || 0;
  var max = childProps.max || 100;
  var value = childProps.max ? (childProps.progress - min) / (max - min) * 100 : childProps.progress;
  if (status === 'auto') {
    status = value >= max ? 'success' : '';
  }
  var childClassName = (0, _classnames2.default)(childProps.className, 'progress-bar progress-bar-default ', { 'progress-bar-success': status === 'success' }, { 'progress-bar-info': status === 'info' }, { 'progress-bar-warning': status === 'warning' }, { 'progress-bar-danger': status === 'danger' });

  return _react2.default.createElement(
    'div',
    {
      className: childClassName,
      key: key,
      role: 'progressbar',
      'aria-valuenow': value,
      'aria-valuemin': min,
      'aria-valuemax': max,
      style: _extends({}, childProps.style, { width: value + '%' })
    },
    childProps.progressText && _react2.default.createElement(
      'div',
      { className: 'progress-label' },
      value >= max && childProps.status === 'auto' && _react2.default.createElement('i', { className: 'fa fa-check m-r-sm' }),
      childProps.progressText
    )
  );
}

function Progress(props) {
  var progress = void 0;

  var value = props.max ? props.progress / props.max * 100 : props.progress;
  var max = props.max || 100;

  if (_typeof(props.progress) === 'object') {
    progress = props.progress.map(function (item, index) {
      return renderChild(item, index);
    });
  } else {
    progress = renderChild(props);
  }

  var parentClassName = (0, _classnames2.default)(props.type, { progress: !props.type }, { 'progress-striped': props.striped }, { active: props.animated });

  return _react2.default.createElement(
    'div',
    { className: parentClassName },
    progress,
    (props.text || props.children) && _react2.default.createElement(
      'div',
      { className: 'progress-label' },
      value >= max && props.status === 'auto' && _react2.default.createElement('i', { className: 'fa fa-check m-r-sm' }),
      props.text,
      props.children
    )
  );
}

Progress.propTypes = {
  animated: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.element.isRequired,
  max: _propTypes2.default.number.isRequired,
  status: _propTypes2.default.string.isRequired,
  striped: _propTypes2.default.bool.isRequired,
  text: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired
};

function ProgressPill(props) {
  return Progress(_extends({}, props, { type: 'progress-pill' }));
}

function ProgressBar(props) {
  return Progress(_extends({}, props, {
    type: 'progress',
    text: '',
    progressText: props.text || props.children,
    children: ''
  }));
}

function ProgressStub(props) {
  return Progress(_extends({}, props, { type: 'progress-pill-stub' }));
}

var requiredTypes = {
  progress: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.array]).isRequired
};

Progress.propTypes = requiredTypes;
ProgressBar.propTypes = requiredTypes;
ProgressStub.propTypes = requiredTypes;
ProgressPill.propTypes = requiredTypes;

exports.default = Progress;

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactComponents = __webpack_require__(35);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _help = __webpack_require__(115);

var _help2 = _interopRequireDefault(_help);

var _joyride = __webpack_require__(134);

var _joyride2 = _interopRequireDefault(_joyride);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _NavLines = __webpack_require__(541);

var _NavLines2 = _interopRequireDefault(_NavLines);

var _ContactForm = __webpack_require__(1003);

var _ContactForm2 = _interopRequireDefault(_ContactForm);

__webpack_require__(1008);

var _package = __webpack_require__(1009);

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HelpModal = function (_Component) {
    _inherits(HelpModal, _Component);

    function HelpModal() {
        _classCallCheck(this, HelpModal);

        return _possibleConstructorReturn(this, (HelpModal.__proto__ || Object.getPrototypeOf(HelpModal)).apply(this, arguments));
    }

    _createClass(HelpModal, [{
        key: '_startJoyride',
        value: function _startJoyride() {
            setTimeout(function () {
                window.scrollTo({ top: 6, behavior: "smooth" });
            }, 100);
            this.props.startTour();
        }
    }, {
        key: '_renderFaqs',
        value: function _renderFaqs() {
            return _react2.default.createElement(
                'dl',
                { className: 'faq-list p-a-md' },
                this.props.faqs.map(function (faq, i) {
                    return _react2.default.createElement(
                        'span',
                        { key: i },
                        _react2.default.createElement(
                            'dt',
                            null,
                            faq.question
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            faq.answer
                        )
                    );
                })
            );
        }
    }, {
        key: '_renderContent',
        value: function _renderContent() {
            var _this2 = this;

            if (!this.props.helpIsLoaded) {
                return _react2.default.createElement(_reactComponents.Spinner, { size: 'large' });
            }

            switch (this.props.visibleTab) {
                case 'contact':
                    return _react2.default.createElement(_ContactForm2.default, {
                        contacts: this.props.contacts,
                        updateMessage: this.props.updateMessage,
                        updateSubjectIndex: this.props.updateSubjectIndex,
                        sendMessage: this.props.sendMessage,
                        message: this.props.contactMessage,
                        messageInTransit: this.props.contactMessageInTransit,
                        messageSent: this.props.contactMessageSent,
                        subjectIndex: this.props.contactSubjectIndex
                    });
                case 'tour':
                    return _react2.default.createElement(
                        'div',
                        { className: 'p-a-md' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _strings2.default.takeTour
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'pull-right m-b-0' },
                            _react2.default.createElement(
                                'button',
                                {
                                    onClick: function onClick() {
                                        return _this2._startJoyride();
                                    },
                                    className: 'btn btn-info'
                                },
                                _strings2.default.startTour
                            )
                        )
                    );
                case 'about':
                    return _react2.default.createElement(
                        'div',
                        { className: 'p-a-md' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                _strings2.default.mentorAdvantage
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                _strings2.default.version
                            ),
                            ':',
                            ' ',
                            _package2.default.version
                        )
                    );
                case 'faq':
                default:
                    return this._renderFaqs();
            }
        }
    }, {
        key: '_handleTabChange',
        value: function _handleTabChange(key) {
            switch (key) {
                case 'about':
                    return this.props.showAboutTab();
                case 'tour':
                    return this.props.showTourTab();
                case 'contact':
                    return this.props.showContactTab();
                case 'faq':
                default:
                    return this.props.showFaqTab();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'help-modal',
                    modalTitle: _strings2.default.help,
                    visible: this.props.visible,
                    closeModal: function closeModal() {
                        return _this3.props.closeModal();
                    }
                },
                _react2.default.createElement(_NavLines2.default, {
                    activeTab: this.props.visibleTab,
                    onChange: function onChange(key) {
                        return _this3._handleTabChange(key);
                    },
                    tabs: [{
                        name: 'faq',
                        label: _strings2.default.faq
                    }, {
                        name: 'contact',
                        label: _strings2.default.contact
                    }, {
                        name: 'tour',
                        label: _strings2.default.tour
                    }, {
                        name: 'about',
                        label: _strings2.default.about
                    }]
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'help-container' },
                        this._renderContent()
                    )
                )
            );
        }
    }]);

    return HelpModal;
}(_react.Component);

HelpModal.propTypes = {
    faqs: _propTypes2.default.arrayOf(_MapPropTypes2.default.FaqProps),
    contacts: _propTypes2.default.arrayOf(_MapPropTypes2.default.ContactProps),
    visible: _propTypes2.default.bool.isRequired,
    closeModal: _propTypes2.default.func.isRequired,
    startTour: _propTypes2.default.func.isRequired
};

HelpModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        visible: _selectors2.default.ui.getHelpModalVisible,
        faqs: _selectors2.default.help.getFaqs,
        contacts: _selectors2.default.help.getContacts,
        contactMessage: _selectors2.default.help.getContactMessage,
        contactSubjectIndex: _selectors2.default.help.getContactSubjectIndex,
        contactMessageInTransit: _selectors2.default.help.getContactMessageTransferring,
        contactMessageSent: _selectors2.default.help.getContactMessageSent,
        helpIsLoaded: _selectors2.default.help.getHelpIsLoaded,
        visibleTab: _selectors2.default.help.getVisibleTab
    });
};

HelpModal.mapDispatch = function (dispatch) {
    return {
        closeModal: function closeModal() {
            return dispatch(_ui2.default.closeHelpModal());
        },
        requestFaqs: function requestFaqs() {
            return dispatch(_help2.default.requestFaqs());
        },
        updateSubjectIndex: function updateSubjectIndex(index) {
            return dispatch(_help2.default.updateContactSubjectIndex(index));
        },
        updateMessage: function updateMessage(message) {
            return dispatch(_help2.default.updateContactMessage(message));
        },
        sendMessage: function sendMessage(subject, message) {
            return dispatch(_help2.default.sendContactMessage(subject, message));
        },
        showFaqTab: function showFaqTab() {
            return dispatch(_help2.default.showFaqTab());
        },
        showContactTab: function showContactTab() {
            return dispatch(_help2.default.showContactTab());
        },
        showTourTab: function showTourTab() {
            return dispatch(_help2.default.showTourTab());
        },
        startTour: function startTour() {
            dispatch(_ui2.default.closeModal('help'));
            dispatch(_joyride2.default.startJoyride());
        },
        showAboutTab: function showAboutTab() {
            return dispatch(_help2.default.showAboutTab());
        }
    };
};

exports.default = (0, _ReduxStore.attach)(HelpModal);

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactComponents = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loading = function (_Component) {
    _inherits(Loading, _Component);

    function Loading() {
        _classCallCheck(this, Loading);

        return _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).apply(this, arguments));
    }

    _createClass(Loading, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { id: 'loadingPage' },
                _react2.default.createElement(_reactComponents.Spinner, null)
            );
        }
    }]);

    return Loading;
}(_react.Component);

exports.default = Loading;

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

__webpack_require__(1132);

var _reactCustomScrollbars = __webpack_require__(252);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Summary = function (_Component) {
    _inherits(Summary, _Component);

    function Summary() {
        _classCallCheck(this, Summary);

        return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).apply(this, arguments));
    }

    _createClass(Summary, [{
        key: '_showEndDate',
        value: function _showEndDate() {
            if (this.props.offer.enterprise_deal || _utils2.default.isDateRangeSoldTO(this.props.soldTo) || this.props.offer.dailyPricingEnabled) {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: '_showDays',
        value: function _showDays() {
            if (this.props.offer.dailyPricingEnabled) {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: '_renderSummary',
        value: function _renderSummary() {
            if (!this.props.excelUpload == true) {
                return _react2.default.createElement(
                    'dl',
                    { className: 'dl-horizontal' },
                    _react2.default.createElement(
                        'dt',
                        { className: 'col-md-7 display-3' },
                        _strings2.default.creditsUsed
                    ),
                    _react2.default.createElement(
                        'dd',
                        { className: 'col-md-5 text-info display-3 text-emphasis-strong' },
                        _utils2.default.formatPrice(this.props.cartTotal)
                    ),
                    _react2.default.createElement(
                        'dt',
                        { className: 'col-md-7' },
                        _strings2.default.availableCredits
                    ),
                    _react2.default.createElement(
                        'dd',
                        { className: 'col-md-5' },
                        _utils2.default.formatPrice(this.props.offer.balance)
                    ),
                    _react2.default.createElement(
                        'dt',
                        { className: 'col-md-7' },
                        _strings2.default.remaining
                    ),
                    _react2.default.createElement(
                        'dd',
                        { className: 'col-md-5 text-success' },
                        _utils2.default.formatPrice(this.props.offer.balance - this.props.cartTotal)
                    )
                );
            }
        }
    }, {
        key: '_renderPurchases',
        value: function _renderPurchases() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'text-xs text-uppercase text-muted m-b-xs' },
                    _strings2.default.order
                ),
                _react2.default.createElement(
                    _reactCustomScrollbars.Scrollbars,
                    {
                        style: { width: '100%', height: 260 },
                        universal: true
                    },
                    _react2.default.createElement(
                        'table',
                        { className: 'table table-bordered table-striped' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.partNumber
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.product
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.seats
                                ),
                                this._showEndDate() && _react2.default.createElement(
                                    'th',
                                    null,
                                    'Start Date'
                                ),
                                this._showEndDate() && _react2.default.createElement(
                                    'th',
                                    null,
                                    'End Date'
                                ),
                                !this._showDays() && _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.months
                                ),
                                this._showDays() && _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.days
                                ),
                                this.props.offer.weeklyPricingEnabled && _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.weeks
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.subtotal
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            this.props.cart.filter(function (item) {
                                return _this2.props.excelUpload || item.addedToCart && !item.saveForLater;
                            }).map(function (item, i) {
                                return _react2.default.createElement(
                                    'tr',
                                    { key: i },
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        item.pricing.product.mentorId
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        item.pricing.product.name
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        item.seats
                                    ),
                                    _this2._showEndDate() && _react2.default.createElement(
                                        'td',
                                        { className: 'text-nowrap' },
                                        (0, _moment2.default)(item.startDate).format('MM-DD-YYYY')
                                    ),
                                    _this2._showEndDate() && _react2.default.createElement(
                                        'td',
                                        { className: 'text-nowrap' },
                                        (0, _moment2.default)(item.endDate).format('MM-DD-YYYY')
                                    ),
                                    !_this2._showDays() && _react2.default.createElement(
                                        'td',
                                        null,
                                        item.monthCount
                                    ),
                                    _this2._showDays() && _react2.default.createElement(
                                        'td',
                                        null,
                                        item.dayCount
                                    ),
                                    _this2.props.offer.weeklyPricingEnabled && _react2.default.createElement(
                                        'td',
                                        null,
                                        item.weekCount
                                    ),
                                    _react2.default.createElement(
                                        'td',
                                        null,
                                        _utils2.default.formatPrice(item.subtotal)
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '_renderCommentForm',
        value: function _renderCommentForm() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'text-xs text-uppercase text-muted m-b-xs' },
                    _strings2.default.notes
                ),
                _react2.default.createElement('textarea', {
                    className: 'form-control comment-field m-b',
                    placeholder: _strings2.default.enterSpecialInstructions,
                    onChange: function onChange(event) {
                        return _this3.props.onUpdateInstructions(event);
                    }
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'checkout-summary' },
                this._renderSummary(),
                this._renderPurchases(),
                this._renderCommentForm()
            );
        }
    }]);

    return Summary;
}(_react.Component);

Summary.propTypes = {
    cartTotal: _propTypes2.default.number.isRequired,
    offer: _MapPropTypes2.default.OfferProps.isRequired,
    cart: _MapPropTypes2.default.CartProps.isRequired,
    onUpdateInstructions: _propTypes2.default.func.isRequired,
    excelUpload: _propTypes2.default.bool,
    sheetResponseData: _propTypes2.default.object,
    soldTo: _propTypes2.default.string
};
exports.default = Summary;

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _user = __webpack_require__(112);

var _user2 = _interopRequireDefault(_user);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _assembleShoppingCart(userId, state) {
    var offer = _selectors2.default.offer.getSelectedOffer(state);
    var serversBySite = _selectors2.default.offer.getServersGroupedBySite(state);
    var soldTo = _selectors2.default.cart.getSoldTo(state);
    var timezoneOffset = (0, _moment2.default)().utcOffset() / 60;
    return _selectors2.default.cart.getCartContents(state).filter(function (item) {
        return item.itemDataChanged === true && item.addedToCart;
    }).map(function (item) {
        var offerEnd = (0, _moment2.default)(offer.validTo);
        var validTo = (0, _moment2.default)(item.startDate).add(item.monthCount, 'months');
        if (offer.enterprise_deal || _utils2.default.isDateRangeSoldTO(soldTo) || offer.dailyPricingEnabled) {
            validTo = (0, _moment2.default)(item.endDate);
        } else {
            if (offer.weeklyPricingEnabled && item.weekCount) {
                validTo = validTo.add(item.weekCount, 'weeks');
            }
        }
        validTo = validTo.isAfter(offerEnd) ? offerEnd : validTo;

        return {
            id: item.cartId,
            amount: item.subtotal,
            duration: item.monthCount,
            offer: _selectors2.default.offer.getSelectedOfferId(state),
            product: item.pricing.product.id || null,
            save_for_later: item.saveForLater,
            seats: item.seats,
            server: serversBySite[item.siteIndex].servers[item.serverIndex].id || null,
            site: serversBySite[item.siteIndex].id || null,
            tiered_discount: item.isTieredDiscountApplied || false,
            timezoneOffset: timezoneOffset,
            transaction: '',
            user: userId || null,
            validFrom: (0, _moment2.default)(item.startDate).toISOString(),
            validTo: validTo.toISOString(),
            weeks: item.weekCount || 0,
            wish_list_name: ''
        };
    });
}

var CartActions = function CartActions() {
    _classCallCheck(this, CartActions);
};

CartActions.types = (0, _ReduxTools.actionsFromList)(['ADD_ITEM_TO_CART', 'SELECT_ITEM_IN_CART', 'REMOVE_ITEM_FROM_CART', 'UPDATE_ITEM_SEATS', 'UPDATE_ITEM_MONTH_COUNT', 'UPDATE_ITEM_WEEK_COUNT', 'UPDATE_ITEM_START_DATE', 'UPDATE_ITEM_DATE_RANGE', 'UPDATE_ITEM_SERVER', 'UPDATE_CART_INSTRUCTIONS', 'CLEAR_CART', 'UPDATE_ITEM_END_DATE', 'UPDATE_SAVE_FOR_LATER_LIST', 'ADD_INITIAL_ITEMS_TO_CART', 'ADD_UNSAVED_ITEMS_TO_CART']);

CartActions.selectItemInCart = function (itemIndex) {
    return {
        type: CartActions.types.SELECT_ITEM_IN_CART,
        payload: { itemIndex: itemIndex }
    };
};

CartActions.updateCartItems = function (unsavedItems) {
    return {
        type: CartActions.types.ADD_UNSAVED_ITEMS_TO_CART,
        payload: { unsavedItems: unsavedItems }
    };
};

CartActions.setItems = function () {
    return function (dispatch, getState) {
        // Access the Redux state using getState
        var state = getState();

        // Get the selected offer using the selector
        var selectedOffer = _selectors2.default.offer.getSelectedOffer(state);
        var user = _selectors2.default.user.getMyself(state);
        var userCart = user && user.cart ? user.cart : [];
        var serversBySite = _selectors2.default.offer.getServersGroupedBySite(state);
        var unsaved_cart_items = _selectors2.default.cart.getCartContents(state).filter(function (item) {
            return !item.addedToCart;
        });
        dispatch({
            type: CartActions.types.ADD_INITIAL_ITEMS_TO_CART,
            payload: { userCart: userCart, selectedOffer: selectedOffer, serversBySite: serversBySite }
        });
        // retaining primary screen items not added to cart after updating data from DB.
        if (unsaved_cart_items && unsaved_cart_items.length > 0) dispatch(CartActions.updateCartItems(unsaved_cart_items));
    };
};

CartActions.removeItemFromCart = function (itemIndex, cartId) {
    return function (dispatch, getState) {
        var state = getState(); // Get the current state
        var triggerAPI = false;
        var cart_id_data = cartId;
        if (Array.isArray(cartId) && cartId.length > 0) {
            triggerAPI = true;
            cart_id_data = cartId;
        } else if (cartId && cartId.length > 0) {
            cart_id_data = [cartId];
            triggerAPI = true;
        } else {
            // If cartId is empty or null, simply remove the item locally
            console.log('No cart data available, skipping API call.');
            // Dispatch the action to remove the item from the cart
            dispatch({
                type: CartActions.types.REMOVE_ITEM_FROM_CART,
                payload: { itemIndex: itemIndex, cartId: cartId }
            });

            return Promise.resolve(); // Return resolved promise to avoid breaking flow
        }
        if (triggerAPI) {
            return state.api.deleteShoppingCartBulk(cart_id_data) // Make the API call
            .then(function (result) {
                if (result && result.data) {
                    dispatch(_user2.default.receivedUser(result));
                }
                dispatch(CartActions.setItems());
            }).catch(function (error) {
                console.error('Error removing item from cart:', error);
            });
        }
    };
};

CartActions.updateItemSeats = function (cartIndex, seats) {
    return {
        type: CartActions.types.UPDATE_ITEM_SEATS,
        payload: { cartIndex: cartIndex, seats: seats }
    };
};

CartActions.updateItemMonthCount = function (cartIndex, monthCount) {
    return {
        type: CartActions.types.UPDATE_ITEM_MONTH_COUNT,
        payload: { cartIndex: cartIndex, monthCount: monthCount }
    };
};

CartActions.updateItemWeekCount = function (cartIndex, weekCount) {
    return {
        type: CartActions.types.UPDATE_ITEM_WEEK_COUNT,
        payload: { cartIndex: cartIndex, weekCount: weekCount }
    };
};

CartActions.updateItemStartDate = function (cartIndex, startDate) {
    return {
        type: CartActions.types.UPDATE_ITEM_START_DATE,
        payload: { cartIndex: cartIndex, startDate: startDate }
    };
};

CartActions.updateItemDateRange = function (cartIndex, startDate, endDate) {
    return {
        type: CartActions.types.UPDATE_ITEM_DATE_RANGE,
        payload: { cartIndex: cartIndex, startDate: startDate, endDate: endDate }
    };
};

CartActions.updateItemEndDate = function (cartIndex, endDate) {
    return {
        type: CartActions.types.UPDATE_ITEM_END_DATE,
        payload: { cartIndex: cartIndex, endDate: endDate }
    };
};

CartActions.updateItemServer = function (cartIndex, siteIndex, serverIndex) {
    return {
        type: CartActions.types.UPDATE_ITEM_SERVER,
        payload: { cartIndex: cartIndex, siteIndex: siteIndex, serverIndex: serverIndex }
    };
};

CartActions.updateCartInstructions = function (instructions) {
    return {
        type: CartActions.types.UPDATE_CART_INSTRUCTIONS,
        payload: { instructions: instructions }
    };
};

CartActions.updateSaveForLaterList = function (cartIndex, saveForLater) {
    return {
        type: CartActions.types.UPDATE_SAVE_FOR_LATER_LIST,
        payload: { cartIndex: cartIndex, saveForLater: saveForLater }
    };
};

CartActions.clearCart = function () {
    return { type: CartActions.types.CLEAR_CART };
};

CartActions.saveShoppingCart = function (userId) {
    return function (dispatch, getState) {
        var state = getState();
        var cart_data = _assembleShoppingCart(userId, state);

        if (cart_data && cart_data.length > 0) {
            return state.api.saveShoppingCart(cart_data).then(function (result) {
                if (result && result.data) {
                    dispatch(_user2.default.receivedUser(result));
                }
                dispatch(CartActions.setItems());
            }).catch(function (error) {
                console.error('Error saving shopping cart:', error);
            });
        } else {
            console.log('No cart data available, skipping API call.');
            return Promise.resolve(); // Return a resolved promise to handle as a no-op
        }
    };
};

CartActions.addProductToCart = function (productIndex) {
    return function (dispatch, getState) {
        var state = getState();
        var siteIndex = _selectors2.default.user.getFavoriteSiteIndex(state);
        var serverIndex = _selectors2.default.user.getFavoriteServerIndex(state);
        var hasOnlyWeekly = _selectors2.default.offer.getHasOnlyWeeklyPricing(state);
        var amounts = _selectors2.default.offer.getSelectedOffer(state).pricing.map(function (item) {
            return item.monthly[0].amount;
        });
        var uniqueAmounts = [].concat(_toConsumableArray(new Set(amounts)));
        var amount = uniqueAmounts.length === 1 ? uniqueAmounts[0] : null;
        var soldTo = _selectors2.default.cart.getSoldTo(state);
        var dailyPricingEnabled = _selectors2.default.offer.getSelectedOffer(state).dailyPricingEnabled;
        var offerEndDate = _selectors2.default.offer.getSelectedOffer(state).validTo;

        dispatch({
            type: CartActions.types.ADD_ITEM_TO_CART,
            payload: {
                productIndex: productIndex,
                siteIndex: siteIndex,
                serverIndex: serverIndex,
                monthCount: hasOnlyWeekly ? 0 : amount,
                weekCount: hasOnlyWeekly ? 1 : 0,
                dayCount: 0,
                soldTo: soldTo,
                dailyPricingEnabled: dailyPricingEnabled,
                offerEndDate: offerEndDate
            }
        });
    };
};

exports.default = CartActions;

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _BrowserTools = __webpack_require__(322);

var _bootstrap = __webpack_require__(716);

var _bootstrap2 = _interopRequireDefault(_bootstrap);

var _MapApp = __webpack_require__(717);

var _MapApp2 = _interopRequireDefault(_MapApp);

__webpack_require__(579);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _bootstrap2.default)();

// Set div to build app in
var appContainer = document.getElementById('map-app');
var content = _react2.default.createElement(_MapApp2.default, null);

if (!(0, _BrowserTools.isBrowserSupported)()) {
    content = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_BrowserTools.BrowserWarning, null),
        _react2.default.createElement(_MapApp2.default, null)
    );
}

_reactDom2.default.render(content, appContainer);

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bootstrap;
// import numeral from 'numeral';
// import strings from './strings';

function bootstrap() {
    //numeral.locale(strings.getInterfaceLanguage());
}

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(215);

var _reactRouterDom = __webpack_require__(132);

var _store = __webpack_require__(763);

var _store2 = _interopRequireDefault(_store);

var _bootstrap = __webpack_require__(348);

var _bootstrap2 = _interopRequireDefault(_bootstrap);

var _Login = __webpack_require__(814);

var _Login2 = _interopRequireDefault(_Login);

var _Order = __webpack_require__(1014);

var _Order2 = _interopRequireDefault(_Order);

var _Root = __webpack_require__(1144);

var _Root2 = _interopRequireDefault(_Root);

var _UnknownUser = __webpack_require__(1145);

var _UnknownUser2 = _interopRequireDefault(_UnknownUser);

var _Joyride = __webpack_require__(1146);

var _Joyride2 = _interopRequireDefault(_Joyride);

var _NewUserModal = __webpack_require__(1147);

var _NewUserModal2 = _interopRequireDefault(_NewUserModal);

var _PrintableTransaction = __webpack_require__(1148);

var _PrintableTransaction2 = _interopRequireDefault(_PrintableTransaction);

__webpack_require__(1149);

__webpack_require__(1150);

__webpack_require__(579);

var _sites = __webpack_require__(114);

var _sites2 = _interopRequireDefault(_sites);

var _Downtime = __webpack_require__(1151);

var _Downtime2 = _interopRequireDefault(_Downtime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MapApp = function (_Component) {
    _inherits(MapApp, _Component);

    function MapApp() {
        _classCallCheck(this, MapApp);

        var _this = _possibleConstructorReturn(this, (MapApp.__proto__ || Object.getPrototypeOf(MapApp)).call(this));

        _this.state = { router: null };
        return _this;
    }

    _createClass(MapApp, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _store2.default.dispatch(_bootstrap2.default.bootstrapApp());
            // store.dispatch(SiteActions.fetchSitesForUserAccount());
            // store.dispatch(SiteActions.fetchSites());
        }
    }, {
        key: '_adminRedirect',
        value: function _adminRedirect() {
            var adminUrl = window.location.href.replace(/advantage\.sw\.siemens/g, 'advantage-admin.sw.siemens');
            window.location = adminUrl;
            return _react2.default.createElement(
                'span',
                null,
                'loading...'
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _reactRedux.Provider,
                { store: _store2.default },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'hidden-print' },
                        _react2.default.createElement(
                            _reactRouterDom.BrowserRouter,
                            { ref: function ref(r) {
                                    // I know, I know :(
                                    if (!_this2.state.router) {
                                        _this2.setState({ router: r });
                                    }
                                },
                                basename: '/' },
                            _react2.default.createElement(
                                _reactRouterDom.Switch,
                                null,
                                _react2.default.createElement(_reactRouterDom.Route, { path: '/login', component: _Login2.default, exact: true }),
                                _react2.default.createElement(_reactRouterDom.Route, { path: '/order', component: _Order2.default, exact: true }),
                                _react2.default.createElement(_reactRouterDom.Route, { path: '/unknown-user', component: _UnknownUser2.default, exact: true }),
                                _react2.default.createElement(_reactRouterDom.Route, { path: '/admin', render: function render() {
                                        return _this2._adminRedirect();
                                    } }),
                                _react2.default.createElement(_reactRouterDom.Route, { path: '/maintenance', component: _Downtime2.default, exact: true }),
                                _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: _Root2.default })
                            )
                        ),
                        _react2.default.createElement(_Joyride2.default, { router: this.state.router }),
                        _react2.default.createElement(_NewUserModal2.default, null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'visible-print-block' },
                        _react2.default.createElement(_PrintableTransaction2.default, null)
                    )
                )
            );
        }
    }]);

    return MapApp;
}(_react.Component);

exports.default = MapApp;

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReduxTools = __webpack_require__(11);

var _sentry = __webpack_require__(351);

var _sentry2 = _interopRequireDefault(_sentry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorActions = function () {
    function ErrorActions() {
        _classCallCheck(this, ErrorActions);
    }

    _createClass(ErrorActions, null, [{
        key: 'errorHandler',
        value: function errorHandler(dispatch) {
            return function (error) {
                _sentry2.default.logException(error);
                console.log(error);

                if (error.request && error.request.status === 401) {
                    dispatch(ErrorActions.authError(error));
                } else {
                    dispatch(ErrorActions.transferError(error));
                }
                throw error;
            };
        }

        // sync --------------------------------------------------------------------

    }]);

    return ErrorActions;
}();

ErrorActions.types = (0, _ReduxTools.actionsFromList)(['AUTH_ERROR', 'TRANSFER_ERROR', 'CATCH_ERROR', 'SET_ERROR_MESSAGE']);

ErrorActions.transferError = function (error) {
    return {
        type: ErrorActions.types.TRANSFER_ERROR,
        payload: { error: error }
    };
};

ErrorActions.authError = function (error) {
    return {
        type: ErrorActions.types.AUTH_ERROR,
        payload: { error: error }
    };
};

ErrorActions.catchError = function (error) {
    _sentry2.default.logException(error);
    console.error(error);

    return {
        type: ErrorActions.types.CATCH_ERROR,
        payload: { error: error }
    };
};

ErrorActions.setErrorMessage = function (message) {
    return {
        type: ErrorActions.types.SET_ERROR_MESSAGE,
        payload: { message: message }
    };
};

exports.default = ErrorActions;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(64);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalBase = function (_Component) {
    _inherits(ModalBase, _Component);

    function ModalBase() {
        _classCallCheck(this, ModalBase);

        return _possibleConstructorReturn(this, (ModalBase.__proto__ || Object.getPrototypeOf(ModalBase)).apply(this, arguments));
    }

    _createClass(ModalBase, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: this.props.modalClassName,
                    show: this.props.visible,
                    animation: false,
                    backdrop: this.props.backdrop,
                    onHide: function onHide() {
                        return _this2.props.closeModal();
                    }
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    null,
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        this.props.modalTitle,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'close',
                                'aria-label': _strings2.default.close,
                                onClick: function onClick() {
                                    return _this2.props.closeModal();
                                }
                            },
                            _react2.default.createElement(
                                'span',
                                null,
                                '\xD7'
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                _strings2.default.close
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    this.props.children
                )
            );
        }
    }]);

    return ModalBase;
}(_react.Component);

exports.default = ModalBase;

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReduxStore = __webpack_require__(25);

var _reducers = __webpack_require__(784);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _ReduxStore.createStore)(_reducers2.default);

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _error = __webpack_require__(72);

var _error2 = _interopRequireDefault(_error);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _user = __webpack_require__(112);

var _user2 = _interopRequireDefault(_user);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _sentry = __webpack_require__(351);

var _sentry2 = _interopRequireDefault(_sentry);

var _uploadConfiguration = __webpack_require__(494);

var _uploadConfiguration2 = _interopRequireDefault(_uploadConfiguration);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _assembleTransaction(state) {
    var offer = _selectors2.default.offer.getSelectedOffer(state);
    var serversBySite = _selectors2.default.offer.getServersGroupedBySite(state);
    var soldTo = _selectors2.default.cart.getSoldTo(state);
    var timezoneOffset = (0, _moment2.default)().utcOffset() / 60;
    //console.log('state order js=',state);
    return {
        amount: _selectors2.default.cart.getTotal(state),
        currency: _selectors2.default.offer.getSelectedCurrency(state),
        description: 'Software Order',
        instructions: _selectors2.default.cart.getInstructions(state),
        licenses: _selectors2.default.cart.getCartContents(state).filter(function (item) {
            return item.addedToCart && !item.saveForLater;
        }) // Exclude items with saveForLater === true
        .map(function (item) {
            var offerEnd = (0, _moment2.default)(offer.validTo);
            var validTo = (0, _moment2.default)(item.startDate).add(item.monthCount, 'months');
            if (offer.enterprise_deal || _utils2.default.isDateRangeSoldTO(soldTo) || offer.dailyPricingEnabled) {
                validTo = (0, _moment2.default)(item.endDate);
            } else {
                if (offer.weeklyPricingEnabled && item.weekCount) {
                    validTo = validTo.add(item.weekCount, 'weeks');
                }
            }
            validTo = validTo.isAfter(offerEnd) ? offerEnd : validTo;

            return {
                amount: item.subtotal,
                duration: item.monthCount,
                product: item.pricing.product.id,
                seats: item.seats,
                server: serversBySite[item.siteIndex].servers[item.serverIndex].id,
                site: serversBySite[item.siteIndex].id,
                timezoneOffset: timezoneOffset,
                validFrom: item.startDate,
                validTo: validTo.toISOString(),
                weeks: item.weekCount || 0,
                tiered_discount: item.isTieredDiscountApplied,
                cartId: item.cartId
            };
        }),
        offer: _selectors2.default.offer.getSelectedOfferId(state),
        type: 'order'
    };
}

function _return_date_time_adjusted_with_offset(date, timezoneOffset) {
    var dateTime = timezoneOffset > 0 ? (0, _moment2.default)(date).utcOffset(0, true).subtract(timezoneOffset, 'hours').toISOString() : (0, _moment2.default)(date).utcOffset(0, true).add(Math.abs(timezoneOffset), 'hours').toISOString();
    return dateTime;
}

function _build_licenses(cart, offer, timezoneOffset) {
    return cart.filter(function (item) {
        return !item.saveForLater;
    }) // Exclude items with saveForLater === true
    .map(function (item) {
        var offerEnd = (0, _moment2.default)(offer.validTo).toISOString();

        // Calculating validFrom and validTo moment date without timezone
        var validFrom = _return_date_time_adjusted_with_offset(item.startDate, timezoneOffset);
        var validTo = _return_date_time_adjusted_with_offset(item.endDate, timezoneOffset);

        // Even though the license end date given as greater than offer end period
        // We should allow license end date only until offer end period, so replace
        // it with offer end date
        if (validTo > offerEnd) {
            validTo = offerEnd;
        }

        return {
            amount: item.subtotal,
            duration: item.monthCount,
            product: item.pricing.product.productId,
            seats: item.seats,
            server: item.serverId,
            site: item.siteId,
            timezoneOffset: timezoneOffset,
            validFrom: validFrom,
            validTo: validTo,
            weeks: item.weekCount || 0,
            cartId: item.cartId
        };
    });
}

function _assembleBulkProductExcelUploadTransaction(state, cart) {
    var offer = _selectors2.default.offer.getSelectedOffer(state);
    var timezoneOffset = (0, _moment2.default)().utcOffset() / 60;

    return {
        amount: cart.reduce(function (sum, item) {
            return sum + item.subtotal;
        }, 0),
        currency: _selectors2.default.offer.getSelectedCurrency(state),
        description: 'Software Order',
        instructions: _selectors2.default.cart.getInstructions(state),
        licenses: _build_licenses(cart, offer, timezoneOffset),
        offer: _selectors2.default.offer.getSelectedOfferId(state),
        type: 'order',
        uploadType: 'excel',
        is_excel: Boolean(true)
    };
}

var OrderActions = function OrderActions() {
    _classCallCheck(this, OrderActions);
};

OrderActions.types = (0, _ReduxTools.actionsFromList)(['CANCELED_ORDER', 'CANCELING_ORDER', 'DOWNLOADED_TRANSACTION_REPORT', 'DOWNLOADING_TRANSACTION_REPORT', 'ORDER_COMPLETE', 'ORDER_FAILURE', 'EXCEL_ORDER_FAILURE', 'ORDER_INPROGRESS', 'ORDER_PROGRESS_RESET', 'SELECT_TRANSACTION', 'CANCELING_EXCEL_ORDER', 'CANCELED_EXCEL_ORDER', 'EXCEL_ORDER_INPROGRESS', 'EXCEL_ORDER_PROGRESS_RESET', 'EXCEL_ORDER_COMPLETE', 'DOWNLOADED_CONFIGURATION_LIST', 'DOWNLOADING_CONFIGURATION_LIST']);

OrderActions.resetProgress = function () {
    return {
        type: OrderActions.types.ORDER_PROGRESS_RESET
    };
};

OrderActions.resetExcelProgress = function () {
    return {
        type: OrderActions.types.EXCEL_ORDER_PROGRESS_RESET
    };
};

OrderActions.orderInProgress = function () {
    return {
        type: OrderActions.types.ORDER_INPROGRESS
    };
};

OrderActions.excelOrderInProgress = function () {
    return {
        type: OrderActions.types.EXCEL_ORDER_INPROGRESS
    };
};

OrderActions.orderComplete = function (transaction) {
    return {
        type: OrderActions.types.ORDER_COMPLETE,
        payload: { transaction: transaction }
    };
};

OrderActions.excelOrderComplete = function (transaction) {
    return {
        type: OrderActions.types.EXCEL_ORDER_COMPLETE,
        payload: { transaction: transaction }
    };
};

OrderActions.orderFailure = function (error) {
    return {
        type: OrderActions.types.ORDER_FAILURE,
        payload: { error: error }
    };
};

OrderActions.excelOrderFailure = function (error) {
    return {
        type: OrderActions.types.EXCEL_ORDER_FAILURE,
        payload: { error: error }
    };
};

OrderActions.cancelingOrder = function (transaction) {
    return {
        type: OrderActions.types.CANCELING_ORDER,
        payload: { transaction: transaction }
    };
};

OrderActions.cancelingExcelOrder = function (transaction) {
    return {
        type: OrderActions.types.CANCELING_EXCEL_ORDER,
        payload: { transaction: transaction }
    };
};

OrderActions.canceledOrder = function (transaction) {
    return {
        type: OrderActions.types.CANCELED_ORDER,
        payload: { transaction: transaction }
    };
};

OrderActions.canceledExcelOrder = function (transaction) {
    return {
        type: OrderActions.types.CANCELED_EXCEL_ORDER,
        payload: { transaction: transaction }
    };
};

OrderActions.selectTransaction = function (transaction) {
    return {
        type: OrderActions.types.SELECT_TRANSACTION,
        payload: { transaction: transaction }
    };
};

OrderActions.downloadingTransactionReport = function () {
    return {
        type: OrderActions.types.DOWNLOADING_TRANSACTION_REPORT
    };
};

OrderActions.downloadedTransactionReport = function () {
    return {
        type: OrderActions.types.DOWNLOADED_TRANSACTION_REPORT
    };
};

OrderActions.downloadingConfigurationProductList = function () {
    return {
        type: OrderActions.types.DOWNLOADING_CONFIGURATION_LIST
    };
};

OrderActions.downloadedConfigurationProductList = function () {
    return {
        type: OrderActions.types.DOWNLOADED_CONFIGURATION_LIST
    };
};

OrderActions.submitOrder = function () {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(OrderActions.orderInProgress());

        return state.api.putOrder(_assembleTransaction(state)).then(function (result) {
            if (result.data && result.data.message && result.data.message === 'Request was acceptable but ignored.') {
                dispatch(OrderActions.orderFailure(result.data));
            } else {
                dispatch(OrderActions.orderComplete(result.data));
                // Setting user data with updated cart data into the user object:
                var user = { data: result.data.user };
                dispatch(_user2.default.receivedUser(user));
            }
        }).catch(function (error) {
            // Handle errors in order submission
            _sentry2.default.logException(error);
            dispatch(OrderActions.orderFailure(error));
        });
    };
};

OrderActions.submitExcelOrder = function (cart) {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(OrderActions.excelOrderInProgress());

        return state.api.putOrder(_assembleBulkProductExcelUploadTransaction(state, cart)).then(function (result) {
            return dispatch(OrderActions.excelOrderComplete(result.data));
        }).catch(function (error) {
            _sentry2.default.logException(error);
            dispatch(OrderActions.excelOrderFailure(error));
        });
    };
};

OrderActions.cancelExcelOrder = function (transaction, history) {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(OrderActions.cancelingExcelOrder(transaction));

        return state.api.cancelOrder(transaction).then(function () {
            dispatch(OrderActions.canceledExcelOrder(transaction));
            dispatch(_ui2.default.finishExcelOrder(history));
            dispatch(_ui2.default.closeModal('cancel'));
            dispatch(_ui2.default.closeModal('transaction'));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

OrderActions.cancelOrder = function (transaction, history) {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(OrderActions.cancelingOrder(transaction));

        return state.api.cancelOrder(transaction).then(function () {
            dispatch(OrderActions.canceledOrder(transaction));
            dispatch(_ui2.default.finishOrder(history));
            dispatch(_ui2.default.closeModal('cancel'));
            dispatch(_ui2.default.closeModal('transaction'));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

OrderActions.downloadTransactionReport = function (offer) {
    return function (dispatch, getState) {
        var state = getState();
        var filename = _strings2.default.transactionReportFilename + ' ' + offer.mentorId + '.xlsx';

        dispatch(OrderActions.downloadingTransactionReport());

        state.api.downloadOfferTransactionReport(offer.id, filename).then(function () {
            return OrderActions.downloadedTransactionReport();
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

OrderActions.downloadConfigurationProductList = function (offerId) {
    return function (dispatch, getState) {
        var state = getState();
        var filename = _strings2.default.configurationTemplate + '.xlsm';

        dispatch(_uploadConfiguration2.default.setDownloadSpinner(true));

        dispatch(OrderActions.downloadingConfigurationProductList());

        state.api.downloadConfigurationProductList(offerId, filename).then(function () {
            OrderActions.downloadedConfigurationProductList();
            dispatch(_uploadConfiguration2.default.setDownloadSpinner(false));
        }).catch(_error2.default.errorHandler(dispatch));
    };
};

OrderActions.downloadConfigurationProductListWithErrors = function (fileData) {
    return function (dispatch, getState) {
        var state = getState();
        var filename = 'ConfigurationTemplateWithErrors' + '.xlsm';

        // dispatch(OrderActions.downloadingConfigurationProductList());

        state.api.downloadConfigurationProductListWithErrors(fileData, filename);
        // .then(() => {})
        // .catch(ErrorActions.errorHandler(dispatch));
    };
};

exports.default = OrderActions;

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _actions = __webpack_require__(159);

var _actions2 = _interopRequireDefault(_actions);

var _MapApi = __webpack_require__(133);

var _MapApi2 = _interopRequireDefault(_MapApi);

var _cart = __webpack_require__(803);

var _cart2 = _interopRequireDefault(_cart);

var _help = __webpack_require__(804);

var _help2 = _interopRequireDefault(_help);

var _joyride = __webpack_require__(805);

var _joyride2 = _interopRequireDefault(_joyride);

var _login = __webpack_require__(806);

var _login2 = _interopRequireDefault(_login);

var _offer = __webpack_require__(807);

var _offer2 = _interopRequireDefault(_offer);

var _order = __webpack_require__(808);

var _order2 = _interopRequireDefault(_order);

var _ui = __webpack_require__(809);

var _ui2 = _interopRequireDefault(_ui);

var _user = __webpack_require__(810);

var _user2 = _interopRequireDefault(_user);

var _sites = __webpack_require__(811);

var _sites2 = _interopRequireDefault(_sites);

var _uploadConfiguration = __webpack_require__(812);

var _uploadConfiguration2 = _interopRequireDefault(_uploadConfiguration);

var _error = __webpack_require__(813);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    // We can make the API client without the XSRF token here no problem. We
    // just can't use it to make any authenticated calls.
    api: function api() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _MapApi2.default();
        var action = arguments[1];

        switch (action.type) {
            case _actions2.default.STORE_XSRF_TOKEN:
                return new _MapApi2.default(action.payload.xsrfToken);
            default:
                return state;
        }
    },

    myself: function myself() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var action = arguments[1];

        switch (action.type) {
            case _actions2.default.RECEIVED_USER:
                return action.payload.response;

            case _actions2.default.UPDATED_PREFERENCES:
                return Object.assign({}, state, {
                    preferences: action.payload.response
                });

            default:
                return state;
        }
    },

    cart: _cart2.default,
    help: _help2.default,
    joyride: _joyride2.default,
    login: _login2.default,
    offer: _offer2.default,
    order: _order2.default,
    ui: _ui2.default,
    user: _user2.default,
    sites: _sites2.default,
    configurations: _uploadConfiguration2.default,
    error: _error2.default
});

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(88);

var _offer = __webpack_require__(227);

var _offer2 = _interopRequireDefault(_offer);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartSelectors = function CartSelectors() {
    _classCallCheck(this, CartSelectors);
};

CartSelectors.getItems = function (state) {
    return state.cart.items;
};

CartSelectors.getInstructions = function (state) {
    return state.cart.instructions;
};

CartSelectors.getAccounts = function (state) {
    return state.myself.accounts;
};

CartSelectors.showCart = (0, _reselect.createSelector)(CartSelectors.getItems, _offer2.default.getSelectedOffer, function (items, offer) {
    var filteredItems = items.filter(function (item) {
        return !item.addedToCart || item.editItem;
    }); // Show cart if non-cart items exist or editing cart items
    return Boolean(filteredItems.length > 0 && offer);
});
CartSelectors.editCart = (0, _reselect.createSelector)(CartSelectors.getItems, _offer2.default.getSelectedOffer, function (items, offer) {
    var filteredItems = items.filter(function (item) {
        return item.editItem;
    }); // checking if cart items edit was triggered.
    return Boolean(filteredItems.length > 0 && offer);
});
CartSelectors.getSoldTo = (0, _reselect.createSelector)(_offer2.default.getSelectedOffer, function (offer) {
    return offer ? offer.account.soldTo : "";
});
CartSelectors.getProducts = (0, _reselect.createSelector)(CartSelectors.getItems, _offer2.default.getSelectedOffer, function (items, offer) {
    return offer ? items.map(function (item) {
        return offer.pricing[item.productIndex];
    }) : [];
});
CartSelectors.getCartContents = (0, _reselect.createSelector)(CartSelectors.getItems, _offer2.default.getSelectedOffer, _offer2.default.getServersGroupedBySite, function (items, offer, serversBySite) {
    if (!offer) {
        return [];
    }
    return items.map(function (item) {
        var pricing = offer.pricing[item.productIndex];
        var site = offer.sites[item.siteIndex];
        var server = serversBySite[item.siteIndex].servers[item.serverIndex];
        var cartId = item.cartId;
        if (item.cartId === '') item.addedToCart = false;else item.addedToCart = true;
        // Onlt Set item.itemDataChanged based on cartId if it's not already true
        item.itemDataChanged = item.itemDataChanged === true ? true : !cartId;
        var seatCost = 0;
        var soldTo = offer.account.soldTo;
        var isTieredDiscountApplied = false;
        var lowTierDiscountPct = pricing.lowTierDiscountPct;

        var usesEndDatePicker = offer.enterprise_deal || _utils2.default.isDateRangeSoldTO(soldTo) || offer.dailyPricingEnabled;
        var hasInvalidDateRange = usesEndDatePicker && (!item.startDate || !item.endDate || !(0, _moment2.default)(item.endDate).isAfter((0, _moment2.default)(item.startDate)));

        if (hasInvalidDateRange) {
            // Keep invalid saved-cart items selectable, but do not attempt
            // to calculate pricing for an end date before/equal to start date.
            item.monthCount = 0;
            item.dayCount = 0;
        } else if (_utils2.default.isDateRangeSoldTO(soldTo)) {

            seatCost = pricing.monthly.find(function (p) {
                return p.amount === 3;
            }).price;
            var Endate = (0, _moment2.default)(item.endDate).clone().startOf('day');
            var Stdate = (0, _moment2.default)(item.startDate).clone().startOf('day');

            var monthCount = void 0,
                weekCount = void 0;
            if (offer.weeklyPricingEnabled && pricing.weekly && pricing.weekly[0] && pricing.weekly[0].price) {
                var fullMonths = Math.floor(Endate.diff(Stdate, 'months', true));
                var afterMonths = Stdate.clone().add(fullMonths, 'months');
                var remainingDays = Endate.diff(afterMonths, 'd');
                var weeks = Math.ceil(remainingDays / 7);
                monthCount = fullMonths;
                weekCount = weeks;
            } else {
                monthCount = Math.ceil(Endate.diff(Stdate, 'months', true));
                weekCount = 0;
            }
            item.monthCount = monthCount;
            item.weekCount = weekCount;

            var StDateAfterAdding3Mtns = Stdate.clone().add(3, 'months').subtract(1, 'day');
            var diffBtwStEnDts = Endate.diff(StDateAfterAdding3Mtns, 'd');

            diffBtwStEnDts = diffBtwStEnDts - (+"3" + 1);
            // check for previous transactions for # of licenses for this product if its tiered product
            //Get previous eligible licenses from transactions
            var annual_seat_cost = pricing.monthly.find(function (p) {
                return p.amount === 12;
            }).price;
            if (pricing.tieredPricing) {
                var eligibleLicenses = [];
                var prevLicensesSeats = 0;
                //eligibleTransactions = offer.transactions.filter(transaction => transaction.lincenses)
                offer.transactions.forEach(function (transaction) {
                    if (transaction.licenses) {
                        transaction.licenses.forEach(function (license) {
                            if (license.product.id === pricing.product.id && (0, _moment2.default)(license.validTo).startOf('day') > Stdate) {
                                eligibleLicenses.push(license);
                                prevLicensesSeats += license.seats;
                            }
                        });
                    }
                });
                if (prevLicensesSeats + item.seats >= 11) {
                    seatCost = Math.round((1 - lowTierDiscountPct / 100) * seatCost);
                    isTieredDiscountApplied = true;
                    annual_seat_cost = Math.round((1 - lowTierDiscountPct / 100) * annual_seat_cost);
                }
            }

            if (diffBtwStEnDts > 0) {
                var remaningDaysCost = annual_seat_cost / 365 * diffBtwStEnDts;
                seatCost = seatCost + remaningDaysCost;
                seatCost = Math.round(seatCost);
            }
        } else if (offer.enterprise_deal) {
            var _Endate = (0, _moment2.default)(item.endDate).clone().startOf('day');
            var _Stdate = (0, _moment2.default)(item.startDate).clone().startOf('day');

            var _monthCount = void 0,
                _weekCount = void 0;
            if (offer.weeklyPricingEnabled && pricing.weekly && pricing.weekly[0] && pricing.weekly[0].price) {
                var _fullMonths = Math.floor(_Endate.diff(_Stdate, 'months', true));
                var _afterMonths = _Stdate.clone().add(_fullMonths, 'months');
                var _remainingDays = _Endate.diff(_afterMonths, 'd');
                var _weeks = Math.ceil(_remainingDays / 7);
                _monthCount = _fullMonths;
                _weekCount = _weeks;
            } else {
                _monthCount = Math.ceil(_Endate.diff(_Stdate, 'months', true));
                _weekCount = 0;
            }
            item.monthCount = _monthCount;
            item.weekCount = _weekCount;
            if (_monthCount > 0) {
                seatCost = pricing.monthly.find(function (p) {
                    return p.amount === _monthCount;
                }).price;
            }
        } else if (offer.dailyPricingEnabled) {
            var _Endate2 = (0, _moment2.default)(item.endDate).clone().startOf('day');
            var _Stdate2 = (0, _moment2.default)(item.startDate).clone().startOf('day');
            var stDateAfterAdding1Mtn = _Stdate2.clone().add(1, 'month');
            var daysBetweenStartAndEndDate = _Endate2.diff(_Stdate2, 'd');
            var daysInOneMonthPeriod = stDateAfterAdding1Mtn.diff(_Stdate2, 'd');
            var monthsDiff = Math.ceil(_Endate2.diff(_Stdate2, 'months', true));
            item.monthCount = monthsDiff;
            item.dayCount = daysBetweenStartAndEndDate;
            if (daysBetweenStartAndEndDate <= daysInOneMonthPeriod) {
                seatCost = pricing.monthly.find(function (p) {
                    return p.amount === 1;
                }).price;
            } else {
                var dailyPrice = pricing.monthly.find(function (p) {
                    return p.amount === 1;
                }).price * 12 / 365;
                seatCost = daysBetweenStartAndEndDate * dailyPrice;
            }
        } else if (item.monthCount > 0) {
            seatCost += pricing.monthly.find(function (p) {
                return p.amount === item.monthCount;
            }).price;
        }

        if (!hasInvalidDateRange && offer.weeklyPricingEnabled && item.weekCount > 0) {
            seatCost += pricing.weekly[0].price * item.weekCount;
        }
        return _extends({}, item, {
            site: site,
            server: server,
            pricing: pricing,
            seatCost: seatCost,
            subtotal: Math.round(item.seats * seatCost),
            isTieredDiscountApplied: isTieredDiscountApplied,
            cartId: cartId
        });
    });
});
CartSelectors.getTotal = (0, _reselect.createSelector)(CartSelectors.getCartContents, function (contents) {
    return contents.filter(function (item) {
        return item.addedToCart && !item.saveForLater;
    }).reduce(function (sum, item) {
        return sum + item.subtotal;
    }, 0);
});
CartSelectors.getTempCartTotal = (0, _reselect.createSelector)(CartSelectors.getCartContents, function (contents) {
    return contents.filter(function (item) {
        return !item.addedToCart && !item.saveForLater;
    }).reduce(function (sum, item) {
        return sum + item.subtotal;
    }, 0);
});
CartSelectors.hasOverspent = (0, _reselect.createSelector)(CartSelectors.getTotal, _offer2.default.getSelectedOffer, function (total, offer) {
    return total > (offer ? offer.balance : 0);
});
CartSelectors.hasTempCartOverspent = (0, _reselect.createSelector)(CartSelectors.getTempCartTotal, CartSelectors.getTotal, _offer2.default.getSelectedOffer, function (tempTotal, total, offer) {
    return tempTotal + total > (offer ? offer.balance : 0);
});
CartSelectors.readyForCheckout = (0, _reselect.createSelector)(CartSelectors.getItems, CartSelectors.hasOverspent, function (items, hasOverspent) {
    var filteredItems = items.filter(function (item) {
        return item.addedToCart && !item.saveForLater;
    }); // Exclude items saved for later
    return filteredItems.reduce(function (result, item) {
        return result && item.startDate !== '' && !(item.startDate && item.endDate && !(0, _moment2.default)(item.endDate).isAfter((0, _moment2.default)(item.startDate))) && item.serverIndex >= 0 && item.siteIndex >= 0 && item.seats > 0 && (item.monthCount > 0 || item.weekCount > 0);
    }, !hasOverspent && filteredItems.length > 0);
});
CartSelectors.readyForaddToCart = (0, _reselect.createSelector)(CartSelectors.getItems, CartSelectors.hasTempCartOverspent, _offer2.default.getSelectedOffer, function (items, hasOverspent, offer) {
    var filteredItems = items.filter(function (item) {
        return !item.addedToCart;
    });

    var result = filteredItems.reduce(function (result, item) {
        return result && !!item.startDate && item.startDate !== '' && !!item.endDate && item.endDate !== '' && (0, _moment2.default)(item.endDate).isAfter((0, _moment2.default)(item.startDate)) && item.serverIndex >= 0 && item.siteIndex >= 0 && item.seats > 0 && (item.monthCount > 0 || item.weekCount > 0);
    }, !hasOverspent && filteredItems.length > 0);

    return result;
});
exports.default = CartSelectors;

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = __webpack_require__(88);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HelpSelectors = function HelpSelectors() {
    _classCallCheck(this, HelpSelectors);
};

HelpSelectors.getFaqs = function (state) {
    return state.help.faqs;
};

HelpSelectors.getFaqsTransferring = function (state) {
    return state.help.faqsTransferring;
};

HelpSelectors.getVisibleTab = function (state) {
    return state.help.visibleTab;
};

HelpSelectors.getContacts = function (state) {
    return state.help.contacts;
};

HelpSelectors.getContactsTransferring = function (state) {
    return state.help.contactsTransferring;
};

HelpSelectors.getContactMessage = function (state) {
    return state.help.contactMessage;
};

HelpSelectors.getContactSubjectIndex = function (state) {
    return state.help.contactSubjectIndex;
};

HelpSelectors.getContactMessageTransferring = function (state) {
    return state.help.contactMessageTransferring;
};

HelpSelectors.getContactMessageSent = function (state) {
    return state.help.contactMessageSent;
};

HelpSelectors.getContactSubject = (0, _reselect.createSelector)(HelpSelectors.getContacts, HelpSelectors.getContactSubjectIndex, function (contacts, index) {
    return contacts[index].kind;
});
HelpSelectors.getHelpIsLoaded = (0, _reselect.createSelector)(HelpSelectors.getFaqs, HelpSelectors.getFaqsTransferring, HelpSelectors.getContacts, HelpSelectors.getContactsTransferring, function (faqs, faqsTransferring, contacts, contactsTransferring) {
    return faqs.length > 0 && !faqsTransferring && contacts.length > 0 && !contactsTransferring;
});
exports.default = HelpSelectors;

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JoyrideSelectors = function JoyrideSelectors() {
    _classCallCheck(this, JoyrideSelectors);
};

JoyrideSelectors.shouldStartJoyride = function (state) {
    return state.joyride.runJoyride;
};

JoyrideSelectors.getJoyrideStatus = function (state) {
    return state.joyride.joyrideStatus;
};

JoyrideSelectors.getJoyrideStatusSaveInProgress = function (state) {
    return state.joyride.joyrideStatusSaveInProgress;
};

exports.default = JoyrideSelectors;

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginSelectors = function LoginSelectors() {
    _classCallCheck(this, LoginSelectors);
};

LoginSelectors.getIsLoggedIn = function (state) {
    return state.login.isLoggedIn;
};

LoginSelectors.getWantLogin = function (state) {
    return state.login.wantLogin;
};

exports.default = LoginSelectors;

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = __webpack_require__(88);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSelectors = function OrderSelectors() {
    _classCallCheck(this, OrderSelectors);
};

OrderSelectors.getProgress = function (state) {
    return state.order.progress;
};

OrderSelectors.getExcelOrderProgress = function (state) {
    return state.order.progress;
};

OrderSelectors.getSelectedTransaction = function (state) {
    return state.order.selectedTransaction;
};

OrderSelectors.getCancelProgress = function (state) {
    return state.order.cancelProgress;
};

OrderSelectors.getExcelOrderCancelProgress = function (state) {
    return state.order.cancelProgress;
};

OrderSelectors.getLastTransaction = function (state) {
    return state.order.lastTransaction;
};

OrderSelectors.orderInProgress = (0, _reselect.createSelector)(OrderSelectors.getProgress, function (progress) {
    return progress === 'inprogress';
});
OrderSelectors.excelOrderInProgress = (0, _reselect.createSelector)(OrderSelectors.getExcelOrderProgress, function (progress) {
    return progress === 'inprogress';
});
OrderSelectors.orderStarted = (0, _reselect.createSelector)(OrderSelectors.getProgress, function (progress) {
    return progress !== 'unknown';
});
OrderSelectors.excelOrderStarted = (0, _reselect.createSelector)(OrderSelectors.getExcelOrderProgress, function (progress) {
    return progress !== 'unknown';
});
OrderSelectors.orderIsComplete = (0, _reselect.createSelector)(OrderSelectors.getProgress, function (progress) {
    return ['complete', 'error'].indexOf(progress) > -1;
});
OrderSelectors.excelOrderIsComplete = (0, _reselect.createSelector)(OrderSelectors.getExcelOrderProgress, function (progress) {
    return ['complete', 'error'].indexOf(progress) > -1;
});
OrderSelectors.orderIsSuccessful = (0, _reselect.createSelector)(OrderSelectors.getProgress, function (progress) {
    return progress === 'complete';
});
OrderSelectors.excelOrderIsSuccessful = (0, _reselect.createSelector)(OrderSelectors.getExcelOrderProgress, function (progress) {
    return progress === 'complete';
});
OrderSelectors.orderFailed = (0, _reselect.createSelector)(OrderSelectors.getProgress, function (progress) {
    return progress === 'error';
});
OrderSelectors.excelOrderFailed = (0, _reselect.createSelector)(OrderSelectors.getExcelOrderProgress, function (progress) {
    return progress === 'error';
});
OrderSelectors.excelOrderPassed = (0, _reselect.createSelector)(OrderSelectors.getExcelOrderProgress, function (progress) {
    return progress === 'complete';
});
OrderSelectors.cancelInProgress = (0, _reselect.createSelector)(OrderSelectors.getCancelProgress, function (progress) {
    return progress === 'inprogress';
});
OrderSelectors.excelOrderCancelInProgress = (0, _reselect.createSelector)(OrderSelectors.getExcelOrderCancelProgress, function (progress) {
    return progress === 'inprogress';
});
OrderSelectors.cancelIsComplete = (0, _reselect.createSelector)(OrderSelectors.getCancelProgress, function (progress) {
    return progress == 'complete';
});
OrderSelectors.excelOrderCancelIsComplete = (0, _reselect.createSelector)(OrderSelectors.getExcelOrderCancelProgress, function (progress) {
    return progress == 'complete';
});
exports.default = OrderSelectors;

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UiSelectors = function UiSelectors() {
    _classCallCheck(this, UiSelectors);
};

UiSelectors.getAccountModalVisible = function (state) {
    return state.ui.modals.account || false;
};

UiSelectors.getHelpModalVisible = function (state) {
    return state.ui.modals.help || false;
};

UiSelectors.getTransactionModalVisible = function (state) {
    return state.ui.modals.transaction || false;
};

UiSelectors.getPricingModalVisible = function (state) {
    return state.ui.modals.pricing || false;
};

UiSelectors.getCheckoutModalVisible = function (state) {
    return state.ui.modals.checkout || false;
};

UiSelectors.getShoppingCartModalVisible = function (state) {
    return state.ui.modals.shoppingcart || false;
};

UiSelectors.getValidationModalVisible = function (state) {
    return state.ui.modals.validation || false;
};

UiSelectors.getFailedValidationModalVisible = function (state) {
    return state.ui.modals.failedValidation || false;
};

UiSelectors.getValidationFailureModalVisible = function (state) {
    return state.ui.modals.validationFailed || false;
};

UiSelectors.getValidationCancelModalVisible = function (state) {
    return state.ui.modals.cancel || false;
};

UiSelectors.getOrderCancelModalVisible = function (state) {
    return state.ui.modals.cancel || false;
};

UiSelectors.getLoginLookupModalVisible = function (state) {
    return state.ui.modals.lookup || false;
};

UiSelectors.getNewUserModalVisible = function (state) {
    return state.ui.modals.newUser || false;
};

UiSelectors.getAppMounted = function (state) {
    return state.ui.appMounted;
};

UiSelectors.getAccountModalPane = function (state) {
    return state.ui.accountModalPane;
};

exports.default = UiSelectors;

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _offer = __webpack_require__(227);

var _offer2 = _interopRequireDefault(_offer);

var _reselect = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSelectors = function UserSelectors() {
    _classCallCheck(this, UserSelectors);
};

UserSelectors.getMyself = function (state) {
    return state.myself;
};

UserSelectors.getMapUsername = function (state) {
    return state.user.mapUsername;
};

UserSelectors.getLookupInProgress = function (state) {
    return state.user.lookupInProgress;
};

UserSelectors.getLookupFinished = function (state) {
    return state.user.lookupFinished;
};

UserSelectors.getSummaries = function (state) {
    return state.user.userSummaries;
};

UserSelectors.getSummariesInTransit = function (state) {
    return state.user.userSummariesInTransit;
};

UserSelectors.getSpoofInProgress = function (state) {
    return state.user.spoofInProgress;
};

UserSelectors.getPreferences = (0, _reselect.createSelector)(UserSelectors.getMyself, function (user) {
    return user ? user.preferences : null;
});
UserSelectors.getSpoofer = (0, _reselect.createSelector)(UserSelectors.getMyself, function (user) {
    return user ? user.spoofer : null;
});
UserSelectors.getSpoofEnabled = (0, _reselect.createSelector)(UserSelectors.getSpoofer, function (spoofer) {
    return Boolean(spoofer);
});
UserSelectors.getSortedSummaries = (0, _reselect.createSelector)(UserSelectors.getSummaries, function (summaries) {
    return summaries.slice().sort(function (a, b) {
        var compare = function compare(x, y) {
            return x.toLowerCase().localeCompare(y.toLowerCase());
        };
        var comparisons = [function () {
            return compare(a.firstName, b.firstName);
        }, function () {
            return compare(a.lastName, b.lastName);
        }, function () {
            return -1;
        }];

        return comparisons.find(function (f) {
            return f() !== 0;
        })();
    });
});
UserSelectors.getMyselfIsAdmin = (0, _reselect.createSelector)(UserSelectors.getMyself, UserSelectors.getSpoofer, function (user, spoofer) {
    if (!user) {
        return false;
    }

    var isAdmin = function isAdmin(role) {
        return ['super', 'admin', 'com', 'developer'].indexOf(role.name.toLowerCase()) >= 0;
    };

    if (spoofer) {
        return Boolean(spoofer.roles.find(function (role) {
            return isAdmin(role);
        }));
    }
    return Boolean(user.roles.find(function (role) {
        return isAdmin(role);
    }));
});
UserSelectors.getFavorites = (0, _reselect.createSelector)(_offer2.default.getSelectedOffer, UserSelectors.getPreferences, function (offer, preferences) {
    if (preferences && offer) {
        return preferences['favorites' + offer.mentorId];
    }
    return null;
});
UserSelectors.getFavoriteSite = (0, _reselect.createSelector)(UserSelectors.getFavorites, function (favorites) {
    return favorites ? favorites.site : null;
});
UserSelectors.getFavoriteServer = (0, _reselect.createSelector)(UserSelectors.getFavorites, function (favorites) {
    return favorites ? favorites.server : null;
});
UserSelectors.getFavoriteSiteIndex = (0, _reselect.createSelector)(_offer2.default.getServersGroupedBySite, UserSelectors.getFavoriteSite, function (serversBySite, siteId) {
    if (siteId) {
        var index = serversBySite.findIndex(function (site) {
            return site.id == siteId;
        });
        return index >= 0 ? index : 0; // Default to first site if favorite site not found
    }
    return 0;
});
UserSelectors.getFavoriteServerIndex = (0, _reselect.createSelector)(_offer2.default.getServersGroupedBySite, UserSelectors.getFavoriteSiteIndex, UserSelectors.getFavoriteServer, function (serversBySite, siteIndex, serverId) {
    if (siteIndex > -1 && serverId) {
        var index = serversBySite[siteIndex].servers.findIndex(function (server) {
            return server.id == serverId;
        });
        return index >= 0 ? index : 0; // Default to first server if favorite server not found
    }
    return 0;
});
UserSelectors.getServerAliases = (0, _reselect.createSelector)(UserSelectors.getPreferences, function (preferences) {
    return preferences && preferences.serverAliases ? preferences.serverAliases : {};
});
exports.default = UserSelectors;

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = __webpack_require__(88);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SiteSelectors = function SiteSelectors() {
    _classCallCheck(this, SiteSelectors);
};

SiteSelectors.getSitesInTransit = function (s) {
    return s.sites.sitesInTransit;
};

SiteSelectors.getSites = function (s) {
    return s.sites.all_sites;
};

SiteSelectors.getSelectedSiteId = function (s) {
    return s.sites.selectedSiteId;
};

SiteSelectors.getSelectedSite = (0, _reselect.createSelector)(SiteSelectors.getSites, SiteSelectors.getSelectedSiteId, function (sites, siteId) {
    return sites.find(function (site) {
        return site.id === siteId;
    });
});

SiteSelectors.showAlert = function (_store) {
    return _store.sites.showAlert;
};

SiteSelectors.getServerId = function (_store) {
    return _store.sites.serverId;
};

SiteSelectors.getHostId = function (_store) {
    return _store.sites.hostId;
};

SiteSelectors.getAlertMessage = function (_store) {
    return _store.sites.alertMessage;
};

exports.default = SiteSelectors;

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConfigurationSelectors = function ConfigurationSelectors() {
    _classCallCheck(this, ConfigurationSelectors);
};

ConfigurationSelectors.getUploadInTransit = function (s) {
    return s.configurations.uploadInTransit;
};

ConfigurationSelectors.getDownloadSpinner = function (s) {
    return s.configurations.downloadSpinner;
};

ConfigurationSelectors.getUploadProgress = function (s) {
    return Math.round(100 * s.configurations.uploadProgress / s.configurations.uploadTotal);
};

ConfigurationSelectors.getFileUploaded = function (s) {
    s.configurations.fileUploaded;
};

ConfigurationSelectors.getUploadError = function (s) {
    s.configurations.uploadError;
};

ConfigurationSelectors.getUploadErrorResponseData = function (s) {
    s.configurations.excelUploadErrorResponse;
};

ConfigurationSelectors.getconfigurationSheetUploadInTransit = function (s) {
    return s.configurations.configurationSheetUploadInTransit;
};

ConfigurationSelectors.getconfigurationSheetUploadResponse = function (s) {
    return s.configurations.configurationSheetUploadResponse;
};

ConfigurationSelectors.getDownloadInProgress = function (s) {
    return s.configurations.downloadInProgress;
};

ConfigurationSelectors.dragOver = function (s) {
    return s.configurations.dragOver;
};

ConfigurationSelectors.unknownFileType = function (s) {
    return s.configurations.unknownFileType;
};

ConfigurationSelectors.catchedErrorMessage = function (s) {
    return s.configurations.catchedErrorMessage;
};

ConfigurationSelectors.getExcelErrorMessageDataObj = function (s) {
    return s.configurations.excelUploadErrorResponse;
};

exports.default = ConfigurationSelectors;

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _actions = __webpack_require__(159);

var _actions2 = _interopRequireDefault(_actions);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _updateAttrAtIndex(state, action, attr) {
    var cartIndex = action.payload.cartIndex;
    var attrValue = action.payload[attr];
    var result = state.slice();

    result[cartIndex][attr] = attrValue;

    return result;
}

function _updateItemDataChangedFlag(state, action) {
    var cartIndex = action.payload.cartIndex;
    var result = state.slice();
    result[cartIndex]['itemDataChanged'] = true;
    return result;
}

function _setEndData(action, startDate) {
    var _action$payload = action.payload,
        soldTo = _action$payload.soldTo,
        monthCount = _action$payload.monthCount,
        weekCount = _action$payload.weekCount,
        dailyPricingEnabled = _action$payload.dailyPricingEnabled,
        offerEndDate = _action$payload.offerEndDate;


    if (_utils2.default.isDateRangeSoldTO(soldTo)) {
        var threeMonthEndDate = (0, _moment2.default)(startDate).add(3, 'M').subtract(1, 'd');
        var contractEndDate = (0, _moment2.default)(offerEndDate);

        return threeMonthEndDate.isAfter(contractEndDate) ? contractEndDate.toISOString() : threeMonthEndDate.toISOString();
    }

    if (dailyPricingEnabled) {
        return null;
    }

    if (monthCount && monthCount > 0) {
        return (0, _moment2.default)(startDate).add(monthCount, 'M').toISOString();
    }

    if (weekCount && weekCount === 1) {
        return (0, _moment2.default)(startDate).add(weekCount, 'w').toISOString();
    }

    return null;
}

function _startDate(state) {
    return (0, _moment2.default)().startOf('day').toISOString();
}

function _transFormItems(state, action) {
    var _action$payload2 = action.payload,
        userCart = _action$payload2.userCart,
        selectedOffer = _action$payload2.selectedOffer,
        serversBySite = _action$payload2.serversBySite;

    // Filter cart to only process items where the offer matches selectedOffer.id

    var filteredCart = Array.isArray(userCart) ? userCart.filter(function (item) {
        return item.offer === selectedOffer.id;
    }) : [];

    //const result = state.slice(); // Make a shallow copy of the current state

    if (filteredCart.length === 0) {
        console.log("No matching cart items for the selected offer.");
        return [];
    }

    var items = filteredCart.map(function (item) {
        var monthCount = item.duration;
        var weekCount = item.weeks;
        //const startDate = item.validFrom; 
        var startDate = item.validFrom < (0, _moment2.default)().toISOString() ? (0, _moment2.default)().toISOString() : item.validFrom;
        var endDate = item.validTo;
        var seats = item.seats;
        var saveForLater = item.save_for_later;
        var productMentorId = item.product.mentorId;
        var cartId = item.id;
        var itemDataChanged = cartId ? false : true;

        var productIndex = selectedOffer.pricing.findIndex(function (pricing) {
            return pricing.product && pricing.product.mentorId === productMentorId;
        });

        if (productIndex === -1) {
            console.log('No matching product found for mentorId: ' + productMentorId);
            return null;
        }

        var siteIndex = serversBySite.findIndex(function (site) {
            return site.mentorId === item.site.mentorId;
        });
        if (siteIndex === -1) {
            console.log('No matching site found for siteMentorId: ' + item.site.mentorId);
            return null;
        }

        // Find the serverIndex within the matched site
        var serverIndex = serversBySite[siteIndex].servers.findIndex(function (server) {
            return server.mentorId === item.server.mentorId;
        });
        if (serverIndex === -1) {
            console.log('No matching server found for mentorId: ' + item.server.mentorId);
            return null;
        }

        return {
            productIndex: productIndex,
            seats: seats,
            startDate: startDate,
            endDate: endDate,
            monthCount: monthCount,
            weekCount: weekCount,
            siteIndex: siteIndex,
            serverIndex: serverIndex,
            saveForLater: saveForLater,
            itemDataChanged: itemDataChanged,
            cartId: cartId
        };
    });

    // Filter out null items resulting from unmatched products, sites, or servers
    var validItems = items.filter(function (item) {
        return item !== null;
    });

    if (validItems.length === 0) {
        console.log("No valid items to process after filtering.");
        return null; // Exit early if no valid items remain
    }

    return validItems; // Return the updated result
}

exports.default = (0, _redux.combineReducers)({
    instructions: (0, _ReduxTools.simpleReducer)('', {
        UPDATE_CART_INSTRUCTIONS: function UPDATE_CART_INSTRUCTIONS(a) {
            return a.payload.instructions;
        },
        SELECT_OFFER: '',
        CLEAR_CART: ''
    }),

    selectedItemIndex: (0, _ReduxTools.simpleReducer)(-1, {
        SELECT_ITEM_IN_CART: function SELECT_ITEM_IN_CART(a) {
            return a.payload.itemIndex;
        },
        SELECT_OFFER: -1,
        CLEAR_CART: -1
    }),

    items: function items() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var action = arguments[1];

        //items: (state = __debugging_data, action) => {
        var result = null;

        switch (action.type) {
            /* regular cart actions */

            case _actions2.default.ADD_ITEM_TO_CART:
                {
                    result = state.slice();
                    var startDate = _startDate(state); // Get the start date based on the current state           
                    result.push({
                        productIndex: action.payload.productIndex,
                        seats: 1,
                        // Check if start date is behind current time & date then update it to current moment | if empty default set to current moment.
                        startDate: startDate,
                        endDate: _setEndData(action, startDate),
                        monthCount: action.payload.monthCount || 0,
                        weekCount: action.payload.weekCount || 0,
                        siteIndex: action.payload.siteIndex || 0,
                        serverIndex: action.payload.serverIndex || 0,
                        saveForLater: false,
                        itemDataChanged: true, // Set itemDataChanged flag as true for regular cart action -Siva Kishore
                        cartId: ""
                    });
                    return result;
                }
            case _actions2.default.REMOVE_ITEM_FROM_CART:
                {
                    var itemIndex = action.payload.itemIndex;

                    result = state.slice();
                    result.splice(itemIndex, 1);
                    return result;
                }

            case _actions2.default.ADD_INITIAL_ITEMS_TO_CART:
                {
                    return _transFormItems(state, action);
                }

            case _actions2.default.UPDATE_ITEM_SEATS:
                result = _updateItemDataChangedFlag(state, action);
                return _updateAttrAtIndex(result, action, 'seats');

            case _actions2.default.UPDATE_ITEM_START_DATE:
                result = _updateItemDataChangedFlag(state, action);
                return _updateAttrAtIndex(result, action, 'startDate');

            case _actions2.default.UPDATE_ITEM_DATE_RANGE:
                {
                    var _action$payload3 = action.payload,
                        cartIndex = _action$payload3.cartIndex,
                        _startDate2 = _action$payload3.startDate,
                        endDate = _action$payload3.endDate;

                    result = state.slice();
                    result[cartIndex] = _extends({}, result[cartIndex], {
                        startDate: _startDate2,
                        endDate: endDate,
                        itemDataChanged: true
                    });
                    return result;
                }

            case _actions2.default.UPDATE_ITEM_END_DATE:
                result = _updateItemDataChangedFlag(state, action);
                return _updateAttrAtIndex(result, action, 'endDate');

            case _actions2.default.UPDATE_ITEM_MONTH_COUNT:
                result = _updateItemDataChangedFlag(state, action);
                return _updateAttrAtIndex(result, action, 'monthCount');

            case _actions2.default.UPDATE_ITEM_WEEK_COUNT:
                result = _updateItemDataChangedFlag(state, action);
                return _updateAttrAtIndex(result, action, 'weekCount');

            case _actions2.default.UPDATE_ITEM_SERVER:
                result = _updateItemDataChangedFlag(state, action);
                result = _updateAttrAtIndex(result, action, 'siteIndex');
                return _updateAttrAtIndex(result, action, 'serverIndex');

            case _actions2.default.UPDATE_SAVE_FOR_LATER_LIST:
                {
                    var _action$payload4 = action.payload,
                        _cartIndex = _action$payload4.cartIndex,
                        saveForLater = _action$payload4.saveForLater;

                    result = state.slice();
                    result[_cartIndex].saveForLater = saveForLater;
                    // Set the itemDataChanged as true to save to DB
                    result[_cartIndex]['itemDataChanged'] = true;
                    return result;
                }

            case _actions2.default.ADD_UNSAVED_ITEMS_TO_CART:
                {
                    var unsavedItems = action.payload.unsavedItems;
                    result = state.slice();
                    unsavedItems.map(function (item) {
                        result.push({
                            productIndex: item.productIndex,
                            seats: item.seats,
                            // Check if start date is behind current time & date then update it to current moment | if empty default set to current moment.
                            startDate: item.startDate,
                            endDate: item.endDate,
                            monthCount: item.monthCount || 0,
                            weekCount: item.weekCount || 0,
                            siteIndex: item.siteIndex || 0,
                            serverIndex: item.serverIndex || 0,
                            saveForLater: item.saveForLater,
                            itemDataChanged: item.itemDataChanged, // Set itemDataChanged flag as true for regular cart action -Siva Kishore
                            cartId: item.cartId
                        });
                    });
                    return result;
                }

            case _actions2.default.CLEAR_CART:
            case _actions2.default.SELECT_OFFER:
                return [];

            /* pre-populate the cart for showing off during joyride */

            case _actions2.default.START_JOYRIDE:
                return [{
                    productIndex: 0,
                    seats: 1,
                    startDate: (0, _moment2.default)().toISOString(),
                    endDate: (0, _moment2.default)().add(1, 'M').toISOString(),
                    monthCount: 1,
                    weekCount: 0,
                    siteIndex: 0,
                    serverIndex: 0,
                    saveForLater: false,
                    cartId: ""
                }];

            case _actions2.default.FINISH_JOYRIDE:
            case _actions2.default.CANCEL_JOYRIDE:
                return [];

            default:
                return state;
        }
    }
});

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReduxTools = __webpack_require__(11);

var _redux = __webpack_require__(38);

exports.default = (0, _redux.combineReducers)({
    visibleTab: (0, _ReduxTools.simpleReducer)('faq', {
        HELP_SHOW_FAQ: 'faq',
        HELP_SHOW_CONTACT: 'contact',
        HELP_SHOW_TOUR: 'tour',
        HELP_SHOW_ABOUT: 'about'
    }),

    faqs: (0, _ReduxTools.simpleReducer)([], {
        RECEIVED_FAQS: function RECEIVED_FAQS(a) {
            return a.payload.response;
        }
    }),

    faqsTransferring: (0, _ReduxTools.simpleReducer)(false, {
        REQUESTING_FAQS: true,
        RECEIVED_FAQS: false
    }),

    contacts: (0, _ReduxTools.simpleReducer)([], {
        RECEIVED_CONTACTS: function RECEIVED_CONTACTS(a) {
            return a.payload.response;
        }
    }),

    contactsTransferring: (0, _ReduxTools.simpleReducer)(false, {
        REQUESTING_CONTACTS: true,
        RECEIVED_CONTACTS: false
    }),

    contactSubjectIndex: (0, _ReduxTools.simpleReducer)(0, {
        UPDATE_CONTACT_SUBJECT_INDEX: function UPDATE_CONTACT_SUBJECT_INDEX(a) {
            return a.payload.index;
        },
        CONTACT_MESSAGE_SENT: 0
    }),

    contactMessage: (0, _ReduxTools.simpleReducer)('', {
        UPDATE_CONTACT_MESSAGE: function UPDATE_CONTACT_MESSAGE(a) {
            return a.payload.message;
        },
        CONTACT_MESSAGE_SENT: ''
    }),

    contactMessageTransferring: (0, _ReduxTools.simpleReducer)(false, {
        SENDING_CONTACT_MESSAGE: true,
        CONTACT_MESSAGE_SENT: false
    }),

    contactMessageSent: (0, _ReduxTools.simpleReducer)(false, {
        SENDING_CONTACT_MESSAGE: false,
        CONTACT_MESSAGE_SENT: true,
        HELP_SHOW_FAQ: false,
        HELP_SHOW_TOUR: false,
        HELP_SHOW_ABOUT: false
    })
});

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

var _joyride = __webpack_require__(134);

var _joyride2 = _interopRequireDefault(_joyride);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    runJoyride: (0, _ReduxTools.simpleReducer)(false, {
        START_JOYRIDE: true,
        FINISH_JOYRIDE: false,
        CANCEL_JOYRIDE: false
    }),

    joyrideStatus: (0, _ReduxTools.simpleReducer)(_joyride2.default.STATUS.UNFINISHED, {
        RECEIVED_USER: function RECEIVED_USER(a) {
            return a.payload.response.preferences.joyrideStatus || _joyride2.default.STATUS.UNFINISHED;
        },
        UPDATED_PREFERENCES: function UPDATED_PREFERENCES(a) {
            return a.payload.response.joyrideStatus || _joyride2.default.STATUS.UNFINISHED;
        },
        START_JOYRIDE: _joyride2.default.STATUS.UNFINISHED,
        FINISH_JOYRIDE: _joyride2.default.STATUS.FINISHED,
        CANCEL_JOYRIDE: _joyride2.default.STATUS.CANCELED
    }),

    joyrideStatusSaveInProgress: (0, _ReduxTools.simpleReducer)(false, {
        SAVING_JOYRIDE_STATUS: true,
        SAVED_JOYRIDE_STATUS: false
    })
});

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

exports.default = (0, _redux.combineReducers)({
    isLoggedIn: (0, _ReduxTools.simpleReducer)(false, {
        RECEIVED_OFFERS: true,
        RECEIVED_USER: true,
        AUTH_ERROR: false
    }),

    wantLogin: (0, _ReduxTools.simpleReducer)(false, {
        WANT_LOGIN: function WANT_LOGIN(a) {
            return a.payload.wantLogin;
        },
        RECEIVED_OFFERS: false,
        RECEIVED_USER: false,
        AUTH_ERROR: true
    }),

    xsrfToken: (0, _ReduxTools.simpleReducer)('', {
        STORE_XSRF_TOKEN: function STORE_XSRF_TOKEN(a) {
            return a.payload.xsrfToken;
        }
    })
});

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

var _actions = __webpack_require__(159);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    offers: (0, _ReduxTools.simpleReducer)([], {
        RECEIVED_OFFERS: function RECEIVED_OFFERS(a) {
            return a.payload.response;
        }
    }),

    selectedOfferIndex: function selectedOfferIndex() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var action = arguments[1];

        switch (action.type) {
            case _actions2.default.RECEIVED_OFFERS:
                if (-1 < state && state < action.payload.response.length) {
                    return state;
                }
                if (action.payload.response.length > 0) {
                    return 0;
                }
                return -1;

            case _actions2.default.SELECT_OFFER:
                return action.payload.offerIndex;

            default:
                return state;
        }
    },

    offersRetrieved: (0, _ReduxTools.simpleReducer)(false, {
        RECEIVED_OFFERS: true,
        REQUESTING_OFFERS: false
    }),

    selectedProductIndex: (0, _ReduxTools.simpleReducer)(-1, {
        SELECT_PRODUCT: function SELECT_PRODUCT(a) {
            return a.payload.productIndex;
        },
        START_JOYRIDE: 0,
        FINISH_JOYRIDE: -1,
        CANCEL_JOYRIDE: -1
    })
});

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

exports.default = (0, _redux.combineReducers)({
    selectedTransaction: (0, _ReduxTools.simpleReducer)(null, {
        SELECT_TRANSACTION: function SELECT_TRANSACTION(a) {
            return a.payload.transaction;
        },
        CANCELED_ORDER: null,
        EXCEL_CANCELED_ORDER: null
    }),

    cancelProgress: (0, _ReduxTools.simpleReducer)('unknown', {
        CANCELING_ORDER: 'inprogress',
        CANCELING_EXCEL_ORDER: 'inprogress',
        CANCELED_ORDER: 'complete',
        CANCELED_EXCEL_ORDER: 'complete'
    }),

    progress: (0, _ReduxTools.simpleReducer)('unknown', {
        ORDER_COMPLETE: 'complete',
        EXCEL_ORDER_COMPLETE: 'complete',
        ORDER_FAILURE: 'error',
        EXCEL_ORDER_FAILURE: 'error',
        ORDER_INPROGRESS: 'inprogress',
        EXCEL_ORDER_INPROGRESS: 'inprogress',
        ORDER_PROGRESS_RESET: 'unknown',
        EXCEL_ORDER_PROGRESS_RESET: 'unknown'
    }),

    lastTransaction: (0, _ReduxTools.simpleReducer)(null, {
        ORDER_COMPLETE: function ORDER_COMPLETE(a) {
            return a.payload.transaction;
        },
        EXCEL_ORDER_COMPLETE: function EXCEL_ORDER_COMPLETE(a) {
            return a.payload.transaction;
        }
    })
});

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

var _actions = __webpack_require__(159);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _updateModalVisibility(state, modalName, visible) {
    return Object.assign({}, state, _defineProperty({}, modalName, visible));
}

exports.default = (0, _redux.combineReducers)({
    //modals: (state = { transaction: true }, action) => {
    modals: function modals() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case _actions2.default.OPEN_MODAL:
                return _updateModalVisibility(state, action.payload.modalName, true);

            case _actions2.default.CLOSE_MODAL:
                return _updateModalVisibility(state, action.payload.modalName, false);

            default:
                return state;
        }
    },

    appMounted: (0, _ReduxTools.simpleReducer)(false, { APP_MOUNTED: true }),

    accountModalPane: (0, _ReduxTools.simpleReducer)('profile', {
        SWITCH_ACCOUNT_MODAL_VIEW: function SWITCH_ACCOUNT_MODAL_VIEW(a) {
            return a.payload.pane;
        }
    })
});

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

exports.default = (0, _redux.combineReducers)({
    userSummaries: (0, _ReduxTools.simpleReducer)([], {
        REQUESTING_USER_SUMMARIES: [],
        RECEIVED_USER_SUMMARIES: function RECEIVED_USER_SUMMARIES(a) {
            return a.payload.summaries;
        }
    }),

    userSummariesInTransit: (0, _ReduxTools.simpleReducer)(false, {
        REQUESTING_USER_SUMMARIES: true,
        RECEIVED_USER_SUMMARIES: false
    }),

    mapUsername: (0, _ReduxTools.simpleReducer)('', {
        UPDATE_MAP_USERNAME: function UPDATE_MAP_USERNAME(a) {
            return a.payload.value;
        },
        USERNAME_LOOKUP_RESET: ''
    }),

    lookupInProgress: (0, _ReduxTools.simpleReducer)(false, {
        USERNAME_LOOKUP_STARTED: true,
        USERNAME_LOOKUP_FINISHED: false,
        USERNAME_LOOKUP_RESET: false
    }),

    lookupFinished: (0, _ReduxTools.simpleReducer)(false, {
        USERNAME_LOOKUP_STARTED: false,
        USERNAME_LOOKUP_FINISHED: true,
        USERNAME_LOOKUP_RESET: false
    }),

    spoofInProgress: (0, _ReduxTools.simpleReducer)(false, {
        REQUESTING_SPOOF: true,
        REQUESTED_SPOOF: false
    })
});

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

exports.default = (0, _redux.combineReducers)({
    sitesInTransit: (0, _ReduxTools.simpleReducer)(false, {
        REQUESTING_SITES: true,
        RECEIVED_SITES: false
    }),

    all_sites: (0, _ReduxTools.simpleReducer)([], {
        REQUESTING_SITES: [],
        RECEIVED_SITES: function RECEIVED_SITES(a) {
            return a.payload.response.sites;
        }
    }),

    selectedSiteId: (0, _ReduxTools.simpleReducer)('', {
        SELECT_SITE: function SELECT_SITE(a) {
            return a.payload.siteId;
        }
    }),

    showAlert: (0, _ReduxTools.simpleReducer)(false, {
        SHOW_ALERT: function SHOW_ALERT(action_response) {
            return action_response.payload.showAlert;
        }
    }),

    serverId: (0, _ReduxTools.simpleReducer)('', {
        SET_SERVER_ID: function SET_SERVER_ID(action_response) {
            return action_response.payload.serverId;
        }
    }),

    hostId: (0, _ReduxTools.simpleReducer)('', {
        SET_HOST_ID: function SET_HOST_ID(action_response) {
            return action_response.payload.hostId;
        }
    }),

    alertMessage: (0, _ReduxTools.simpleReducer)({ message: '', errorType: '' }, {
        SET_ALERT_MESSAGE: function SET_ALERT_MESSAGE(action_response) {
            return {
                message: action_response.payload.message,
                errorType: action_response.payload.errorType
            };
        }
    })
});

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

exports.default = (0, _redux.combineReducers)({
    uploadInTransit: (0, _ReduxTools.simpleReducer)(false, {
        CONFIGURATION_SHEET_UPLOADING: true,
        CONFIGURATION_SHEET_UPLOAD_SUCCESS: false,
        CONFIGURATION_SHEET_UPLOAD_DUPLICATE: false,
        CONFIGURATION_SHEET_UPLOAD_ERROR: false
    }),

    downloadSpinner: (0, _ReduxTools.simpleReducer)(false, {
        SET_DOWNLOAD_SPINNER: function SET_DOWNLOAD_SPINNER(a) {
            return a.payload;
        }
    }),

    dragOver: (0, _ReduxTools.simpleReducer)(false, {
        SET_DRAG_OVER: function SET_DRAG_OVER(a) {
            return a.payload.boolVal;
        }
    }),

    unknownFileType: (0, _ReduxTools.simpleReducer)(false, {
        SET_UNKOWN_FILETYE: function SET_UNKOWN_FILETYE(a) {
            return a.payload.boolVal;
        }
    }),

    fileUploaded: (0, _ReduxTools.simpleReducer)(null, {
        CONFIGURATION_SHEET_UPLOADING: function CONFIGURATION_SHEET_UPLOADING(a) {
            return a.payload.file;
        }
    }),

    uploadError: (0, _ReduxTools.simpleReducer)(null, {
        CONFIGURATION_SHEET_UPLOADING: null,
        CONFIGURATION_SHEET_UPLOAD_SUCCESS: null,
        CONFIGURATION_SHEET_UPLOAD_ERROR: function CONFIGURATION_SHEET_UPLOAD_ERROR(a) {
            return a.payload.error;
        }
    }),

    excelUploadErrorResponse: (0, _ReduxTools.simpleReducer)({}, {
        CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE: function CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE(a) {
            return a.payload.error.data;
        },
        CLEAR_EXCEL_SHEET_UPLOAD_ERROR_RESPONSE: {}
    }),

    uploadTotal: (0, _ReduxTools.simpleReducer)(0, {
        CONFIGURATION_SHEET_UPLOADING: function CONFIGURATION_SHEET_UPLOADING(a) {
            return a.payload.file.size;
        },
        CONFIGURATION_SHEET_UPLOAD_PROGRESS: function CONFIGURATION_SHEET_UPLOAD_PROGRESS(a) {
            return a.payload.total;
        }
    }),

    uploadProgress: (0, _ReduxTools.simpleReducer)(0, {
        CONFIGURATION_SHEET_UPLOADING: 0,
        CONFIGURATION_SHEET_UPLOAD_PROGRESS: function CONFIGURATION_SHEET_UPLOAD_PROGRESS(a) {
            return a.payload.complete;
        },
        CONFIGURATION_SHEET_UPLOAD_ERROR: 0,
        PRICE_SHEET_UPLOAD_DUPLICATE: 0
    }),

    catchedErrorMessage: (0, _ReduxTools.simpleReducer)(0, {
        SET_ERROR_MESSAGE: function SET_ERROR_MESSAGE(a) {
            return a.payload.message;
        }
    }),

    supermanReducer: (0, _ReduxTools.simpleReducer)('', {
        SUPERMAN: function SUPERMAN(a) {
            return a.payload.message;
        }
    }),

    configurationSheetUploadInTransit: (0, _ReduxTools.simpleReducer)(false, {
        REQUESTING_CONFIGURATION_SHEET: true,
        RECEIVED_CONFIGURATION_SHEET_RESPONSE: false
    }),

    configurationSheetUploadResponse: (0, _ReduxTools.simpleReducer)({}, {
        REQUESTING_CONFIGURATION_SHEET_RESPONSE: [],
        RECEIVED_CONFIGURATION_SHEET_RESPONSE: function RECEIVED_CONFIGURATION_SHEET_RESPONSE(a) {
            return a.payload.response;
        }
    }),

    downloadInProgress: (0, _ReduxTools.simpleReducer)(false, {
        DOWNLOADING_PRICING: true,
        DOWNLOADED_PRICING: false,
        DOWNLOADING_ALL_PRICING: true,
        DOWNLOADED_ALL_PRICING: false
    })
});

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(38);

var _ReduxTools = __webpack_require__(11);

exports.default = (0, _redux.combineReducers)({
    lastError: (0, _ReduxTools.simpleReducer)(null, {
        CATCH_ERROR: function CATCH_ERROR(a) {
            return a.payload.error;
        },
        ACKNOWLEDGE_ERROR: null
    }),

    errorMessage: (0, _ReduxTools.simpleReducer)(null, {
        SET_ERROR_MESSAGE: function SET_ERROR_MESSAGE(a) {
            return a.payload.message;
        },
        ACKNOWLEDGE_ERROR: null
    })
});

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReduxStore = __webpack_require__(25);

var _BaseLayout = __webpack_require__(160);

var _BaseLayout2 = _interopRequireDefault(_BaseLayout);

var _MapApi = __webpack_require__(133);

var _MapApi2 = _interopRequireDefault(_MapApi);

var _MigrationNotice = __webpack_require__(1013);

var _MigrationNotice2 = _interopRequireDefault(_MigrationNotice);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Login = function (_Component) {
    _inherits(Login, _Component);

    function Login() {
        _classCallCheck(this, Login);

        return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
    }

    _createClass(Login, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _BaseLayout2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { id: 'loginPage' },
                    _react2.default.createElement(_MigrationNotice2.default, { visible: true }),
                    _react2.default.createElement(
                        'div',
                        { className: 'row row-flex row-flush row-bordered flex-center p-y-lg' },
                        _react2.default.createElement(
                            'div',
                            { className: 'text-center' },
                            _react2.default.createElement(
                                'a',
                                { href: _MapApi2.default.getLoginUrl() },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-primary btn-pill btn-lg p-l-lg p-r-lg' },
                                    _strings2.default.login
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Login;
}(_react.Component);

exports.default = (0, _ReduxStore.attach)(Login);

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _MapApi = __webpack_require__(133);

var _MapApi2 = _interopRequireDefault(_MapApi);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _AccountModal = __webpack_require__(816);

var _AccountModal2 = _interopRequireDefault(_AccountModal);

var _TransactionModal = __webpack_require__(978);

var _TransactionModal2 = _interopRequireDefault(_TransactionModal);

var _ShoppingCartModal = __webpack_require__(542);

var _ShoppingCartModal2 = _interopRequireDefault(_ShoppingCartModal);

var _HelpModal = __webpack_require__(545);

var _HelpModal2 = _interopRequireDefault(_HelpModal);

__webpack_require__(1010);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header() {
        _classCallCheck(this, Header);

        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
    }

    _createClass(Header, [{
        key: '_renderButton',
        value: function _renderButton() {
            var _this2 = this;

            if (!this.props.isLoggedIn) {
                return _react2.default.createElement('span', null);
            }

            return _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-need-help btn-sm help-button',
                    onClick: function onClick() {
                        return _this2.props.openHelpModal();
                    }
                },
                _strings2.default.needHelpQuestion
            );
        }
    }, {
        key: '_renderBalance',
        value: function _renderBalance() {
            var _this3 = this;

            if (!this.props.offer) {
                return null;
            }

            var balance = _utils2.default.formatPrice(this.props.offer.balance);

            return _react2.default.createElement(
                'div',
                { className: 'navbar-flex-addon p-lg-r-md' },
                _react2.default.createElement(
                    'a',
                    {
                        onClick: function onClick() {
                            return _this3.props.openModal('transaction');
                        },
                        className: 'btn btn-sm btn-opaque-dark transaction-button'
                    },
                    _react2.default.createElement(
                        'b',
                        { className: 'text-xs text-mute text-uppercase' },
                        _strings2.default.myBalance,
                        ':'
                    ),
                    ' ' + balance
                )
            );
        }
    }, {
        key: '_renderCart',
        value: function _renderCart() {
            var _this4 = this;

            if (!this.props.offer) {
                return null;
            }

            var _props$cart$reduce = this.props.cart.reduce(function (counts, item) {
                if (item.cartId != '') {
                    if (!item.saveForLater) counts.cartItemCount++;else counts.saveForLaterCount++;
                }
                return counts;
            }, { cartItemCount: 0, saveForLaterCount: 0 }),
                cartItemCount = _props$cart$reduce.cartItemCount,
                saveForLaterCount = _props$cart$reduce.saveForLaterCount;
            // displaying item count for items which are not saved for later and added to cart.   


            var isDisabled = cartItemCount === 0 && saveForLaterCount === 0;

            return _react2.default.createElement(
                'div',
                { className: 'navbar-flex-addon p-lg-r-md' },
                _react2.default.createElement(
                    'a',
                    {
                        onClick: function onClick(e) {
                            if (isDisabled) {
                                e.preventDefault(); // Prevent the default action if disabled
                            } else {
                                _this4.props.openModal('shoppingcart'); // Open the modal if not disabled
                            }
                        },
                        className: 'btn btn-sm btn-opaque-dark cart-button ' + (isDisabled ? 'disabled' : '') // Add disabled class for styling
                        , style: { pointerEvents: isDisabled ? 'none' : 'auto' } // Disable pointer events if cart is empty
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'cart-icon' },
                        _react2.default.createElement(
                            'svg',
                            { className: 'icon icon-plm-shopping-cart' },
                            _react2.default.createElement('use', { href: '#icon-plm-shopping-cart' })
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'cart-count' },
                        cartItemCount
                    )
                )
            );
        }
    }, {
        key: '_renderLogoutLink',
        value: function _renderLogoutLink() {
            var _this5 = this;

            var _props = this.props,
                myself = _props.myself,
                spoofer = _props.spoofer;

            if (!myself) {
                return null;
            }

            var icon = 'icon-user';
            var iconClass = '';
            var labelClass = 'text-muted';

            if (spoofer) {
                icon = 'icon-users';
                iconClass = 'text-success';
                labelClass = 'text-success';
            }

            return _react2.default.createElement(
                'div',
                { className: 'navbar-flex-addon' },
                _react2.default.createElement(
                    'span',
                    { className: 'text-xs' },
                    _react2.default.createElement(
                        'a',
                        {
                            className: 'cursor-pointer account-button',
                            onClick: function onClick() {
                                return _this5.props.openModal('account');
                            }
                        },
                        _react2.default.createElement(
                            'span',
                            { className: iconClass },
                            _react2.default.createElement(
                                'svg',
                                { className: 'icon icon-circle-border ' + icon },
                                _react2.default.createElement('use', { href: '#' + icon })
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: labelClass },
                            ' ' + myself.firstName + ' ' + myself.lastName
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'text-pipe' },
                        ' | '
                    ),
                    _react2.default.createElement(
                        'a',
                        { className: 'logout-link', href: _MapApi2.default.getLogoutUrl() },
                        _strings2.default.signOut
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'nav',
                { className: 'navbar navbar-top navbar-top-no-shadow navbar-flex text-webfont-one p-a-sm text-inverse header' },
                _react2.default.createElement(
                    'div',
                    { className: 'navbar-flex-addon' },
                    _react2.default.createElement('a', { className: 'logo-mentor', href: '#' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'navbar-flex-addon p-l' },
                    _react2.default.createElement(
                        'h1',
                        { className: 'h4 m-a-0' },
                        _strings2.default.mentorAdvantage
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'navbar-flex-addon p-l' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-flex-addon text-xs text-muted' },
                        this._renderButton()
                    )
                ),
                _react2.default.createElement('div', { className: 'navbar-flex-main' }),
                this._renderBalance(),
                this._renderCart(),
                this._renderLogoutLink(),
                _react2.default.createElement(_HelpModal2.default, null),
                ' ',
                _react2.default.createElement(_AccountModal2.default, null),
                _react2.default.createElement(_TransactionModal2.default, null),
                _react2.default.createElement(_ShoppingCartModal2.default, null),
                ' '
            );
        }
    }]);

    return Header;
}(_react.Component);

Header.propTypes = {
    offer: _MapPropTypes2.default.OfferProps,
    myself: _MapPropTypes2.default.UserProps,
    spoofer: _MapPropTypes2.default.UserProps,
    cart: _MapPropTypes2.default.CartProps
};

Header.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        offer: _selectors2.default.offer.getSelectedOffer,
        myself: _selectors2.default.user.getMyself,
        spoofer: _selectors2.default.user.getSpoofer,
        cart: _selectors2.default.cart.getCartContents,
        isLoggedIn: _selectors2.default.login.getIsLoggedIn
    });
};

Header.mapDispatch = function (dispatch) {
    return {
        openModal: function openModal(modal) {
            return dispatch(_ui2.default.openModal(modal));
        },
        openHelpModal: function openHelpModal() {
            return dispatch(_ui2.default.openHelpModal());
        }
    };
};

exports.default = (0, _ReduxStore.attach)(Header);

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _reactComponents = __webpack_require__(35);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _user = __webpack_require__(112);

var _user2 = _interopRequireDefault(_user);

var _sites = __webpack_require__(114);

var _sites2 = _interopRequireDefault(_sites);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _NavLines = __webpack_require__(541);

var _NavLines2 = _interopRequireDefault(_NavLines);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

var _SiteList = __webpack_require__(972);

var _SiteList2 = _interopRequireDefault(_SiteList);

var _UserSpoofer = __webpack_require__(975);

var _UserSpoofer2 = _interopRequireDefault(_UserSpoofer);

__webpack_require__(977);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountModal = function (_Component) {
    _inherits(AccountModal, _Component);

    function AccountModal() {
        _classCallCheck(this, AccountModal);

        return _possibleConstructorReturn(this, (AccountModal.__proto__ || Object.getPrototypeOf(AccountModal)).apply(this, arguments));
    }

    _createClass(AccountModal, [{
        key: '_renderProfile',
        value: function _renderProfile() {
            var myself = this.props.myself;


            return _react2.default.createElement(
                'dl',
                { className: 'dl-horizontal p-l-md p-r-md m-t profile' },
                this.props.offer && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'dt',
                        { className: 'col-sm-4 p-l-0' },
                        _strings2.default.myMentorContact
                    ),
                    _react2.default.createElement(
                        'dd',
                        { className: 'col-sm-8 p-l-0' },
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'mailto:' + this.props.offer.fulfillmentContactName
                            },
                            this.props.offer.fulfillmentContactId,
                            ' ',
                            _react2.default.createElement(
                                'sup',
                                null,
                                _react2.default.createElement(_reactComponents.Icon, { name: 'icon-envelope' })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'dt',
                    { className: 'col-sm-4 p-l-0' },
                    _strings2.default.myProfile
                ),
                _react2.default.createElement(
                    'dd',
                    { className: 'col-sm-8 p-l-0' },
                    _react2.default.createElement(
                        'div',
                        { className: myself.spoofer ? 'text-success' : '' },
                        _react2.default.createElement(
                            'address',
                            { className: 'm-b-0' },
                            _react2.default.createElement(
                                'strong',
                                null,
                                myself.firstName,
                                ' ',
                                myself.lastName
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'em',
                                null,
                                myself.email
                            ),
                            _react2.default.createElement('br', null),
                            myself.accounts.map(function (_ref) {
                                var name = _ref.name;
                                return name;
                            }).join(', '),
                            _react2.default.createElement('br', null),
                            myself.address1,
                            _react2.default.createElement('br', null),
                            myself.address2,
                            ' ',
                            myself.address2 ? _react2.default.createElement('br', null) : '',
                            myself.city,
                            ' ',
                            myself.state,
                            ' ',
                            myself.postalCode,
                            _react2.default.createElement('br', null)
                        )
                    )
                )
            );
        }
    }, {
        key: '_handleFavoriteClick',
        value: function _handleFavoriteClick(site, server) {
            var _props = this.props,
                favoriteSite = _props.favoriteSite,
                favoriteServer = _props.favoriteServer;

            if (site.id !== favoriteSite || server.id !== favoriteServer) {
                this.props.updateFavorites(this.props.offer, site, server);
            }
        }
    }, {
        key: '_handleServerBySiteListDownload',
        value: function _handleServerBySiteListDownload(id) {
            this.props.downloadServersBySiteList(this.props.offer.id);
        }
    }, {
        key: '_renderVisiblePane',
        value: function _renderVisiblePane() {
            var _this2 = this;

            switch (this.props.visiblePane) {
                case 'spoof':
                    return _react2.default.createElement(_UserSpoofer2.default, null);

                case 'sites':
                    return _react2.default.createElement(_SiteList2.default, {
                        sites: this.props.serversBySite,
                        favoriteSite: this.props.favoriteSite,
                        favoriteServer: this.props.favoriteServer,
                        setFavorites: function setFavorites(site, server) {
                            return _this2._handleFavoriteClick(site, server);
                        },
                        serverAliases: this.props.serverAliases,
                        setServerAlias: function setServerAlias(server, alias) {
                            return _this2.props.updateServerAlias(server, alias);
                        },
                        downloadServersBySiteList: function downloadServersBySiteList() {
                            return _this2._handleServerBySiteListDownload();
                        },
                        offer: this.props.offer.id
                    });

                case 'profile':
                default:
                    return this._renderProfile();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.props.myself) {
                return _react2.default.createElement('div', null);
            }

            var tabs = [{
                name: 'profile',
                label: _strings2.default.profile
            }];

            if (this.props.offer) {
                tabs.push({
                    name: 'sites',
                    label: _strings2.default.sites
                });
            }

            if (this.props.myselfIsAdmin) {
                tabs.push({
                    name: 'spoof',
                    label: _strings2.default.spoof
                });
            }

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'account-modal',
                    modalTitle: _strings2.default.myAccount,
                    visible: this.props.visible,
                    closeModal: this.props.close
                },
                _react2.default.createElement(_NavLines2.default, {
                    onChange: function onChange(key) {
                        return _this3.props.switchPane(key);
                    },
                    activeTab: this.props.visiblePane,
                    tabs: tabs
                }),
                this._renderVisiblePane()
            );
        }
    }]);

    return AccountModal;
}(_react.Component);

AccountModal.propTypes = {
    myself: _MapPropTypes2.default.UserProps,
    myselfIsAdmin: _propTypes2.default.bool.isRequired,
    offer: _MapPropTypes2.default.OfferProps,
    serversBySite: _propTypes2.default.arrayOf(_MapPropTypes2.default.SiteProps).isRequired,
    visible: _propTypes2.default.bool.isRequired,
    favoriteSite: _propTypes2.default.string,
    favoriteServer: _propTypes2.default.string,
    visiblePane: _propTypes2.default.string.isRequired,
    serverAliases: _propTypes2.default.object.isRequired,
    close: _propTypes2.default.func.isRequired,
    updateFavorites: _propTypes2.default.func.isRequired,
    updateServerAlias: _propTypes2.default.func.isRequired,
    switchPane: _propTypes2.default.func.isRequired
};

AccountModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, _defineProperty({
        myself: _selectors2.default.user.getMyself,
        myselfIsAdmin: _selectors2.default.user.getMyselfIsAdmin,
        offer: _selectors2.default.offer.getSelectedOffer,
        serversBySite: _selectors2.default.offer.getServersGroupedBySite,
        visible: _selectors2.default.ui.getAccountModalVisible,
        favoriteSite: _selectors2.default.user.getFavoriteSite,
        favoriteServer: _selectors2.default.user.getFavoriteServer,
        visiblePane: _selectors2.default.ui.getAccountModalPane,
        serverAliases: _selectors2.default.user.getServerAliases
    }, 'offer', _selectors2.default.offer.getSelectedOffer));
};

AccountModal.mapDispatch = function (dispatch) {
    return {
        close: function close() {
            return dispatch(_ui2.default.closeModal('account'));
        },
        updateFavorites: function updateFavorites(offer, site, server) {
            return dispatch(_user2.default.updateFavorites(offer, site, server));
        },
        updateServerAlias: function updateServerAlias(server, alias) {
            return dispatch(_user2.default.updateServerAlias(server, alias));
        },
        switchPane: function switchPane(pane) {
            return dispatch(_ui2.default.switchAccountModalPane(pane));
        },
        downloadServersBySiteList: function downloadServersBySiteList(id) {
            return dispatch(_sites2.default.downloadServersBySiteList(id));
        }
    };
};

exports.default = (0, _ReduxStore.attach)(AccountModal);

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(64);

var _reactComponents = __webpack_require__(35);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

__webpack_require__(973);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SiteList = function (_Component) {
    _inherits(SiteList, _Component);

    function SiteList() {
        _classCallCheck(this, SiteList);

        var _this = _possibleConstructorReturn(this, (SiteList.__proto__ || Object.getPrototypeOf(SiteList)).call(this));

        _this.state = { aliasBuffers: {} };
        return _this;
    }

    _createClass(SiteList, [{
        key: '_renderFavoriteButton',
        value: function _renderFavoriteButton(site, server) {
            var _this2 = this;

            var isFavorite = this.props.favoriteSite && this.props.favoriteServer && this.props.favoriteSite === site.id && this.props.favoriteServer === server.id;
            var title = isFavorite ? _strings2.default.currentFavorite : _strings2.default.favoriteThisServer;
            var btnClass = isFavorite ? 'btn-info text-inverse' : 'btn-info-outline';

            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        key: server.id,
                        placement: 'left',
                        trigger: ['hover', 'focus'],
                        overlay: _react2.default.createElement(
                            _reactBootstrap.Tooltip,
                            { id: server.id },
                            title
                        )
                    },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'site-favorite-button btn btn-xs ' + btnClass,
                            onClick: function onClick() {
                                return _this2.props.setFavorites(site, server);
                            }
                        },
                        _react2.default.createElement(_reactComponents.Icon, { name: 'icon-star-full' }),
                        ' ',
                        _strings2.default.favorite
                    )
                )
            );
        }
    }, {
        key: '_setEditing',
        value: function _setEditing(server) {
            this.setState({
                aliasBuffers: _extends({}, this.state.aliasBuffers, _defineProperty({}, server.id, this.props.serverAliases[server.id] || server.mentorId))
            });
        }
    }, {
        key: '_updateAliasBuffer',
        value: function _updateAliasBuffer(server, event) {
            this.setState({
                aliasBuffers: _extends({}, this.state.aliasBuffers, _defineProperty({}, server.id, event.target.value))
            });
        }
    }, {
        key: '_wipeAliasUpdate',
        value: function _wipeAliasUpdate(server) {
            var newState = {
                aliasBuffers: _extends({}, this.state.aliasBuffers)
            };
            delete newState.aliasBuffers[server.id];
            this.setState(newState);
        }
    }, {
        key: '_saveAliasUpdate',
        value: function _saveAliasUpdate(server) {
            this.props.setServerAlias(server, this.state.aliasBuffers[server.id]);
            this._wipeAliasUpdate(server);
        }
    }, {
        key: '_renderStaticServerName',
        value: function _renderStaticServerName(server) {
            var _this3 = this;

            var name = this.props.serverAliases[server.id] || _react2.default.createElement(
                'em',
                { className: 'text-muted' },
                _strings2.default.none
            );
            var clearIcon = this.props.serverAliases[server.id] ? _react2.default.createElement(
                'a',
                {
                    className: 'cursor-pointer text-xxs text-danger',
                    onClick: function onClick() {
                        return _this3.props.setServerAlias(server, '');
                    }
                },
                _react2.default.createElement(_reactComponents.Icon, { name: 'icon-cross2' })
            ) : null;

            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    'span',
                    {
                        onDoubleClick: function onDoubleClick(evt) {
                            _this3._setEditing(server);
                            evt.preventDefault();
                        }
                    },
                    name
                ),
                '\xA0',
                clearIcon,
                '\xA0',
                _react2.default.createElement(
                    'a',
                    {
                        className: 'cursor-pointer text-xxs text-primary',
                        onClick: function onClick() {
                            return _this3._setEditing(server);
                        }
                    },
                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-pencil' })
                )
            );
        }
    }, {
        key: '_handleInputKeyPress',
        value: function _handleInputKeyPress(server, event) {
            if (event.key === 'Enter') {
                this._saveAliasUpdate(server);
            }
        }
    }, {
        key: '_renderInputServerName',
        value: function _renderInputServerName(server) {
            var _this4 = this;

            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('input', {
                    onFocus: function onFocus(evt) {
                        return evt.target.select();
                    },
                    className: 'form-control server-name-input',
                    onChange: function onChange(event) {
                        return _this4._updateAliasBuffer(server, event);
                    },
                    onKeyPress: function onKeyPress(event) {
                        return _this4._handleInputKeyPress(server, event);
                    },
                    value: this.state.aliasBuffers[server.id]
                }),
                '\xA0',
                _react2.default.createElement(
                    'a',
                    {
                        className: 'text-danger cursor-pointer',
                        onClick: function onClick() {
                            return _this4._wipeAliasUpdate(server);
                        }
                    },
                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-cross2' })
                ),
                '\xA0',
                _react2.default.createElement(
                    'a',
                    {
                        className: 'text-success cursor-pointer',
                        onClick: function onClick() {
                            return _this4._saveAliasUpdate(server);
                        }
                    },
                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-checkmark' })
                )
            );
        }
    }, {
        key: '_renderNickname',
        value: function _renderNickname(server) {
            if (this.state.aliasBuffers[server.id] !== undefined) {
                return this._renderInputServerName(server);
            }

            return this._renderStaticServerName(server);
        }
    }, {
        key: '_renderPlatform',
        value: function _renderPlatform(server) {
            if (!server.platform) {
                return _react2.default.createElement(
                    'em',
                    { className: 'text-mute' },
                    _react2.default.createElement(_reactComponents.Icon, { name: 'icon-display' }),
                    '\xA0',
                    _strings2.default.unknownPlatform
                );
            }

            var iconName = 'icon-display';
            if (server.platform.mentorId === 'LINUX') {
                iconName = 'icon-tux';
            }
            if (server.platform.mentorId === 'WINDOWS') {
                iconName = 'icon-windows8';
            }

            return _react2.default.createElement(
                'span',
                { className: 'text-mute' },
                _react2.default.createElement(_reactComponents.Icon, { name: iconName }),
                '\xA0',
                server.platform.vendor,
                ' - ',
                server.platform.variant
            );
        }
    }, {
        key: '_renderSite',
        value: function _renderSite(site, i) {
            var _this5 = this;

            return _react2.default.createElement(
                'div',
                { className: 'card text-sm m-a', key: i },
                _react2.default.createElement(
                    'div',
                    { className: 'card-header p-a-sm' },
                    _strings2.default.serversFor,
                    '\xA0',
                    _react2.default.createElement(
                        'b',
                        null,
                        site.mentorId,
                        ' ',
                        ' - ',
                        site.name,
                        site.city ? _react2.default.createElement(
                            'span',
                            null,
                            ', ',
                            site.city,
                            ', ',
                            site.state
                        ) : ''
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'card-block p-a-0' },
                    site.servers.map(function (server, j) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'row p-a-sm p-r', key: j },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-9 server-name' },
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    _strings2.default.server
                                ),
                                ':',
                                ' ',
                                server.mentorId,
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    _strings2.default.nickname
                                ),
                                ':',
                                ' ',
                                _this5._renderNickname(server),
                                _react2.default.createElement('br', null),
                                _this5._renderPlatform(server)
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-3 text-right p-r-sm' },
                                _this5._renderFavoriteButton(site, server)
                            )
                        );
                    })
                )
            );
        }
    }, {
        key: '_handleDownloadServersBySiteButtonClick',
        value: function _handleDownloadServersBySiteButtonClick() {
            this.props.downloadServersBySiteList();
        }
    }, {
        key: '_renderDownloadButton',
        value: function _renderDownloadButton() {
            var _this6 = this;

            return _react2.default.createElement(
                'div',
                { className: 'p-t-sm wide-border' },
                _react2.default.createElement('div', { className: 'col-sm-7' }),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-5' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-info btn-sm',
                            onClick: function onClick() {
                                return _this6._handleDownloadServersBySiteButtonClick();
                            },
                            disabled: false },
                        _react2.default.createElement(_reactComponents.Icon, { name: 'icon-download2' }),
                        ' ',
                        _strings2.default.ServersBySiteList
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var floatCont = {
                border: '3px solid #fff',
                padding: '10px',
                width: '50%',
                position: 'right'
            };
            var floatChild = {
                width: '50%',
                float: 'right',
                padding: '10px'
                // border: '2px solid red',
            };
            return _react2.default.createElement(
                'div',
                { className: 'container' },
                this._renderDownloadButton(),
                _react2.default.createElement(
                    'div',
                    { className: 'site-list' },
                    this.props.sites.map(function (site, i) {
                        return _this7._renderSite(site, i);
                    })
                )
            );
        }
    }]);

    return SiteList;
}(_react.Component);

SiteList.propTypes = {
    sites: _propTypes2.default.arrayOf(_MapPropTypes2.default.SiteProps),
    favoriteSite: _propTypes2.default.string,
    favoriteServer: _propTypes2.default.string,
    setFavorites: _propTypes2.default.func.isRequired,
    serverAliases: _propTypes2.default.object.isRequired,
    setServerAlias: _propTypes2.default.func.isRequired
};
exports.default = SiteList;

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 974:
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _reactSelectPlus = __webpack_require__(92);

var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);

var _ReduxStore = __webpack_require__(25);

var _ReduxStore2 = _interopRequireDefault(_ReduxStore);

var _ReduxTools = __webpack_require__(11);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _user = __webpack_require__(112);

var _user2 = _interopRequireDefault(_user);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSpoofer = function (_Component) {
    _inherits(UserSpoofer, _Component);

    function UserSpoofer() {
        _classCallCheck(this, UserSpoofer);

        return _possibleConstructorReturn(this, (UserSpoofer.__proto__ || Object.getPrototypeOf(UserSpoofer)).apply(this, arguments));
    }

    _createClass(UserSpoofer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.summaries || this.props.summaries.length === 0) {
                this.props.fetchSummaries();
            }
        }
    }, {
        key: '_handleCheckboxClick',
        value: function _handleCheckboxClick(event) {
            if (event.target.checked) {
                return this.props.spoofUser(this.props.summaries[0].id);
            }
            return this.props.spoofUser(null);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.props.summaries || !this.props.myself) {
                return null;
            }

            var _props = this.props,
                myself = _props.myself,
                spoofEnabled = _props.spoofEnabled,
                spoofer = _props.spoofer,
                summaries = _props.summaries;

            var cardClass = spoofer ? 'text-inverse card-success' : 'bg-gray-lightest';
            var value = spoofer ? myself.id : '';
            var loading = this.props.summariesInTransit || this.props.spoofInProgress;

            return _react2.default.createElement(
                'div',
                { className: 'p-l-sm p-r-sm m-t-md spoofer' },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'checkbox',
                            onChange: function onChange(e) {
                                return _this2._handleCheckboxClick(e);
                            },
                            checked: spoofEnabled
                        }),
                        '\xA0',
                        _strings2.default.enableUserSpoofing
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'card p-a ' + cardClass },
                        _react2.default.createElement(_reactSelectPlus2.default, {
                            options: summaries.map(function (_ref) {
                                var firstName = _ref.firstName,
                                    lastName = _ref.lastName,
                                    email = _ref.email,
                                    id = _ref.id;
                                return {
                                    label: firstName + ' ' + lastName + ' - ' + email,
                                    value: id
                                };
                            }),
                            value: value,
                            onChange: function onChange(opt) {
                                return opt ? _this2.props.spoofUser(opt.value) : null;
                            },
                            pageSize: 3,
                            clearable: false,
                            disabled: loading || !spoofEnabled,
                            isLoading: loading,
                            valueRenderer: loading ? function () {
                                return _strings2.default.spoofing;
                            } : undefined,
                            placeholder: loading ? _strings2.default.spoofing : undefined
                        }),
                        spoofer ? _react2.default.createElement(
                            'div',
                            { className: 'row m-t-sm text-sm p-l' },
                            _strings2.default.loggedInAs,
                            '\xA0',
                            _react2.default.createElement(
                                'em',
                                null,
                                spoofer.firstName,
                                ' ',
                                spoofer.lastName
                            )
                        ) : null
                    )
                )
            );
        }
    }]);

    return UserSpoofer;
}(_react.Component);

UserSpoofer.propTypes = {
    fetchSummaries: _propTypes2.default.func.isRequired,
    myself: _MapPropTypes2.default.UserProps,
    spoofEnabled: _propTypes2.default.bool.isRequired,
    spoofInProgress: _propTypes2.default.bool.isRequired,
    spoofUser: _propTypes2.default.func.isRequired,
    spoofer: _MapPropTypes2.default.UserProps,
    summaries: _propTypes2.default.arrayOf(_propTypes2.default.object),
    summariesInTransit: _propTypes2.default.bool
};

UserSpoofer.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        myself: _selectors2.default.user.getMyself,
        spoofEnabled: _selectors2.default.user.getSpoofEnabled,
        spoofInProgress: _selectors2.default.user.getSpoofInProgress,
        spoofer: _selectors2.default.user.getSpoofer,
        summaries: _selectors2.default.user.getSortedSummaries,
        summariesInTransit: _selectors2.default.user.getSummariesInTransit
    });
};

UserSpoofer.mapDispatch = function (dispatch) {
    return {
        fetchSummaries: function fetchSummaries() {
            return dispatch(_user2.default.fetchSummaries());
        },
        spoofUser: function spoofUser(userId) {
            dispatch(_user2.default.spoofUser(userId));
        }
    };
};

exports.default = _ReduxStore2.default.attach(UserSpoofer);

/***/ }),

/***/ 977:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(132);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReduxStore = __webpack_require__(25);

var _ReduxTools = __webpack_require__(11);

var _reactComponents = __webpack_require__(35);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _selectors = __webpack_require__(22);

var _selectors2 = _interopRequireDefault(_selectors);

var _ui = __webpack_require__(36);

var _ui2 = _interopRequireDefault(_ui);

var _order = __webpack_require__(78);

var _order2 = _interopRequireDefault(_order);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

var _TransactionHistory = __webpack_require__(979);

var _TransactionHistory2 = _interopRequireDefault(_TransactionHistory);

var _OrderCancelModal = __webpack_require__(981);

var _OrderCancelModal2 = _interopRequireDefault(_OrderCancelModal);

__webpack_require__(982);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TransactionModal = function (_Component) {
    _inherits(TransactionModal, _Component);

    function TransactionModal() {
        _classCallCheck(this, TransactionModal);

        return _possibleConstructorReturn(this, (TransactionModal.__proto__ || Object.getPrototypeOf(TransactionModal)).apply(this, arguments));
    }

    _createClass(TransactionModal, [{
        key: '_renderAvailableCredits',
        value: function _renderAvailableCredits() {
            if (!this.props.offer) {
                return _react2.default.createElement('span', null);
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'display-3 text-info text-center' },
                    _react2.default.createElement(
                        'b',
                        null,
                        _utils2.default.formatPrice(this.props.offer.balance)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'text-uppercase text-xs text-mute text-center' },
                    _strings2.default.availableCredits
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'text-center text-xs text-muted m-t-xs' },
                    _strings2.default.contractDuration,
                    ':',
                    ' ',
                    _utils2.default.formatShortDate(this.props.offer.validFrom),
                    ' -',
                    ' ',
                    _utils2.default.formatShortDate(this.props.offer.validTo)
                )
            );
        }
    }, {
        key: '_renderLastTransaction',
        value: function _renderLastTransaction() {
            var _this2 = this;

            if (!this.props.lastTransaction) {
                return _react2.default.createElement('div', null);
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'dl',
                    { className: 'dl-horizontal border-top text-sm m-b-0 m-t p-t-sm' },
                    _react2.default.createElement(
                        'dt',
                        { className: 'col-xs-6 text-right' },
                        _strings2.default.lastTransaction
                    ),
                    _react2.default.createElement(
                        'dd',
                        { className: 'col-xs-6' },
                        _utils2.default.formatDate(this.props.lastTransaction.lastModified)
                    ),
                    _react2.default.createElement(
                        'dt',
                        { className: 'col-xs-6 text-right' },
                        _strings2.default.creditsUsed
                    ),
                    _react2.default.createElement(
                        'dd',
                        {
                            className: 'col-xs-6 ' + _utils2.default.amountClass(this.props.lastTransaction)
                        },
                        _utils2.default.formatPrice(this.props.lastTransaction.amount)
                    ),
                    _react2.default.createElement(
                        'dt',
                        { className: 'col-xs-6 text-right' },
                        _strings2.default.currency
                    ),
                    _react2.default.createElement(
                        'dd',
                        { className: 'col-xs-6' },
                        this.props.lastTransaction.currencey || 'USD'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'text-center border-bottom p-b-sm m-b-md wide-border' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-info btn-sm',
                            onClick: function onClick() {
                                return _this2.props.downloadTransactionReport(_this2.props.offer);
                            }
                        },
                        _react2.default.createElement(_reactComponents.Icon, { name: 'icon-download2' }),
                        ' ',
                        _strings2.default.downloadTransactions
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'transaction-modal',
                    modalTitle: _strings2.default.transactions,
                    visible: this.props.visible,
                    closeModal: this.props.close
                },
                this._renderAvailableCredits(),
                this._renderLastTransaction(),
                _react2.default.createElement(_TransactionHistory2.default, {
                    transactions: this.props.transactions,
                    cancelOrder: function cancelOrder(t) {
                        _this3.props.selectTransaction(t);
                        _this3.props.openCancelModal();
                    },
                    downloadTransactionReport: function downloadTransactionReport() {
                        return _this3.props.downloadTransactionReport();
                    }
                }),
                _react2.default.createElement(_OrderCancelModal2.default, {
                    visible: this.props.cancelVisible,
                    close: function close() {
                        return _this3.props.closeCancel();
                    },
                    transaction: this.props.selectedTransaction,
                    cancelOrder: function cancelOrder(t) {
                        return _this3.props.cancelOrder(t, _this3.props.history);
                    }
                })
            );
        }
    }]);

    return TransactionModal;
}(_react.Component);

TransactionModal.propTypes = {
    close: _propTypes2.default.func.isRequired,
    offer: _MapPropTypes2.default.OfferProps,
    transactions: _propTypes2.default.arrayOf(_MapPropTypes2.default.TransactionProps),
    lastTransaction: _MapPropTypes2.default.TransactionProps,
    selectedTransaction: _MapPropTypes2.default.TransactionProps,
    visible: _propTypes2.default.bool.isRequired,
    downloadTransactionReport: _propTypes2.default.func.isRequired
};

TransactionModal.mapState = function (state) {
    return (0, _ReduxTools.mapSelectors)(state, {
        offer: _selectors2.default.offer.getSelectedOffer,
        visible: _selectors2.default.ui.getTransactionModalVisible,
        cancelVisible: _selectors2.default.ui.getOrderCancelModalVisible,
        lastTransaction: _selectors2.default.offer.getLastTransaction,
        selectedTransaction: _selectors2.default.order.getSelectedTransaction,
        transactions: _selectors2.default.offer.getSortedTransactions
    });
};

TransactionModal.mapDispatch = function (dispatch) {
    return {
        close: function close() {
            return dispatch(_ui2.default.closeModal('transaction'));
        },
        selectTransaction: function selectTransaction(transaction) {
            return dispatch(_order2.default.selectTransaction(transaction));
        },
        closeCancel: function closeCancel() {
            return dispatch(_ui2.default.closeModal('cancel'));
        },
        cancelOrder: function cancelOrder(transaction, history) {
            return dispatch(_order2.default.cancelOrder(transaction, history));
        },
        openCancelModal: function openCancelModal() {
            return dispatch(_ui2.default.openModal('cancel'));
        },
        downloadTransactionReport: function downloadTransactionReport(offer) {
            return dispatch(_order2.default.downloadTransactionReport(offer));
        }
    };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _ReduxStore.attach)(TransactionModal));

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(64);

var _reactComponents = __webpack_require__(35);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

__webpack_require__(980);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TransactionHistory = function (_Component) {
    _inherits(TransactionHistory, _Component);

    function TransactionHistory() {
        _classCallCheck(this, TransactionHistory);

        return _possibleConstructorReturn(this, (TransactionHistory.__proto__ || Object.getPrototypeOf(TransactionHistory)).apply(this, arguments));
    }

    _createClass(TransactionHistory, [{
        key: '_renderPopover',
        value: function _renderPopover(transaction, key) {
            var showWeeks = transaction.licenses.length > 0 && transaction.licenses.find(function (_ref) {
                var weeks = _ref.weeks;
                return weeks > 0;
            });

            return _react2.default.createElement(
                _reactBootstrap.Popover,
                { id: key },
                _react2.default.createElement(
                    'table',
                    { className: 'table table-sm m-b-0' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                null,
                                'Product'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Seats'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Months'
                            ),
                            showWeeks && _react2.default.createElement(
                                'th',
                                null,
                                _strings2.default.weeks
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Credits Used'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        transaction.licenses.map(function (license, j) {
                            return _react2.default.createElement(
                                'tr',
                                { key: j },
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    license.product.name
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    license.seats
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    license.duration
                                ),
                                showWeeks && _react2.default.createElement(
                                    'td',
                                    null,
                                    license.weeks
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _utils2.default.formatPrice(license.amount)
                                )
                            );
                        })
                    )
                ),
                transaction.instructions && _react2.default.createElement(
                    'div',
                    { className: 'transaction-instructions text-mute' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _strings2.default.specialInstructions,
                        ':'
                    ),
                    ' ',
                    transaction.instructions
                )
            );
        }
    }, {
        key: '_renderUser',
        value: function _renderUser(transaction) {
            var user = transaction.user,
                type = transaction.type,
                lastModified = transaction.lastModified;


            if (!user || !user.email || type !== 'order') {
                return null;
            }

            return _react2.default.createElement(
                'a',
                {
                    href: 'mailto:' + user.email + '?subject=' + _strings2.default.regardingOrder + ' ' + _utils2.default.formatShortDate(lastModified)
                },
                user.email
            );
        }

        // _renderCancelButton(transaction) {
        // if (transaction.type === 'order') {
        //     return (
        //         <button
        //             type="button"
        //             className="close"
        //             aria-label="Close"
        //             onClick={() => this.props.cancelOrder(transaction)}
        //         >
        //             <span className="text-danger text-md" aria-hidden="true">
        //                 <Icon name="icon-cancel" />
        //             </span>
        //             <span className="sr-only">Close</span>
        //         </button>
        //     );
        // }

        // return null;
        // }

    }, {
        key: '_renderTransactionItem',
        value: function _renderTransactionItem(transaction, key) {
            var buildPopover = transaction.licenses && transaction.licenses.length > 0;
            var result = _react2.default.createElement(
                'tr',
                { key: key },
                _react2.default.createElement(
                    'td',
                    { className: 'text-sm text-muted' },
                    _utils2.default.formatDate(transaction.lastModified)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    transaction.description,
                    buildPopover ? _react2.default.createElement(
                        'span',
                        { className: 'text-info' },
                        ' ',
                        _react2.default.createElement(_reactComponents.Icon, { name: 'icon-bubble-lines2' })
                    ) : ''
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this._renderUser(transaction)
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right ' + _utils2.default.amountClass(transaction) },
                    _react2.default.createElement(
                        'b',
                        null,
                        _utils2.default.formatPrice(transaction.amount)
                    )
                )
            );

            if (buildPopover) {
                return _react2.default.createElement(
                    _reactBootstrap.OverlayTrigger,
                    {
                        key: key,
                        placement: 'top',
                        trigger: ['hover', 'focus'],
                        overlay: this._renderPopover(transaction, key)
                    },
                    result
                );
            }

            return result;
        }

        /* we'll never need to repaint this. if the offer changes, the use will have
         *  to refresh the page anyway
         */

    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: '_renderTable',
        value: function _renderTable() {
            var _this2 = this;

            var transactions = this.props.transactions;


            if (transactions.length === 0) {
                return _react2.default.createElement(
                    'div',
                    { className: 'p-a-md text-center text-mute' },
                    _react2.default.createElement(
                        'em',
                        null,
                        _strings2.default.none
                    )
                );
            }

            return _react2.default.createElement(
                'table',
                { className: 'table table-hover m-b-0' },
                _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            { className: 'text-xs text-uppercase' },
                            _strings2.default.date
                        ),
                        _react2.default.createElement(
                            'th',
                            { className: 'text-xs text-uppercase' },
                            _strings2.default.description
                        ),
                        _react2.default.createElement(
                            'th',
                            { className: 'text-xs text-uppercase' },
                            _strings2.default.user
                        ),
                        _react2.default.createElement(
                            'th',
                            { className: 'text-xs text-uppercase text-right' },
                            _strings2.default.creditsUsed
                        )
                    )
                ),
                _react2.default.createElement(
                    'tbody',
                    null,
                    transactions.map(function (t, i) {
                        return _this2._renderTransactionItem(t, i);
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'transaction-history p-a-0' },
                _react2.default.createElement(
                    'div',
                    { className: 'p-r-sm p-l-sm border-bottom' },
                    _react2.default.createElement(
                        'b',
                        null,
                        _strings2.default.history
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'transaction-table' },
                    this._renderTable()
                )
            );
        }
    }]);

    return TransactionHistory;
}(_react.Component);

TransactionHistory.propTypes = {
    transactions: _propTypes2.default.arrayOf(_MapPropTypes2.default.TransactionProps),
    cancelOrder: _propTypes2.default.func.isRequired
};
exports.default = TransactionHistory;

/***/ }),

/***/ 980:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactComponents = __webpack_require__(35);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _Base = __webpack_require__(73);

var _Base2 = _interopRequireDefault(_Base);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderCancelModal = function (_Component) {
    _inherits(OrderCancelModal, _Component);

    function OrderCancelModal() {
        _classCallCheck(this, OrderCancelModal);

        return _possibleConstructorReturn(this, (OrderCancelModal.__proto__ || Object.getPrototypeOf(OrderCancelModal)).apply(this, arguments));
    }

    _createClass(OrderCancelModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.props.transaction) {
                return null;
            }

            var description = [{
                label: _strings2.default.description,
                value: this.props.transaction.description
            }, {
                label: _strings2.default.orderedOn,
                value: _utils2.default.formatDate(this.props.transaction.lastModified)
            }, {
                label: _strings2.default.fulfilledOn,
                value: this.props.transaction.batchTimestamp ? _utils2.default.formatDate(this.props.transaction.batchTimestamp) : _react2.default.createElement(
                    'span',
                    { className: 'text-mute' },
                    _strings2.default.notFulfilled
                )
            }, {
                label: _strings2.default.confirmation,
                value: this.props.transaction.confirmation
            }, {
                label: _strings2.default.amount,
                value: _utils2.default.formatPrice(this.props.transaction.amount)
            }];

            return _react2.default.createElement(
                _Base2.default,
                {
                    modalClassName: 'cancel-order-modal',
                    modalTitle: _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            'span',
                            { className: 'text-warning' },
                            _react2.default.createElement(_reactComponents.Icon, { name: 'icon-warning2' }),
                            ' '
                        ),
                        _strings2.default.reallyCancel
                    ),
                    visible: this.props.visible,
                    closeModal: this.props.close
                },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'dl',
                        { className: 'dl-horizontal' },
                        description.map(function (item, i) {
                            return _react2.default.createElement(
                                'span',
                                { key: i },
                                _react2.default.createElement(
                                    'dt',
                                    { className: 'col-md-3' },
                                    item.label
                                ),
                                _react2.default.createElement(
                                    'dd',
                                    { className: 'col-md-9' },
                                    item.value
                                )
                            );
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-12 text-right m-b-sm p-a-0' },
                        _react2.default.createElement(
                            'button',
                            {
                                onClick: function onClick() {
                                    return _this2.props.close();
                                },
                                className: 'btn btn-success m-r-sm'
                            },
                            _strings2.default.no
                        ),
                        _react2.default.createElement(
                            'button',
                            {
                                onClick: function onClick() {
                                    return _this2.props.cancelOrder(_this2.props.transaction);
                                },
                                className: 'btn btn-danger'
                            },
                            _strings2.default.yes
                        )
                    )
                )
            );
        }
    }]);

    return OrderCancelModal;
}(_react.Component);

OrderCancelModal.propTypes = {
    visible: _propTypes2.default.bool.isRequired,
    close: _propTypes2.default.func.isRequired,
    transaction: _MapPropTypes2.default.TransactionProps,
    cancelOrder: _propTypes2.default.func.isRequired
};
exports.default = OrderCancelModal;

/***/ }),

/***/ 982:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(64);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShoppingCartModalBase = function (_Component) {
    _inherits(ShoppingCartModalBase, _Component);

    function ShoppingCartModalBase() {
        _classCallCheck(this, ShoppingCartModalBase);

        return _possibleConstructorReturn(this, (ShoppingCartModalBase.__proto__ || Object.getPrototypeOf(ShoppingCartModalBase)).apply(this, arguments));
    }

    _createClass(ShoppingCartModalBase, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    dialogClassName: this.props.modalClassName,
                    show: this.props.visible,
                    animation: false,
                    backdrop: this.props.backdrop,
                    onHide: function onHide() {
                        return _this2.props.closeModal();
                    }
                },
                _react2.default.createElement(
                    'div',
                    { className: 'shopping-cart' },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Header,
                        null,
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Title,
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'title' },
                                this.props.modalTitle
                            ),
                            _react2.default.createElement(
                                'button',
                                {
                                    type: 'button',
                                    className: 'close',
                                    'aria-label': _strings2.default.close,
                                    onClick: function onClick() {
                                        return _this2.props.closeModal();
                                    }
                                },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'x-symbol' },
                                    '\xD7'
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'sr-only' },
                                    _strings2.default.close
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Body,
                        null,
                        this.props.children
                    )
                )
            );
        }
    }]);

    return ShoppingCartModalBase;
}(_react.Component);

exports.default = ShoppingCartModalBase;

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _MapPropTypes = __webpack_require__(21);

var _MapPropTypes2 = _interopRequireDefault(_MapPropTypes);

var _strings = __webpack_require__(12);

var _strings2 = _interopRequireDefault(_strings);

var _utils = __webpack_require__(34);

var _utils2 = _interopRequireDefault(_utils);

__webpack_require__(985);

var _reactCustomScrollbars = __webpack_require__(252);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Summary = function (_Component) {
    _inherits(Summary, _Component);

    function Summary() {
        _classCallCheck(this, Summary);

        return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).apply(this, arguments));
    }

    _createClass(Summary, [{
        key: '_handleSaveForLaterClick',
        value: function _handleSaveForLaterClick(itemId, flag) {
            this.props.updateSaveForLater(itemId, flag); // Dispatch action to update save for later state
        }
    }, {
        key: '_showDays',
        value: function _showDays() {
            if (this.props.offer.dailyPricingEnabled) {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: '_renderSummary',
        value: function _renderSummary() {
            if (!this.props.excelUpload) {
                return _react2.default.createElement(
                    'dl',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-summary' },
                        _react2.default.createElement(
                            'div',
                            { className: 'credits-used ' },
                            _react2.default.createElement(
                                'h2',
                                null,
                                _strings2.default.creditsUsed
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'credits-value' },
                                ' ',
                                _utils2.default.formatPrice(this.props.cartTotal)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'available-credits' },
                            _react2.default.createElement(
                                'p',
                                null,
                                _strings2.default.availableCredits
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'credits-amount' },
                                _utils2.default.formatPrice(this.props.offer.balance)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'remaining-credits' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Remaining'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'remaining-credits-amount' },
                                _utils2.default.formatPrice(this.props.offer.balance - this.props.cartTotal)
                            )
                        )
                    )
                );
            }
        }
    }, {
        key: '_renderPurchases',
        value: function _renderPurchases(cart, isSavedLaterFlag) {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'cart-table' },
                _react2.default.createElement(
                    _reactCustomScrollbars.Scrollbars,
                    { style: { width: '100%', height: 160 }, universal: true },
                    _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.partNumber
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.product
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Server Information'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.seats
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Start Date'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'End Date'
                                ),
                                this._showDays() ? _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.days
                                ) : _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.months
                                ),
                                this.props.offer.weeklyPricingEnabled && _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.weeks
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _strings2.default.subtotal
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Actions'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            cart.filter(function (item) {
                                return item.addedToCart;
                            }).map(function (item, i) {
                                // Compare saveForLater with isSavedLaterFlag
                                if (item.saveForLater === isSavedLaterFlag) {
                                    return _react2.default.createElement(
                                        'tr',
                                        { key: i },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            item.pricing.product.mentorId
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            item.pricing.product.name
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            item.server.mentorId
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            item.seats
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-nowrap' },
                                            (0, _moment2.default)(item.startDate).format('MM-DD-YYYY')
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-nowrap' },
                                            (0, _moment2.default)(item.endDate).format('MM-DD-YYYY')
                                        ),
                                        _this2._showDays() ? _react2.default.createElement(
                                            'td',
                                            null,
                                            item.dayCount
                                        ) : _react2.default.createElement(
                                            'td',
                                            null,
                                            item.monthCount
                                        ),
                                        _this2.props.offer.weeklyPricingEnabled && _react2.default.createElement(
                                            'td',
                                            null,
                                            item.weekCount
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _utils2.default.formatPrice(item.subtotal)
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'cart-actions' },
                                                item.saveForLater ? _react2.default.createElement(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: 'move-to-cart-button',
                                                        onClick: function onClick() {
                                                            return _this2._handleSaveForLaterClick(i, false);
                                                        }
                                                    },
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'btn-link text-link' },
                                                        'Move to Cart'
                                                    )
                                                ) : _react2.default.createElement(
                                                    'button',
                                                    {
                                                        type: 'button',
                                                        className: 'save-for-later-button',
                                                        onClick: function onClick() {
                                                            return _this2._handleSaveForLaterClick(i, true);
                                                        }
                                                    },
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'btn-link text-link' },
                                                        'Save for Later'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'cart-remove' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        {
                                                            type: 'button',
                                                            className: 'close cart-remove-icon',
                                                            'aria-label': _strings2.default.remove,
                                                            onClick: function onClick() {
                                                                return _this2.props.removeItemFromCart(i, item.cartId, false);
                                                            } },
                                                        _react2.default.createElement(
                                                            'span',
                                                            { className: 'text-danger remove-text' },
                                                            _strings2.default.remove
                                                        ),
                                                        _react2.default.createElement(
                                                            'svg',
                                                            { className: 'remove-icon', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' },
                                                            _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', fill: 'red' }),
                                                            _react2.default.createElement('line', { x1: '8', y1: '8', x2: '16', y2: '16', stroke: 'white', strokeWidth: '2' }),
                                                            _react2.default.createElement('line', { x1: '16', y1: '8', x2: '8', y2: '16', stroke: 'white', strokeWidth: '2' })
                                                        )
                                                    )
                                                ),
                                                _react2.default.createElement('div', null)
                                            )
                                        )
                                    );
                                }
                                return null; // Return null if item doesn't match the condition
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var cartItems = this.props.cart; // Use the same cart for both
            var nonSavedItemsCount = cartItems.filter(function (item) {
                return item.addedToCart && !item.saveForLater;
            }).length;
            var savedForLaterItemsCount = cartItems.filter(function (item) {
                return item.addedToCart && item.saveForLater;
            }).length;

            return _react2.default.createElement(
                'div',
                null,
                this._renderSummary(),
                _react2.default.createElement(
                    'div',
                    null,
                    nonSavedItemsCount > 0 && _react2.default.createElement(
                        'div',
                        { className: 'cart-section' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section-header' },
                            _react2.default.createElement(
                                'h2',
                                null,
                                _strings2.default.yourCart
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'pull-right' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        type: 'button',
                                        className: 'btn btn-link manage-cart ',
                                        onClick: this.props.onEditOrder // Assuming an onEditOrder callback is passed as a prop
                                    },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'edit-icon' },
                                        _react2.default.createElement(
                                            'svg',
                                            { className: 'icon icon-plm-edit' },
                                            _react2.default.createElement('use', { href: '#icon-plm-edit' })
                                        )
                                    ),
                                    'Edit/Manage Cart'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    {
                                        type: 'button',
                                        className: 'btn btn-link clear-cart',
                                        onClick: function onClick() {
                                            return _this3.props.removeItemFromCart(-1, '', false);
                                        }
                                    },
                                    _react2.default.createElement(
                                        'svg',
                                        { width: '20', height: '20', viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
                                        _react2.default.createElement('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13 2C14.5977 2 15.9037 3.24892 15.9949 4.82373L16 5H21V7H19.453L18.2731 18.4116C18.0692 20.3825 16.457 21.8962 14.4982 21.9949L14.2943 22H9.70566C7.72421 22 6.05272 20.5521 5.75297 18.6138L5.7269 18.4116L4.546 7H3V5H8C8 3.40232 9.24892 2.09634 10.8237 2.00509L11 2H13ZM17.443 7H6.556L7.71628 18.2058C7.81619 19.1716 8.59244 19.9178 9.5453 19.9936L9.70566 20H14.2943C15.2143 20 16.0036 19.2901 16.1933 18.394L16.2837 18.2058L17.443 7ZM10 9V17H8V9H10ZM16 9V17H14V9H16Z' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'clear-text' },
                                        'Clear Cart'
                                    )
                                )
                            )
                        ),
                        this._renderPurchases(cartItems, false),
                        ' '
                    ),
                    savedForLaterItemsCount > 0 && _react2.default.createElement(
                        'div',
                        { className: 'cart-section' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section-header' },
                            _react2.default.createElement(
                                'h2',
                                null,
                                'Saved For Later'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'pull-right' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        type: 'button',
                                        className: 'btn btn-link clear-cart',
                                        onClick: function onClick() {
                                            return _this3.props.removeItemFromCart(-1, '', true);
                                        }
                                    },
                                    _react2.default.createElement(
                                        'svg',
                                        { width: '20', height: '20', viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
                                        _react2.default.createElement('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13 2C14.5977 2 15.9037 3.24892 15.9949 4.82373L16 5H21V7H19.453L18.2731 18.4116C18.0692 20.3825 16.457 21.8962 14.4982 21.9949L14.2943 22H9.70566C7.72421 22 6.05272 20.5521 5.75297 18.6138L5.7269 18.4116L4.546 7H3V5H8C8 3.40232 9.24892 2.09634 10.8237 2.00509L11 2H13ZM17.443 7H6.556L7.71628 18.2058C7.81619 19.1716 8.59244 19.9178 9.5453 19.9936L9.70566 20H14.2943C15.2143 20 16.0036 19.2901 16.1933 18.394L16.2837 18.2058L17.443 7ZM10 9V17H8V9H10ZM16 9V17H14V9H16Z' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'clear-text' },
                                        'Clear Saved for Later'
                                    )
                                )
                            )
                        ),
                        this._renderPurchases(cartItems, true),
                        ' '
                    )
                )
            );
        }
    }]);

    return Summary;
}(_react.Component);

Summary.propTypes = {
    cartTotal: _propTypes2.default.number.isRequired,
    offer: _MapPropTypes2.default.OfferProps.isRequired,
    cart: _MapPropTypes2.default.CartProps,
    onUpdateInstructions: _propTypes2.default.func.isRequired,
    removeItemFromCart: _propTypes2.default.func.isRequired,
    updateSaveForLater: _propTypes2.default.func.isRequired,
    onEditOrder: _propTypes2.default.func.isRequired,
    excelUpload: _propTypes2.default.bool,
    sheetResponseData: _propTypes2.default.object,
    soldTo: _propTypes2.default.string
};
exports.default = Summary;

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[620]);


// WEBPACK FOOTER //
// 8b1e8349ce0e9a423511.js